/* Options:
Date: 2025-01-30 23:35:07
Version: 8.22
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://genservices.dabto.com

//GlobalNamespace:
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export class BaseRequest_1<E>
{

    public constructor(init?: Partial<BaseRequest_1<E>>) { (Object as any).assign(this, init); }
}

export class DabIdUserChangePasswordApiDto
{
    public userId: string;
    public password: string;
    public confirmPassword: string;

    public constructor(init?: Partial<DabIdUserChangePasswordApiDto>) { (Object as any).assign(this, init); }
}

export enum KisiTurleri
{
    GercekKisi = 1,
    TuzelKisi = 2,
    YabanciKisi = 3,
}

export enum Severity
{
    Error = 'Error',
    Warning = 'Warning',
    Info = 'Info',
}

export class ValidationFailure
{
    public propertyName: string;
    public errorMessage: string;
    public attemptedValue: Object;
    public customState: Object;
    public severity: Severity;
    public errorCode: string;
    public formattedMessagePlaceholderValues: { [index: string]: Object; };

    public constructor(init?: Partial<ValidationFailure>) { (Object as any).assign(this, init); }
}

export class ValidationResult
{
    public isValid: boolean;
    public errors: ValidationFailure[];
    public ruleSetsExecuted: string[];

    public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}

export class BaseCursorDto implements IBaseCursorDto
{

    public constructor(init?: Partial<BaseCursorDto>) { (Object as any).assign(this, init); }
}

export class TemImzaYetkiDto implements IBaseCursorDto
{
    public unvanTuru: string;
    public adiSoyadi: string;
    public kod: string;

    public constructor(init?: Partial<TemImzaYetkiDto>) { (Object as any).assign(this, init); }
}

export class CommonEntityBase
{

    public constructor(init?: Partial<CommonEntityBase>) { (Object as any).assign(this, init); }
}

export class AasOdeme extends CommonEntityBase
{
    public aciklama?: string;
    public ay: number;
    public basvuruAileKod?: number;
    public basvuruKod: number;
    public belediyeKod: number;
    public cocukTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gun?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kiraTutar?: number;
    public kod: number;
    public maasTutar?: number;
    public yil: number;
    public aasBasvuru: AasBasvuru;
    public aasBasvuruAile?: AasBasvuruAile;

    public constructor(init?: Partial<AasOdeme>) { super(init); (Object as any).assign(this, init); }
}

export class GenIl extends CommonEntityBase
{
    public aciklama: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genIlces: GenIlce[];

    public constructor(init?: Partial<GenIl>) { super(init); (Object as any).assign(this, init); }
}

export class EisKiraArtis extends CommonEntityBase
{
    public artisMiktar?: number;
    public artisOran?: number;
    public artisTarih: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sozlesmeKod: number;
    public yeniKira?: number;
    public eisKiraSozlesme: EisKiraSozlesme;

    public constructor(init?: Partial<EisKiraArtis>) { super(init); (Object as any).assign(this, init); }
}

export class GenKodAna extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genKodDetays: GenKodDetay[];

    public constructor(init?: Partial<GenKodAna>) { super(init); (Object as any).assign(this, init); }
}

export class IrsIzinDetay extends CommonEntityBase
{
    public cevap?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruKod: number;
    public genKodDetay: GenKodDetay;
    public irsIzin: IrsIzin;

    public constructor(init?: Partial<IrsIzinDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GenBinaKullanimAna extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBinaKullanimGrups: GenBinaKullanimGrup[];

    public constructor(init?: Partial<GenBinaKullanimAna>) { super(init); (Object as any).assign(this, init); }
}

export class GenBinaKullanimGrup extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public binaKullanimAnaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBinaKullanims: GenBinaKullanim[];
    public genBinaKullanimAna: GenBinaKullanimAna;

    public constructor(init?: Partial<GenBinaKullanimGrup>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullanimSekli extends CommonEntityBase
{
    public aciklama: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isyeriEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBinaKullanims: GenBinaKullanim[];

    public constructor(init?: Partial<GenKullanimSekli>) { super(init); (Object as any).assign(this, init); }
}

export class GenBinaKullanim extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public binaKullanimGrupKod: number;
    public ctvKullanimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullanimSekliKod?: number;
    public genBinaKullanimGrup: GenBinaKullanimGrup;
    public genKullanimSekli?: GenKullanimSekli;

    public constructor(init?: Partial<GenBinaKullanim>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeDagitim extends CommonEntityBase
{
    public aciklama?: string;
    public belgeKod: number;
    public birimAciklama?: string;
    public birimKimlikNo?: string;
    public birimKod: number;
    public birimTuru?: string;
    public dagitimSekli: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gonderimAdres?: string;
    public gonderimBedeli?: number;
    public gonderimDurum?: string;
    public gonderimNot?: string;
    public gonderimTarih?: string;
    public gonderimTipi?: string;
    public islemTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kepAdres?: string;
    public kepDurum?: string;
    public kepId?: number;
    public kisiKod?: number;
    public kod: number;
    public redAdedi?: number;
    public redNedeni?: string;
    public sira?: number;
    public bysBelge: BysBelge;
    public bysEvraks: BysEvrak[];
    public genBirim: GenBirim;

    public constructor(init?: Partial<BysBelgeDagitim>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeHavale extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakKod?: number;
    public havaleAciklama?: string;
    public havaleTarih: string;
    public havaleTipi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public sonucAciklama?: string;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public bysBelge: BysBelge;
    public bysEvrak?: BysEvrak;
    public genBirim: GenBirim;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<BysBelgeHavale>) { super(init); (Object as any).assign(this, init); }
}

export class BysEvrak extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public belgeKod: number;
    public birimKod: number;
    public birimNot?: string;
    public dagitimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakNo: number;
    public evrakTarih: string;
    public evrakTuru: string;
    public gelenGiden: string;
    public genelArsivKod?: number;
    public kapatmaAciklama?: string;
    public kapatmaTarih?: string;
    public kapatmaTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public postaNot?: string;
    public tebligNot?: string;
    public zimmetNo?: number;
    public zimmetTarih?: string;
    public bysBelge: BysBelge;
    public bysBelgeDagitim: BysBelgeDagitim;
    public bysBelgeHavales: BysBelgeHavale[];
    public gasDosya?: GasDosya;
    public genBirim: GenBirim;

    public constructor(init?: Partial<BysEvrak>) { super(init); (Object as any).assign(this, init); }
}

export class BysDegisen extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public icerik?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public surecKod: number;
    public bysBelge: BysBelge;
    public bysGorev: BysGorev;

    public constructor(init?: Partial<BysDegisen>) { super(init); (Object as any).assign(this, init); }
}

export class GenOrganizasyonRol extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public rolAciklama: string;
    public rolAd: string;
    public rolNot?: string;
    public genBirim?: GenBirim;

    public constructor(init?: Partial<GenOrganizasyonRol>) { super(init); (Object as any).assign(this, init); }
}

export class GenOrganizasyon extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kadroAdet?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public rolAciklama: string;
    public rolAd: string;
    public ustKod?: number;
    public genBirim?: GenBirim;
    public ustGenOrganizasyon?: GenOrganizasyon;
    public genOrganizasyons: GenOrganizasyon[];
    public genOrganizasyonRol?: GenOrganizasyonRol;

    public constructor(init?: Partial<GenOrganizasyon>) { super(init); (Object as any).assign(this, init); }
}

export class BysGorevDetay extends CommonEntityBase
{
    public aciklama?: string;
    public aktifGorevEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiPersonelKod?: number;
    public eypImzaEh?: string;
    public gorevAd: string;
    public gorevBaslamaTarih?: string;
    public gorevBitisTarih?: string;
    public gorevKod: number;
    public gorevSonucTuru?: number;
    public gorevTamamlandiEh: string;
    public gorevTuru: number;
    public imzaEh: string;
    public imzaGorev?: string;
    public imzaOnayTuru?: string;
    public imzaStatus?: number;
    public imzaTuru?: string;
    public imzaUnvan?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mailEh: string;
    public personelKod?: number;
    public rolAd?: string;
    public smsEh: string;
    public sonrakiGorevKod?: number;
    public surecGorevKod: number;
    public zamanDamgaEh: string;
    public bysGorev: BysGorev;
    public ikaPersonel?: IkaPersonel;
    public genOrganizasyon?: GenOrganizasyon;

    public constructor(init?: Partial<BysGorevDetay>) { super(init); (Object as any).assign(this, init); }
}

export class BysGorev extends CommonEntityBase
{
    public baslamaTarih: string;
    public belediyeKod: number;
    public belgeKod: number;
    public birimKod: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sonucAciklama?: string;
    public sonucTuru: number;
    public surecKod: number;
    public bysBelge: BysBelge;
    public bysDegisens: BysDegisen[];
    public bysGorevDetays: BysGorevDetay[];
    public bysSurec: BysSurec;
    public genBirim: GenBirim;

    public constructor(init?: Partial<BysGorev>) { super(init); (Object as any).assign(this, init); }
}

export class BysRaporBelgeDagitim extends CommonEntityBase
{
    public aciklama?: string;
    public birimKod: number;
    public dagitimSekli: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporBelgeKod: number;
    public bysRaporBelge: BysRaporBelge;
    public genBirim: GenBirim;

    public constructor(init?: Partial<BysRaporBelgeDagitim>) { super(init); (Object as any).assign(this, init); }
}

export class GenDosyaPlan extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public dayanak?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public klasorTuru?: string;
    public kod: number;
    public konuBoyut?: number;
    public konuTarihTuru?: string;
    public konuTuru?: string;
    public saklamaPlanKod?: number;
    public seviye?: number;
    public sure?: number;
    public sureTuru?: string;
    public tasfiyeIslemKod?: number;
    public genKodDetay?: GenKodDetay;

    public constructor(init?: Partial<GenDosyaPlan>) { super(init); (Object as any).assign(this, init); }
}

export class BysRaporBelge extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeAdi?: string;
    public belgeIcerikKod?: number;
    public belgeTuruKod: number;
    public bilgiEdinmeEh: string;
    public dagitimSekli?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilKod: number;
    public dosyaPlanKod: string;
    public evrakTuru?: string;
    public gecerliSure?: number;
    public gelenGiden?: string;
    public guvenlikDurumu: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiselEh: string;
    public kod: number;
    public kontrolEh: string;
    public oncelikDurumu: string;
    public raporAdi: string;
    public telifKapsamindaEh: string;
    public bysRaporBelgeDagitims: BysRaporBelgeDagitim[];
    public bysRaporBelgeDetays: BysRaporBelgeDetay[];
    public genBelgeTuru: GenBelgeTuru;
    public genKodDetay: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<BysRaporBelge>) { super(init); (Object as any).assign(this, init); }
}

export class BysRaporBelgeDetay extends CommonEntityBase
{
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporBelgeKod: number;
    public surecKod: number;
    public bysRaporBelge: BysRaporBelge;
    public bysSurec: BysSurec;
    public genBirim: GenBirim;

    public constructor(init?: Partial<BysRaporBelgeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class BysSurecDetay extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevAd: string;
    public gorevKod: number;
    public gorevTuru: number;
    public imzaEh: string;
    public imzaGorev?: string;
    public imzaTuru?: string;
    public imzaUnvan?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mailEh: string;
    public rolAd?: string;
    public smsEh: string;
    public sonrakiGorevKod?: number;
    public surecKod: number;
    public zamanDamgaEh: string;
    public bysSurec: BysSurec;
    public genOrganizasyon?: GenOrganizasyon;

    public constructor(init?: Partial<BysSurecDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GenAraziTuru extends CommonEntityBase
{
    public aciklama: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;

    public constructor(init?: Partial<GenAraziTuru>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanBagimsiz extends CommonEntityBase
{
    public beyanKod: number;
    public binaKod: number;
    public bolumKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBina: AksBina;
    public aksBinaBolum: AksBinaBolum;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanBagimsiz>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanCtvDetay extends CommonEntityBase
{
    public beyanKod: number;
    public ctvDerece: number;
    public ctvGrup: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanCtvDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanEglDetay extends CommonEntityBase
{
    public Adet?: number;
    public Ay: number;
    public BeyanKod: number;
    public BiletFiat?: number;
    public DegisKullaniciKod?: number;
    public DegisTarih?: string;
    public EkAdet?: number;
    public Gun?: number;
    public IadeBiletAdet?: number;
    public ISeriNo?: number;
    public KabulTarih: string;
    public KayitKullaniciKod: number;
    public KayitTarih: string;
    public Kod: number;
    public Matrah?: number;
    public SSeriNo?: number;
    public Tutari?: number;
    public Yil: number;
    public KdvTutari: number;
    public GysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanEglDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanEkaDetay extends CommonEntityBase
{
    public beyanKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekaDerece: number;
    public ekaGrup: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanEkaDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlakDonemDetay extends CommonEntityBase
{
    public araziOran: number;
    public arsaOran: number;
    public belediyeKod: number;
    public binaIsyerOran: number;
    public binaKonutEmekliOran: number;
    public binaKonutOran: number;
    public binaMuafiyetLimit?: number;
    public degerlemeOran: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public ekVergiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public matrahYuvDilim?: number;
    public matrahYuvSekli?: string;
    public yil: number;
    public gysEmlakDonem: GysEmlakDonem;

    public constructor(init?: Partial<GysEmlakDonemDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlakDonem extends CommonEntityBase
{
    public aciklama: string;
    public asansorOran: number;
    public asgariKontrolEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iYil: number;
    public kaloriferOran: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisitliOrani: number;
    public kod: number;
    public koyIstisnasi: number;
    public koyIstisnasiEskiMiktar: number;
    public sYil: number;
    public gysBeyanEmlakAsgaris: GysBeyanEmlakAsgari[];
    public gysEmlakDonemDetays: GysEmlakDonemDetay[];

    public constructor(init?: Partial<GysEmlakDonem>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanEmlakAsgari extends CommonEntityBase
{
    public arsaHisseDegeri?: number;
    public arsaM2Degeri?: number;
    public asgariDeger?: number;
    public asgariHesapYili: number;
    public beyanKod: number;
    public binaAsansorDegeri?: number;
    public binaAsinmaPayi?: number;
    public binaInsaatMaliyeti?: number;
    public binaKaloriferDegeri?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public ekVergiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public rayicBedeli?: number;
    public gysBeyan: GysBeyan;
    public gysEmlakDonem: GysEmlakDonem;

    public constructor(init?: Partial<GysBeyanEmlakAsgari>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanEmlakTezyid extends CommonEntityBase
{
    public beyanKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public matrahFarkTutar?: number;
    public yil: number;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanEmlakTezyid>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanGenelDetay extends CommonEntityBase
{
    public beyanKod: number;
    public carpan?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public matrah?: number;
    public yil: number;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanGenelDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanIlanDetay extends CommonEntityBase
{
    public beyanKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilanBoy?: number;
    public ilanEn?: number;
    public ilanMuaf?: number;
    public ilanNetToplam: number;
    public ilanToplam?: number;
    public ilanYon?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanIlanDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyanSatis extends CommonEntityBase
{
    public aciklama?: string;
    public alanKisiKod?: number;
    public beyanKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genKisiAlan?: GenKisi;
    public genKisiEski?: GenKisi;
    public gysBeyan: GysBeyan;

    public constructor(init?: Partial<GysBeyanSatis>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtvTarife extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece: number;
    public grup: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tarife: number;
    public yil: number;
    public gysCtvTarifeDetays: GysCtvTarifeDetay[];

    public constructor(init?: Partial<GysCtvTarife>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtvTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilkDeger: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullanimKod: number;
    public sonDeger: number;
    public tarifeKod: number;
    public gysCtvKullanim: GysCtvKullanim;
    public gysCtvTarife: GysCtvTarife;

    public constructor(init?: Partial<GysCtvTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtvKullanim extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kriter: number;
    public genBinaKullanims: GenBinaKullanim[];
    public gysBeyans: GysBeyan[];
    public gysCtvTarifeDetays: GysCtvTarifeDetay[];

    public constructor(init?: Partial<GysCtvKullanim>) { super(init); (Object as any).assign(this, init); }
}

export class GysEglGelir extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public oranTutar: number;
    public tarifeKod: number;
    public uygulamaTuru: string;
    public vadeUygulamaTuru: string;
    public yil: number;
    public gysEglTarife: GysEglTarife;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysEglGelir>) { super(init); (Object as any).assign(this, init); }
}

export class GysEglTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekLimit?: number;
    public ekTutar?: number;
    public ilkLimit?: number;
    public ilkTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kod: number;
    public tarifeKod: number;
    public uygulanacakOran?: number;
    public yil: number;
    public gysEglTarife: GysEglTarife;

    public constructor(init?: Partial<GysEglTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysEglTarife extends CommonEntityBase
{
    public ad: string;
    public adresKontrolTuru: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysBeyans: GysBeyan[];
    public gysEglGelirs: GysEglGelir[];
    public gysEglTarifeDetays: GysEglTarifeDetay[];
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysEglTarife>) { super(init); (Object as any).assign(this, init); }
}

export class GysEkaTarife extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece: number;
    public grup: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tarife: number;
    public yil: number;
    public gysEkaTarifeDetays: GysEkaTarifeDetay[];

    public constructor(init?: Partial<GysEkaTarife>) { super(init); (Object as any).assign(this, init); }
}

export class GysEkaTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekaKullanimKod: number;
    public ekaTarifeKod: number;
    public ilkDeger: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sonDeger: number;
    public gysEkaKullanim: GysEkaKullanim;
    public gysEkaTarife: GysEkaTarife;

    public constructor(init?: Partial<GysEkaTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysEkaKullanim extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kriter: number;
    public tarifeBirimGenel: string;
    public gysBeyans: GysBeyan[];
    public gysEkaTarifeDetays: GysEkaTarifeDetay[];
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysEkaKullanim>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlakMuafiyetTuru extends CommonEntityBase
{
    public aciklama: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysBeyans: GysBeyan[];

    public constructor(init?: Partial<GysEmlakMuafiyetTuru>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenelTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekLimit?: number;
    public ekTutarOran?: number;
    public ilkLimit?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sonLimit?: number;
    public tarifeKod: number;
    public tutarOran?: number;
    public yil: number;
    public gysGenelTarife: GysGenelTarife;

    public constructor(init?: Partial<GysGenelTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenelTarife extends CommonEntityBase
{
    public ad: string;
    public adresKontrolTuru: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysBeyans: GysBeyan[];
    public gysGelirDetay: GysGelirDetay;
    public gysGenelTarifeDetays: GysGenelTarifeDetay[];

    public constructor(init?: Partial<GysGenelTarife>) { super(init); (Object as any).assign(this, init); }
}

export class GysHkpIslerDetay extends CommonEntityBase
{
    public ada?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public koseEh: string;
    public mahalleCaddeKod?: number;
    public notlar?: string;
    public parsel?: number;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public gysHkpIsler: GysHkpIsler;

    public constructor(init?: Partial<GysHkpIslerDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysHkpIslerVade extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public isKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public vadeTarih?: string;
    public gysHkpIsler: GysHkpIsler;

    public constructor(init?: Partial<GysHkpIslerVade>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiVaris extends CommonEntityBase
{
    public adi: string;
    public aktifEh: string;
    public babaAdi: string;
    public beyanVerenEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public eskiKisiKod?: number;
    public hisse?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public oran?: number;
    public soyadi: string;
    public tckimlikNo?: number;
    public genIlce?: GenIlce;
    public genKisi: GenKisi;

    public constructor(init?: Partial<GenKisiVaris>) { super(init); (Object as any).assign(this, init); }
}

export class GenTelAlanKodlari extends CommonEntityBase
{
    public aciklama?: string;
    public alanKod: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gsmEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;

    public constructor(init?: Partial<GenTelAlanKodlari>) { super(init); (Object as any).assign(this, init); }
}

export class GenUlke extends CommonEntityBase
{
    public ad: string;
    public alanKod?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public plaka?: string;
    public uyrukKod?: number;
    public genKodDetay?: GenKodDetay;

    public constructor(init?: Partial<GenUlke>) { super(init); (Object as any).assign(this, init); }
}

export class EtsBeyanDetay extends CommonEntityBase
{
    public ad: string;
    public adresIlceKod?: number;
    public adresNot?: string;
    public akrabalikDerece?: string;
    public anneAd?: string;
    public anneBireySiraNo?: string;
    public anneSagEh: string;
    public anneSoyad?: string;
    public askerlikCuzdanNo?: string;
    public babaAd?: string;
    public babaBireySiraNo?: string;
    public babaSagEh: string;
    public babaSoyad?: string;
    public bakmaklaYukumluCocuk?: number;
    public beyanCiltNo?: string;
    public blokNo?: string;
    public bolumKod?: number;
    public bosanmaTarih?: string;
    public caddeSokakAd?: string;
    public cinsiyet: string;
    public cocukSayisi?: number;
    public daireNo?: string;
    public danismanlikEgitimEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devletVatandaslikEh: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public dogumYeriUlkeKod?: number;
    public dogumYil?: number;
    public eMail?: string;
    public evlenBeyanKod: number;
    public evlenEhliyetBelgesiEh: string;
    public evlenmeYasakEh: string;
    public evlilikSayisi?: number;
    public gsmAlanKod?: number;
    public gsmTel?: string;
    public hastaneAdi?: string;
    public hastaneDoktorAdi?: string;
    public hastaneDoktorBolumu?: string;
    public hastaneDoktorNo?: string;
    public hastaneDosyaNo?: string;
    public hastaneTarih?: string;
    public kanGrubu?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazaiEvlenmeYasakEh: string;
    public kod: number;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public medeniDurumKod?: number;
    public meslekKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: string;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public ogrenimTuruKod?: number;
    public oncekiSoyad?: string;
    public oncekiSoyadKullanEh: string;
    public pasaportNo?: string;
    public postaKodu?: number;
    public saglikRaporuEh: string;
    public siteApartmanAd?: string;
    public soyad: string;
    public tckn?: number;
    public tescilNufusYerKod?: number;
    public tescilTarih?: string;
    public uyrukKod?: number;
    public vasiAdi?: string;
    public vasiAnneBabaIzniEh?: string;
    public vasiYakinlik?: string;
    public vatandaslikEh?: string;
    public velayetAb?: string;
    public velayetMahkemeAdi?: string;
    public velayetMahkemeKararNo?: string;
    public velayetMahkemeTarih?: string;
    public zuhreviHastalikEh: string;
    public aksBinaBolum?: AksBinaBolum;
    public etsBeyan: EtsBeyan;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genIlce3?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genUlke?: GenUlke;

    public constructor(init?: Partial<EtsBeyanDetay>) { super(init); (Object as any).assign(this, init); }
}

export class EtsBeyanResim extends CommonEntityBase
{
    public cinsiyet: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evlenBeyanKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelResim?: string;
    public etsBeyan: EtsBeyan;

    public constructor(init?: Partial<EtsBeyanResim>) { super(init); (Object as any).assign(this, init); }
}

export class EtsParametre extends CommonEntityBase
{
    public adresKontrolTuru: string;
    public arsivEh?: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dosyaPlanKod?: string;
    public duzenMemurKod?: number;
    public evlendirmeDairesi?: string;
    public evlenMemurKod?: number;
    public evlenOzelKod?: number;
    public evlenTurKod?: number;
    public evlenYerKod?: number;
    public hastaneAdi?: string;
    public izinOzelKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public tasdikMemurKod?: number;
    public ulkeKod?: number;
    public etsMemur?: EtsMemur;
    public etsMemur_?: EtsMemur;
    public etsMemur__?: EtsMemur;
    public genBirim?: GenBirim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay_?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genModul: GenModul;
    public genUlke?: GenUlke;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<EtsParametre>) { super(init); (Object as any).assign(this, init); }
}

export class EtsSalon extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public etsSalonDetays: EtsSalonDetay[];

    public constructor(init?: Partial<EtsSalon>) { super(init); (Object as any).assign(this, init); }
}

export class EtsSalonDetay extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaSaat: string;
    public belediyeKod: number;
    public bitisSaat?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public evlenBeyanKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public nikahMemurKod?: number;
    public rezervTarih: string;
    public salonKod: number;
    public yapilacakYer?: string;
    public etsBeyan?: EtsBeyan;
    public etsMemur?: EtsMemur;
    public etsSalon: EtsSalon;
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;

    public constructor(init?: Partial<EtsSalonDetay>) { super(init); (Object as any).assign(this, init); }
}

export class EtsMemur extends CommonEntityBase
{
    public adSoyad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public unvanKod?: number;
    public etsBeyans: EtsBeyan[];
    public etsBeyans1: EtsBeyan[];
    public etsBeyans2: EtsBeyan[];
    public etsBeyans3: EtsBeyan[];
    public etsParametres: EtsParametre[];
    public etsParametres_: EtsParametre[];
    public etsParametres__: EtsParametre[];
    public etsSalonDetays: EtsSalonDetay[];

    public constructor(init?: Partial<EtsMemur>) { super(init); (Object as any).assign(this, init); }
}

export class EtsDefter extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public defterNo: number;
    public defterSiraNo: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;

    public constructor(init?: Partial<EtsDefter>) { super(init); (Object as any).assign(this, init); }
}

export class EtsBeyan extends CommonEntityBase
{
    public adresIlceKod?: number;
    public adresNot?: string;
    public aileCuzdanSeriNo?: string;
    public belediyeKod: number;
    public beyanNo: number;
    public beyanSekli: string;
    public beyanTarih: string;
    public beyanTur: string;
    public beyanYil: number;
    public blokNo?: string;
    public bolumKod?: number;
    public caddeSokakAd?: string;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dusunceler?: string;
    public duzenleyenMemurKod?: number;
    public duzenleyenTarih?: string;
    public erkekSahitAdi?: string;
    public evlenBucakKoy?: string;
    public evlenDefterNo?: number;
    public evlenDefterSira?: number;
    public evlenIlceKod?: number;
    public evlenmeIzniVarEh: string;
    public evlenMemurKod?: number;
    public evlenTarih?: string;
    public evlenTescilNo?: string;
    public evlenTescilTarih?: string;
    public evlenTurKod?: number;
    public evlenUlkeKod?: number;
    public evlenYerKod?: number;
    public evlenYil?: number;
    public iptalTarih?: string;
    public izinNo?: number;
    public izinTarih?: string;
    public kadinSahitAdi?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public nisanTarih?: string;
    public onayMemurKod?: number;
    public onayTarih?: string;
    public ozelKutukSiraNo?: string;
    public siteApartmanAd?: string;
    public tasdikMemurKod?: number;
    public tasdikTarih?: string;
    public aksBinaBolum?: AksBinaBolum;
    public etsBeyanDetays: EtsBeyanDetay[];
    public etsBeyanResims: EtsBeyanResim[];
    public etsMemur?: EtsMemur;
    public etsMemur1?: EtsMemur;
    public etsMemur2?: EtsMemur;
    public etsMemur3?: EtsMemur;
    public etsSalonDetays: EtsSalonDetay[];
    public etsUcretTahakkuks: EtsUcretTahakkuk[];
    public gasDosyas: GasDosya[];
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genUlke?: GenUlke;
    public etsDefter?: EtsDefter;

    public constructor(init?: Partial<EtsBeyan>) { super(init); (Object as any).assign(this, init); }
}

export class EtsUcretTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tutarOran?: number;
    public ucretTarifeKod: number;
    public yil: number;
    public etsUcretTarife: EtsUcretTarife;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<EtsUcretTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class EtsUcretTarife extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public etsUcretTahakkuks: EtsUcretTahakkuk[];
    public etsUcretTarifeDetays: EtsUcretTarifeDetay[];

    public constructor(init?: Partial<EtsUcretTarife>) { super(init); (Object as any).assign(this, init); }
}

export class EtsUcretTahakkuk extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public evlenBeyanKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public ucretTarifeKod: number;
    public yil: number;
    public etsBeyan?: EtsBeyan;
    public etsUcretTarife: EtsUcretTarife;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;

    public constructor(init?: Partial<EtsUcretTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class GenAvukat extends CommonEntityBase
{
    public ad?: string;
    public adres?: string;
    public belediyeKod: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soyad?: string;
    public tckn?: number;

    public constructor(init?: Partial<GenAvukat>) { super(init); (Object as any).assign(this, init); }
}

export class GysIcraBelge extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelenBelgeKod?: number;
    public gelenEvrakNo?: number;
    public genelEvrakTarih?: string;
    public gidenBelgeKod?: number;
    public gidenEvrakNo?: number;
    public gidenEvrakTarih?: string;
    public icraAnaKod: number;
    public icraYazismaTurKod: number;
    public karsilikYazilacakEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yaziTuru: number;
    public bysBelge?: BysBelge;
    public bysBelge1?: BysBelge;
    public gysIcraAna: GysIcraAna;

    public constructor(init?: Partial<GysIcraBelge>) { super(init); (Object as any).assign(this, init); }
}

export class GysIcraAna extends CommonEntityBase
{
    public aciklama?: string;
    public avukatKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public duzenlemeTarih: string;
    public eskiKisiKod?: number;
    public icraPersonelKod?: number;
    public icraRolAd?: string;
    public icraTakipNo: number;
    public islemKod?: string;
    public islemTuru?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public malBildirimiEh?: string;
    public mudurPersonelKod?: number;
    public mudurRolAd?: string;
    public onayPersonelKod?: number;
    public onayRolAd?: string;
    public tahakAnaKod?: number;
    public vekilAdSoyad?: string;
    public yil: number;
    public genAvukat?: GenAvukat;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysIcras: GysIcra[];
    public gysIcraBelges: GysIcraBelge[];
    public gysTahakkukAna?: GysTahakkukAna;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;

    public constructor(init?: Partial<GysIcraAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysGecikmeDetay extends CommonEntityBase
{
    public aylikOran: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecikmeKod: number;
    public gunlukOran?: number;
    public iTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sTarih: string;
    public gysGecikme: GysGecikme;

    public constructor(init?: Partial<GysGecikmeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksit extends CommonEntityBase
{
    public aktifEh: string;
    public anaVadeTarih?: string;
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeKod?: number;
    public gecikmeZammi?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public iptalTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod: number;
    public tahsilatGFaiz?: number;
    public tahsilatVergi?: number;
    public taksitAnaKod: number;
    public taksitGFaiz?: number;
    public taksitNo: number;
    public taksitTarih: string;
    public taksitVergi?: number;
    public terkinGFaiz?: number;
    public terkinVergi?: number;
    public vadeTarih: string;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGecikme?: GysGecikme;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysTahakkuk: GysTahakkuk;

    public constructor(init?: Partial<GysTaksit>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitAna extends CommonEntityBase
{
    public aciklama?: string;
    public anaParaTutar?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public gecikmeKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public suAboneKod?: number;
    public taksitFaizTutar?: number;
    public taksitNo: number;
    public taksitSayi: number;
    public taksitTarih: string;
    public taksitTurKod?: number;
    public toplamTutar?: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysGecikme?: GysGecikme;

    public constructor(init?: Partial<GysTaksitAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitIptalAna extends CommonEntityBase
{
    public aciklama?: string;
    public anaParaTutar?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public gecikmeKod?: number;
    public iptalAciklama?: string;
    public iptalTarih: string;
    public iptalTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public suAboneKod?: number;
    public taksitAnaKod: number;
    public taksitFaizTutar?: number;
    public taksitNo: number;
    public taksitSayi: number;
    public taksitTarih: string;
    public taksitTurKod?: number;
    public toplamTutar?: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysGecikme?: GysGecikme;
    public gysTaksitIptals: GysTaksitIptal[];

    public constructor(init?: Partial<GysTaksitIptalAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitIptal extends CommonEntityBase
{
    public aktifEh: string;
    public anaVadeTarih?: string;
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeKod?: number;
    public gecikmeZammi?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public iptalTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod: number;
    public tahsilatGFaiz?: number;
    public tahsilatVergi?: number;
    public taksitAnaKod: number;
    public taksitGFaiz?: number;
    public taksitIptalKod?: number;
    public taksitKod: number;
    public taksitNo: number;
    public taksitTarih: string;
    public taksitVergi?: number;
    public terkinGFaiz?: number;
    public terkinVergi?: number;
    public vadeTarih: string;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGecikme?: GysGecikme;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysTahakkuk: GysTahakkuk;
    public gysTaksitIptalAna?: GysTaksitIptalAna;

    public constructor(init?: Partial<GysTaksitIptal>) { super(init); (Object as any).assign(this, init); }
}

export class GysMukellefBitisTuru extends CommonEntityBase
{
    public aciklama: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysBeyans: GysBeyan[];
    public gysGenelParametres: GysGenelParametre[];

    public constructor(init?: Partial<GysMukellefBitisTuru>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenelParametre extends CommonEntityBase
{
    public aKusurGelirKod?: number;
    public arsivEh?: string;
    public belediyeKod: number;
    public birimKod?: number;
    public borcBeyanSuretDokEh: string;
    public cIhbarFisTuru: string;
    public cIhbarSatir?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKontrolEh: string;
    public dosyaNoGenelModul: string;
    public dosyaNoOtomatikEh: string;
    public dosyaPlanKod?: string;
    public kacakcilikGelirKod?: number;
    public kapamaBorcKontrolEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisitFisTuru: string;
    public kisitSatir?: number;
    public kod: number;
    public mobilKontrolTuru?: string;
    public mukBitisKod?: number;
    public otoNumaraGenelModul?: string;
    public tahakFisTuru: string;
    public tahakSatir?: number;
    public tcknVergiNoKontrol: string;
    public terkinFisTuru: string;
    public terkinOtoOnayEh?: string;
    public terkinTurKod?: number;
    public usulsuzluk1GelirKod?: number;
    public usulsuzluk2GelirKod?: number;
    public vIhbarFisTuru: string;
    public vIhbarSatir?: number;
    public vZiyaiGelirKod?: number;
    public genBirim?: GenBirim;
    public gysGelirDetay?: GysGelirDetay;
    public gysGelirDetay1?: GysGelirDetay;
    public gysGelirDetay2?: GysGelirDetay;
    public gysGelirDetay3?: GysGelirDetay;
    public gysGelirDetay4?: GysGelirDetay;
    public gysMukellefBitisTuru?: GysMukellefBitisTuru;
    public gysTerkinTuru?: GysTerkinTuru;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<GysGenelParametre>) { super(init); (Object as any).assign(this, init); }
}

export class ArsAnketSoruCevap extends CommonEntityBase
{
    public ad: string;
    public agirlik?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruKod: number;
    public arsAnketSoru: ArsAnketSoru;

    public constructor(init?: Partial<ArsAnketSoruCevap>) { super(init); (Object as any).assign(this, init); }
}

export class ArsAnketSoru extends CommonEntityBase
{
    public ad: string;
    public agirlik?: number;
    public anketKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruNo: number;
    public arsAnket: ArsAnket;
    public arsAnketSoruCevaps: ArsAnketSoruCevap[];

    public constructor(init?: Partial<ArsAnketSoru>) { super(init); (Object as any).assign(this, init); }
}

export class ArsParametre extends CommonEntityBase
{
    public anketKod?: number;
    public belediyeKod: number;
    public bildirimOtomatikCevapEh: string;
    public cagriMerkezBirimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public icIletisimMailEh: string;
    public icIletisimSmsEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public arsAnket?: ArsAnket;
    public genBirim?: GenBirim;

    public constructor(init?: Partial<ArsParametre>) { super(init); (Object as any).assign(this, init); }
}

export class ArsAnket extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public arsAnketSorus: ArsAnketSoru[];
    public arsBasvuruAnkets: ArsBasvuruAnket[];
    public arsParametres: ArsParametre[];

    public constructor(init?: Partial<ArsAnket>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBasvuruAnketCevap extends CommonEntityBase
{
    public anketKod: number;
    public basvuruAnketKod: number;
    public cevapKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dusunceler?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruKod: number;
    public arsBasvuruAnket: ArsBasvuruAnket;
    public arsAnketSoruCevap: ArsAnketSoruCevap;

    public constructor(init?: Partial<ArsBasvuruAnketCevap>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBasvuruAnket extends CommonEntityBase
{
    public anketKod: number;
    public basvuruKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gonderIpAdres?: string;
    public gonderMacAdres?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public arsAnket: ArsAnket;
    public arsBasvuru?: ArsBasvuru;
    public arsBasvuruAnketCevaps: ArsBasvuruAnketCevap[];

    public constructor(init?: Partial<ArsBasvuruAnket>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBasvuruBirimDetay extends CommonEntityBase
{
    public basvuruBirimKod: number;
    public basvuruKod: number;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public sonucAciklama?: string;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public arsBasvuruBirim: ArsBasvuruBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<ArsBasvuruBirimDetay>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBasvuruBirim extends CommonEntityBase
{
    public basvuruKod: number;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public sonucAciklama?: string;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public arsBasvuru: ArsBasvuru;
    public arsBasvuruBirimDetays: ArsBasvuruBirimDetay[];
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<ArsBasvuruBirim>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBasvuruGorusme extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public belediyeKod: number;
    public birimAdi?: string;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorusmeTarih: string;
    public gorusulenAdi?: string;
    public gorusulenGorevi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public arsBasvuru: ArsBasvuru;
    public genBirim?: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<ArsBasvuruGorusme>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBirimIsTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBirim: GenBirim;

    public constructor(init?: Partial<ArsBirimIsTur>) { super(init); (Object as any).assign(this, init); }
}

export class ArsPlan extends CommonEntityBase
{
    public aciklama?: string;
    public ada?: number;
    public belediyeKod: number;
    public binaKod?: number;
    public birimKod: number;
    public blokNo?: string;
    public boy?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derinlik?: number;
    public en?: number;
    public ihaleBedeli?: number;
    public ihaleNo?: string;
    public ihaleTarih?: string;
    public isAdi: string;
    public isTurKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod?: number;
    public muteahhitEh: string;
    public muteahhitKisiKod?: number;
    public onemDereceKod?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public planTarih: string;
    public siteApartmanAd?: string;
    public tahminiBaslangicTarih: string;
    public tahminiBitisTarih: string;
    public tamamlamaNotlari?: string;
    public tamamlamaTarih?: string;
    public tamamlandiEh: string;
    public arsBasvurus: ArsBasvuru[];
    public genBirim: GenBirim;
    public genKisi?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public arsBirimIsTur?: ArsBirimIsTur;

    public constructor(init?: Partial<ArsPlan>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBasvuru extends CommonEntityBase
{
    public ad?: string;
    public basvuruSekliKod: number;
    public basvuruTarih: string;
    public basvuruTuruKod?: number;
    public belediyeKod: number;
    public bimerNo?: number;
    public bimerTarih?: string;
    public cagriDetayKod?: number;
    public cagriKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eMail?: string;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public gelenEvrakNo?: number;
    public gelenEvrakTarih?: string;
    public gizliEh: string;
    public gonderIpAdres?: string;
    public gonderMacAdres?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiBinaKod?: number;
    public kisiBlokNo?: string;
    public kisiBolumKod?: number;
    public kisiDaireNo?: string;
    public kisiKapiNo?: number;
    public kisiKapiNo1?: string;
    public kisiKod?: number;
    public kisiMahalleCaddeKod?: number;
    public kisiSiteApartmanAd?: string;
    public kod: number;
    public konuKod: number;
    public koordinatX?: number;
    public koordinatY?: number;
    public onayEh: string;
    public onemDereceKod?: number;
    public ortalamaBitisTarih?: string;
    public planKod?: number;
    public sabitAlanKod?: number;
    public sabitTelefon?: string;
    public sonucAciklama?: string;
    public sonucFaxEh: string;
    public sonucMailEh: string;
    public sonucSmsEh: string;
    public sonucTarih?: string;
    public sonucTelEh: string;
    public sonucTurKod?: number;
    public sonucYaziliEh: string;
    public soyad?: string;
    public talepAciklama: string;
    public talepAciklamaSesPath?: string;
    public talepAdresSesPath?: string;
    public talepBinaKod?: number;
    public talepBlokNo?: string;
    public talepBolumKod?: number;
    public talepDaireNo?: string;
    public talepKapiNo?: number;
    public talepKapiNo1?: string;
    public talepKisaTarif?: string;
    public talepKisiSesPath?: string;
    public talepMahalleCaddeKod?: number;
    public talepSiteApartmanAd?: string;
    public tckn?: number;
    public unvani?: string;
    public arsBasvuruAnket: ArsBasvuruAnket;
    public arsBasvuruBirims: ArsBasvuruBirim[];
    public arsBasvuruGorusmes: ArsBasvuruGorusme[];
    public arsPlan?: ArsPlan;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKullanici?: GenKullanici;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genMahalleCaddeSokak1?: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public genTelAlanKodlari2?: GenTelAlanKodlari;

    public constructor(init?: Partial<ArsBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class ArsBirimKullanici extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gizliBasvuruGorsunEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public mailTuru: string;
    public smsTuru: string;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<ArsBirimKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class ArsKonuGrup extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public arsKonus: ArsKonu[];

    public constructor(init?: Partial<ArsKonuGrup>) { super(init); (Object as any).assign(this, init); }
}

export class ArsKonu extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimKod?: number;
    public cozumBirim?: string;
    public cozumSure?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public grupKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public webEh: string;
    public arsKonuBirims: ArsKonuBirim[];
    public arsKonuGrup?: ArsKonuGrup;

    public constructor(init?: Partial<ArsKonu>) { super(init); (Object as any).assign(this, init); }
}

export class ArsKonuBirim extends CommonEntityBase
{
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konuKod: number;
    public kullaniciKod: number;
    public arsKonu: ArsKonu;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<ArsKonuBirim>) { super(init); (Object as any).assign(this, init); }
}

export class GenBirimIletisim extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public birimAdres?: string;
    public birimEPosta?: string;
    public birimKod?: number;
    public birimWebAdres?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public faxAlanKod?: number;
    public faxNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public telAlanKod?: number;
    public telNo?: string;
    public yetkiliAdSoyad?: string;
    public yetkiliPersonelKod?: number;
    public yetkiliTelNo?: string;
    public yetkiliUnvani?: string;
    public genBirim?: GenBirim;

    public constructor(init?: Partial<GenBirimIletisim>) { super(init); (Object as any).assign(this, init); }
}

export class BysBirimKullaniciYetki extends CommonEntityBase
{
    public belediyeKod: number;
    public birimEvrakSorgulaEh?: string;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public guvenlikDurumu: number;
    public kalemEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public mailEh?: string;
    public servisKod?: number;
    public smsEh?: string;
    public genBirim: GenBirim;
    public genBirimIletisim?: GenBirimIletisim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<BysBirimKullaniciYetki>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeTakip extends CommonEntityBase
{
    public belgeAtamaEh?: string;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKlasorKod?: number;
    public kullaniciKod: number;
    public bysBelge: BysBelge;
    public bysKullaniciKlasor?: BysKullaniciKlasor;

    public constructor(init?: Partial<BysBelgeTakip>) { super(init); (Object as any).assign(this, init); }
}

export class BysKullaniciKlasor extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public klasorAdi?: string;
    public kod: number;
    public kullaniciKod?: number;
    public ustKod?: number;
    public bysBelgeTakips: BysBelgeTakip[];
    public bysKullaniciKlasors: BysKullaniciKlasor[];
    public genKullanici?: GenKullanici;

    public constructor(init?: Partial<BysKullaniciKlasor>) { super(init); (Object as any).assign(this, init); }
}

export class CmyAnketSoruCevap extends CommonEntityBase
{
    public ad: string;
    public agirlik?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruKod: number;
    public cmyAnketSoru: CmyAnketSoru;

    public constructor(init?: Partial<CmyAnketSoruCevap>) { super(init); (Object as any).assign(this, init); }
}

export class CmyAnketSoru extends CommonEntityBase
{
    public ad: string;
    public agirlik?: number;
    public anketKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruNo: number;
    public cmyAnket: CmyAnket;
    public cmyAnketSoruCevaps: CmyAnketSoruCevap[];

    public constructor(init?: Partial<CmyAnketSoru>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruSekli extends CommonEntityBase
{
    public ad: string;
    public aktifEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public onKontrolEh: string;
    public siralama?: number;
    public cmyBasvurus: CmyBasvuru[];
    public cmyParametres: CmyParametre[];

    public constructor(init?: Partial<CmyBasvuruSekli>) { super(init); (Object as any).assign(this, init); }
}

export class CmyParametre extends CommonEntityBase
{
    public adresKontrolTuru: string;
    public anketKod?: number;
    public belediyeKod: number;
    public belgeRootPath?: string;
    public bildirimOtomatikCevapEh: string;
    public cagriMerkezBirimKod?: number;
    public calismaPath?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dysServisAdres?: string;
    public ibbKonuKod?: number;
    public ibbKullanici?: string;
    public ibbKurumAdi?: string;
    public ibbKurumId?: string;
    public ibbSifre?: string;
    public icIletisimMailEh: string;
    public icIletisimSmsEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public talepOtoKapatEh?: string;
    public webBasvuruSekliKod?: number;
    public cmyAnket?: CmyAnket;
    public cmyBasvuruSekli?: CmyBasvuruSekli;
    public genBirim?: GenBirim;

    public constructor(init?: Partial<CmyParametre>) { super(init); (Object as any).assign(this, init); }
}

export class CmyAnket extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public cmyAnketSorus: CmyAnketSoru[];
    public cmyBasvuruAnkets: CmyBasvuruAnket[];
    public cmyParametres: CmyParametre[];

    public constructor(init?: Partial<CmyAnket>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruAnketCevap extends CommonEntityBase
{
    public anketKod: number;
    public basvuruAnketKod: number;
    public cevapKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dusunceler?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public soruKod: number;
    public cmyBasvuruAnket: CmyBasvuruAnket;
    public cmyAnketSoruCevap: CmyAnketSoruCevap;

    public constructor(init?: Partial<CmyBasvuruAnketCevap>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruAnket extends CommonEntityBase
{
    public anketKod: number;
    public basvuruKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gonderIpAdres?: string;
    public gonderMacAdres?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public cmyAnket: CmyAnket;
    public cmyBasvuru?: CmyBasvuru;
    public cmyBasvuruAnketCevaps: CmyBasvuruAnketCevap[];

    public constructor(init?: Partial<CmyBasvuruAnket>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruBelge extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public cmyBasvuru: CmyBasvuru;
    public genBelgeTip: GenBelgeTip;

    public constructor(init?: Partial<CmyBasvuruBelge>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruGorusme extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public belediyeKod: number;
    public birimAdi?: string;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorusmeTarih: string;
    public gorusulenAdi?: string;
    public gorusulenGorevi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public cmyBasvuru: CmyBasvuru;
    public genBirim?: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<CmyBasvuruGorusme>) { super(init); (Object as any).assign(this, init); }
}

export class CmyCagriAgent extends CommonEntityBase
{
    public ad: string;
    public agentId?: string;
    public agentKullaniciKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public cmyCagriDetays: CmyCagriDetay[];
    public genKullanici?: GenKullanici;

    public constructor(init?: Partial<CmyCagriAgent>) { super(init); (Object as any).assign(this, init); }
}

export class CmyCagriTur extends CommonEntityBase
{
    public ad?: string;
    public aktifEh?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siralama?: number;
    public cmyCagriDetays: CmyCagriDetay[];

    public constructor(init?: Partial<CmyCagriTur>) { super(init); (Object as any).assign(this, init); }
}

export class CmyCagriDetay extends CommonEntityBase
{
    public agentKod?: number;
    public baslangicTarih?: string;
    public belediyeKod: number;
    public bitisTarih?: string;
    public cagriAciklama?: string;
    public cagriKod: number;
    public cagriTurKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTuru?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sesKaydiPath?: string;
    public cmyBasvurus: CmyBasvuru[];
    public cmyCagri: CmyCagri;
    public cmyCagriAgent?: CmyCagriAgent;
    public cmyCagriTur?: CmyCagriTur;

    public constructor(init?: Partial<CmyCagriDetay>) { super(init); (Object as any).assign(this, init); }
}

export class CmyCagri extends CommonEntityBase
{
    public ad?: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public notlar?: string;
    public soyad?: string;
    public telAlanKod: number;
    public telNo: string;
    public unvani?: string;
    public cmyBasvurus: CmyBasvuru[];
    public cmyCagriDetays: CmyCagriDetay[];
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;
    public genTelAlanKodlari: GenTelAlanKodlari;

    public constructor(init?: Partial<CmyCagri>) { super(init); (Object as any).assign(this, init); }
}

export class CmyKonuBirim extends CommonEntityBase
{
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konuKod: number;
    public kullaniciKod: number;
    public mailGonderEh?: string;
    public smsGonderEh?: string;
    public cmyKonu: CmyKonu;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<CmyKonuBirim>) { super(init); (Object as any).assign(this, init); }
}

export class CmyKonuGrup extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public cmyKonus: CmyKonu[];

    public constructor(init?: Partial<CmyKonuGrup>) { super(init); (Object as any).assign(this, init); }
}

export class CmyKonuKullanici extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konuKod: number;
    public kullaniciKod: number;
    public mailGonderEh: string;
    public smsGonderEh: string;
    public cmyKonu: CmyKonu;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<CmyKonuKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class CmyKonu extends CommonEntityBase
{
    public ad: string;
    public aktifEh?: string;
    public belediyeKod: number;
    public cozumBirim?: string;
    public cozumSure?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public grupKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public otomatikYonlendirEh: string;
    public turu?: string;
    public webEh: string;
    public cmyBasvurus: CmyBasvuru[];
    public cmyKonuBirims: CmyKonuBirim[];
    public cmyKonuGrup?: CmyKonuGrup;
    public cmyKonuKullanicis: CmyKonuKullanici[];

    public constructor(init?: Partial<CmyKonu>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBirimIsTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBirim: GenBirim;

    public constructor(init?: Partial<CmyBirimIsTur>) { super(init); (Object as any).assign(this, init); }
}

export class CmyPlan extends CommonEntityBase
{
    public aciklama?: string;
    public ada?: number;
    public belediyeKod: number;
    public binaKod?: number;
    public birimKod: number;
    public blokNo?: string;
    public boy?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derinlik?: number;
    public en?: number;
    public eskiMuteahhitKisiKod?: number;
    public ihaleBedeli?: number;
    public ihaleNo?: string;
    public ihaleTarih?: string;
    public isAdi: string;
    public isTurKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod?: number;
    public muteahhitEh: string;
    public muteahhitKisiKod?: number;
    public onemDereceKod?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public planTarih: string;
    public siteApartmanAd?: string;
    public tahminiBaslangicTarih: string;
    public tahminiBitisTarih: string;
    public tamamlamaNotlari?: string;
    public tamamlamaTarih?: string;
    public tamamlandiEh: string;
    public cmyBasvurus: CmyBasvuru[];
    public cmyBasvuruBirims: CmyBasvuruBirim[];
    public genBirim: GenBirim;
    public genKisiEskiMuteahhit?: GenKisi;
    public genKisiMuteahhit?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public cmyBirimIsTur?: CmyBirimIsTur;

    public constructor(init?: Partial<CmyPlan>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruBirimDetay extends CommonEntityBase
{
    public basvuruBirimKod: number;
    public basvuruKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public sonucAciklama?: string;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public cmyBasvuruBirim: CmyBasvuruBirim;
    public cmySonucTur?: CmySonucTur;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<CmyBasvuruBirimDetay>) { super(init); (Object as any).assign(this, init); }
}

export class CmySonucTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public otomatikKapatEh: string;
    public planEh: string;
    public cmyBasvurus: CmyBasvuru[];
    public cmyBasvuruBirims: CmyBasvuruBirim[];
    public cmyBasvuruBirimDetays: CmyBasvuruBirimDetay[];

    public constructor(init?: Partial<CmySonucTur>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuru extends CommonEntityBase
{
    public ad?: string;
    public basvuruSekliKod: number;
    public basvuruTarih: string;
    public basvuruTuruKod?: number;
    public belediyeKod: number;
    public bimerNo?: number;
    public bimerTarih?: string;
    public cagriDetayKod?: number;
    public cagriKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eMail?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public gelenEvrakNo?: number;
    public gelenEvrakTarih?: string;
    public gizliEh: string;
    public gonderIpAdres?: string;
    public gonderMacAdres?: string;
    public gorusmeTurKod?: number;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public ibbBasvuruNo?: string;
    public ibbGelenGiden?: string;
    public ibbGuvenlikNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiBinaKod?: number;
    public kisiBlokNo?: string;
    public kisiBolumKod?: number;
    public kisiDaireNo?: string;
    public kisiKapiNo?: number;
    public kisiKapiNo1?: string;
    public kisiKod?: number;
    public kisiMahalleCaddeKod?: number;
    public kisiSiteApartmanAd?: string;
    public kod: number;
    public konuKod: number;
    public koordinatX?: number;
    public koordinatY?: number;
    public muhtarKod?: number;
    public onayEh: string;
    public onemDereceKod?: number;
    public ortalamaBitisTarih?: string;
    public planKod?: number;
    public sabitAlanKod?: number;
    public sabitTelefon?: string;
    public sonucAciklama?: string;
    public sonucFaxEh: string;
    public sonucKullaniciKod?: number;
    public sonucMailEh: string;
    public sonucSmsEh: string;
    public sonucTarih?: string;
    public sonucTelEh: string;
    public sonucTurKod?: number;
    public sonucYaziliEh: string;
    public soyad?: string;
    public status?: number;
    public talepAciklama: string;
    public talepAciklamaSesPath?: string;
    public talepAdresSesPath?: string;
    public talepBinaKod?: number;
    public talepBlokNo?: string;
    public talepBolumKod?: number;
    public talepDaireNo?: string;
    public talepKapiNo?: number;
    public talepKapiNo1?: string;
    public talepKisaTarif?: string;
    public talepKisiSesPath?: string;
    public talepMahalleCaddeKod?: number;
    public talepSiteApartmanAd?: string;
    public tckn?: number;
    public unvani?: string;
    public cmyBasvuruAnket: CmyBasvuruAnket;
    public cmyBasvuruBelges: CmyBasvuruBelge[];
    public cmyBasvuruBirims: CmyBasvuruBirim[];
    public cmyBasvuruGorusmes: CmyBasvuruGorusme[];
    public cmyBasvuruSekli: CmyBasvuruSekli;
    public cmyCagri?: CmyCagri;
    public cmyCagriDetay?: CmyCagriDetay;
    public cmyKonu: CmyKonu;
    public cmyPlan?: CmyPlan;
    public cmySonucTur?: CmySonucTur;
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genMahalleCaddeSokak1?: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public genTelAlanKodlari2?: GenTelAlanKodlari;

    public constructor(init?: Partial<CmyBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBasvuruBirim extends CommonEntityBase
{
    public basvuruKod: number;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formBasildiEh?: string;
    public isSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konuDegisNedeni?: string;
    public kullaniciKod: number;
    public planKod?: number;
    public sonucAciklama?: string;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public status?: number;
    public cmyBasvuru: CmyBasvuru;
    public cmyBasvuruBirimDetays: CmyBasvuruBirimDetay[];
    public cmyPlan?: CmyPlan;
    public cmySonucTur?: CmySonucTur;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<CmyBasvuruBirim>) { super(init); (Object as any).assign(this, init); }
}

export class CmyBirimKullanici extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gizliBasvuruGorsunEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public mailTuru: string;
    public smsTuru: string;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<CmyBirimKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class OmsHizmetEkipMahalle extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekipKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public mahalleKod?: number;
    public genMahalleKoy?: GenMahalleKoy;

    public constructor(init?: Partial<OmsHizmetEkipMahalle>) { super(init); (Object as any).assign(this, init); }
}

export class GenMahalleKoy extends CommonEntityBase
{
    public acilisTarihi?: string;
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilceKod?: number;
    public kapanisTarihi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public koyEh: string;
    public tuikMahalleKod?: number;
    public tuikTanitimNo?: number;
    public genIlce?: GenIlce;
    public genMahalleCaddeSokaks: GenMahalleCaddeSokak[];
    public omsHizmetEkipMahalles: OmsHizmetEkipMahalle[];

    public constructor(init?: Partial<GenMahalleKoy>) { super(init); (Object as any).assign(this, init); }
}

export class CmyMuhtar extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public mahalleKod: number;
    public sabitAlanKod?: number;
    public sabitTelefon?: string;
    public soyad: string;
    public tckn: number;
    public genKullanici: GenKullanici;
    public genMahalleKoy: GenMahalleKoy;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;

    public constructor(init?: Partial<CmyMuhtar>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimDosyaNumara extends CommonEntityBase
{
    public birimDosyaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public gasBirimDosya: GasBirimDosya;

    public constructor(init?: Partial<GasBirimDosyaNumara>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimDosyaOzelNo extends CommonEntityBase
{
    public birimDosyaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ozelDosyaKod: number;
    public yil: number;
    public gasBirimDosya: GasBirimDosya;
    public gasBirimDosyaOzel: GasBirimDosyaOzel;

    public constructor(init?: Partial<GasBirimDosyaOzelNo>) { super(init); (Object as any).assign(this, init); }
}

export class HisMahkeme extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimDosyaOzelKod?: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahkemeTurKod?: number;
    public gasBirimDosyaOzel?: GasBirimDosyaOzel;
    public genBirim?: GenBirim;
    public genKodDetay?: GenKodDetay;

    public constructor(init?: Partial<HisMahkeme>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimDosyaOzel extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimDosyaKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gasBirimDosya: GasBirimDosya;
    public gasBirimDosyaOzelNos: GasBirimDosyaOzelNo[];
    public gasDosyas: GasDosya[];
    public hisMahkemes: HisMahkeme[];

    public constructor(init?: Partial<GasBirimDosyaOzel>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimDosya extends CommonEntityBase
{
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod: string;
    public dosyaTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kontrolTuru: string;
    public ozelKodEh: string;
    public gasBirimDosyaBelges: GasBirimDosyaBelge[];
    public gasBirimDosyaNumaras: GasBirimDosyaNumara[];
    public gasBirimDosyaOzels: GasBirimDosyaOzel[];
    public gasBirimDosyaOzelNos: GasBirimDosyaOzelNo[];
    public genBirim: GenBirim;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<GasBirimDosya>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimDosyaBelge extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeTuruKod: number;
    public birimDosyaKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gasBirimDosya: GasBirimDosya;
    public genBelgeTuru: GenBelgeTuru;

    public constructor(init?: Partial<GasBirimDosyaBelge>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimDosyaYetki extends CommonEntityBase
{
    public belgeTuruKod: number;
    public birimDosyaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public yetkiEh: string;
    public genKullanici: GenKullanici;
    public gasBirimDosyaBelge?: GasBirimDosyaBelge;

    public constructor(init?: Partial<GasBirimDosyaYetki>) { super(init); (Object as any).assign(this, init); }
}

export class GasBirimKullaniciYetki extends CommonEntityBase
{
    public aktifEh: string;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public degistirEh: string;
    public kayitEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public silEh: string;
    public sorumluEh: string;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<GasBirimKullaniciYetki>) { super(init); (Object as any).assign(this, init); }
}

export class GenDinamikSorgu extends CommonEntityBase
{
    public ad?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public groupBy?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public param?: string;
    public sorgu: string;
    public uygulamalar?: string;
    public genDinamikSorguYetkis: GenDinamikSorguYetki[];

    public constructor(init?: Partial<GenDinamikSorgu>) { super(init); (Object as any).assign(this, init); }
}

export class GenDinamikSorguYetki extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public sorguKod: number;
    public genDinamikSorgu: GenDinamikSorgu;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<GenDinamikSorguYetki>) { super(init); (Object as any).assign(this, init); }
}

export class GenFormEntity extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public entityAd?: string;
    public formKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public testEh?: string;
    public testNot?: string;
    public genForm?: GenForm;

    public constructor(init?: Partial<GenFormEntity>) { super(init); (Object as any).assign(this, init); }
}

export class GenFormIslem extends CommonEntityBase
{
    public aktifYn?: number;
    public bStyle?: string;
    public bStylingMode?: string;
    public bTextVisibleYn?: number;
    public bType?: string;
    public bWitdh?: number;
    public dabNot?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKontrolYn?: number;
    public formKod?: number;
    public formYer?: string;
    public icon?: string;
    public islemAd?: string;
    public islemBaslik?: string;
    public islemDetay?: string;
    public islemTipi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public status?: number;
    public testEh?: string;
    public testNot?: string;
    public yetkiAd?: string;
    public genForm?: GenForm;

    public constructor(init?: Partial<GenFormIslem>) { super(init); (Object as any).assign(this, init); }
}

export class GenFormTest extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public testAd?: string;
    public testEh?: string;
    public testKod?: string;
    public testNot?: string;
    public genForm?: GenForm;

    public constructor(init?: Partial<GenFormTest>) { super(init); (Object as any).assign(this, init); }
}

export class GenFormYetki extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yetkiAciklama?: string;
    public yetkiAd: string;
    public yetkiTip: string;
    public genForm: GenForm;

    public constructor(init?: Partial<GenFormYetki>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullaniciMenuForm extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public pozisyonX: number;
    public pozisyonY: number;
    public genForm: GenForm;

    public constructor(init?: Partial<GenKullaniciMenuForm>) { super(init); (Object as any).assign(this, init); }
}

export class GenRaporLogDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kriterAd: string;
    public kriterDeger?: string;
    public raporLogKod: number;
    public genRaporLog: GenRaporLog;

    public constructor(init?: Partial<GenRaporLogDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GenRaporLog extends CommonEntityBase
{
    public belediyeKod: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public ipAdres?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporAd?: string;
    public genForm: GenForm;
    public genRaporLogDetays: GenRaporLogDetay[];

    public constructor(init?: Partial<GenRaporLog>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullaniciRol extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public rolKod: number;
    public genKullanici: GenKullanici;
    public genRol: GenRol;

    public constructor(init?: Partial<GenKullaniciRol>) { super(init); (Object as any).assign(this, init); }
}

export class GenRolFormYetki extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuAnaKod: number;
    public rolKod: number;
    public yetkiAd: string;
    public yetkiTur: string;
    public genForm: GenForm;
    public genRol: GenRol;
    public genFormYetki?: GenFormYetki;
    public genRolForm?: GenRolForm;

    public constructor(init?: Partial<GenRolFormYetki>) { super(init); (Object as any).assign(this, init); }
}

export class GenRol extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formAciklama?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public url?: string;
    public genKullaniciRols: GenKullaniciRol[];
    public genRolForms: GenRolForm[];
    public genRolFormYetkis: GenRolFormYetki[];

    public constructor(init?: Partial<GenRol>) { super(init); (Object as any).assign(this, init); }
}

export class GenRolForm extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuAnaKod: number;
    public rolKod: number;
    public genForm: GenForm;
    public genRol: GenRol;

    public constructor(init?: Partial<GenRolForm>) { super(init); (Object as any).assign(this, init); }
}

export class GenSikKullanilan extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public otomatikAcEh?: string;
    public genForm: GenForm;

    public constructor(init?: Partial<GenSikKullanilan>) { super(init); (Object as any).assign(this, init); }
}

export class GenForm extends CommonEntityBase
{
    public anaDlistAd?: string;
    public anaEntityAd?: string;
    public appUrl?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formAciklama: string;
    public formAd: string;
    public formAppAd?: string;
    public formTipi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public url: string;
    public genFavoris: GenFavori[];
    public genFormEntities: GenFormEntity[];
    public genFormIslems: GenFormIslem[];
    public genFormTests: GenFormTest[];
    public genFormYetkis: GenFormYetki[];
    public genKullaniciMenuForms: GenKullaniciMenuForm[];
    public genRaporLogs: GenRaporLog[];
    public genRolForms: GenRolForm[];
    public genRolFormYetkis: GenRolFormYetki[];
    public genSikKullanilans: GenSikKullanilan[];

    public constructor(init?: Partial<GenForm>) { super(init); (Object as any).assign(this, init); }
}

export class GenFavori extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod?: number;
    public icon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public url?: string;
    public genForm?: GenForm;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<GenFavori>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullaniciErisim extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public erisimKontrolTuru: string;
    public ipAdres?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public makinaAd?: string;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<GenKullaniciErisim>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullaniciYazici extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public modulKod: number;
    public turu: string;
    public yaziciAdi: string;
    public genKullanici: GenKullanici;
    public genModul: GenModul;

    public constructor(init?: Partial<GenKullaniciYazici>) { super(init); (Object as any).assign(this, init); }
}

export class GysGelirYetki extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iconUrl?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public modulKod: number;
    public genKullanici: GenKullanici;
    public genModul: GenModul;

    public constructor(init?: Partial<GysGelirYetki>) { super(init); (Object as any).assign(this, init); }
}

export class IkaBirimKullanici extends CommonEntityBase
{
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public genBirim: GenBirim;
    public genKullanici: GenKullanici;

    public constructor(init?: Partial<IkaBirimKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscDonemKazanc extends CommonEntityBase
{
    public aktarEh: string;
    public carpan?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public hizliPuanSira?: number;
    public katsayi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public sgkAsgariOran?: number;
    public sgkAsgariTuru?: string;
    public yuvarlamaSekli?: string;
    public ikaIscDonem: IkaIscDonem;
    public ikaIscKazanc: IkaIscKazanc;

    public constructor(init?: Partial<IkaIscDonemKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscDonemKesinti extends CommonEntityBase
{
    public aktarEh: string;
    public carpan?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public hesapKod?: string;
    public hizliPuanSira?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiKod: number;
    public kod: number;
    public netMaasKesEh?: string;
    public sabitTutar?: number;
    public yuvarlamaSekli?: string;
    public ikaIscDonem: IkaIscDonem;
    public ikaIscKesinti: IkaIscKesinti;

    public constructor(init?: Partial<IkaIscDonemKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class IkaHuzurDonem extends CommonEntityBase
{
    public asgariUcretTutar?: number;
    public ay: number;
    public baslamaTarih: string;
    public belediyeKod: number;
    public bitisTarih: string;
    public damgaHesapEh: string;
    public damgaHesapKod?: string;
    public damgaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemAd: string;
    public encumenTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancHesapKod?: string;
    public kod: number;
    public meclisTutar?: number;
    public stajyerTutar?: number;
    public turu: string;
    public vergiHesapEh: string;
    public vergiHesapKod?: string;
    public vergiMatrah1?: number;
    public vergiMatrah2?: number;
    public vergiMatrah3?: number;
    public vergiMatrah4?: number;
    public vergiMatrah5?: number;
    public vergiOran1?: number;
    public vergiOran2?: number;
    public vergiOran3?: number;
    public vergiOran4?: number;
    public vergiOran5?: number;
    public yil: number;
    public ikaHuzurMaas: IkaHuzurMaas[];

    public constructor(init?: Partial<IkaHuzurDonem>) { super(init); (Object as any).assign(this, init); }
}

export class IkaHuzurMaas extends CommonEntityBase
{
    public agiEh: string;
    public agiTutar?: number;
    public belediyeKod: number;
    public damgaVergi?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public gelirVergi?: number;
    public gorevBirimKod: number;
    public gunlukTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public matrah?: number;
    public netOdenen?: number;
    public personelKod: number;
    public puan?: number;
    public turu: string;
    public genBirim: GenBirim;
    public ikaHuzurDonem: IkaHuzurDonem;
    public ikaMaasMuhasebes: IkaMaasMuhasebe[];
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaHuzurMaas>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemDonemHesap extends CommonEntityBase
{
    public artisKisiHesapKod?: string;
    public artisKurumHesapKod?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public emekliGsspKurumHesapKod?: string;
    public emekliGsspKurumKHesapKod?: string;
    public emekliKisiHesapKod?: string;
    public emekliKurumHesapKod?: string;
    public emekliKurumKHesapKod?: string;
    public gAidatKisiHesapKod?: string;
    public gAidatKurumHesapKod?: string;
    public gAidatKurumKHesapKod?: string;
    public gssKisiHesapKod?: string;
    public gssKurumHesapKod?: string;
    public gssKurumKHesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kVadeKisiHesapKod?: string;
    public kVadeKurumHesapKod?: string;
    public kVadeKurumKHesapKod?: string;
    public myoKisiHesapKod?: string;
    public myoKurumHesapKod?: string;
    public myoKurumKHesapKod?: string;
    public personelTurKod: number;
    public ikaMemDonem: IkaMemDonem;
    public ikaPersonelTur: IkaPersonelTur;

    public constructor(init?: Partial<IkaMemDonemHesap>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemDonemKazanc extends CommonEntityBase
{
    public aktarEh: string;
    public carpan?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public katsayi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public yuvarlamaSekli?: string;
    public ikaMemDonem: IkaMemDonem;
    public ikaMemKazanc: IkaMemKazanc;

    public constructor(init?: Partial<IkaMemDonemKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemSendika extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public dayanismaKesintiKod?: number;
    public dayanismaOran: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public sendikaKesintiKod?: number;
    public sendikaOran: number;
    public telAlanKod?: number;
    public telTelefon?: string;
    public genKisi?: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public ikaMemDonemKatsayis: IkaMemDonemKatsayi[];
    public ikaMemKesinti?: IkaMemKesinti;
    public ikaMemKesinti1?: IkaMemKesinti;
    public ikaMemMaasSicils: IkaMemMaasSicil[];
    public ikaMemMaasSicils1: IkaMemMaasSicil[];
    public ikaMemSendikaKazancs: IkaMemSendikaKazanc[];
    public ikaPersonelMemurs: IkaPersonelMemur[];
    public ikaPersonelMemurs1: IkaPersonelMemur[];

    public constructor(init?: Partial<IkaMemSendika>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemSendikaKazanc extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public sendikaKod: number;
    public ikaMemKazanc: IkaMemKazanc;
    public ikaMemSendika: IkaMemSendika;

    public constructor(init?: Partial<IkaMemSendikaKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelMemurKazanc extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public katsayi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public personelKod: number;
    public puan?: number;
    public ikaMemKazanc: IkaMemKazanc;
    public ikaPersonelMemur: IkaPersonelMemur;

    public constructor(init?: Partial<IkaPersonelMemurKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemKazanc extends CommonEntityBase
{
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinEh: string;
    public emekliHesapEh: string;
    public hesapSekli: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancAd: string;
    public kazancTuru: string;
    public kefaletEh: string;
    public kod: number;
    public netOdemeEh: string;
    public siraNo: number;
    public vekaletEh: string;
    public vergiHesapEh: string;
    public ikaMemDonemKatsayis: IkaMemDonemKatsayi[];
    public ikaMemDonemKazancs: IkaMemDonemKazanc[];
    public ikaMemSendikaKazancs: IkaMemSendikaKazanc[];
    public ikaPersonelMemurKazancs: IkaPersonelMemurKazanc[];

    public constructor(init?: Partial<IkaMemKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemDonemKatsayi extends CommonEntityBase
{
    public agiAsgariTutar?: number;
    public aileTutar?: number;
    public asgariUcretTutar?: number;
    public asgDamgaIndirimTutar?: number;
    public asgVergiIndirimTutar?: number;
    public brutKazancKod?: number;
    public cocukPuan1?: number;
    public cocukPuan2?: number;
    public damgaHesapKod?: string;
    public damgaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dengeKesinti1Kod?: number;
    public dengeKesinti1Tutar?: number;
    public dengeKesinti2Kod?: number;
    public dengeKesinti2Tutar?: number;
    public dengeSendikaKod?: number;
    public devletMemurAyligi?: number;
    public disiplinKesintiKod?: number;
    public donemKod: number;
    public eGosterge1?: number;
    public eGosterge2?: number;
    public eGosterge3?: number;
    public eGosterge4?: number;
    public eGosterge5?: number;
    public eGosterge6?: number;
    public eGosterge7?: number;
    public emekliGsspKurumOran?: number;
    public emekliKisiOran?: number;
    public emekliKurumOran?: number;
    public eOran1?: number;
    public eOran2?: number;
    public eOran3?: number;
    public eOran4?: number;
    public eOran5?: number;
    public eOran6?: number;
    public eOran7?: number;
    public girisAidatOran?: number;
    public gssKisiOran?: number;
    public gssKurumOran?: number;
    public ilacKesintiKod?: number;
    public indirimA?: number;
    public indirimB?: number;
    public indirimC?: number;
    public indirimD?: number;
    public indirimE?: number;
    public indirimF?: number;
    public indirimG?: number;
    public indirimH?: number;
    public indirimI?: number;
    public indirimJ?: number;
    public itfaiyeMesaiTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletBesAy?: number;
    public kefaletDigerAy?: number;
    public kefaletKesintiKod?: number;
    public kidemPuan1?: number;
    public kidemPuan2?: number;
    public kisaVadeKisiOran?: number;
    public kisaVadeKurumOran?: number;
    public kod: number;
    public maasKatsayi?: number;
    public myoKisiOran?: number;
    public myoKurumOran?: number;
    public netKazancKod?: number;
    public sakatlik1?: number;
    public sakatlik2?: number;
    public sakatlik3?: number;
    public sYemekTutar1?: number;
    public sYemekTutar2?: number;
    public sYemekTutar3?: number;
    public sYemekTutar4?: number;
    public tabanAylikKatsayi?: number;
    public tedaviKesintiKod?: number;
    public vergiHesapKod?: string;
    public vergiMatrah1?: number;
    public vergiMatrah2?: number;
    public vergiMatrah3?: number;
    public vergiMatrah4?: number;
    public vergiMatrah5?: number;
    public vergiMatrah6?: number;
    public vergiOran1?: number;
    public vergiOran2?: number;
    public vergiOran3?: number;
    public vergiOran4?: number;
    public vergiOran5?: number;
    public vergiOran6?: number;
    public yanOdemeKatsayi?: number;
    public yemekKesintiKod?: number;
    public yGosterge1?: number;
    public yGosterge2?: number;
    public yGosterge3?: number;
    public yGosterge4?: number;
    public yGosterge5?: number;
    public yGosterge6?: number;
    public yTutar1?: number;
    public yTutar2?: number;
    public yTutar3?: number;
    public yTutar4?: number;
    public yTutar5?: number;
    public yTutar6?: number;
    public yuvarlamaDilimi?: number;
    public zabitaMesaiTutar?: number;
    public ikaMemDonem: IkaMemDonem;
    public ikaMemKazanc?: IkaMemKazanc;
    public ikaMemKesinti?: IkaMemKesinti;
    public ikaMemKesinti1?: IkaMemKesinti;
    public ikaMemKesinti2?: IkaMemKesinti;
    public ikaMemKesinti3?: IkaMemKesinti;
    public ikaMemKesinti4?: IkaMemKesinti;
    public ikaMemKesinti5?: IkaMemKesinti;
    public ikaMemKesinti6?: IkaMemKesinti;
    public ikaMemSendika?: IkaMemSendika;

    public constructor(init?: Partial<IkaMemDonemKatsayi>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemDonemKesinti extends CommonEntityBase
{
    public aktarEh: string;
    public carpan?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiKod: number;
    public kod: number;
    public netMaasKesEh: string;
    public sabitTutar?: number;
    public yuvarlamaSekli?: string;
    public ikaMemDonem: IkaMemDonem;
    public ikaMemKesinti: IkaMemKesinti;

    public constructor(init?: Partial<IkaMemDonemKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemDonem extends CommonEntityBase
{
    public anaDonemKod?: number;
    public araziEh?: string;
    public ay: number;
    public baslamaTarih: string;
    public belediyeKod: number;
    public bitisTarih: string;
    public calismaGun?: number;
    public damgaPulHesapEh: string;
    public damgaPulYSekli?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemAd: string;
    public donemSifre: string;
    public donemTuru: string;
    public emekliHesapEh: string;
    public emekliTuru: string;
    public emekliYSekli?: string;
    public fiiliHizmetSekli?: string;
    public intibakKisiKesKod?: number;
    public intibakKurumKesKod?: number;
    public islemTarih: string;
    public kapandiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sgkKesintiBaslamaTarih?: string;
    public sgkKesintiBitisTarih?: string;
    public siraNo: number;
    public sozlesmeEh?: string;
    public sozlesmeUygulamaSekli?: string;
    public vergiHesapEh: string;
    public vergiYil: number;
    public vergiYSekli?: string;
    public webYayinEh?: string;
    public yil: number;
    public anaIkaMemDonem?: IkaMemDonem;
    public ikaMemDonems: IkaMemDonem[];
    public ikaMemDonemHesaps: IkaMemDonemHesap[];
    public ikaMemDonemKatsayi: IkaMemDonemKatsayi;
    public ikaMemDonemKazancs: IkaMemDonemKazanc[];
    public ikaMemDonemKesintis: IkaMemDonemKesinti[];
    public ikaMemKesinti?: IkaMemKesinti;
    public ikaMemKesinti1?: IkaMemKesinti;
    public ikaMemMaasSicils: IkaMemMaasSicil[];

    public constructor(init?: Partial<IkaMemDonem>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemMaasKesintiDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiKod: number;
    public kesintiTutar?: number;
    public kod: number;
    public personelKesintiKod: number;
    public personelKod: number;
    public ikaPersonelMemurKesinti: IkaPersonelMemurKesinti;
    public ikaMemDonemKesinti: IkaMemDonemKesinti;
    public ikaMemMaasSicil: IkaMemMaasSicil;

    public constructor(init?: Partial<IkaMemMaasKesintiDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelMemurKesinti extends CommonEntityBase
{
    public aciklama?: string;
    public alacakli?: string;
    public anaParaTutar?: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKapandiEh: string;
    public dosyaNo?: string;
    public evrakNo?: number;
    public faizTutar?: number;
    public gelisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefil?: string;
    public kesintiKod: number;
    public kesintiOran?: number;
    public kesintiSekli: string;
    public kesintiTuru: string;
    public kesintiTutar?: number;
    public kod: number;
    public personelKod: number;
    public siraNo?: number;
    public taahhutEh: string;
    public toplamTutar?: number;
    public ikaMemKesinti: IkaMemKesinti;
    public ikaMemMaasKesintiDetays: IkaMemMaasKesintiDetay[];
    public ikaPersonelMemur?: IkaPersonelMemur;

    public constructor(init?: Partial<IkaPersonelMemurKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemKesinti extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hesapSekli: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiAd: string;
    public kesintiTuru: string;
    public kod: number;
    public siraNo: number;
    public vergiDusEh: string;
    public ikaMemBesFirmas: IkaMemBesFirma[];
    public ikaMemDonems: IkaMemDonem[];
    public ikaMemDonems1: IkaMemDonem[];
    public ikaMemDonemKatsayis: IkaMemDonemKatsayi[];
    public ikaMemDonemKatsayis1: IkaMemDonemKatsayi[];
    public ikaMemDonemKatsayis2: IkaMemDonemKatsayi[];
    public ikaMemDonemKatsayis3: IkaMemDonemKatsayi[];
    public ikaMemDonemKatsayis4: IkaMemDonemKatsayi[];
    public ikaMemDonemKatsayis5: IkaMemDonemKatsayi[];
    public ikaMemDonemKatsayis6: IkaMemDonemKatsayi[];
    public ikaMemDonemKesintis: IkaMemDonemKesinti[];
    public ikaMemSendikas: IkaMemSendika[];
    public ikaMemSendikas1: IkaMemSendika[];
    public ikaPersonelMemurKesintis: IkaPersonelMemurKesinti[];

    public constructor(init?: Partial<IkaMemKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemBesFirma extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public besKesintiKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public telAlanKod?: number;
    public telTelefon?: string;
    public genKisi?: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public ikaMemKesinti?: IkaMemKesinti;
    public ikaMemMaasSicils: IkaMemMaasSicil[];
    public ikaPersonelMemurs: IkaPersonelMemur[];

    public constructor(init?: Partial<IkaMemBesFirma>) { super(init); (Object as any).assign(this, init); }
}

export class EksKararUye extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikTurKod?: number;
    public imzaEh: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public uyeKod: number;
    public eksDevamsizlikTur?: EksDevamsizlikTur;
    public eksKarar: EksKarar;
    public eksUye: EksUye;

    public constructor(init?: Partial<EksKararUye>) { super(init); (Object as any).assign(this, init); }
}

export class EksDevamsizlikTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public eksGundemDetayUyes: EksGundemDetayUye[];
    public eksKararUyes: EksKararUye[];

    public constructor(init?: Partial<EksDevamsizlikTur>) { super(init); (Object as any).assign(this, init); }
}

export class EksGundem extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gundemNo: string;
    public gundemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public eksGundemDetays: EksGundemDetay[];

    public constructor(init?: Partial<EksGundem>) { super(init); (Object as any).assign(this, init); }
}

export class EksGundemDetay extends CommonEntityBase
{
    public aciklama?: string;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakHavaleTarih?: string;
    public evrakNo?: number;
    public evrakTarih?: string;
    public gundemKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konusu?: string;
    public siraNo: number;
    public sonucTurKod?: number;
    public eksGundem: EksGundem;
    public genBirim: GenBirim;
    public genKodDetay?: GenKodDetay;

    public constructor(init?: Partial<EksGundemDetay>) { super(init); (Object as any).assign(this, init); }
}

export class EksGundemDetayUye extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikTurKod?: number;
    public gundemKod: number;
    public gundemSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public uyeKod: number;
    public eksDevamsizlikTur?: EksDevamsizlikTur;
    public eksUye: EksUye;
    public eksGundemDetay?: EksGundemDetay;

    public constructor(init?: Partial<EksGundemDetayUye>) { super(init); (Object as any).assign(this, init); }
}

export class EksUye extends CommonEntityBase
{
    public adSoyad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevi?: string;
    public imzaEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public rolAd?: string;
    public siraNo?: number;
    public ucret?: number;
    public unvanKod?: number;
    public uyeBaslangicTarih: string;
    public uyeSonucAciklama?: string;
    public uyeSonucTarih?: string;
    public eksGundemDetayUyes: EksGundemDetayUye[];
    public eksKararUyes: EksKararUye[];
    public ikaPersonel?: IkaPersonel;
    public ikaUnvan?: IkaUnvan;
    public genOrganizasyon?: GenOrganizasyon;

    public constructor(init?: Partial<EksUye>) { super(init); (Object as any).assign(this, init); }
}

export class GenRaporImza extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporAciklama: string;
    public raporAdi: string;
    public genRaporImzaDetays: GenRaporImzaDetay[];

    public constructor(init?: Partial<GenRaporImza>) { super(init); (Object as any).assign(this, init); }
}

export class GenRaporImzaDetay extends CommonEntityBase
{
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevAd?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public paramDegeri?: string;
    public parametre?: string;
    public personelKod?: number;
    public raporImzaKod: number;
    public siraNo: number;
    public turu?: string;
    public unvanKod?: number;
    public genRaporImza: GenRaporImza;

    public constructor(init?: Partial<GenRaporImzaDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscKadroDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iptalNo?: string;
    public iptalTarih?: string;
    public kadroBirimKod: number;
    public kadroKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public tayinTarih: string;
    public genBirim: GenBirim;
    public ikaIscKadro: IkaIscKadro;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaIscKadroDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscKadro extends CommonEntityBase
{
    public adet: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iptalNo?: string;
    public iptalTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public unvanKod: number;
    public ikaIscKadroDetays: IkaIscKadroDetay[];
    public ikaUnvan: IkaUnvan;

    public constructor(init?: Partial<IkaIscKadro>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscKadroIhdas extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meclisKararNo: string;
    public meclisKararTarih: string;
    public notlar?: string;
    public turu: number;
    public ikaIscKadroIhdasDetays: IkaIscKadroIhdasDetay[];

    public constructor(init?: Partial<IkaIscKadroIhdas>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscKadroIhdasDetay extends CommonEntityBase
{
    public adet?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gerekce?: string;
    public kadroKod: number;
    public kaldirAdet?: number;
    public kaldirUnvanKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public unvanKod: number;
    public ikaIscKadroIhdas: IkaIscKadroIhdas;
    public ikaUnvan?: IkaUnvan;
    public ikaUnvan1: IkaUnvan;

    public constructor(init?: Partial<IkaIscKadroIhdasDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaKadroIhdas extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kadroTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meclisKararNo: string;
    public meclisKararTarih: string;
    public notlar?: string;
    public turu: number;
    public ikaKadroIhdasDetays: IkaKadroIhdasDetay[];

    public constructor(init?: Partial<IkaKadroIhdas>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemKadroDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iptalNo?: string;
    public iptalTarih?: string;
    public kadroBirimKod: number;
    public kadroKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public tayinTarih: string;
    public genBirim: GenBirim;
    public ikaMemKadro: IkaMemKadro;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaMemKadroDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemKadro extends CommonEntityBase
{
    public adet: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece: number;
    public iptalNo?: string;
    public iptalTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public sinifKod: number;
    public unvanKod: number;
    public ikaMemKadroDetays: IkaMemKadroDetay[];
    public ikaSinif: IkaSinif;
    public ikaUnvan: IkaUnvan;

    public constructor(init?: Partial<IkaMemKadro>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemKadroIhdas extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meclisKararNo: string;
    public meclisKararTarih: string;
    public notlar?: string;
    public turu: number;
    public ikaMemKadroIhdasDetays: IkaMemKadroIhdasDetay[];

    public constructor(init?: Partial<IkaMemKadroIhdas>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemKadroIhdasDetay extends CommonEntityBase
{
    public adet: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece: number;
    public kadroKod: number;
    public kaldirAdet?: number;
    public kaldirDerece?: number;
    public kaldirSinifKod?: number;
    public kaldirUnvanKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sinifKod: number;
    public unvanKod: number;
    public ikaMemKadroIhdas: IkaMemKadroIhdas;
    public ikaSinif?: IkaSinif;
    public ikaSinif1: IkaSinif;
    public ikaUnvan?: IkaUnvan;
    public ikaUnvan1: IkaUnvan;

    public constructor(init?: Partial<IkaMemKadroIhdasDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIzinTurSureIsci extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public limit: number;
    public sure: number;
    public ikaIzinTur: IkaIzinTur;

    public constructor(init?: Partial<IkaIzinTurSureIsci>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIzinTurSureMemur extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public limit: number;
    public sure: number;
    public ikaIzinTur: IkaIzinTur;

    public constructor(init?: Partial<IkaIzinTurSureMemur>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIzinTurSureSozlesme extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public limit: number;
    public sure: number;
    public ikaIzinTur: IkaIzinTur;

    public constructor(init?: Partial<IkaIzinTurSureSozlesme>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelIzin extends CommonEntityBase
{
    public baslangicTarih: string;
    public belediyeKod: number;
    public belgeNo?: string;
    public bitisTarih: string;
    public definYeri?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iseBaslamaTarih?: string;
    public izinAdres?: string;
    public izinTurKod: number;
    public izinVerenPersonelKod?: number;
    public izinVerenRolAd?: string;
    public izinYil?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public onayVerenPersonelKod?: number;
    public onayVerenRolAd?: string;
    public personelKod: number;
    public personelRolAd?: string;
    public personelTuru: string;
    public raporNo?: string;
    public raporVerenKurum?: string;
    public sefPersonelKod?: number;
    public sefRolAd?: string;
    public sehirDisiEh: string;
    public sure?: number;
    public vekilPersonelKod?: number;
    public vekilRolAd?: string;
    public yakinlikNot?: string;
    public yolSuresi?: number;
    public ikaIzinTur: IkaIzinTur;
    public ikaPersonel: IkaPersonel;
    public ikaPersonelIzınVeren?: IkaPersonel;
    public ikaPersonelOnayVeren?: IkaPersonel;
    public ikaPersonelSef?: IkaPersonel;
    public ikaPersonelVekil?: IkaPersonel;
    public izinVerenOrganizasyonRol?: GenOrganizasyonRol;
    public onayVerenOrganizasyonRol?: GenOrganizasyonRol;
    public personelOrganizasyonRol?: GenOrganizasyonRol;
    public sefOrganizasyonRol?: GenOrganizasyonRol;
    public vekilOrganizasyonRol?: GenOrganizasyonRol;

    public constructor(init?: Partial<IkaPersonelIzin>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIzinTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hizmetGunDusEh: string;
    public isciCtesiDahilEh: string;
    public isciPazarDahilEh: string;
    public isciTatilDahilEh: string;
    public izinRaporAdi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public maxIzinGunu?: number;
    public memurCtesiDahilEh: string;
    public memurPazarDahilEh: string;
    public memurTatilDahilEh: string;
    public raporIzinEh: string;
    public sirketCtesiDahilEh?: string;
    public sirketPazarDahilEh?: string;
    public sirketTatilDahilEh?: string;
    public turu?: number;
    public yillikIzinEh: string;
    public ikaIzinTurSureIscis: IkaIzinTurSureIsci[];
    public ikaIzinTurSureMemurs: IkaIzinTurSureMemur[];
    public ikaIzinTurSureSozlesmes: IkaIzinTurSureSozlesme[];
    public ikaParametres: IkaParametre[];
    public ikaPersonelIzins: IkaPersonelIzin[];

    public constructor(init?: Partial<IkaIzinTur>) { super(init); (Object as any).assign(this, init); }
}

export class IkaParametre extends CommonEntityBase
{
    public arsivEh: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod?: string;
    public hitapKullaniciAd?: string;
    public hitapKullaniciSifre?: string;
    public hitapUrl?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mesaiLimit?: number;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public raporIzinTurKod?: number;
    public terfiHizmetKod?: number;
    public genBirim?: GenBirim;
    public ikaHizmetSebep?: IkaHizmetSebep;
    public ikaIzinTur?: IkaIzinTur;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<IkaParametre>) { super(init); (Object as any).assign(this, init); }
}

export class IkaHizmetSebep extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ikaParametres: IkaParametre[];
    public ikaPersonelHizmets: IkaPersonelHizmet[];

    public constructor(init?: Partial<IkaHizmetSebep>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelHizmet extends CommonEntityBase
{
    public aciklama?: string;
    public adaylikSure?: number;
    public aylikDerece?: number;
    public aylikEkGosterge?: number;
    public aylikKademe?: number;
    public baslamaTarih?: string;
    public birimKod?: number;
    public bitisTarih?: string;
    public dayanak?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public emekDerece?: number;
    public emekEkGosterge?: number;
    public emekKademe?: number;
    public gorevYeri: string;
    public hizmetSebepKod: number;
    public hizmetSinifKod?: number;
    public kadroDerece?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazanDerece?: number;
    public kazanEkGosterge?: number;
    public kazanKademe?: number;
    public kidemYil?: number;
    public kod: number;
    public kurumOnayTarih?: string;
    public onayPersonelKod?: number;
    public onayRolAd?: string;
    public personelKod: number;
    public teklifPersonelKod?: number;
    public teklifRolAd?: string;
    public ucret?: number;
    public ugorenPersonelKod?: number;
    public ugorenRolAd?: string;
    public unvanKod: number;
    public yevmiye?: number;
    public yururlukTarih?: string;
    public genBirim?: GenBirim;
    public ikaHizmetSebep: IkaHizmetSebep;
    public ikaPersonel: IkaPersonel;
    public ikaPersonel_?: IkaPersonel;
    public ikaPersonel__?: IkaPersonel;
    public ikaPersonel___?: IkaPersonel;
    public ikaSinif?: IkaSinif;
    public ikaUnvan: IkaUnvan;

    public constructor(init?: Partial<IkaPersonelHizmet>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelRol extends CommonEntityBase
{
    public aktifEh: string;
    public atamaSekliKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevBaslamaTarih: string;
    public gorevBitisTarih?: string;
    public gorevTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public rolAd: string;
    public sinifKod: number;
    public unvanKod: number;
    public genKodDetay?: GenKodDetay;
    public ikaPersonel: IkaPersonel;
    public ikaSinif: IkaSinif;
    public ikaUnvan: IkaUnvan;
    public genOrganizasyon?: GenOrganizasyon;

    public constructor(init?: Partial<IkaPersonelRol>) { super(init); (Object as any).assign(this, init); }
}

export class PysKadroDerece extends CommonEntityBase
{
    public ad?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pysUnvanDetays: PysUnvanDetay[];

    public constructor(init?: Partial<PysKadroDerece>) { super(init); (Object as any).assign(this, init); }
}

export class PysKodAna extends CommonEntityBase
{
    public adi: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hitapKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBelediye: GenBelediye;
    public pysKodDetays: PysKodDetay[];

    public constructor(init?: Partial<PysKodAna>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajOkulKod extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tur: string;
    public pysStajOkulKodDetays: PysStajOkulKodDetay[];

    public constructor(init?: Partial<PysStajOkulKod>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajOkulKodDetay extends CommonEntityBase
{
    public aciklama: string;
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stajOkulKod: number;
    public pysKodDetay: PysKodDetay;
    public pysStajOkulKod: PysStajOkulKod;

    public constructor(init?: Partial<PysStajOkulKodDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PysTaseronFirma extends CommonEntityBase
{
    public aciklama?: string;
    public adres: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public firmaAdi: string;
    public firmaKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public vergiNo?: string;
    public genBelediye: GenBelediye;
    public genKisi?: GenKisi;
    public pysTaseronFirmaSozlesmes: PysTaseronFirmaSozlesme[];

    public constructor(init?: Partial<PysTaseronFirma>) { super(init); (Object as any).assign(this, init); }
}

export class StsIhaleBelge extends CommonEntityBase
{
    public belgeNo?: string;
    public belgeTarih?: string;
    public belgeTurKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ihaleKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public genBelgeTuru: GenBelgeTuru;
    public stsIhale: StsIhale;

    public constructor(init?: Partial<StsIhaleBelge>) { super(init); (Object as any).assign(this, init); }
}

export class GysVezneTahsilTur extends CommonEntityBase
{
    public defaultEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tahsilatTurKod: number;
    public vezneKod: number;
    public gysTahsilatTur: GysTahsilatTur;
    public gysVezne: GysVezne;

    public constructor(init?: Partial<GysVezneTahsilTur>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsilatTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public nakitEh: string;
    public gysHavaleTurleris: GysHavaleTurleri[];
    public gysTahsilAnas: GysTahsilAna[];
    public gysVezneTahsilTurs: GysVezneTahsilTur[];

    public constructor(init?: Partial<GysTahsilatTur>) { super(init); (Object as any).assign(this, init); }
}

export class GysHavaleTurleri extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public emanetHesapKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tahsilatTurKod?: number;
    public vezneKod?: number;
    public gysTahsilatTur?: GysTahsilatTur;
    public gysVezne?: GysVezne;

    public constructor(init?: Partial<GysHavaleTurleri>) { super(init); (Object as any).assign(this, init); }
}

export class GysMakbuzZimmet extends CommonEntityBase
{
    public aciklama?: string;
    public ciltNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iadeTarihi?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public makbuzBaslamaNo: number;
    public makbuzBitisNo: number;
    public makbuzNo: number;
    public makbuzSeri: string;
    public makbuzTipi: number;
    public vezneKod: number;
    public zimmetTarihi: string;
    public gysVezne: GysVezne;

    public constructor(init?: Partial<GysMakbuzZimmet>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsilIptal extends CommonEntityBase
{
    public belediyeKod?: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod?: number;
    public donem?: number;
    public ekVergiEh?: string;
    public gecikmeKod?: number;
    public gelirKod?: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public makbuzNo?: number;
    public modulKod?: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public seriNo?: string;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukYeniEh?: string;
    public tahsilGecikmeFaiz?: number;
    public tahsilGecikmeZammi?: number;
    public tahsilIptalAnaKod: number;
    public tahsilTarih?: string;
    public tahsilVergi?: number;
    public takipliEh?: string;
    public taksitKod?: number;
    public vadeTarih?: string;
    public vezneKod?: number;
    public yil?: number;
    public gysTahsilAnaIptal: GysTahsilAnaIptal;

    public constructor(init?: Partial<GysTahsilIptal>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsilAnaIptal extends CommonEntityBase
{
    public aciklama?: string;
    public bankaOnayNo?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecikmeZammi?: number;
    public havaleNo?: string;
    public havaleTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public krediAdSoyad?: string;
    public krediTckn?: number;
    public krediVergiNo?: string;
    public makbuzNo: number;
    public seriNo: string;
    public tahsilatTurKod?: number;
    public tahsilIptalAciklama?: string;
    public tahsilIptalKod?: number;
    public tahsilTarih: string;
    public tahsilTutar?: number;
    public taksitAnaKod?: number;
    public taksitNo?: number;
    public toplamTutar?: number;
    public vezneKod: number;
    public genKisi: GenKisi;
    public gysTahsilIptals: GysTahsilIptal[];
    public gysVezne: GysVezne;

    public constructor(init?: Partial<GysTahsilAnaIptal>) { super(init); (Object as any).assign(this, init); }
}

export class GysVezneKullanici extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: string;
    public vezneKod: number;
    public gysVezne: GysVezne;
    public genKullanici?: GenKullanici;

    public constructor(init?: Partial<GysVezneKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class GysVezneModul extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public modulKod: number;
    public vezneKod: number;
    public genModul: GenModul;
    public gysVezne: GysVezne;

    public constructor(init?: Partial<GysVezneModul>) { super(init); (Object as any).assign(this, init); }
}

export class SasAboneAciklama extends CommonEntityBase
{
    public aboneAciklamaKod?: number;
    public aboneKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevliPersonel?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public genKodDetay?: GenKodDetay;
    public sasAbone: SasAbone;

    public constructor(init?: Partial<SasAboneAciklama>) { super(init); (Object as any).assign(this, init); }
}

export class SasAboneEndex extends CommonEntityBase
{
    public aboneKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public endeks: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sasAbone: SasAbone;

    public constructor(init?: Partial<SasAboneEndex>) { super(init); (Object as any).assign(this, init); }
}

export class SasBankaHata extends CommonEntityBase
{
    public aboneKod: number;
    public bankaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public tahsilTarih: string;
    public tutar?: number;
    public yil: number;
    public genBanka: GenBanka;
    public genKisi: GenKisi;
    public sasAbone: SasAbone;

    public constructor(init?: Partial<SasBankaHata>) { super(init); (Object as any).assign(this, init); }
}

export class SasAssTarifeDetay extends CommonEntityBase
{
    public assTarifeKod: number;
    public carpanEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapTuru: number;
    public ilkLimit: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public muafHesapEh: string;
    public siraNo: number;
    public sonLimit: number;
    public tutarOran: number;
    public gysGelirDetay: GysGelirDetay;
    public sasAssTarife: SasAssTarife;

    public constructor(init?: Partial<SasAssTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasOdemeTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gun: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sasSozlesmes: SasSozlesme[];

    public constructor(init?: Partial<SasOdemeTur>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacOkumaLimit extends CommonEntityBase
{
    public birimFiyat: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sarfiyat: number;
    public sayacOkumaDetayKod: number;
    public sayacOkumaKod: number;
    public siraNo: number;
    public tutar: number;
    public sasSayacOkuma: SasSayacOkuma;
    public sasSayacOkumaDetay: SasSayacOkumaDetay;

    public constructor(init?: Partial<SasSayacOkumaLimit>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacOkumaDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sayacOkumaKod: number;
    public suGelirKod: number;
    public sasGelir: SasGelir;
    public sasSayacOkuma: SasSayacOkuma;
    public sasSayacOkumaLimits: SasSayacOkumaLimit[];

    public constructor(init?: Partial<SasSayacOkumaDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacTerkinLimit extends CommonEntityBase
{
    public birimFiyat: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sarfiyat: number;
    public sayacTerkinDetayKod: number;
    public sayacTerkinKod: number;
    public siraNo: number;
    public tutar: number;
    public sasSayacTerkin: SasSayacTerkin;
    public sasSayacTerkinDetay: SasSayacTerkinDetay;

    public constructor(init?: Partial<SasSayacTerkinLimit>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacTerkinDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sayacTerkinKod: number;
    public suGelirKod: number;
    public sasGelir: SasGelir;
    public sasSayacTerkin: SasSayacTerkin;
    public sasSayacTerkinLimits: SasSayacTerkinLimit[];

    public constructor(init?: Partial<SasSayacTerkinDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasDonemDetay extends CommonEntityBase
{
    public aciklama: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemDetayNo: number;
    public donemKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sasDonem: SasDonem;

    public constructor(init?: Partial<SasDonemDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasDonem extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public donemKapatildiEh: string;
    public ilkAy: number;
    public kacAy: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sifre?: string;
    public yil: number;
    public sasDonemDetays: SasDonemDetay[];

    public constructor(init?: Partial<SasDonem>) { super(init); (Object as any).assign(this, init); }
}

export class SasTarife extends CommonEntityBase
{
    public belediyeKod: number;
    public bolgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public gecikmeZammiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public maxKullanim?: number;
    public minKullanim?: number;
    public muafTuru?: number;
    public ortalamaHesapSekli: string;
    public ortalamaMinM3?: number;
    public sarfiyatMuafM3?: number;
    public sayacBozukKullanim?: number;
    public tarifeTurKod: number;
    public uyariSeviye?: number;
    public yil: number;
    public sasBolge: SasBolge;
    public sasTarifeDetays: SasTarifeDetay[];
    public sasTarifeTur: SasTarifeTur;
    public sasDonem?: SasDonem;

    public constructor(init?: Partial<SasTarife>) { super(init); (Object as any).assign(this, init); }
}

export class SasTarifeDetayLimit extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sarfiyat: number;
    public siraNo: number;
    public tarifeDetayKod: number;
    public tutar: number;
    public sasTarifeDetay: SasTarifeDetay;

    public constructor(init?: Partial<SasTarifeDetayLimit>) { super(init); (Object as any).assign(this, init); }
}

export class SasTarifeDetay extends CommonEntityBase
{
    public aboneCarpanEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemSayisiCarpEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sarfiyatVarsaEh: string;
    public suGelirKod: number;
    public tarifeKod: number;
    public tutarOran?: number;
    public ustTarifeEh: string;
    public sasGelir: SasGelir;
    public sasTarife: SasTarife;
    public sasTarifeDetayLimits: SasTarifeDetayLimit[];

    public constructor(init?: Partial<SasTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasGelir extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapSekli: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ozelEh: string;
    public suUcretiEh: string;
    public turu?: string;
    public gysGelirDetay: GysGelirDetay;
    public sasSayacOkumaDetays: SasSayacOkumaDetay[];
    public sasSayacTerkinDetays: SasSayacTerkinDetay[];
    public sasSozlesmeDetays: SasSozlesmeDetay[];
    public sasTarifeDetays: SasTarifeDetay[];

    public constructor(init?: Partial<SasGelir>) { super(init); (Object as any).assign(this, init); }
}

export class SasSozlesmeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sozlesmeKod: number;
    public suGelirKod: number;
    public tutarOran?: number;
    public sasGelir: SasGelir;
    public sasSozlesme: SasSozlesme;

    public constructor(init?: Partial<SasSozlesmeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasSozlesme extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public daskBaslangicTarih?: string;
    public daskBitisTarih?: string;
    public daskPoliceNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public iptalTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kiraciAd?: string;
    public kiraciSoyad?: string;
    public kisiKod: number;
    public kod: number;
    public muafiyetM3?: number;
    public notlar?: string;
    public odemeTurKod?: number;
    public sozlesmeDurumu?: string;
    public sozlesmeIptalTarih?: string;
    public sozlesmeTarih: string;
    public sozlesmeTurKod?: number;
    public tarifeTurKod: number;
    public genKisi: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public sasAbone: SasAbone;
    public sasOdemeTur?: SasOdemeTur;
    public sasSozlesmeDetays: SasSozlesmeDetay[];
    public sasTarifeTur: SasTarifeTur;

    public constructor(init?: Partial<SasSozlesme>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacAcma extends CommonEntityBase
{
    public aboneKod: number;
    public acildiEh: string;
    public acmaNotlar?: string;
    public acmaTarih?: string;
    public aparatKirildiEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilekceTarih?: string;
    public eskiKisiKod?: number;
    public gorevAciklama?: string;
    public gorevPersonelKod?: number;
    public isEmriTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public sayacKesmeKod: number;
    public sozlesmeTarih: string;
    public genKisi?: GenKisi;
    public ikaPersonel?: IkaPersonel;
    public sasSayacKesme: SasSayacKesme;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacAcma>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacKesmeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sayacKesmeKod: number;
    public sayacOkumaKod: number;
    public tutar: number;
    public sasSayacKesme: SasSayacKesme;
    public sasSayacOkuma: SasSayacOkuma;

    public constructor(init?: Partial<SasSayacKesmeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacKesme extends CommonEntityBase
{
    public aboneKod: number;
    public aparatTakildiEh: string;
    public belediyeKod: number;
    public borcToplam?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilekceTarih?: string;
    public eskiKisiKod?: number;
    public gorevAciklama?: string;
    public gorevPersonelKod?: number;
    public isEmriTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesildiEh: string;
    public kesimEndeksi?: number;
    public kesimTarih?: string;
    public kesmeAciklama?: string;
    public kesmeTurKod: number;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public sozlesmeTarih: string;
    public genKisi?: GenKisi;
    public ikaPersonel?: IkaPersonel;
    public sasKesmeTur: SasKesmeTur;
    public sasSayacAcmas: SasSayacAcma[];
    public sasSayacKesmeDetays: SasSayacKesmeDetay[];
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacKesme>) { super(init); (Object as any).assign(this, init); }
}

export class SasKesmeTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public borcEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sasParametres: SasParametre[];
    public sasSayacKesmes: SasSayacKesme[];

    public constructor(init?: Partial<SasKesmeTur>) { super(init); (Object as any).assign(this, init); }
}

export class SasParametre extends CommonEntityBase
{
    public aboneOtomatikEh: string;
    public aboneUcretTurKod?: number;
    public adresKontrolTuru: string;
    public anaGelirKod?: number;
    public arsivEh: string;
    public assBorcKontrolTuru?: string;
    public assMuafKontrolEh?: string;
    public avsYuvarlamaGelirKod?: number;
    public bankaBilgi?: string;
    public belediyeKod: number;
    public birimKod?: number;
    public borcKesmeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod?: string;
    public fazlaGelirKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public sozlesmeKontrolTuru?: string;
    public teminatGelirKod?: number;
    public vadeGun: number;
    public vadeUygulamaSekli?: string;
    public vergiDairesi?: string;
    public vergiNo?: string;
    public genBirim?: GenBirim;
    public genModul: GenModul;
    public gysGelirDetay?: GysGelirDetay;
    public gysGelirDetay1?: GysGelirDetay;
    public gysGelirDetay2?: GysGelirDetay;
    public gysGelirDetay3?: GysGelirDetay;
    public sasKesmeTur?: SasKesmeTur;
    public sasUcretTur?: SasUcretTur;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<SasParametre>) { super(init); (Object as any).assign(this, init); }
}

export class SasUcretTahakkuk extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public endeks?: number;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public sozlesmeTarih: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public ucretTurKod?: number;
    public yil: number;
    public genKisi?: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;
    public sasUcretTur?: SasUcretTur;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasUcretTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class SasUcretTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tutarOran?: number;
    public ucretTarifeKod: number;
    public gysGelirDetay: GysGelirDetay;
    public sasUcretTarife: SasUcretTarife;

    public constructor(init?: Partial<SasUcretTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasUcretTarife extends CommonEntityBase
{
    public belediyeKod: number;
    public bolgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tarifeTurKod: number;
    public ucretTurKod: number;
    public yil: number;
    public sasBolge: SasBolge;
    public sasTarifeTur: SasTarifeTur;
    public sasUcretTarifeDetays: SasUcretTarifeDetay[];
    public sasUcretTur: SasUcretTur;

    public constructor(init?: Partial<SasUcretTarife>) { super(init); (Object as any).assign(this, init); }
}

export class SasUcretTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sasGeciciKapatmas: SasGeciciKapatma[];
    public sasParametres: SasParametre[];
    public sasUcretTahakkuks: SasUcretTahakkuk[];
    public sasUcretTarives: SasUcretTarife[];

    public constructor(init?: Partial<SasUcretTur>) { super(init); (Object as any).assign(this, init); }
}

export class SasGeciciKapatma extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public carpan?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public sonTarih: string;
    public sozlesmeTarih: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public tarifeTurKod: number;
    public ucretTurKod?: number;
    public yil: number;
    public genKisi?: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;
    public sasTarifeTur: SasTarifeTur;
    public sasUcretTur?: SasUcretTur;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasGeciciKapatma>) { super(init); (Object as any).assign(this, init); }
}

export class SasTarifeTur extends CommonEntityBase
{
    public ad: string;
    public bankayaGonderEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public grupKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mobilAktarEh: string;
    public ortakAboneEh: string;
    public genKodDetay?: GenKodDetay;
    public sasAssTarives: SasAssTarife[];
    public sasGeciciKapatmas: SasGeciciKapatma[];
    public sasSayacOkumas: SasSayacOkuma[];
    public sasSozlesmes: SasSozlesme[];
    public sasTarives: SasTarife[];
    public sasUcretTarives: SasUcretTarife[];

    public constructor(init?: Partial<SasTarifeTur>) { super(init); (Object as any).assign(this, init); }
}

export class SasAssTarife extends CommonEntityBase
{
    public belediyeKod: number;
    public bolgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tarifeTurKod: number;
    public yil: number;
    public sasAssTarifeDetays: SasAssTarifeDetay[];
    public sasBolge: SasBolge;
    public sasTarifeTur: SasTarifeTur;

    public constructor(init?: Partial<SasAssTarife>) { super(init); (Object as any).assign(this, init); }
}

export class SasMobil extends CommonEntityBase
{
    public adSoyad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilkEndexGorEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod?: number;
    public makbuz?: number;
    public ortEndexGirEh: string;
    public otoAboneGecisEh: string;
    public otoFaturaCekEh: string;
    public sayacOkumaSilEh: string;
    public sasMobilDetays: SasMobilDetay[];

    public constructor(init?: Partial<SasMobil>) { super(init); (Object as any).assign(this, init); }
}

export class SasMobilDetay extends CommonEntityBase
{
    public baslaSayfaNo?: number;
    public baslaSiraNo?: number;
    public belediyeKod: number;
    public bitisSayfaNo?: number;
    public bitisSiraNo?: number;
    public defterKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mobilKod: number;
    public okumaSiraNo?: number;
    public sasDefter: SasDefter;
    public sasMobil: SasMobil;

    public constructor(init?: Partial<SasMobilDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasDefter extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public bolgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public ikaPersonel?: IkaPersonel;
    public sasAbones: SasAbone[];
    public sasBolge: SasBolge;
    public sasMobilDetays: SasMobilDetay[];
    public sasSayacOkumas: SasSayacOkuma[];

    public constructor(init?: Partial<SasDefter>) { super(init); (Object as any).assign(this, init); }
}

export class SasBolge extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public ikaPersonel?: IkaPersonel;
    public sasAbones: SasAbone[];
    public sasAssTarives: SasAssTarife[];
    public sasDefters: SasDefter[];
    public sasSayacOkumas: SasSayacOkuma[];
    public sasTarives: SasTarife[];
    public sasUcretTarives: SasUcretTarife[];

    public constructor(init?: Partial<SasBolge>) { super(init); (Object as any).assign(this, init); }
}

export class SasHatBaglanti extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hatAciklama: string;
    public hatAd: string;
    public hatCap?: number;
    public hatDerinlik?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ustKod?: number;
    public sasAbones: SasAbone[];
    public ustSasHatBaglanti?: SasHatBaglanti;
    public sasHatBaglantis: SasHatBaglanti[];

    public constructor(init?: Partial<SasHatBaglanti>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacDurum extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public endexIlerleEh: string;
    public hesapTuru: string;
    public katiAtikEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public raporEh: string;
    public siviAtikEh: string;
    public sonrakiSayacDurumKod?: number;
    public turu: number;
    public sasAbones: SasAbone[];
    public sonrakiSasSayacDurum?: SasSayacDurum;
    public sasSayacDurums: SasSayacDurum[];
    public sasSayacOkumas: SasSayacOkuma[];

    public constructor(init?: Partial<SasSayacDurum>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacMuayene extends CommonEntityBase
{
    public aboneKod: number;
    public anmaYuku?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilekceTarih?: string;
    public eskiKisiKod?: number;
    public girisCapi?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public okumaEndeks?: number;
    public sayacDamgaYili?: number;
    public sayacMarkaKod?: number;
    public sayacMarkaModel?: string;
    public sayacSeriNo?: string;
    public sokmeEndeks?: number;
    public sonucTarih?: string;
    public sozlesmeTarih: string;
    public genKisi?: GenKisi;
    public sasSayacMarkaYer?: SasSayacMarkaYer;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacMuayene>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacTakma extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public gorevPersonelKod?: number;
    public isEmriTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public sayacCapi?: number;
    public sayacCarpan?: number;
    public sayacDamgaYili?: number;
    public sayacKartNo?: string;
    public sayacMarkaKod?: number;
    public sayacMarkaModel?: string;
    public sayacMuhurNo?: number;
    public sayacMuhurTarih?: string;
    public sayacOdemeSekli?: number;
    public sayacSeriNo?: string;
    public sayacSokmeKod?: number;
    public sayacTakildiEh: string;
    public sayacTuru?: number;
    public sayacYeriKod?: number;
    public sozlesmeTarih: string;
    public takmaAciklama?: string;
    public takmaEndeksi?: number;
    public takmaTarih?: string;
    public takmaTurKod?: number;
    public genKisi?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public sasSayacMarkaYer?: SasSayacMarkaYer;
    public sasSayacMarkaYer1?: SasSayacMarkaYer;
    public sasSayacSokme?: SasSayacSokme;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacTakma>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacSokme extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public gorevPersonelKod?: number;
    public isEmriTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public sayacCapi?: number;
    public sayacCarpan?: number;
    public sayacDamgaYili?: number;
    public sayacKartNo?: string;
    public sayacMarkaKod?: number;
    public sayacMarkaModel?: string;
    public sayacMuhurNo?: number;
    public sayacMuhurTarih?: string;
    public sayacOdemeSekli?: number;
    public sayacSeriNo?: string;
    public sayacSokulduEh: string;
    public sayacTuru?: number;
    public sayacYeriKod?: number;
    public sokmeAciklama?: string;
    public sokmeEndeksi?: number;
    public sokmeTarih?: string;
    public sokmeTurKod: number;
    public sozlesmeTarih: string;
    public genKisi?: GenKisi;
    public genKodDetay: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public sasSayacMarkaYer?: SasSayacMarkaYer;
    public sasSayacMarkaYer1?: SasSayacMarkaYer;
    public sasSayacTakmas: SasSayacTakma[];
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacSokme>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacMarkaYer extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public markaTuru?: number;
    public turu: string;
    public sasAbones: SasAbone[];
    public sasAbones1: SasAbone[];
    public sasSayacMuayenes: SasSayacMuayene[];
    public sasSayacSokmes: SasSayacSokme[];
    public sasSayacSokmes1: SasSayacSokme[];
    public sasSayacTakmas: SasSayacTakma[];
    public sasSayacTakmas1: SasSayacTakma[];

    public constructor(init?: Partial<SasSayacMarkaYer>) { super(init); (Object as any).assign(this, init); }
}

export class SasAbone extends CommonEntityBase
{
    public aboneNo: number;
    public acilisTarih?: string;
    public ada?: number;
    public alan?: number;
    public barkodNo?: string;
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolgeKod: number;
    public bolumKod?: number;
    public daireNo?: string;
    public defterKod: number;
    public degisenSayacEndeks?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiAboneNo?: number;
    public eskiMalikKisiKod?: number;
    public hatBaglantiKod?: number;
    public iptalTarih?: string;
    public isyeriSayi?: number;
    public kanalBaglantiNo?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konutSayi?: number;
    public kullanimAdi?: string;
    public kullanimTurKod?: number;
    public mahalleCaddeKod: number;
    public malikKisiKod?: number;
    public notlar?: string;
    public ortakAboneKod?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public sayacCapi?: number;
    public sayacCarpan: number;
    public sayacDamgaYili?: number;
    public sayacKartNo?: string;
    public sayacMarkaKod?: number;
    public sayacMarkaModel?: string;
    public sayacMuhurNo?: number;
    public sayacMuhurTarih?: string;
    public sayacOdemeSekli?: number;
    public sayacSeriNo?: string;
    public sayacTuru: number;
    public sayacYeriKod?: number;
    public sayfaNo: number;
    public siraNo?: number;
    public siteApartmanAd?: string;
    public sonEndeks?: number;
    public sonOkumaDurumKod?: number;
    public sonOkumaTarih?: string;
    public sonOrtalamaEndeks?: number;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public gasDosyas: GasDosya[];
    public genBinaKullanim?: GenBinaKullanim;
    public genKisiEskiMalik?: GenKisi;
    public genKisiMalik?: GenKisi;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;
    public ortakSasAbone?: SasAbone;
    public sasAbones: SasAbone[];
    public sasAboneAciklamas: SasAboneAciklama[];
    public sasAboneEndices: SasAboneEndex[];
    public sasBankaHatas: SasBankaHata[];
    public sasBankaTalimats: SasBankaTalimat[];
    public sasBankaTalimatReds: SasBankaTalimatRed[];
    public sasBolge: SasBolge;
    public sasDefter: SasDefter;
    public sasHatBaglanti?: SasHatBaglanti;
    public sasSayacDurum?: SasSayacDurum;
    public sasSayacMarkaYer?: SasSayacMarkaYer;
    public sasSayacMarkaYer1?: SasSayacMarkaYer;
    public sasSozlesmes: SasSozlesme[];

    public constructor(init?: Partial<SasAbone>) { super(init); (Object as any).assign(this, init); }
}

export class SasBankaTalimatRed extends CommonEntityBase
{
    public aboneKod: number;
    public bankaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public redBankaKod: number;
    public genKisi?: GenKisi;
    public genKisi_: GenKisi;
    public sasAbone: SasAbone;
    public sasBanka: SasBanka;
    public sasBanka_: SasBanka;

    public constructor(init?: Partial<SasBankaTalimatRed>) { super(init); (Object as any).assign(this, init); }
}

export class SasBanka extends CommonEntityBase
{
    public ad: string;
    public bankaKodu: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisaAd: string;
    public kod: number;
    public kurumKodu: string;
    public vezneKod?: number;
    public genBelediye: GenBelediye;
    public gysVezne?: GysVezne;
    public sasBankaTalimatReds: SasBankaTalimatRed[];
    public sasBankaTalimatReds_: SasBankaTalimatRed[];

    public constructor(init?: Partial<SasBanka>) { super(init); (Object as any).assign(this, init); }
}

export class TemDefterKullanici extends CommonEntityBase
{
    public defterKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public genKullanici: GenKullanici;
    public temDefterTur: TemDefterTur;

    public constructor(init?: Partial<TemDefterKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class TemDefterTur extends CommonEntityBase
{
    public ad?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turu: string;
    public temDefterKullanicis: TemDefterKullanici[];
    public temHesaps: TemHesap[];

    public constructor(init?: Partial<TemDefterTur>) { super(init); (Object as any).assign(this, init); }
}

export class TebDonem extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public yil1Oran?: number;
    public yil2Oran?: number;

    public constructor(init?: Partial<TebDonem>) { super(init); (Object as any).assign(this, init); }
}

export class TemHesap extends CommonEntityBase
{
    public ad: string;
    public anaHesapKod?: string;
    public bankaHesapKod?: string;
    public bankaIbanNo?: string;
    public bankaKodu?: string;
    public bankaMusteriNo?: string;
    public bankaSubeAdi?: string;
    public bankaSubeKodu?: string;
    public belediyeKod: number;
    public defterKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirEh: string;
    public donem: number;
    public ekonomikKod?: string;
    public hesapBakiyeTuru?: string;
    public hesapKod: string;
    public hesapTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kbsHesapKod?: string;
    public kisiHesapEh: string;
    public kod: number;
    public ustKod?: number;
    public temDefterTur?: TemDefterTur;
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TemHesap>) { super(init); (Object as any).assign(this, init); }
}

export class TemTeslimat extends CommonEntityBase
{
    public aciklama?: string;
    public bankaDekontNo?: string;
    public bankaDekontTarih?: string;
    public belediyeKod: number;
    public ciltNo: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public fisKod?: number;
    public hesapKod: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public ozelNo: number;
    public siraNo: number;
    public teslimEden: string;
    public teslimTutar?: number;
    public vezneKod?: number;
    public genKisi?: GenKisi;
    public gysVezne?: GysVezne;
    public temFis?: TemFis;
    public temHesap?: TemHesap;

    public constructor(init?: Partial<TemTeslimat>) { super(init); (Object as any).assign(this, init); }
}

export class GysVezne extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public haftaSonuCalismaEh: string;
    public icraTahsilatiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public makbuzBaslamaNo: number;
    public makbuzBitisNo: number;
    public makbuzCekilsinEh: string;
    public makbuzNo?: number;
    public makbuzOtomatikEh: string;
    public seriNo: string;
    public sifre?: string;
    public sorguTuru?: number;
    public tarihMudaheleEh: string;
    public turu?: number;
    public tutarDuzeltEh: string;
    public vezneAd: string;
    public vezneGorev: string;
    public vezneKapamaSaat?: string;
    public vezneKod: number;
    public yaziciAd?: string;
    public yetkiGunu?: number;
    public genBankas: GenBanka[];
    public gysHavaleTurleris: GysHavaleTurleri[];
    public gysMakbuzZimmets: GysMakbuzZimmet[];
    public gysTahsils: GysTahsil[];
    public gysTahsilAnas: GysTahsilAna[];
    public gysTahsilAnaIptals: GysTahsilAnaIptal[];
    public gysVezneKullanicis: GysVezneKullanici[];
    public gysVezneModuls: GysVezneModul[];
    public gysVezneTahsilTurs: GysVezneTahsilTur[];
    public sasBankas: SasBanka[];
    public temAlindiBelges: TemAlindiBelge[];
    public temTeslimats: TemTeslimat[];

    public constructor(init?: Partial<GysVezne>) { super(init); (Object as any).assign(this, init); }
}

export class TemAlindiBelgeDetay extends CommonEntityBase
{
    public alindiKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public siraNo: number;
    public tutar?: number;
    public temAlindiBelge: TemAlindiBelge;

    public constructor(init?: Partial<TemAlindiBelgeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TemAlindiBelge extends CommonEntityBase
{
    public adSoyadUnvan: string;
    public alindiNo: number;
    public alindiTeslimNo?: string;
    public alindiTeslimTarih?: string;
    public alindiTuru: string;
    public bankasi?: string;
    public belediyeKod: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public fisKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public notlar?: string;
    public sebebi?: string;
    public sure?: string;
    public tahsilTarih?: string;
    public tckn?: number;
    public vezneKod?: number;
    public genKisi?: GenKisi;
    public gysVezne?: GysVezne;
    public temAlindiBelgeDetays: TemAlindiBelgeDetay[];
    public temFis: TemFis;
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TemAlindiBelge>) { super(init); (Object as any).assign(this, init); }
}

export class TemDuzeltmeDefter extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public fisKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public hesapKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public siraNo?: string;
    public tahakGercekTutar?: number;
    public tahakIadeTutar?: number;
    public tahakTutar?: number;
    public tahsilTutar?: number;
    public thsBelgeNo?: string;
    public thsBelgeTarih?: string;
    public genKisi: GenKisi;
    public temFis: TemFis;
    public temHesap?: TemHesap;

    public constructor(init?: Partial<TemDuzeltmeDefter>) { super(init); (Object as any).assign(this, init); }
}

export class TemBankaAlacak extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public fisDetayKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public hesapKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kimeOdendigi?: string;
    public kisiKod?: number;
    public kod: number;
    public odemeNo?: string;
    public odemeTuru: string;
    public odenenNo?: string;
    public odenenParaSiraNo?: number;
    public odenenTarih?: string;
    public odenenTutar?: number;
    public tutar?: number;
    public genKisi?: GenKisi;
    public temFisDetay: TemFisDetay;

    public constructor(init?: Partial<TemBankaAlacak>) { super(init); (Object as any).assign(this, init); }
}

export class TemBankaBorc extends CommonEntityBase
{
    public bankaAlindiNo?: string;
    public bankaAlindiTarih?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public fisDetayKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public hesapKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public neredenGeldigi?: string;
    public notlar?: string;
    public tutar?: number;
    public genKisi?: GenKisi;
    public temFisDetay: TemFisDetay;

    public constructor(init?: Partial<TemBankaBorc>) { super(init); (Object as any).assign(this, init); }
}

export class TebKurumSinif extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public fax?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvMukellefEh: string;
    public kod: number;
    public kurumsalKod: string;
    public odenekKontrolEh: string;
    public tel?: string;
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TebKurumSinif>) { super(init); (Object as any).assign(this, init); }
}

export class TemDefterKarsi extends CommonEntityBase
{
    public adet?: number;
    public adSoyadUnvan?: string;
    public bankaSubesi?: string;
    public belediyeKod: number;
    public belgeNo?: string;
    public belgeTarih?: string;
    public cinsNitelik?: string;
    public defterSiraNo: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerTutar?: number;
    public donem: number;
    public eskiKisiKod?: number;
    public fisDetayKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public gecerlilikTarih?: string;
    public hesapKod: string;
    public karsiDefterKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public kurumsalKod: string;
    public nakitTutar?: number;
    public neden?: string;
    public terkinTutar?: number;
    public tutar?: number;
    public genKisi?: GenKisi;
    public temDefter: TemDefter;
    public temFisDetay: TemFisDetay;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemDefterKarsi>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaahhutBorc extends CommonEntityBase
{
    public adSoyad: string;
    public alacakTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaNo: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public odenenTutar?: number;
    public siraNo: number;
    public taahhutKod: number;
    public temTaahhut: TemTaahhut;

    public constructor(init?: Partial<TemTaahhutBorc>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaahhutTaahhut extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirButcesiEh: string;
    public fisDetayKod: number;
    public iptalEdilenOdenek?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taahhutKod: number;
    public taahhutTuru?: string;
    public taahhutTutar: number;
    public taahhutTutar1?: number;
    public taahhutTutar2?: number;
    public taahhutTutar3?: number;
    public taahhutTutar4?: number;
    public temFisDetay: TemFisDetay;
    public temTaahhut: TemTaahhut;

    public constructor(init?: Partial<TemTaahhutTaahhut>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaahhutTeminat extends CommonEntityBase
{
    public aciklama?: string;
    public defterKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taahhutKod: number;
    public temDefter: TemDefter;
    public temTaahhut: TemTaahhut;

    public constructor(init?: Partial<TemTaahhutTeminat>) { super(init); (Object as any).assign(this, init); }
}

export class TebFinansman extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public finansmanKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TebFinansman>) { super(init); (Object as any).assign(this, init); }
}

export class TebFonksiyon extends CommonEntityBase
{
    public ad: string;
    public anaKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public fonksiyonelKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TebFonksiyon>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaahhut extends CommonEntityBase
{
    public adres?: string;
    public adSoyadUnvan: string;
    public baslamaTarih?: string;
    public belediyeKod: number;
    public bitirmeTarih?: string;
    public damgaAlindiNo?: string;
    public damgaAlindiTutar?: number;
    public damgaTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerEkonomikKod?: string;
    public donem: number;
    public dptOnayNo?: string;
    public edEkoGiderKod?: string;
    public edFinansmanKod?: string;
    public edFonksiyonelKod?: string;
    public edHesapKod?: string;
    public edKurumsalKod?: string;
    public ekoGiderKod: string;
    public eskiKisiKod?: number;
    public finansmanKod: string;
    public fonksiyonelKod: string;
    public geciciKabulTarih?: string;
    public ihaleBedel?: number;
    public ihaleNo?: string;
    public ihaleTarih?: string;
    public indirimOran?: number;
    public kararNo?: string;
    public kararTarih?: string;
    public kararTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesifBedel: number;
    public kisiKod?: number;
    public kod: number;
    public konu: string;
    public kurumsalKod: string;
    public projeSiraNo?: string;
    public sozlesmeTarih?: string;
    public sureUzatim1?: number;
    public sureUzatim2?: number;
    public sureUzatim3?: number;
    public sureUzatimTarih1?: string;
    public sureUzatimTarih2?: string;
    public sureUzatimTarih3?: string;
    public taahhutIptal?: number;
    public taahhutNo: number;
    public taahhutToplam?: number;
    public genKisi?: GenKisi;
    public temBirimFis: TemBirimFis[];
    public temFis: TemFis[];
    public temTaahhutAvans: TemTaahhutAvans[];
    public temTaahhutBorcs: TemTaahhutBorc[];
    public temTaahhutTaahhuts: TemTaahhutTaahhut[];
    public temTaahhutTeminats: TemTaahhutTeminat[];
    public edTebFinansman?: TebFinansman;
    public tebFinansman?: TebFinansman;
    public edTebFonksiyon?: TebFonksiyon;
    public tebFonksiyon?: TebFonksiyon;
    public edTebKurumSinif?: TebKurumSinif;
    public tebKurumSinif?: TebKurumSinif;
    public edTemHesap?: TemHesap;

    public constructor(init?: Partial<TemTaahhut>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaahhutAvans extends CommonEntityBase
{
    public aciklama?: string;
    public defterKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taahhutKod: number;
    public temDefter: TemDefter;
    public temTaahhut: TemTaahhut;

    public constructor(init?: Partial<TemTaahhutAvans>) { super(init); (Object as any).assign(this, init); }
}

export class TemDefter extends CommonEntityBase
{
    public adres?: string;
    public adSoyadUnvan?: string;
    public bankaSubesi?: string;
    public belediyeKod: number;
    public belgeCinsi?: string;
    public belgeNo?: string;
    public belgeTarih?: string;
    public defterSiraNo: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerTutar?: number;
    public donem: number;
    public eskiKisiKod?: number;
    public fisDetayKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public gecerlilikTarih?: string;
    public hesapKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public kuponAdet?: number;
    public kuponTutar?: number;
    public kurumsalKod: string;
    public neden?: string;
    public tahsilDigerTutar?: number;
    public tahsilTutar?: number;
    public tutar?: number;
    public zamanAsimBaslamaTarih?: string;
    public genKisi?: GenKisi;
    public temDefterKarsis: TemDefterKarsi[];
    public temFisDetay: TemFisDetay;
    public temTaahhutAvans: TemTaahhutAvans[];
    public temTaahhutTeminats: TemTaahhutTeminat[];
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemDefter>) { super(init); (Object as any).assign(this, init); }
}

export class TemDefterOdeHazirlik extends CommonEntityBase
{
    public adres?: string;
    public adSoyadUnvan?: string;
    public bakiye?: number;
    public bankaSubesi?: string;
    public baskanOnayTrh?: string;
    public baskanOnayTutar?: number;
    public belediyeKod: number;
    public belgeCinsi?: string;
    public belgeNo?: string;
    public belgeTarih?: string;
    public birimFisKod?: number;
    public defterBakiyeKodE?: number;
    public defterSiraNo: number;
    public digerTutar?: number;
    public donem: number;
    public emaneteAlinan?: number;
    public fisDetayKodE: number;
    public fisNo1E: number;
    public fisNoE: number;
    public fisTarihE: string;
    public gecerlilikTarih?: string;
    public hesapKod: string;
    public islemTarih?: string;
    public kisiKod?: number;
    public kod: number;
    public kuponAdet?: number;
    public kuponTutar?: number;
    public kurumsalKodE: string;
    public mudurOnayTrh?: string;
    public mudurOnayTutar?: number;
    public neden?: string;
    public odenen?: number;
    public statu?: number;
    public tahsilDigerTutar?: number;
    public tahsilTutar?: number;
    public zamanAsimBaslamaTarih?: string;
    public temFisDetay: TemFisDetay;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemDefterOdeHazirlik>) { super(init); (Object as any).assign(this, init); }
}

export class TemFisDetay extends CommonEntityBase
{
    public aciklama?: string;
    public alacakTutar?: number;
    public belediyeKod: number;
    public borcTutar?: number;
    public defterNo?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirButcesiEh: string;
    public dogrudanTeminTuru?: string;
    public donem: number;
    public ekonomikKod?: string;
    public eskiKisiKod?: number;
    public finansmanKod?: string;
    public fisKod: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public fonksiyonelKod?: string;
    public hesapKod: string;
    public karsiDefterNo?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public kurumsalKod: string;
    public yatirimKod?: string;
    public eskiGenKisi?: GenKisi;
    public genKisi?: GenKisi;
    public temBankaAlacaks: TemBankaAlacak[];
    public temBankaBorcs: TemBankaBorc[];
    public temDefters: TemDefter[];
    public temDefterKarsis: TemDefterKarsi[];
    public temDefterOdeHazirliks: TemDefterOdeHazirlik[];
    public temFis: TemFis;
    public temTaahhutTaahhuts: TemTaahhutTaahhut[];
    public temHesap?: TemHesap;

    public constructor(init?: Partial<TemFisDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TemBirimFisEvrak extends CommonEntityBase
{
    public birimFisKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakKdv: number;
    public evrakNo: string;
    public evrakNotlar?: string;
    public evrakTarih: string;
    public evrakTurKod: number;
    public evrakTutar: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public resimDysKod?: string;
    public resimPath?: string;
    public temBirimFis: TemBirimFis;
    public temEvrakTur: TemEvrakTur;

    public constructor(init?: Partial<TemBirimFisEvrak>) { super(init); (Object as any).assign(this, init); }
}

export class TemEvrakTur extends CommonEntityBase
{
    public ad?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBelgeTuru?: GenBelgeTuru;
    public temBirimFisEvraks: TemBirimFisEvrak[];
    public temFisEvraks: TemFisEvrak[];

    public constructor(init?: Partial<TemEvrakTur>) { super(init); (Object as any).assign(this, init); }
}

export class TemFisEvrak extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakKdv: number;
    public evrakNo: string;
    public evrakNotlar?: string;
    public evrakTarih: string;
    public evrakTurKod: number;
    public evrakTutar: number;
    public fisKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public resimDysKod?: string;
    public resimPath?: string;
    public temEvrakTur: TemEvrakTur;
    public temFis: TemFis;

    public constructor(init?: Partial<TemFisEvrak>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakipTerkin extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukVergi?: number;
    public takipKod: number;
    public vadeTarih: string;
    public yil: number;
    public genKisi1: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysTakip: GysTakip;

    public constructor(init?: Partial<GysTakipTerkin>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakip extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukVergi?: number;
    public takipAnaKod: number;
    public taksitKod?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHacizs: GysHaciz[];
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysIcras: GysIcra[];
    public gysTahakkuk?: GysTahakkuk;
    public gysTakipAna: GysTakipAna;
    public gysTakipTerkins: GysTakipTerkin[];

    public constructor(init?: Partial<GysTakip>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakipAna extends CommonEntityBase
{
    public aciklama?: string;
    public barkodNo?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public duzenlemeTarih: string;
    public eskiKisiKod?: number;
    public islemKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public takipNo?: number;
    public tebligEden?: string;
    public tebligEden2?: string;
    public tebligEdilmeme1Kod?: number;
    public tebligEdilmeme2Kod?: number;
    public tebligEdilmemeKod?: number;
    public tebligKullaniciKod?: number;
    public tebligSekli2Kod?: number;
    public tebligSekliKod?: number;
    public tebligTarih?: string;
    public tebligTarih2?: string;
    public tebligTarih3?: string;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public gysTakips: GysTakip[];
    public temFisGelirs: TemFisGelir[];

    public constructor(init?: Partial<GysTakipAna>) { super(init); (Object as any).assign(this, init); }
}

export class TemFisGelir extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public fisKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahsupAnaKod?: number;
    public tahakAnaKod?: number;
    public tahsilAnaKod?: number;
    public takipAnaKod?: number;
    public taksitAnaKod?: number;
    public terkinAnaKod?: number;
    public gysMahsupAna?: GysMahsupAna;
    public gysTahakkukAna?: GysTahakkukAna;
    public gysTahsilAna?: GysTahsilAna;
    public gysTakipAna?: GysTakipAna;
    public gysTerkinAna?: GysTerkinAna;
    public temFis: TemFis;

    public constructor(init?: Partial<TemFisGelir>) { super(init); (Object as any).assign(this, init); }
}

export class TemImzaYetki extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public gorevBaslamaTarih: string;
    public gorevBitisTarih?: string;
    public ikaKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumsalKod: string;
    public soyad: string;
    public unvani: string;
    public unvanTuru: number;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemImzaYetki>) { super(init); (Object as any).assign(this, init); }
}

export class TemGondermeEmri extends CommonEntityBase
{
    public aciklama?: string;
    public bankaHesapNo?: string;
    public bankaHesapTuru?: string;
    public bankaKodu?: string;
    public bankaMusteriNo?: string;
    public bankaSubeKodu?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public dovizTurKod?: number;
    public dovizTutar?: number;
    public eskiKisiKod?: number;
    public fisKod?: number;
    public harcamaYetkiliKod: number;
    public hesapKod: string;
    public ibanNo?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiAdiSoyadi?: string;
    public kisiBankaHesapNo?: string;
    public kisiKod?: number;
    public kod: number;
    public kurumsalKod: string;
    public ozelNo: number;
    public seriNo: number;
    public siraNo: number;
    public tutar: number;
    public genKisi?: GenKisi;
    public dovizTurKodDetay?: GenKodDetay;
    public temFis?: TemFis;
    public temImzaYetkiHarcama: TemImzaYetki;
    public tebKurumSinif?: TebKurumSinif;
    public temHesap?: TemHesap;

    public constructor(init?: Partial<TemGondermeEmri>) { super(init); (Object as any).assign(this, init); }
}

export class TmsMalGrup extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsTasinirMalGrups: TmsTasinirMalGrup[];

    public constructor(init?: Partial<TmsMalGrup>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTasinirMalGrup extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malGrupKod: number;
    public tasinirKod: number;
    public tmsMalGrup: TmsMalGrup;
    public tmsTasinir: TmsTasinir;

    public constructor(init?: Partial<TmsTasinirMalGrup>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTasinirResim extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tasinirKod: number;
    public tasinirResim?: string;
    public tmsTasinir: TmsTasinir;

    public constructor(init?: Partial<TmsTasinirResim>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTasinir extends CommonEntityBase
{
    public ad: string;
    public amortismanOran?: number;
    public amortismanSure?: number;
    public barkodKod?: string;
    public belediyeKod: number;
    public dayanikliEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekoGiderKod?: string;
    public hesapKod?: string;
    public hizmetAlimEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kod: number;
    public marka?: string;
    public maximumSeviye?: number;
    public minimumSeviye?: number;
    public notlar?: string;
    public olcuBirimKod?: number;
    public tasinirKod: string;
    public uretimKod?: string;
    public genKodDetay?: GenKodDetay;
    public tmsTasinirAmbars: TmsTasinirAmbar[];
    public tmsTasinirMalGrups: TmsTasinirMalGrup[];
    public tmsTasinirResims: TmsTasinirResim[];

    public constructor(init?: Partial<TmsTasinir>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTasinirAmbar extends CommonEntityBase
{
    public ambarKod: number;
    public blokKod?: number;
    public bolumKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public rafKod?: number;
    public tasinirKod: number;
    public tmsAmbar: TmsAmbar;
    public tmsAmbarBlok?: TmsAmbarBlok;
    public tmsAmbarBolum?: TmsAmbarBolum;
    public tmsAmbarRaf?: TmsAmbarRaf;
    public tmsTasinir: TmsTasinir;

    public constructor(init?: Partial<TmsTasinirAmbar>) { super(init); (Object as any).assign(this, init); }
}

export class StsDonem extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public donemKapandiEh: string;
    public dosyaNoOtomatikEh: string;
    public evrakTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdv1HesapKod?: string;
    public kdv1Oran?: number;
    public kdv2HesapKod?: string;
    public kdv2Oran?: number;
    public kdv3HesapKod?: string;
    public kdv3Oran?: number;
    public kod: number;
    public kontrolTarihi?: string;
    public muayeneOtomatikEh: string;
    public pul1HesapKod?: string;
    public pul1Oran?: number;
    public pul2HesapKod?: string;
    public pul2Oran?: number;
    public tebDonem: TebDonem;
    public kdv1TemHesap: TemHesap;
    public kdv2TemHesap: TemHesap;
    public kdv3TemHesap: TemHesap;
    public pul1TemHesap: TemHesap;
    public pul2TemHesap: TemHesap;

    public constructor(init?: Partial<StsDonem>) { super(init); (Object as any).assign(this, init); }
}

export class StsOnMuayene extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public dosyaNo: number;
    public eskiKisiKod?: number;
    public faturaNo?: string;
    public faturaTarih?: string;
    public faturaTutari?: number;
    public ihaleKod: number;
    public irsaliyeNo?: string;
    public irsaliyeTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public kurumsalKod: string;
    public muayeneNo: number;
    public muayeneTarih: string;
    public notlar?: string;
    public teklifKod: number;
    public teslimAlanAdSoyad?: string;
    public teslimAlanTckn?: number;
    public teslimEdenAdSoyad?: string;
    public teslimEdenTckn?: number;
    public genKisi: GenKisi;
    public stsIhale: StsIhale;
    public stsTeklif: StsTeklif;
    public stsDonem?: StsDonem;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<StsOnMuayene>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTifGiris extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public cikisAmbarKod?: number;
    public cikisNo?: number;
    public cikisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirEh: string;
    public donem: number;
    public encumenNo?: string;
    public encumenTarih?: string;
    public eskiKisiKod?: number;
    public faturaNo?: string;
    public faturaTarih?: string;
    public faturaTutar?: number;
    public girisNo: number;
    public girisTarih: string;
    public girisTurKod: number;
    public girisTuru: string;
    public ihaleKomisyonNo?: string;
    public ihaleKomisyonTarih?: string;
    public iskontoOran?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kkyPersonelKod?: number;
    public kkyRolAd?: string;
    public kod: number;
    public kurumsalKod: string;
    public muayeneKod?: number;
    public nereyeGonderildi?: string;
    public notlar?: string;
    public satinalmaDonem?: number;
    public satinalmaDosyaNo?: number;
    public teklifKod?: number;
    public teslimAdSoyad?: string;
    public teslimRolAd?: string;
    public teslimTckn?: number;
    public verilenPersonelKod?: number;
    public verilenRolAd?: string;
    public genKisi?: GenKisi;
    public genKodDetay: GenKodDetay;
    public ikaKykPersonel?: IkaPersonel;
    public ikaVerilenPersonel?: IkaPersonel;
    public stsMuayene?: StsMuayene;
    public stsTeklif?: StsTeklif;
    public tmsAmbar: TmsAmbar;
    public tmsAmbar1?: TmsAmbar;
    public tmsMuhasebes: TmsMuhasebe[];
    public tmsTifGirisDetays: TmsTifGirisDetay[];
    public stsIhale?: StsIhale;
    public tebDonem?: TebDonem;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TmsTifGiris>) { super(init); (Object as any).assign(this, init); }
}

export class StsTeklif extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public dosyaNo: number;
    public durumu: number;
    public eskiKisiKod?: number;
    public faturaTutar?: number;
    public ihaleKod: number;
    public iskontoOran?: number;
    public iskontoTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public kurumsalKod: string;
    public notlar?: string;
    public teklifSaat?: string;
    public teklifSiraNo?: number;
    public teklifTarih: string;
    public teslimTarih?: string;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public stsIhale: StsIhale;
    public stsMuayenes: StsMuayene[];
    public stsMuayeneDetays: StsMuayeneDetay[];
    public stsOnMuayenes: StsOnMuayene[];
    public stsTeklifDetays: StsTeklifDetay[];
    public tmsTifGiris: TmsTifGiris[];
    public stsDonem?: StsDonem;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<StsTeklif>) { super(init); (Object as any).assign(this, init); }
}

export class StsTeklifDetay extends CommonEntityBase
{
    public adet?: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public birimKatsayi?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public genelTutar?: number;
    public ihaleDetayKod: number;
    public ihaleKod: number;
    public iskontoTutar?: number;
    public islemAdet?: number;
    public islemBirimKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public marka?: string;
    public model?: string;
    public notlar?: string;
    public otvTutar?: number;
    public plaka?: string;
    public tasinirKod: string;
    public teklifKod: number;
    public toplamTutar?: number;
    public genKodDetay?: GenKodDetay;
    public stsIhale: StsIhale;
    public stsIhaleDetay: StsIhaleDetay;
    public stsMuayeneDetays: StsMuayeneDetay[];
    public stsTeklif: StsTeklif;
    public tmsTifGirisDetays: TmsTifGirisDetay[];
    public tebDonem?: TebDonem;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<StsTeklifDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTerkinImha extends CommonEntityBase
{
    public ambarKod: number;
    public baskanPersonelKod?: number;
    public baskanRolAd?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public harcamaYetkiliPersonelKod?: number;
    public harYetRolAd?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kkyPersonelKod?: number;
    public kkyRolAd?: string;
    public kod: number;
    public kurumsalKod: string;
    public nereyeGonderildi?: string;
    public notlar?: string;
    public terkinImhaAciklama?: string;
    public terkinImhaTurKod: number;
    public turu: string;
    public tutanakNo: number;
    public tutanakTarih: string;
    public ustYoneticiPersonelKod?: number;
    public ustYonRolAd?: string;
    public uye1PersonelKod?: number;
    public uye1RolAd?: string;
    public uye2PersonelKod?: number;
    public uye2RolAd?: string;
    public genKodDetay: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;
    public ikaPersonel3?: IkaPersonel;
    public ikaPersonel4?: IkaPersonel;
    public ikaPersonel5?: IkaPersonel;
    public tmsAmbar: TmsAmbar;
    public tmsTerkinImhaDetays: TmsTerkinImhaDetay[];
    public tebDonem?: TebDonem;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TmsTerkinImha>) { super(init); (Object as any).assign(this, init); }
}

export class TmsBilesen extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsDemirbasBilesens: TmsDemirbasBilesen[];

    public constructor(init?: Partial<TmsBilesen>) { super(init); (Object as any).assign(this, init); }
}

export class TmsDemirbasBilesen extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public bilesenKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public demirbasKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsBilesen: TmsBilesen;
    public tmsDemirbas: TmsDemirbas;

    public constructor(init?: Partial<TmsDemirbasBilesen>) { super(init); (Object as any).assign(this, init); }
}

export class TmsDemirbas extends CommonEntityBase
{
    public adet?: number;
    public alinanFirmaAdi?: string;
    public ambarKod: number;
    public amortismanBitYil?: number;
    public amortismanNo?: number;
    public barkodNo?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public faturaNo?: string;
    public faturaTarih?: string;
    public kararNo?: string;
    public kararTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public marka?: string;
    public model?: string;
    public motorNo?: string;
    public notlar?: string;
    public olcuBirimKod?: number;
    public otvTutar?: number;
    public plaka?: string;
    public saseNo?: string;
    public seriNo?: string;
    public sicilKod: string;
    public siraNo: number;
    public tasinirKod: string;
    public toplamTutar?: number;
    public yil: number;
    public genKodDetay?: GenKodDetay;
    public tmsAmbar: TmsAmbar;
    public tmsDemirbasBilesens: TmsDemirbasBilesen[];
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<TmsDemirbas>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTerkinImhaDetay extends CommonEntityBase
{
    public adet?: number;
    public ambarKod: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public birimKatsayi?: number;
    public dayanikliSicilKod?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public genelTutar?: number;
    public islemAdet?: number;
    public islemBirimKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public notlar?: string;
    public olcuBirimKod?: number;
    public otvTutar?: number;
    public tasinirGirisKod: number;
    public tasinirKod: string;
    public terkinImhaAnaKod: number;
    public toplamTutar?: number;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public tmsAmbar: TmsAmbar;
    public tmsTerkinImha: TmsTerkinImha;
    public tmsTifGirisDetay: TmsTifGirisDetay;
    public tebDonem?: TebDonem;
    public tmsDemirbas?: TmsDemirbas;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<TmsTerkinImhaDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTifCikisDetay extends CommonEntityBase
{
    public adet?: number;
    public ambarCikisAnaKod: number;
    public ambarKod: number;
    public amortismanNo?: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public birimKatsayi?: number;
    public dayanikliSicilKod?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public genelTutar?: number;
    public islemAdet?: number;
    public islemBirimKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public marka?: string;
    public model?: string;
    public motorNo?: string;
    public notlar?: string;
    public olcuBirimKod?: number;
    public otvTutar?: number;
    public plaka?: string;
    public saseNo?: string;
    public seriNo?: string;
    public tasinirGirisKod: number;
    public tasinirKod: string;
    public toplamTutar?: number;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public tmsAmbar: TmsAmbar;
    public tmsTifCikis: TmsTifCikis;
    public tmsTifGirisDetay: TmsTifGirisDetay;
    public tmsTifGirisDetays: TmsTifGirisDetay[];
    public tebDonem?: TebDonem;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<TmsTifCikisDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TebGider extends CommonEntityBase
{
    public ad: string;
    public anaKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public ekoGiderKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TebGider>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTifGirisDetay extends CommonEntityBase
{
    public adet?: number;
    public ambarGirisAnaKod: number;
    public ambarKod: number;
    public amortismanNo?: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public birimKatsayi?: number;
    public blokKod?: number;
    public bolumKod?: number;
    public cikisKod?: number;
    public dayanikliSicilKod?: string;
    public degerArtisEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public ekoGiderKod?: string;
    public finansmanKod?: string;
    public fonksiyonelKod?: string;
    public genelTutar?: number;
    public ilkGirisDetayKod?: number;
    public iskontoTutar?: number;
    public islemAdet?: number;
    public islemBirimKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public marka?: string;
    public model?: string;
    public motorNo?: string;
    public notlar?: string;
    public olcuBirimKod?: number;
    public otvTutar?: number;
    public plaka?: string;
    public rafKod?: number;
    public saseNo?: string;
    public seriNo?: string;
    public tasinirKod: string;
    public teklifDetayKod?: number;
    public toplamTutar?: number;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public stsTeklifDetay?: StsTeklifDetay;
    public tmsAmbar: TmsAmbar;
    public tmsAmbarBlok?: TmsAmbarBlok;
    public tmsAmbarBolum?: TmsAmbarBolum;
    public tmsAmbarRaf?: TmsAmbarRaf;
    public tmsTerkinImhaDetays: TmsTerkinImhaDetay[];
    public tmsTifCikisDetays: TmsTifCikisDetay[];
    public tmsTifCikisDetay?: TmsTifCikisDetay;
    public tmsTifGiris: TmsTifGiris;
    public ilkTmsTifGirisDetay?: TmsTifGirisDetay;
    public tmsTifGirisDetays: TmsTifGirisDetay[];
    public tebDonem?: TebDonem;
    public tebFinansman?: TebFinansman;
    public tebFonksiyon?: TebFonksiyon;
    public tebGider?: TebGider;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<TmsTifGirisDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbarRaf extends CommonEntityBase
{
    public ad: string;
    public ambarKod: number;
    public bolumKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsAmbarBolum: TmsAmbarBolum;
    public tmsTasinirAmbars: TmsTasinirAmbar[];
    public tmsTifGirisDetays: TmsTifGirisDetay[];

    public constructor(init?: Partial<TmsAmbarRaf>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbarBolum extends CommonEntityBase
{
    public ad: string;
    public ambarKod: number;
    public blokKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsAmbarBlok: TmsAmbarBlok;
    public tmsAmbarRafs: TmsAmbarRaf[];
    public tmsTasinirAmbars: TmsTasinirAmbar[];
    public tmsTifGirisDetays: TmsTifGirisDetay[];

    public constructor(init?: Partial<TmsAmbarBolum>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbarBlok extends CommonEntityBase
{
    public ad: string;
    public ambarKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsAmbar: TmsAmbar;
    public tmsAmbarBolums: TmsAmbarBolum[];
    public tmsTasinirAmbars: TmsTasinirAmbar[];
    public tmsTifGirisDetays: TmsTifGirisDetay[];

    public constructor(init?: Partial<TmsAmbarBlok>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbarKurumsal extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumsalKod: string;
    public tmsAmbar: TmsAmbar;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TmsAmbarKurumsal>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbarOtoNumara extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public girisCikisNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tutanakNo: number;
    public tmsAmbar: TmsAmbar;
    public tebDonem: TebDonem;

    public constructor(init?: Partial<TmsAmbarOtoNumara>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbarYetki extends CommonEntityBase
{
    public aktifEh: string;
    public ambarKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public genKullanici: GenKullanici;
    public tmsAmbar: TmsAmbar;

    public constructor(init?: Partial<TmsAmbarYetki>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmortisman extends CommonEntityBase
{
    public ambarKod: number;
    public amortismanNo?: number;
    public amortismanTutar?: number;
    public belediyeKod: number;
    public degerArtis?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iktisapDegeri: number;
    public iktisapTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public satisTarih?: string;
    public sicilNo: string;
    public tasinirKod: string;
    public yenDegAmorTutar?: number;
    public yenDegerOran?: number;
    public yenDegTutar?: number;
    public yevmiyeNo?: number;
    public yevmiyeTarih?: string;
    public yili: number;
    public tmsAmbar: TmsAmbar;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<TmsAmortisman>) { super(init); (Object as any).assign(this, init); }
}

export class TmsDemirbasYer extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBirim?: GenBirim;
    public tmsZimmetTerkins: TmsZimmetTerkin[];

    public constructor(init?: Partial<TmsDemirbasYer>) { super(init); (Object as any).assign(this, init); }
}

export class TmsZimmetTerkinDetay extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public dayanikliSicilKod: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public verilisTurKod?: number;
    public zimmetDetayKod?: number;
    public zimmetTerkinAnaKod: number;
    public genKodDetay?: GenKodDetay;
    public tmsAmbar: TmsAmbar;
    public tmsDemirbas?: TmsDemirbas;

    public constructor(init?: Partial<TmsZimmetTerkinDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TmsZimmetTerkin extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public demirbasYerKod: number;
    public islemNo: number;
    public islemTarih: string;
    public islemTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kkyPersonelKod?: number;
    public kkyRolAd?: string;
    public kod: number;
    public kurumsalKod: string;
    public notlar?: string;
    public terkinTurKod?: number;
    public verilenPersonelKod?: number;
    public verilenRolAd?: string;
    public zimmetTerkinTuru: string;
    public zimmetTurKod?: string;
    public genKodDetay?: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public tmsAmbar: TmsAmbar;
    public tmsDemirbasYer: TmsDemirbasYer;
    public tmsZimmetTerkinDetays: TmsZimmetTerkinDetay[];

    public constructor(init?: Partial<TmsZimmetTerkin>) { super(init); (Object as any).assign(this, init); }
}

export class TmsAmbar extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public aktifEh: string;
    public ambarKisaKodu?: string;
    public ambarYerTakipEh: string;
    public anaAmbarEh: string;
    public belediyeKod: number;
    public birimKod?: number;
    public blokKod?: number;
    public bolumKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kkyPersonelKod?: number;
    public kod: number;
    public rafKod?: number;
    public sifre?: string;
    public genBirim?: GenBirim;
    public tmsAmbarBloks: TmsAmbarBlok[];
    public tmsAmbarKurumsals: TmsAmbarKurumsal[];
    public tmsAmbarOtoNumaras: TmsAmbarOtoNumara[];
    public tmsAmbarYetkis: TmsAmbarYetki[];
    public tmsAmortismen: TmsAmortisman[];
    public tmsDemirbas: TmsDemirbas[];
    public tmsTasinirAmbars: TmsTasinirAmbar[];
    public tmsTerkinImhas: TmsTerkinImha[];
    public tmsTerkinImhaDetays: TmsTerkinImhaDetay[];
    public tmsTifCikis: TmsTifCikis[];
    public tmsTifCikis1: TmsTifCikis[];
    public tmsTifCikisDetays: TmsTifCikisDetay[];
    public tmsTifGiris: TmsTifGiris[];
    public tmsTifGiris1: TmsTifGiris[];
    public tmsTifGirisDetays: TmsTifGirisDetay[];
    public tmsZimmetTerkins: TmsZimmetTerkin[];
    public tmsZimmetTerkinDetays: TmsZimmetTerkinDetay[];

    public constructor(init?: Partial<TmsAmbar>) { super(init); (Object as any).assign(this, init); }
}

export class TmsCikisYer extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tmsTifCikis: TmsTifCikis[];

    public constructor(init?: Partial<TmsCikisYer>) { super(init); (Object as any).assign(this, init); }
}

export class TmsTifCikis extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public cikisAmbarKod?: number;
    public cikisKurumsalKod?: string;
    public cikisMahalleCaddeKod?: number;
    public cikisNo: number;
    public cikisTarih: string;
    public cikisTurKod: number;
    public cikisTuru: string;
    public cikisYerKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public istekFisNo?: number;
    public istekFisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kkyPersonelKod?: number;
    public kkyRolAd?: string;
    public kod: number;
    public kurumsalKod: string;
    public nereyeGonderildi?: string;
    public notlar?: string;
    public teslimAdSoyad?: string;
    public teslimRolAd?: string;
    public teslimTckn?: number;
    public verilenPersonelKod?: number;
    public verilenRolAd?: string;
    public genKodDetay: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public tmsAmbar: TmsAmbar;
    public tmsAmbar1?: TmsAmbar;
    public tmsCikisYer?: TmsCikisYer;
    public tmsMuhasebes: TmsMuhasebe[];
    public tmsTifCikisDetays: TmsTifCikisDetay[];
    public tebDonem?: TebDonem;
    public cikisTebKurumSinif?: TebKurumSinif;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TmsTifCikis>) { super(init); (Object as any).assign(this, init); }
}

export class TmsMuhasebe extends CommonEntityBase
{
    public birimFisKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public fisKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tifCikisKod?: number;
    public tifGirisKod?: number;
    public temBirimFis?: TemBirimFis;
    public temFis?: TemFis;
    public tmsTifCikis?: TmsTifCikis;
    public tmsTifGiris?: TmsTifGiris;

    public constructor(init?: Partial<TmsMuhasebe>) { super(init); (Object as any).assign(this, init); }
}

export class TemFis extends CommonEntityBase
{
    public aciklama?: string;
    public avansFisNo?: number;
    public avansFisNo1?: number;
    public avansNo?: number;
    public avansVerildigiTarih?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirFisKapanis: string;
    public dogrudanTeminEh: string;
    public donem: number;
    public duzenleyenKod?: number;
    public duzenleyenTarih?: string;
    public emanetAciklama?: string;
    public emaneteAlindiTarih?: string;
    public eskiKisiKod?: number;
    public fisIslemKod?: number;
    public fisNo: number;
    public fisNo1: number;
    public fisTarih: string;
    public fisTuru: string;
    public harcamaKod?: number;
    public harcamaYetkilisiKod?: number;
    public harcamaYetkilisiTarih?: string;
    public ihaleMaddeKod?: number;
    public ilkDefterNo?: number;
    public ilkDefterTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiAdiSoyadi?: string;
    public kisiAdres?: string;
    public kisiBankaHesapNo?: string;
    public kisiBankaSubesi?: string;
    public kisiIbanNo?: string;
    public kisiKod?: number;
    public kisiTckn?: number;
    public kisiVergiDairesi?: string;
    public kisiVergiNo?: string;
    public kisiYetkiliAdiSoyadi?: string;
    public kisiYetkiliKisiKod?: number;
    public kod: number;
    public kurumsalKod: string;
    public maliKontrolKod?: number;
    public maliKontrolTarih?: string;
    public muhasebeYetkilisiKod?: number;
    public muhasebeYetkilisiTarih?: string;
    public odemeBelgeNo?: number;
    public odemeBelgeNo1?: number;
    public odemeNo?: string;
    public odemeTuru?: string;
    public onaylayanMemurKod?: number;
    public onaylayanSefKod?: number;
    public onaylayanYetkiliKod?: number;
    public otomatikOdemeKod?: number;
    public planOdemeKod?: number;
    public satinalmaDonem?: number;
    public satinalmaDosyaNo?: number;
    public sonDefterNo?: number;
    public sonDefterTarih?: string;
    public taahhutKod?: number;
    public vezneYetkiliKod?: number;
    public vezneYetkiliTarih?: string;
    public eskiGenKisi?: GenKisi;
    public genKisi?: GenKisi;
    public fisIslemKodDetay?: GenKodDetay;
    public gysMahsupAnas: GysMahsupAna[];
    public ikaMaasMuhasebes: IkaMaasMuhasebe[];
    public stsDosyaMuhasebes: StsDosyaMuhasebe[];
    public stsIhaleMadde?: StsIhaleMadde;
    public temAlindiBelges: TemAlindiBelge[];
    public temDuzeltmeDefters: TemDuzeltmeDefter[];
    public temFisDetays: TemFisDetay[];
    public temFisEvraks: TemFisEvrak[];
    public temFisGelirs: TemFisGelir[];
    public temGondermeEmris: TemGondermeEmri[];
    public temHarcamaTalimat?: TemHarcamaTalimat;
    public temImzaYetkiDuzenleyen?: TemImzaYetki;
    public temImzaYetkiHarcamaYetkili?: TemImzaYetki;
    public temImzaYetkiMaliKontrol?: TemImzaYetki;
    public temImzaYetkiMuhasebeYetkili?: TemImzaYetki;
    public temImzaYetkiOnaylayanMemur?: TemImzaYetki;
    public temImzaYetkiOnaylayanSef?: TemImzaYetki;
    public temImzaYetkiOnaylayanYetkili?: TemImzaYetki;
    public temImzaYetkiVezne?: TemImzaYetki;
    public temTaahhut?: TemTaahhut;
    public temTeslimats: TemTeslimat[];
    public tmsMuhasebes: TmsMuhasebe[];
    public tebDonem?: TebDonem;

    public constructor(init?: Partial<TemFis>) { super(init); (Object as any).assign(this, init); }
}

export class TemHarcamaTalimatDetay extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirButcesiEh: string;
    public dogrudanTeminTuru?: string;
    public donem: number;
    public ekoGiderKod: string;
    public finansmanKod: string;
    public fonksiyonelKod: string;
    public harcamaTalimatKod: number;
    public iptalTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumsalKod: string;
    public odemeTutar?: number;
    public tutar: number;
    public yatirimKod?: string;
    public temHarcamaTalimat: TemHarcamaTalimat;
    public tebFinansman?: TebFinansman;
    public tebFonksiyon?: TebFonksiyon;
    public tebGider?: TebGider;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemHarcamaTalimatDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TemHarcamaTalimat extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogrudanTeminEh: string;
    public donem: number;
    public dosyaNo: number;
    public dosyaTarih: string;
    public duzenleyenKod?: number;
    public evrakNo?: number;
    public evrakTarih?: string;
    public gerceklesmeTarih?: string;
    public ihaleSekliKod?: number;
    public isAdi: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konu?: string;
    public kurumsalKod: string;
    public onaylayanKod?: number;
    public yaklasikTutar?: number;
    public stsIhales: StsIhale[];
    public stsIhaleSekli?: StsIhaleSekli;
    public temBirimFis: TemBirimFis[];
    public temFis: TemFis[];
    public temHarcamaTalimatDetays: TemHarcamaTalimatDetay[];
    public temImzaYetkiDuzenleyen?: TemImzaYetki;
    public temImzaYetkiOnaylayan?: TemImzaYetki;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemHarcamaTalimat>) { super(init); (Object as any).assign(this, init); }
}

export class StsIhaleSekli extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogrudanTeminEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stsIhales: StsIhale[];
    public stsIhaleMaddes: StsIhaleMadde[];
    public temHarcamaTalimats: TemHarcamaTalimat[];

    public constructor(init?: Partial<StsIhaleSekli>) { super(init); (Object as any).assign(this, init); }
}

export class StsIhaleMadde extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ihaleSekliKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stsIhales: StsIhale[];
    public stsIhaleSekli?: StsIhaleSekli;
    public temBirimFis: TemBirimFis[];
    public temFis: TemFis[];

    public constructor(init?: Partial<StsIhaleMadde>) { super(init); (Object as any).assign(this, init); }
}

export class TemBirimFisDetay extends CommonEntityBase
{
    public aciklama?: string;
    public alacakTutar?: number;
    public belediyeKod: number;
    public birimFisKod: number;
    public borcTutar?: number;
    public defterNo?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirButcesiEh: string;
    public dogrudanTeminTuru?: string;
    public donem: number;
    public ekonomikKod?: string;
    public eskiKisiKod?: number;
    public finansmanKod?: string;
    public fonksiyonelKod?: string;
    public hesapKod: string;
    public karsiDefterNo?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public kurumsalKod: string;
    public yatirimKod?: string;
    public genKisi?: GenKisi;
    public temBirimFis: TemBirimFis;
    public tebFinansman?: TebFinansman;
    public tebFonksiyon?: TebFonksiyon;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemBirimFisDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TemBirimFisSurec extends CommonEntityBase
{
    public birimFisKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sebebi?: string;
    public temBirimFis: TemBirimFis;

    public constructor(init?: Partial<TemBirimFisSurec>) { super(init); (Object as any).assign(this, init); }
}

export class TemBirimFis extends CommonEntityBase
{
    public aciklama?: string;
    public avansFisNo?: number;
    public avansFisNo1?: number;
    public avansNo?: number;
    public avansVerildigiTarih?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogrudanTeminEh: string;
    public donem: number;
    public dosyaNo: number;
    public dosyaTarih: string;
    public duzenleyenKod?: number;
    public duzenleyenTarih?: string;
    public emanetAciklama?: string;
    public emaneteAlindiTarih?: string;
    public eskiKisiKod?: number;
    public fisIslemKod?: number;
    public fisTuru: string;
    public harcamaKod?: number;
    public harcamaYetkilisiKod?: number;
    public harcamaYetkilisiTarih?: string;
    public ihaleMaddeKod?: number;
    public ilkDefterNo?: number;
    public ilkDefterTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiAdiSoyadi?: string;
    public kisiAdres?: string;
    public kisiBankaHesapNo?: string;
    public kisiBankaSubesi?: string;
    public kisiIbanNo?: string;
    public kisiKod?: number;
    public kisiTckn?: number;
    public kisiVergiDairesi?: string;
    public kisiVergiNo?: string;
    public kisiYetkiliAdiSoyadi?: string;
    public kisiYetkiliKisiKod?: number;
    public kod: number;
    public kontrolDeger: number;
    public kurumsalKod: string;
    public maliKontrolKod?: number;
    public maliKontrolTarih?: string;
    public muhasebeYetkilisiKod?: number;
    public muhasebeYetkilisiTarih?: string;
    public odemeNo?: string;
    public odemeTuru?: string;
    public onaylayanMemurKod?: number;
    public onaylayanSefKod?: number;
    public onaylayanYetkiliKod?: number;
    public otomatikOdemeKod?: number;
    public planOdemeKod?: number;
    public satinalmaDonem?: number;
    public satinalmaDosyaNo?: number;
    public sonDefterNo?: number;
    public sonDefterTarih?: string;
    public taahhutKod?: number;
    public vezneYetkiliKod?: number;
    public vezneYetkiliTarih?: string;
    public genKisi?: GenKisi;
    public fisIslemKodDetay?: GenKodDetay;
    public gysMahsupAnas: GysMahsupAna[];
    public ikaMaasMuhasebes: IkaMaasMuhasebe[];
    public stsDosyaMuhasebes: StsDosyaMuhasebe[];
    public stsIhaleMadde?: StsIhaleMadde;
    public temBirimFisDetays: TemBirimFisDetay[];
    public temBirimFisEvraks: TemBirimFisEvrak[];
    public temBirimFisSurecs: TemBirimFisSurec[];
    public temHarcamaTalimat?: TemHarcamaTalimat;
    public temImzaYetkiDuzenleyen?: TemImzaYetki;
    public temImzaYetkiHarcama?: TemImzaYetki;
    public temImzaYetkiMaliKontrol?: TemImzaYetki;
    public temImzaYetkiMuhasebeYetkili?: TemImzaYetki;
    public temImzaYetkiOnaylayanMemur?: TemImzaYetki;
    public temImzaYetkiOnaylayanSef?: TemImzaYetki;
    public temImzaYetkiOnaylayanYetkili?: TemImzaYetki;
    public temImzaYetkiVezne?: TemImzaYetki;
    public temTaahhut?: TemTaahhut;
    public tmsMuhasebes: TmsMuhasebe[];
    public stsIhale?: StsIhale;
    public tebDonem?: TebDonem;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TemBirimFis>) { super(init); (Object as any).assign(this, init); }
}

export class StsDosyaMuhasebe extends CommonEntityBase
{
    public birimFisKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public fisKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public muayeneKod?: number;
    public stsMuayene?: StsMuayene;
    public temBirimFis?: TemBirimFis;
    public temFis?: TemFis;

    public constructor(init?: Partial<StsDosyaMuhasebe>) { super(init); (Object as any).assign(this, init); }
}

export class StsMuayene extends CommonEntityBase
{
    public baskanPerKod?: number;
    public baskanRolAd?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public dosyaNo: number;
    public durumu: number;
    public eskiKisiKod?: number;
    public faturaNo?: string;
    public faturaTarih?: string;
    public faturaTutari?: number;
    public ihaleKod: number;
    public irsaliyeNo?: string;
    public irsaliyeTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public kurumsalKod: string;
    public muayeneNo: number;
    public muayeneTarih: string;
    public notlar?: string;
    public teklifKod: number;
    public uye1PerKod?: number;
    public uye1RolAd?: string;
    public uye2PerKod?: number;
    public uye2RolAd?: string;
    public uye3PerKod?: number;
    public uye3RolAd?: string;
    public uye4PerKod?: number;
    public uye4RolAd?: string;
    public uye5PerKod?: number;
    public uye5RolAd?: string;
    public genKisi: GenKisi;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;
    public ikaPersonel3?: IkaPersonel;
    public ikaPersonel4?: IkaPersonel;
    public ikaPersonel5?: IkaPersonel;
    public stsDosyaMuhasebe: StsDosyaMuhasebe;
    public stsIhale: StsIhale;
    public stsMuayeneDetays: StsMuayeneDetay[];
    public stsTeklif: StsTeklif;
    public tmsTifGiris: TmsTifGiris[];
    public baskanOrganizasyonRol?: GenOrganizasyonRol;
    public uye1OrganizasyonRol?: GenOrganizasyonRol;
    public uye2OrganizasyonRol?: GenOrganizasyonRol;
    public uye3OrganizasyonRol?: GenOrganizasyonRol;
    public uye4OrganizasyonRol?: GenOrganizasyonRol;
    public uye5OrganizasyonRol?: GenOrganizasyonRol;
    public stsDonem?: StsDonem;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<StsMuayene>) { super(init); (Object as any).assign(this, init); }
}

export class StsMuayeneDetay extends CommonEntityBase
{
    public adet?: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public birimKatsayi?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public fiyatFarkTutar?: number;
    public genelTutar?: number;
    public ihaleDetayKod: number;
    public ihaleKod: number;
    public iskontoTutar?: number;
    public islemAdet?: number;
    public islemBirimKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public marka?: string;
    public model?: string;
    public muayeneKod: number;
    public notlar?: string;
    public otvTutar?: number;
    public plaka?: string;
    public tasinirKod: string;
    public teklifDetayKod: number;
    public teklifKod: number;
    public toplamTutar?: number;
    public genKodDetay?: GenKodDetay;
    public stsIhale: StsIhale;
    public stsIhaleDetay: StsIhaleDetay;
    public stsMuayene: StsMuayene;
    public stsTeklif: StsTeklif;
    public stsTeklifDetay: StsTeklifDetay;
    public tebDonem?: TebDonem;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<StsMuayeneDetay>) { super(init); (Object as any).assign(this, init); }
}

export class StsIhaleDetay extends CommonEntityBase
{
    public adet?: number;
    public belediyeKod: number;
    public birimKatsayi?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirButcesiEh: string;
    public donem: number;
    public ekoGiderKod?: string;
    public finansmanKod?: string;
    public fonksiyonelKod?: string;
    public hesapKod?: string;
    public ihaleKod: number;
    public islemAdet?: number;
    public islemBirimKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumsalKod: string;
    public notlar?: string;
    public onayAciklama?: string;
    public onayEh: string;
    public plaka?: string;
    public siraNo?: number;
    public tasinirKod: string;
    public yaklasikMaliyet?: number;
    public genKodDetay?: GenKodDetay;
    public stsIhale: StsIhale;
    public stsMuayeneDetays: StsMuayeneDetay[];
    public stsTeklifDetays: StsTeklifDetay[];
    public tebFinansman?: TebFinansman;
    public tebFonksiyon?: TebFonksiyon;
    public tebGider?: TebGider;
    public tebKurumSinif?: TebKurumSinif;
    public tmsTasinir?: TmsTasinir;

    public constructor(init?: Partial<StsIhaleDetay>) { super(init); (Object as any).assign(this, init); }
}

export class StsIhaleImza extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public depoRolAd?: string;
    public destekRolAd?: string;
    public duzenRolAd?: string;
    public gerGorRolAd?: string;
    public harYetRolAd?: string;
    public ihaleKod: number;
    public ikBaskanPerKod?: number;
    public ikBaskanRolAd?: string;
    public ikMemurPerKod?: number;
    public ikMemurRolAd?: string;
    public ikUye1PerKod?: number;
    public ikUye1RolAd?: string;
    public ikUye2PerKod?: number;
    public ikUye2RolAd?: string;
    public ikUye3PerKod?: number;
    public ikUye3RolAd?: string;
    public ikUye4PerKod?: number;
    public ikUye4RolAd?: string;
    public ikUye5PerKod?: number;
    public ikUye5RolAd?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public paGorev1PerKod?: number;
    public paGorev1RolAd?: string;
    public paGorev2PerKod?: number;
    public paGorev2RolAd?: string;
    public paGorev3PerKod?: number;
    public paGorev3RolAd?: string;
    public paGorev4PerKod?: number;
    public paGorev4RolAd?: string;
    public paGorev5PerKod?: number;
    public paGorev5RolAd?: string;
    public paGorevPerKod?: number;
    public paGorevRolAd?: string;
    public paOnayNo?: string;
    public paOnayPerKod?: number;
    public paOnayRolAd?: string;
    public paOnayTarih?: string;
    public saDepoPerKod?: number;
    public saDestekPerKod?: number;
    public saDestekTarih?: string;
    public saDuzenPerKod?: number;
    public saDuzenTarih?: string;
    public saGerGorPerKod?: number;
    public saGerGorTarih?: string;
    public saHarYetPerKod?: number;
    public saHarYetTarih?: string;
    public saTetkikPerKod?: number;
    public saTetkikTarih?: string;
    public saYoneticiPerKod?: number;
    public saYoneticiTarih?: string;
    public saYonYrdPerKod?: number;
    public saYonYrdTarih?: string;
    public tetkikRolAd?: string;
    public yoneticiRolAd?: string;
    public yonYrdRolAd?: string;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel10?: IkaPersonel;
    public ikaPersonel11?: IkaPersonel;
    public ikaPersonel12?: IkaPersonel;
    public ikaPersonel13?: IkaPersonel;
    public ikaPersonel14?: IkaPersonel;
    public ikaPersonel15?: IkaPersonel;
    public ikaPersonel16?: IkaPersonel;
    public ikaPersonel17?: IkaPersonel;
    public ikaPersonel18?: IkaPersonel;
    public ikaPersonel19?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;
    public ikaPersonel3?: IkaPersonel;
    public ikaPersonel4?: IkaPersonel;
    public ikaPersonel5?: IkaPersonel;
    public ikaPersonel6?: IkaPersonel;
    public ikaPersonel7?: IkaPersonel;
    public ikaPersonel8?: IkaPersonel;
    public ikaPersonel9?: IkaPersonel;
    public stsIhale: StsIhale;
    public depoOrganizasyonRol?: GenOrganizasyonRol;
    public destekOrganizasyonRol?: GenOrganizasyonRol;
    public duzenOrganizasyonRol?: GenOrganizasyonRol;
    public gerGorOrganizasyonRol?: GenOrganizasyonRol;
    public harYetOrganizasyonRol?: GenOrganizasyonRol;
    public baskanOrganizasyonRol?: GenOrganizasyonRol;
    public ikMemurOrganizasyonRol?: GenOrganizasyonRol;
    public uye1OrganizasyonRol?: GenOrganizasyonRol;
    public uye2OrganizasyonRol?: GenOrganizasyonRol;
    public uye3OrganizasyonRol?: GenOrganizasyonRol;
    public uye4OrganizasyonRol?: GenOrganizasyonRol;
    public uye5OrganizasyonRol?: GenOrganizasyonRol;
    public gorev1OrganizasyonRol?: GenOrganizasyonRol;
    public gorev2OrganizasyonRol?: GenOrganizasyonRol;
    public gorev3OrganizasyonRol?: GenOrganizasyonRol;
    public gorev4OrganizasyonRol?: GenOrganizasyonRol;
    public gorev5OrganizasyonRol?: GenOrganizasyonRol;
    public paGorevOrganizasyonRol?: GenOrganizasyonRol;
    public paOnayOrganizasyonRol?: GenOrganizasyonRol;
    public tetkikOrganizasyonRol?: GenOrganizasyonRol;
    public yonYrdOrganizasyonRol?: GenOrganizasyonRol;
    public yoneticiOrganizasyonRol?: GenOrganizasyonRol;

    public constructor(init?: Partial<StsIhaleImza>) { super(init); (Object as any).assign(this, init); }
}

export class TebFaaliyetDetay extends CommonEntityBase
{
    public belediyeKod: number;
    public birimTeklif?: number;
    public birimYil1?: number;
    public birimYil2?: number;
    public butceIslemSekli?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirButcesiEh: string;
    public donem: number;
    public ekAkFaaliyetKod?: number;
    public ekoGiderKod: string;
    public encumenTeklif?: number;
    public encumenYil1?: number;
    public encumenYil2?: number;
    public faaliyetAnaKod: number;
    public faaliyetKod: string;
    public finansmanKod: string;
    public fisNo?: number;
    public fisNo1?: number;
    public fisTarih?: string;
    public fonksiyonelKod: string;
    public haziranHarcama?: number;
    public islemTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumsalKod: string;
    public maliTeklif?: number;
    public maliYil1?: number;
    public maliYil2?: number;
    public meclisTeklif?: number;
    public meclisYil1?: number;
    public meclisYil2?: number;
    public oncekiHarcama?: number;
    public turu: number;
    public ustYoneticiTeklif?: number;
    public ustYoneticiYil1?: number;
    public ustYoneticiYil2?: number;
    public yilsonuTahmin?: number;
    public tebFaaliyet: TebFaaliyet;
    public tebFinansman?: TebFinansman;
    public tebFonksiyon?: TebFonksiyon;
    public tebGider?: TebGider;
    public tebKurumSinif?: TebKurumSinif;
    public temFis?: TemFis;

    public constructor(init?: Partial<TebFaaliyetDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TebStratejikButce extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stratejikPerformansKod: number;
    public tahminButce: number;
    public yil: number;
    public tebStratejikPerformans: TebStratejikPerformans;

    public constructor(init?: Partial<TebStratejikButce>) { super(init); (Object as any).assign(this, init); }
}

export class TebStratejikGosterge extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gostergeAd: string;
    public gostergeKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stratejikPerformansKod: number;
    public tebStratejikPerformans: TebStratejikPerformans;

    public constructor(init?: Partial<TebStratejikGosterge>) { super(init); (Object as any).assign(this, init); }
}

export class TebStratejikPlan extends CommonEntityBase
{
    public aciklama?: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilkYil: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sonYil: number;
    public tebStratejikAmacs: TebStratejikAmac[];

    public constructor(init?: Partial<TebStratejikPlan>) { super(init); (Object as any).assign(this, init); }
}

export class TebStratejikAmac extends CommonEntityBase
{
    public amacAd: string;
    public amacKod: string;
    public amacNotlar?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stratejikKod: number;
    public tebStratejikHedefs: TebStratejikHedef[];
    public tebStratejikPlan: TebStratejikPlan;

    public constructor(init?: Partial<TebStratejikAmac>) { super(init); (Object as any).assign(this, init); }
}

export class TebStratejikHedef extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hedefAd: string;
    public hedefKod: string;
    public hedefNotlar?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stratejikAmacKod: number;
    public tebStratejikAmac: TebStratejikAmac;
    public tebStratejikPerformans: TebStratejikPerformans[];

    public constructor(init?: Partial<TebStratejikHedef>) { super(init); (Object as any).assign(this, init); }
}

export class TebStratejikPerformans extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public performansAd: string;
    public performansKod: string;
    public performansNotlar?: string;
    public stratejikHedefKod: number;
    public tebFaaliyets: TebFaaliyet[];
    public tebStratejikButces: TebStratejikButce[];
    public tebStratejikGosterges: TebStratejikGosterge[];
    public tebStratejikHedef: TebStratejikHedef;

    public constructor(init?: Partial<TebStratejikPerformans>) { super(init); (Object as any).assign(this, init); }
}

export class TebFaaliyet extends CommonEntityBase
{
    public adi: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public faaliyetKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumsalKod: string;
    public stratejikPerformansKod: number;
    public tebFaaliyetDetays: TebFaaliyetDetay[];
    public tebStratejikPerformans: TebStratejikPerformans;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TebFaaliyet>) { super(init); (Object as any).assign(this, init); }
}

export class StsIhale extends CommonEntityBase
{
    public alimTuruKod?: number;
    public arzPerKod?: number;
    public arzRolAd?: string;
    public arzTarih?: string;
    public avansSarti?: string;
    public baskanOnayTarih?: string;
    public beklenenSonTarih?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dmoEh: string;
    public dogrudanTeminEh: string;
    public dogrudanTeminTuru?: string;
    public donem: number;
    public dosyaAdi: string;
    public dosyaNo: number;
    public encumenNo?: string;
    public encumenTarih?: string;
    public evrakNo?: number;
    public evrakTarih?: string;
    public fiyatFarkDayanak?: string;
    public harcamaKod?: number;
    public hizmetTutar?: number;
    public ihaleDokBedeli?: number;
    public ihaleIptalTarih?: string;
    public ihaleMaddeKod: number;
    public ihaleNo?: string;
    public ihaleOnayEh: string;
    public ihaleSaat?: string;
    public ihaleSekliKod: number;
    public ihaleTarih?: string;
    public ilanSekli?: string;
    public isNitelik?: string;
    public istekFisKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullanOdenek?: number;
    public kurumsalKod: string;
    public notlar?: string;
    public onayPerKod?: number;
    public onayRolAd?: string;
    public onayTarih?: string;
    public paraBirimKod?: number;
    public projeNo?: string;
    public talepFisNo?: string;
    public talepPerKod?: number;
    public talepRolAd?: string;
    public talepTarih: string;
    public webYayinEh: string;
    public yatirimKod?: string;
    public genKodAlimTuru?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;
    public pysTaseronFirmaSozlesmes: PysTaseronFirmaSozlesme[];
    public stsIhaleBelges: StsIhaleBelge[];
    public stsIhaleDetays: StsIhaleDetay[];
    public stsIhaleImza: StsIhaleImza;
    public stsIhaleMadde: StsIhaleMadde;
    public stsIhaleSekli: StsIhaleSekli;
    public stsMuayenes: StsMuayene[];
    public stsMuayeneDetays: StsMuayeneDetay[];
    public stsOnMuayenes: StsOnMuayene[];
    public stsTeklifs: StsTeklif[];
    public stsTeklifDetays: StsTeklifDetay[];
    public temHarcamaTalimat?: TemHarcamaTalimat;
    public arzOrganizasyonRol?: GenOrganizasyonRol;
    public onayOrganizasyonRol?: GenOrganizasyonRol;
    public talepOrganizasyonRol?: GenOrganizasyonRol;
    public tebFaaliyet?: TebFaaliyet;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<StsIhale>) { super(init); (Object as any).assign(this, init); }
}

export class PysTaseronFirmaSozlesme extends CommonEntityBase
{
    public aciklama?: string;
    public baslangicTarih?: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ihaleBirimKod: number;
    public ihaleEkapNo?: string;
    public ihaleTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sozlemeIsAdi: string;
    public stsIhaleKod?: number;
    public taseronFirmaKod: number;
    public genBirim: GenBirim;
    public pysTaseronFirma: PysTaseronFirma;
    public pysTaseronFirmaKatsayis: PysTaseronFirmaKatsayi[];
    public stsIhale?: StsIhale;

    public constructor(init?: Partial<PysTaseronFirmaSozlesme>) { super(init); (Object as any).assign(this, init); }
}

export class PysTaseronFirmaKatsayi extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaTarih?: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taseronFirmaSozlesmeKod?: number;
    public pysTaseronFirmaKatsayiDties: PysTaseronFirmaKatsayiDty[];
    public pysTaseronFirmaSozlesme?: PysTaseronFirmaSozlesme;

    public constructor(init?: Partial<PysTaseronFirmaKatsayi>) { super(init); (Object as any).assign(this, init); }
}

export class PysTaseronFirmaKatsayiDty extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public katsayi: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taseronFirmaKatsayiKod: number;
    public taseronGorevTanimKod: number;
    public pysKodDetay: PysKodDetay;
    public pysTaseronFirmaKatsayi: PysTaseronFirmaKatsayi;

    public constructor(init?: Partial<PysTaseronFirmaKatsayiDty>) { super(init); (Object as any).assign(this, init); }
}

export class PysKodDetay extends CommonEntityBase
{
    public adi?: string;
    public anaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hitapKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ozelKod?: string;
    public pysKodAna: PysKodAna;
    public pysStajOkulKodDetays: PysStajOkulKodDetay[];
    public pysTaseronFirmaKatsayiDties: PysTaseronFirmaKatsayiDty[];
    public pysUnvanDetays: PysUnvanDetay[];

    public constructor(init?: Partial<PysKodDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PysMemKazancTanimDetay extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinEh: string;
    public emekliHesapEh: string;
    public formul?: string;
    public gelirTanimKod: number;
    public haftaTatiliDusEh: string;
    public hangiAylarVerilecek?: string;
    public hesapSekli?: number;
    public icraEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancAd: string;
    public kazancKod: number;
    public kazancTip?: string;
    public kazancTuru?: string;
    public kefaletEh: string;
    public kisaAdGrup?: string;
    public kod: number;
    public mesaiKontrolEh: string;
    public netOdemeEh: string;
    public oncelikSirasi?: number;
    public puanHangiKazanctan?: number;
    public puantajGosterEh: string;
    public renkPaleti?: string;
    public siraNo: number;
    public tasarrufHesapEh: string;
    public ucretEh: string;
    public vekaletEh: string;
    public vekilEh: string;
    public vergiHesapEh: string;
    public pysMemKazancAd: PysMemKazancAd;

    public constructor(init?: Partial<PysMemKazancTanimDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PysMemKazancAd extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public damgaPulHesapEh: string;
    public dayanakAciklamasi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinEh: string;
    public emekliHesapEh: string;
    public formul?: string;
    public haftaTatiliDusEh: string;
    public hangiAylarVerilecek?: string;
    public hesapSekli?: number;
    public icraEh: string;
    public ikincilMevzuat?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancAd: string;
    public kazancTip?: string;
    public kazancTuru?: string;
    public kefaletEh: string;
    public kisaAdGrup?: string;
    public kod: number;
    public mesaiKontrolEh: string;
    public mevzuatAdi?: string;
    public mevzuatMaddesi?: string;
    public netOdemeEh: string;
    public oncelikSirasi?: number;
    public puanHangiKazanctan?: number;
    public puantajGosterEh: string;
    public renkPaleti?: string;
    public siraNo: number;
    public tasarrufHesapEh: string;
    public ucretEh: string;
    public vekaletEh: string;
    public vekilEh: string;
    public vergiHesapEh: string;
    public pysMemKazancTanimDetays: PysMemKazancTanimDetay[];
    public pysUnvanDetayGelirs: PysUnvanDetayGelir[];

    public constructor(init?: Partial<PysMemKazancAd>) { super(init); (Object as any).assign(this, init); }
}

export class PysUnvanDetayGelir extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaTarih?: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gostergePuan?: number;
    public gostergePuan1?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kazancKod?: number;
    public kod: number;
    public tutar?: number;
    public tutar1?: number;
    public unvanDetayKod?: number;
    public pysMemKazancAd?: PysMemKazancAd;
    public pysUnvanDetay?: PysUnvanDetay;

    public constructor(init?: Partial<PysUnvanDetayGelir>) { super(init); (Object as any).assign(this, init); }
}

export class PysUnvanDetay extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hizmetSinifKod: number;
    public hizmetYerTurKod: number;
    public kadroDereceKod: number;
    public kadroTurKod: number;
    public kariyerKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ogrenimTuruKod: number;
    public tutar?: number;
    public unvanKod: number;
    public ikaSinif: IkaSinif;
    public ikaUnvan: IkaUnvan;
    public pysKadroDerece: PysKadroDerece;
    public pysKodDetay: PysKodDetay;
    public pysUnvanDetayGelirs: PysUnvanDetayGelir[];

    public constructor(init?: Partial<PysUnvanDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaSinif extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisaAd: string;
    public kod: number;
    public ikaKadroIhdasDetays: IkaKadroIhdasDetay[];
    public ikaKadroIhdasDetays1: IkaKadroIhdasDetay[];
    public ikaMemKadros: IkaMemKadro[];
    public ikaMemKadroIhdasDetays: IkaMemKadroIhdasDetay[];
    public ikaMemKadroIhdasDetays1: IkaMemKadroIhdasDetay[];
    public ikaPersonelHizmets: IkaPersonelHizmet[];
    public ikaPersonelRols: IkaPersonelRol[];
    public pysUnvanDetays: PysUnvanDetay[];

    public constructor(init?: Partial<IkaSinif>) { super(init); (Object as any).assign(this, init); }
}

export class IkaKadroIhdasDetay extends CommonEntityBase
{
    public adet: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece?: number;
    public gerekce?: string;
    public kadroIhdasKod: number;
    public kaldirAdet?: number;
    public kaldirDerece?: number;
    public kaldirSinifKod?: number;
    public kaldirUnvanKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sinifKod?: number;
    public unvanKod: number;
    public ikaKadroIhdas: IkaKadroIhdas;
    public ikaSinif?: IkaSinif;
    public ikaSinif1?: IkaSinif;
    public ikaUnvan?: IkaUnvan;
    public ikaUnvan1: IkaUnvan;

    public constructor(init?: Partial<IkaKadroIhdasDetay>) { super(init); (Object as any).assign(this, init); }
}

export class MksKararDetay extends CommonEntityBase
{
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBelgeTip: GenBelgeTip;
    public mksKarar: MksKarar;

    public constructor(init?: Partial<MksKararDetay>) { super(init); (Object as any).assign(this, init); }
}

export class MksKararEk extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgeNo?: number;
    public belgePath?: string;
    public belgeTarih?: string;
    public belgeTipKod: number;
    public belgeTuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public referansKod?: number;
    public genBelgeTip: GenBelgeTip;
    public genBelgeTuru: GenBelgeTuru;
    public mksKarar: MksKarar;
    public bysBelge?: BysBelge;

    public constructor(init?: Partial<MksKararEk>) { super(init); (Object as any).assign(this, init); }
}

export class MksKararIcerik extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararIcerik?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mksKarar: MksKarar;

    public constructor(init?: Partial<MksKararIcerik>) { super(init); (Object as any).assign(this, init); }
}

export class MksKararOzet extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kararOzetAciklama?: string;
    public kararOzetIcerik?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mksKarar: MksKarar;

    public constructor(init?: Partial<MksKararOzet>) { super(init); (Object as any).assign(this, init); }
}

export class MksKararParsel extends CommonEntityBase
{
    public aciklama?: string;
    public ada: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pafta?: string;
    public parsel: number;
    public parselKod?: number;
    public aksParsel?: AksParsel;
    public mksKarar: MksKarar;

    public constructor(init?: Partial<MksKararParsel>) { super(init); (Object as any).assign(this, init); }
}

export class MksGundem extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gundemNo: string;
    public gundemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mksGundemDetays: MksGundemDetay[];

    public constructor(init?: Partial<MksGundem>) { super(init); (Object as any).assign(this, init); }
}

export class MksGundemDetay extends CommonEntityBase
{
    public aciklama?: string;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakHavaleTarih?: string;
    public evrakNo?: number;
    public evrakTarih?: string;
    public gundemKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKararKod?: number;
    public konusu?: string;
    public siraNo: number;
    public sonucTurKod?: number;
    public genBirim: GenBirim;
    public genKodDetay?: GenKodDetay;
    public mksGundem: MksGundem;
    public mksKomisyonKarar?: MksKomisyonKarar;

    public constructor(init?: Partial<MksGundemDetay>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyonKararDetay extends CommonEntityBase
{
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKararKod: number;
    public genBelgeTip: GenBelgeTip;
    public mksKomisyonKarar: MksKomisyonKarar;

    public constructor(init?: Partial<MksKomisyonKararDetay>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyonKararEk extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgeNo?: number;
    public belgePath?: string;
    public belgeTarih?: string;
    public belgeTipKod: number;
    public belgeTuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKararKod: number;
    public referansKod?: number;
    public genBelgeTip: GenBelgeTip;
    public genBelgeTuru: GenBelgeTuru;
    public mksKomisyonKarar: MksKomisyonKarar;
    public bysBelge?: BysBelge;

    public constructor(init?: Partial<MksKomisyonKararEk>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyonKararIcerik extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararIcerik?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKararKod: number;
    public mksKomisyonKarar: MksKomisyonKarar;

    public constructor(init?: Partial<MksKomisyonKararIcerik>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyonKararUye extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikTurKod?: number;
    public imzaEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKararKod: number;
    public siraNo: number;
    public uyeKod: number;
    public mksDevamsizlikTur?: MksDevamsizlikTur;
    public mksKomisyonKarar: MksKomisyonKarar;
    public mksUye: MksUye;

    public constructor(init?: Partial<MksKomisyonKararUye>) { super(init); (Object as any).assign(this, init); }
}

export class MksKonular extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mksKarars: MksKarar[];
    public mksKomisyonKarars: MksKomisyonKarar[];

    public constructor(init?: Partial<MksKonular>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyonKarar extends CommonEntityBase
{
    public anahtarKelime?: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakNo?: string;
    public evrakTarih?: string;
    public kararAciklama?: string;
    public kararKod?: number;
    public kararNo: string;
    public kararTarih: string;
    public kararTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci: string;
    public kod: number;
    public komisyonKod: number;
    public konuKod: number;
    public oylamaTuru: number;
    public saat?: string;
    public sonucTurKod?: number;
    public genBirim?: GenBirim;
    public genKodDetay?: GenKodDetay;
    public mksGundemDetays: MksGundemDetay[];
    public mksKarar?: MksKarar;
    public mksKomisyon: MksKomisyon;
    public mksKomisyonKararDetay: MksKomisyonKararDetay;
    public mksKomisyonKararEks: MksKomisyonKararEk[];
    public mksKomisyonKararIcerik: MksKomisyonKararIcerik;
    public mksKomisyonKararUyes: MksKomisyonKararUye[];
    public mksKonular: MksKonular;

    public constructor(init?: Partial<MksKomisyonKarar>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyonUye extends CommonEntityBase
{
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKod: number;
    public siraNo: number;
    public uyeKod: number;
    public mksKomisyon: MksKomisyon;
    public mksUye: MksUye;

    public constructor(init?: Partial<MksKomisyonUye>) { super(init); (Object as any).assign(this, init); }
}

export class MksKomisyon extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mksKarars: MksKarar[];
    public mksKomisyonKarars: MksKomisyonKarar[];
    public mksKomisyonUyes: MksKomisyonUye[];

    public constructor(init?: Partial<MksKomisyon>) { super(init); (Object as any).assign(this, init); }
}

export class MksKarar extends CommonEntityBase
{
    public anahtarKelime?: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakNo?: string;
    public evrakTarih?: string;
    public genelArsivKod?: number;
    public gundemKod?: number;
    public gundemSiraNo?: number;
    public kararAciklama?: string;
    public kararNo: string;
    public kararTarih: string;
    public kararTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci?: string;
    public kod: number;
    public komisyonKod?: number;
    public konuKod: number;
    public oylamaTuru: number;
    public saat?: string;
    public sonucTurKod?: number;
    public toplantiNo?: string;
    public webYayiniEh: string;
    public yazimTuru: string;
    public gasDosya?: GasDosya;
    public genBirim: GenBirim;
    public genKodDetay?: GenKodDetay;
    public mksKararDetay: MksKararDetay;
    public mksKararEks: MksKararEk[];
    public mksKararIcerik: MksKararIcerik;
    public mksKararOzet: MksKararOzet;
    public mksKararParsels: MksKararParsel[];
    public mksKararUyes: MksKararUye[];
    public mksKomisyon?: MksKomisyon;
    public mksKomisyonKarars: MksKomisyonKarar[];
    public mksKonular: MksKonular;

    public constructor(init?: Partial<MksKarar>) { super(init); (Object as any).assign(this, init); }
}

export class MksKararUye extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikTurKod?: number;
    public imzaEh: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public uyeKod: number;
    public mksDevamsizlikTur?: MksDevamsizlikTur;
    public mksKarar: MksKarar;
    public mksUye: MksUye;

    public constructor(init?: Partial<MksKararUye>) { super(init); (Object as any).assign(this, init); }
}

export class MksDevamsizlikTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mksGundemDetayUyes: MksGundemDetayUye[];
    public mksKararUyes: MksKararUye[];
    public mksKomisyonKararUyes: MksKomisyonKararUye[];

    public constructor(init?: Partial<MksDevamsizlikTur>) { super(init); (Object as any).assign(this, init); }
}

export class MksGundemDetayUye extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikTurKod?: number;
    public gundemKod: number;
    public gundemSiraNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public uyeKod: number;
    public mksDevamsizlikTur?: MksDevamsizlikTur;
    public mksUye: MksUye;
    public mksGundemDetay?: MksGundemDetay;

    public constructor(init?: Partial<MksGundemDetayUye>) { super(init); (Object as any).assign(this, init); }
}

export class MksUye extends CommonEntityBase
{
    public adSoyad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevi?: string;
    public imzaEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public rolAd?: string;
    public siraNo?: number;
    public unvanKod?: number;
    public uyeBaslangicTarih: string;
    public uyeSonucAciklama?: string;
    public uyeSonucTarih?: string;
    public ikaPersonel?: IkaPersonel;
    public ikaUnvan?: IkaUnvan;
    public mksGundemDetayUyes: MksGundemDetayUye[];
    public mksKararUyes: MksKararUye[];
    public mksKomisyonKararUyes: MksKomisyonKararUye[];
    public mksKomisyonUyes: MksKomisyonUye[];
    public genOrganizasyon?: GenOrganizasyon;

    public constructor(init?: Partial<MksUye>) { super(init); (Object as any).assign(this, init); }
}

export class YisUye extends CommonEntityBase
{
    public adSoyad: string;
    public aktifEh: string;
    public baskanEh?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevi?: string;
    public grupTurKod: number;
    public imzaEh: string;
    public katipYardimciEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public onAdi?: string;
    public personelKod?: number;
    public rolAd?: string;
    public siraNo?: number;
    public siyasiPartiKod?: number;
    public ucret?: number;
    public unvanKod?: number;
    public uyeBaslangicTarih: string;
    public uyeSonucAciklama?: string;
    public uyeSonucTarih?: string;
    public genBelediye: GenBelediye;
    public ikaPersonel?: IkaPersonel;
    public ikaUnvan?: IkaUnvan;

    public constructor(init?: Partial<YisUye>) { super(init); (Object as any).assign(this, init); }
}

export class IkaUnvan extends CommonEntityBase
{
    public ad: string;
    public belediyeAktifEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public standartAktifEh?: string;
    public eksUyes: EksUye[];
    public genRaporImzaDetays: GenRaporImzaDetay[];
    public ikaIscKadros: IkaIscKadro[];
    public ikaIscKadroIhdasDetays: IkaIscKadroIhdasDetay[];
    public ikaIscKadroIhdasDetays1: IkaIscKadroIhdasDetay[];
    public ikaIscMaasSicils: IkaIscMaasSicil[];
    public ikaKadroIhdasDetays: IkaKadroIhdasDetay[];
    public ikaKadroIhdasDetays1: IkaKadroIhdasDetay[];
    public ikaMemKadros: IkaMemKadro[];
    public ikaMemKadroIhdasDetays: IkaMemKadroIhdasDetay[];
    public ikaMemKadroIhdasDetays1: IkaMemKadroIhdasDetay[];
    public ikaMemMaasSicils: IkaMemMaasSicil[];
    public ikaPersonelHizmets: IkaPersonelHizmet[];
    public ikaPersonelIscis: IkaPersonelIsci[];
    public ikaPersonelMemurs: IkaPersonelMemur[];
    public ikaPersonelRols: IkaPersonelRol[];
    public mksUyes: MksUye[];
    public pysUnvanDetays: PysUnvanDetay[];
    public yisUyes: YisUye[];

    public constructor(init?: Partial<IkaUnvan>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemGosterge extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece: number;
    public gosterge: number;
    public kademe: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;

    public constructor(init?: Partial<IkaMemGosterge>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelMemur extends CommonEntityBase
{
    public ailePuan?: number;
    public aylikDerece: number;
    public aylikEkGosterge?: number;
    public aylikKademe: number;
    public baslamaTarih?: string;
    public baslamaTurKod?: number;
    public belediyeKod: number;
    public besFirmaKod?: number;
    public besKesintiOran?: number;
    public bitisTarih?: string;
    public bitisTurKod?: number;
    public borclanmaTutar?: number;
    public burutMaas?: number;
    public calismaGun?: number;
    public cocukEh?: string;
    public cocukPuan?: number;
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekHizmetPuan?: number;
    public ekOzelHizmetPuan?: number;
    public emekliDerece: number;
    public emekliEkGosterge?: number;
    public emekliHesapEh: string;
    public emekliKademe: number;
    public fiiliHizmetGun?: number;
    public fiiliHizmetKod?: number;
    public girisAidat?: number;
    public gorevBirimKod: number;
    public gorevPuan?: number;
    public gssKesilsinEh?: string;
    public hayatSigortaTuru?: string;
    public hayatSigortaTutar?: number;
    public hesapTuru: string;
    public isGuclukPuan?: number;
    public isRiskiPuan?: number;
    public itfaiyeMesaiGun?: number;
    public kadroBirimKod: number;
    public kadroDerece?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletTuru?: string;
    public kidemYil?: number;
    public kod: number;
    public lojmanPuan?: number;
    public maasOran?: number;
    public maasTuru: string;
    public makamPuan?: number;
    public maliSorumlulukPuan?: number;
    public netMaas?: number;
    public nettenBurutEh: string;
    public ohalPuan?: number;
    public ozelHizmetPuan?: number;
    public personelKod: number;
    public sakatlikGrup?: string;
    public sendika1Kod?: number;
    public sendika1Turu?: string;
    public sendika2Kod?: number;
    public sendika2Turu?: string;
    public sosyalDengePuan?: number;
    public sosyalDengeTutar?: number;
    public tabanPuan?: number;
    public temindeGuclukPuan?: number;
    public temsilPuan?: number;
    public toplamRaporGun?: number;
    public ucretsizIzinliEh: string;
    public unvanKod?: number;
    public vekDerece?: number;
    public vekEkGosterge?: number;
    public vekKademe?: number;
    public vekOzelHizmet?: number;
    public vekYanOdeme?: number;
    public vergiGrup?: string;
    public vergiHesapEh: string;
    public yabanciDilPuan?: number;
    public yemekGun?: number;
    public zabitaItfaiye?: string;
    public zabitaMesaiGun?: number;
    public genBirim: GenBirim;
    public genBirim1: GenBirim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public ikaFiiliHizmetTur?: IkaFiiliHizmetTur;
    public ikaMemBesFirma?: IkaMemBesFirma;
    public ikaMemSendika?: IkaMemSendika;
    public ikaMemSendika1?: IkaMemSendika;
    public ikaPersonel: IkaPersonel;
    public ikaUnvan?: IkaUnvan;
    public aylikMemGosterge?: IkaMemGosterge;
    public emekliMemGosterge?: IkaMemGosterge;

    public constructor(init?: Partial<IkaPersonelMemur>) { super(init); (Object as any).assign(this, init); }
}

export class IkaFiiliHizmetTur extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gun?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ikaMemMaasSicils: IkaMemMaasSicil[];
    public ikaPersonelMemurs: IkaPersonelMemur[];

    public constructor(init?: Partial<IkaFiiliHizmetTur>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemMaasSicil extends CommonEntityBase
{
    public ailePuan?: number;
    public aylikDerece: number;
    public aylikEkGosterge?: number;
    public aylikKademe: number;
    public baslamaTarih?: string;
    public baslamaTurKod?: number;
    public belediyeKod: number;
    public besFirmaKod?: number;
    public besKesintiOran?: number;
    public bitisTarih?: string;
    public bitisTurKod?: number;
    public borclanmaTutar?: number;
    public burutMaas?: number;
    public calismaGun?: number;
    public cocukEh?: string;
    public cocukPuan?: number;
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public ekHizmetPuan?: number;
    public ekOzelHizmetPuan?: number;
    public emekliDerece: number;
    public emekliEkGosterge?: number;
    public emekliHesapEh: string;
    public emekliKademe: number;
    public fiiliHizmetGun?: number;
    public fiiliHizmetKod?: number;
    public girisAidat?: number;
    public gorevBirimKod: number;
    public gorevPuan?: number;
    public gssKesilsinEh?: string;
    public hayatSigortaTuru?: string;
    public hayatSigortaTutar?: number;
    public hesapTuru: string;
    public ibanNo?: string;
    public isGuclukPuan?: number;
    public isRiskiPuan?: number;
    public itfaiyeMesaiGun?: number;
    public izinGun?: number;
    public kadroBirimKod: number;
    public kadroDerece?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletTuru?: string;
    public kidemYil?: number;
    public kod: number;
    public lojmanPuan?: number;
    public maasOran?: number;
    public maasTuru: string;
    public makamPuan?: number;
    public maliSorumlulukPuan?: number;
    public netMaas?: number;
    public nettenBurutEh: string;
    public ohalPuan?: number;
    public ozelHizmetPuan?: number;
    public personelKod: number;
    public raporGun?: number;
    public sakatlikGrup?: string;
    public sendika1Kod?: number;
    public sendika1Turu?: string;
    public sendika2Kod?: number;
    public sendika2Turu?: string;
    public sosyalDengePuan?: number;
    public sosyalDengeTutar?: number;
    public tabanPuan?: number;
    public temindeGuclukPuan?: number;
    public temsilPuan?: number;
    public terfiDerece?: number;
    public terfiEkGosterge?: number;
    public terfiKademe?: number;
    public terfiKidemYil?: number;
    public terfiTarih?: string;
    public ucretsizIzinliEh: string;
    public unvanKod?: number;
    public vekCalismaGun?: number;
    public vekDerece?: number;
    public vekEkGosterge?: number;
    public vekKademe?: number;
    public vekOzelHizmet?: number;
    public vekYanOdeme?: number;
    public vergiGrup?: string;
    public vergiHesapEh: string;
    public yabanciDilPuan?: number;
    public yemekGun?: number;
    public zabitaMesaiGun?: number;
    public genBirim: GenBirim;
    public genBirim1: GenBirim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public ikaFiiliHizmetTur?: IkaFiiliHizmetTur;
    public ikaMaasMuhasebes: IkaMaasMuhasebe[];
    public ikaMemBesFirma?: IkaMemBesFirma;
    public ikaMemDonem: IkaMemDonem;
    public ikaMemSendika?: IkaMemSendika;
    public ikaMemSendika1?: IkaMemSendika;
    public ikaUnvan?: IkaUnvan;
    public aylikMemGosterge?: IkaMemGosterge;
    public emekliMemGosterge?: IkaMemGosterge;
    public terfiMemGosterge?: IkaMemGosterge;
    public ikaPersonelMemur?: IkaPersonelMemur;

    public constructor(init?: Partial<IkaMemMaasSicil>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMaasMuhasebe extends CommonEntityBase
{
    public birimFisKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public fisKod?: number;
    public huzurMaasKod?: number;
    public iscMaasKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public memMaasKod?: number;
    public ikaHuzurMaas?: IkaHuzurMaas;
    public ikaIscMaasSicil?: IkaIscMaasSicil;
    public ikaMemMaasSicil?: IkaMemMaasSicil;
    public temBirimFis?: TemBirimFis;
    public temFis?: TemFis;

    public constructor(init?: Partial<IkaMaasMuhasebe>) { super(init); (Object as any).assign(this, init); }
}

export class IkaSgkKanunTuru extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: string;
    public ikaIscMaasSicils: IkaIscMaasSicil[];
    public ikaPersonelIscis: IkaPersonelIsci[];

    public constructor(init?: Partial<IkaSgkKanunTuru>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscMaasSicil extends CommonEntityBase
{
    public aileEh: string;
    public belediyeKod: number;
    public besFirmaKod?: number;
    public besKesintiOran?: number;
    public calismaGun?: number;
    public calismaHizmetGun?: number;
    public cikisTarihi?: string;
    public cocukEh: string;
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinKatsayi?: number;
    public donemKod: number;
    public emekliEh: string;
    public eskiYevmiye?: number;
    public girisTarihi?: string;
    public gorevBirimKod: number;
    public hayatSigortaTuru?: string;
    public hayatSigortaTutar?: number;
    public ibanNo?: string;
    public ikramiyeMatrah?: number;
    public issizlikHesapEh: string;
    public izinGun?: number;
    public izinTutar?: number;
    public kadroBirimKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletTuru?: string;
    public kod: number;
    public netMaas?: number;
    public nettenBurutEh: string;
    public personelKod: number;
    public raporTutar?: number;
    public sakatlikGrup?: string;
    public sendikaKod?: number;
    public sendikaTuru?: string;
    public sgkBelgeTurKod?: number;
    public sgkCikisTurKod?: number;
    public sgkEksikGun?: number;
    public sgkEksikGunKod?: number;
    public sgkFiiliGun?: number;
    public sgkFiiliHizmet?: number;
    public sgkHesapEh: string;
    public sgkKanunKod?: string;
    public sigortaGun?: number;
    public sskBorclanmaTutar?: number;
    public ucretsizGun?: number;
    public unvanKod?: number;
    public vergiGrup?: string;
    public vergiHesapEh: string;
    public yevmiye?: number;
    public genBirim: GenBirim;
    public genBirim1: GenBirim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public ikaIscBesFirma?: IkaIscBesFirma;
    public ikaIscDonem: IkaIscDonem;
    public ikaIscSendika?: IkaIscSendika;
    public ikaMaasMuhasebes: IkaMaasMuhasebe[];
    public ikaSgkKanunTuru?: IkaSgkKanunTuru;
    public ikaUnvan?: IkaUnvan;
    public ikaPersonelIsci?: IkaPersonelIsci;

    public constructor(init?: Partial<IkaIscMaasSicil>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscSendika extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public dayanismaGunEh: string;
    public dayanismaKesintiKod?: number;
    public dayanismaOran: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public sendikaGunEh: string;
    public sendikaKesintiKod?: number;
    public sendikaOran: number;
    public telAlanKod?: number;
    public telTelefon?: string;
    public genKisi?: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public ikaIscKesinti?: IkaIscKesinti;
    public ikaIscKesinti1?: IkaIscKesinti;
    public ikaIscMaasSicils: IkaIscMaasSicil[];
    public ikaPersonelIscis: IkaPersonelIsci[];

    public constructor(init?: Partial<IkaIscSendika>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscMaasKesintiDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiKod: number;
    public kesintiTutar?: number;
    public kod: number;
    public personelKesintiKod: number;
    public personelKod: number;
    public ikaPersonelIsciKesinti: IkaPersonelIsciKesinti;
    public ikaIscDonemKesinti: IkaIscDonemKesinti;
    public ikaIscMaasSicil: IkaIscMaasSicil;

    public constructor(init?: Partial<IkaIscMaasKesintiDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelIsciKesinti extends CommonEntityBase
{
    public aciklama?: string;
    public alacakli?: string;
    public anaParaTutar?: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKapandiEh: string;
    public dosyaNo?: string;
    public evrakNo?: number;
    public faizTutar?: number;
    public gelisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefil?: string;
    public kesintiKod: number;
    public kesintiOran?: number;
    public kesintiSekli: string;
    public kesintiTuru: string;
    public kesintiTutar?: number;
    public kod: number;
    public personelKod: number;
    public raporAyakta?: number;
    public raporYatak?: number;
    public sgkGun?: number;
    public sgkMatrah?: number;
    public siraNo?: number;
    public taahhutEh: string;
    public toplamTutar?: number;
    public ikaIscKesinti: IkaIscKesinti;
    public ikaIscMaasKesintiDetays: IkaIscMaasKesintiDetay[];
    public ikaPersonelIsci?: IkaPersonelIsci;

    public constructor(init?: Partial<IkaPersonelIsciKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscKesinti extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hesapSekli: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiAd: string;
    public kesintiTuru: string;
    public kod: number;
    public siraNo: number;
    public vergiDusEh: string;
    public ikaIscBesFirmas: IkaIscBesFirma[];
    public ikaIscDonemKatsayis: IkaIscDonemKatsayi[];
    public ikaIscDonemKatsayis1: IkaIscDonemKatsayi[];
    public ikaIscDonemKatsayis2: IkaIscDonemKatsayi[];
    public ikaIscDonemKesintis: IkaIscDonemKesinti[];
    public ikaIscSendikas: IkaIscSendika[];
    public ikaIscSendikas1: IkaIscSendika[];
    public ikaPersonelIsciKesintis: IkaPersonelIsciKesinti[];

    public constructor(init?: Partial<IkaIscKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscBesFirma extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public besKesintiKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public telAlanKod?: number;
    public telTelefon?: string;
    public genKisi?: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public ikaIscKesinti?: IkaIscKesinti;
    public ikaIscMaasSicils: IkaIscMaasSicil[];
    public ikaPersonelIscis: IkaPersonelIsci[];

    public constructor(init?: Partial<IkaIscBesFirma>) { super(init); (Object as any).assign(this, init); }
}

export class IkaSgkMeslek extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: string;
    public ikaPersonelIscis: IkaPersonelIsci[];

    public constructor(init?: Partial<IkaSgkMeslek>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelIsci extends CommonEntityBase
{
    public aileEh: string;
    public belediyeKod: number;
    public besFirmaKod?: number;
    public besKesintiOran?: number;
    public cocukEh: string;
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinKatsayi?: number;
    public emekliEh: string;
    public eskiYevmiye?: number;
    public gorevBirimKod: number;
    public hayatSigortaTuru?: string;
    public hayatSigortaTutar?: number;
    public issizlikHesapEh: string;
    public kadroBirimKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletTuru?: string;
    public kod: number;
    public netMaas?: number;
    public nettenBurutEh: string;
    public personelKod: number;
    public raporTutar?: number;
    public sakatlikGrup?: string;
    public sendikaKod?: number;
    public sendikaTuru?: string;
    public sgkBelgeTurKod?: number;
    public sgkCikisTurKod?: number;
    public sgkEksikGunKod?: number;
    public sgkFiiliGun?: number;
    public sgkFiiliHizmet?: number;
    public sgkHesapEh: string;
    public sgkKanunKod?: string;
    public sgkMeslekKod?: string;
    public sskBorclanmaTutar?: number;
    public unvanKod?: number;
    public vergiGrup?: string;
    public vergiHesapEh: string;
    public yevmiye?: number;
    public genBirim: GenBirim;
    public genBirim1: GenBirim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public ikaIscBesFirma?: IkaIscBesFirma;
    public ikaIscSendika?: IkaIscSendika;
    public ikaPersonel: IkaPersonel;
    public ikaSgkKanunTuru?: IkaSgkKanunTuru;
    public ikaSgkMeslek?: IkaSgkMeslek;
    public ikaUnvan?: IkaUnvan;

    public constructor(init?: Partial<IkaPersonelIsci>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelIsciKazanc extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public katsayi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public personelKod: number;
    public puan?: number;
    public ikaIscKazanc: IkaIscKazanc;
    public ikaPersonelIsci: IkaPersonelIsci;

    public constructor(init?: Partial<IkaPersonelIsciKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscKazanc extends CommonEntityBase
{
    public belediyeKod: number;
    public damgaPulHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinEh: string;
    public hesapSekli: string;
    public issizlikHesapEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancAd: string;
    public kazancTuru: string;
    public kod: number;
    public mesaiKontrolEh: string;
    public netOdemeEh: string;
    public puanTuru?: string;
    public sgkHesapEh: string;
    public siraNo: number;
    public ucretEh: string;
    public vergiHesapEh: string;
    public ikaIscDonemKatsayis: IkaIscDonemKatsayi[];
    public ikaIscDonemKatsayis1: IkaIscDonemKatsayi[];
    public ikaIscDonemKatsayis2: IkaIscDonemKatsayi[];
    public ikaIscDonemKazancs: IkaIscDonemKazanc[];
    public ikaPersonelIsciKazancs: IkaPersonelIsciKazanc[];

    public constructor(init?: Partial<IkaIscKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscDonemKatsayi extends CommonEntityBase
{
    public agiAsgariTutar?: number;
    public aileKazancKod?: number;
    public aileTutar?: number;
    public asgariUcretTutar?: number;
    public asgDamgaIndirimTutar?: number;
    public asgVergiIndirimTutar?: number;
    public cocukKazancKod?: number;
    public cocukTutar?: number;
    public damgaHesapKod?: string;
    public damgaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public disiplinKesintiKod?: number;
    public donemKod: number;
    public gssKisiHesapKod?: string;
    public gssKisiOran?: number;
    public gssKurumHesapKod?: string;
    public gssKurumOran?: number;
    public indirimA?: number;
    public indirimB?: number;
    public indirimC?: number;
    public indirimD?: number;
    public indirimE?: number;
    public indirimF?: number;
    public indirimG?: number;
    public indirimH?: number;
    public indirimI?: number;
    public indirimJ?: number;
    public issizlikKisiHesapKod?: string;
    public issizlikKisiOran?: number;
    public issizlikKurumHesapKod?: string;
    public issizlikKurumOran?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletBesAy?: number;
    public kefaletDigerAy?: number;
    public kefaletKesintiKod?: number;
    public kisaVadeKisiOran?: number;
    public kisaVadeKurumOran?: number;
    public kod: number;
    public kVadeKisiHesapKod?: string;
    public kVadeKurumHesapKod?: string;
    public myoKisiHesapKod?: string;
    public myoKisiOran?: number;
    public myoKurumHesapKod?: string;
    public myoKurumOran?: number;
    public nafakaKesintiKod?: number;
    public netKazancKod?: number;
    public sakatlik1?: number;
    public sakatlik2?: number;
    public sakatlik3?: number;
    public sgkCirakOran?: number;
    public sgkEmekliKisiOran?: number;
    public sgkEmekliKurumOran?: number;
    public sgkTabanMatrah: number;
    public sgkTavanMatrah: number;
    public vergiHesapKod?: string;
    public vergiMatrah1?: number;
    public vergiMatrah2?: number;
    public vergiMatrah3?: number;
    public vergiMatrah4?: number;
    public vergiMatrah5?: number;
    public vergiMatrah6?: number;
    public vergiOran1?: number;
    public vergiOran2?: number;
    public vergiOran3?: number;
    public vergiOran4?: number;
    public vergiOran5?: number;
    public vergiOran6?: number;
    public yuvarlamaDilimi?: number;
    public ikaIscDonem: IkaIscDonem;
    public ikaIscKazanc?: IkaIscKazanc;
    public ikaIscKazanc1?: IkaIscKazanc;
    public ikaIscKazanc2?: IkaIscKazanc;
    public ikaIscKesinti?: IkaIscKesinti;
    public ikaIscKesinti1?: IkaIscKesinti;
    public ikaIscKesinti2?: IkaIscKesinti;

    public constructor(init?: Partial<IkaIscDonemKatsayi>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscDonem extends CommonEntityBase
{
    public anaDonemKod?: number;
    public ay: number;
    public baslamaTarih: string;
    public belediyeKod: number;
    public bitisTarih: string;
    public calismaGun?: number;
    public damgaPulHesapEh: string;
    public damgaPulYSekli?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemAd: string;
    public donemSifre: string;
    public donemTuru: string;
    public fiiliGun?: number;
    public islemTarih: string;
    public issizlikHesapEh: string;
    public issizlikYSekli?: string;
    public kapandiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sgkHesapEh: string;
    public sgkTuru: string;
    public sgkYSekli?: string;
    public siraNo: number;
    public vergiHesapEh: string;
    public vergiYil: number;
    public vergiYSekli?: string;
    public webYayinEh?: string;
    public yil: number;
    public anaIkaIscDonem?: IkaIscDonem;
    public ikaIscDonems: IkaIscDonem[];
    public ikaIscDonemHesaps: IkaIscDonemHesap[];
    public ikaIscDonemKatsayi: IkaIscDonemKatsayi;
    public ikaIscDonemKazancs: IkaIscDonemKazanc[];
    public ikaIscDonemKesintis: IkaIscDonemKesinti[];
    public ikaIscMaasSicils: IkaIscMaasSicil[];

    public constructor(init?: Partial<IkaIscDonem>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscDonemHesap extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public gssKisiHesapKod?: string;
    public gssKurumHesapKod?: string;
    public gssKurumKHesapKod?: string;
    public issizlikKisiHesapKod?: string;
    public issizlikKurumHesapKod?: string;
    public issizlikKurumKHesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kVadeKisiHesapKod?: string;
    public kVadeKurumHesapKod?: string;
    public kVadeKurumKHesapKod?: string;
    public myoKisiHesapKod?: string;
    public myoKurumHesapKod?: string;
    public myoKurumKHesapKod?: string;
    public personelTurKod: number;
    public ikaIscDonem: IkaIscDonem;
    public ikaPersonelTur: IkaPersonelTur;

    public constructor(init?: Partial<IkaIscDonemHesap>) { super(init); (Object as any).assign(this, init); }
}

export class IkaIscDonemKazancHesap extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public hesapKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public personelTurKod: number;
    public ikaPersonelTur: IkaPersonelTur;
    public ikaIscDonemKazanc?: IkaIscDonemKazanc;

    public constructor(init?: Partial<IkaIscDonemKazancHesap>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemDonemKazancHesap extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemKod: number;
    public hesapKod: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public personelTurKod: number;
    public ikaPersonelTur: IkaPersonelTur;
    public ikaMemDonemKazanc?: IkaMemDonemKazanc;

    public constructor(init?: Partial<IkaMemDonemKazancHesap>) { super(init); (Object as any).assign(this, init); }
}

export class PysBesFirmaPersonel extends CommonEntityBase
{
    public aciklama?: string;
    public ayrilmaTarih?: string;
    public baslangicTarih: string;
    public besFirmaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public ikaPersonel: IkaPersonel;
    public pysBesFirma: PysBesFirma;

    public constructor(init?: Partial<PysBesFirmaPersonel>) { super(init); (Object as any).assign(this, init); }
}

export class PysBesFirma extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public besKesintiKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public hesapKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public personelTurKod: number;
    public telAlanKod?: number;
    public telTelefon?: string;
    public genBelediye: GenBelediye;
    public genKisi?: GenKisi;
    public ikaPersonelTur: IkaPersonelTur;
    public pysBesFirmaPersonels: PysBesFirmaPersonel[];

    public constructor(init?: Partial<PysBesFirma>) { super(init); (Object as any).assign(this, init); }
}

export class PysIzinTur extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinGrupAdi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yillikIzinEh: string;
    public genBelediye: GenBelediye;
    public pysIzinTurDetays: PysIzinTurDetay[];

    public constructor(init?: Partial<PysIzinTur>) { super(init); (Object as any).assign(this, init); }
}

export class PysIzinTurDetay extends CommonEntityBase
{
    public ctesiDahilEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hizmetGunDusEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public maksimumIzinSuresi: number;
    public pazarDahilEh: string;
    public personelIzinTurKod: number;
    public personelTurKod: number;
    public raporIzinEh: string;
    public tatilDahilEh: string;
    public yillikIzinDusEh: string;
    public yolIzinEh: string;
    public ikaPersonelTur: IkaPersonelTur;
    public pysIzinTur: PysIzinTur;

    public constructor(init?: Partial<PysIzinTurDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PysSendikaHaklar extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hangiAylar: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kod: number;
    public sendikaSozlesmeKod: number;
    public tutar: number;
    public pysSendikaSozlesme: PysSendikaSozlesme;

    public constructor(init?: Partial<PysSendikaHaklar>) { super(init); (Object as any).assign(this, init); }
}

export class PysSendikaHesapKazanc extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kazancKod: number;
    public kazancOran: number;
    public kod: number;
    public sendikaSozlesmeKod: number;
    public pysSendikaSozlesme: PysSendikaSozlesme;

    public constructor(init?: Partial<PysSendikaHesapKazanc>) { super(init); (Object as any).assign(this, init); }
}

export class PysSendikaSozlesme extends CommonEntityBase
{
    public baslamaTarih: string;
    public belediyeKod: number;
    public bitimTarih: string;
    public dayanismaGunEh?: string;
    public dayanismaHesapKod?: string;
    public dayanismaHesapOrani?: number;
    public dayanismaHesapSekli?: number;
    public dayanismaKesintiKod?: number;
    public dayanismaOran?: number;
    public dayanismaTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sendikaGunEh?: string;
    public sendikaHesapKod?: string;
    public sendikaHesapOrani?: number;
    public sendikaHesapSekli?: number;
    public sendikaKesintiKod?: number;
    public sendikaKod: number;
    public sendikaOran?: number;
    public sendikaPersonelTurKod: number;
    public sendikasizDayanismaOran?: number;
    public sendikaTutar?: number;
    public yetkSendikasizOrani?: number;
    public pysSendika: PysSendika;
    public pysSendikaHaklars: PysSendikaHaklar[];
    public pysSendikaHesapKazancs: PysSendikaHesapKazanc[];

    public constructor(init?: Partial<PysSendikaSozlesme>) { super(init); (Object as any).assign(this, init); }
}

export class PysSendika extends CommonEntityBase
{
    public aciklama?: string;
    public adres?: string;
    public aktifEh?: string;
    public bankaAd?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public hizmetKoluKod?: number;
    public ibanNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public sendikaAd: string;
    public telAlanKod?: number;
    public telTelefon?: string;
    public genBelediye: GenBelediye;
    public genKisi?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public pysSendikaPersonelTurs: PysSendikaPersonelTur[];
    public pysSendikaSozlesmes: PysSendikaSozlesme[];

    public constructor(init?: Partial<PysSendika>) { super(init); (Object as any).assign(this, init); }
}

export class PysSendikaPersonelTur extends CommonEntityBase
{
    public aktifEh?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelTurKod: number;
    public sendikaKod: number;
    public ikaPersonelTur: IkaPersonelTur;
    public pysSendika: PysSendika;

    public constructor(init?: Partial<PysSendikaPersonelTur>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelTur extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinTuru?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turu: string;
    public ikaIscDonemHesaps: IkaIscDonemHesap[];
    public ikaIscDonemKazancHesaps: IkaIscDonemKazancHesap[];
    public ikaMemDonemHesaps: IkaMemDonemHesap[];
    public ikaMemDonemKazancHesaps: IkaMemDonemKazancHesap[];
    public ikaPersonels: IkaPersonel[];
    public ikaPersonelTurYetkis: IkaPersonelTurYetki[];
    public pysBesFirmas: PysBesFirma[];
    public pysIzinTurDetays: PysIzinTurDetay[];
    public pysSendikaPersonelTurs: PysSendikaPersonelTur[];

    public constructor(init?: Partial<IkaPersonelTur>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelTurYetki extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public personelTurKod: number;
    public genKullanici: GenKullanici;
    public ikaPersonelTur: IkaPersonelTur;

    public constructor(init?: Partial<IkaPersonelTurYetki>) { super(init); (Object as any).assign(this, init); }
}

export class LytWebKisi extends CommonEntityBase
{
    public bakiye: number;
    public dabId?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaAdi?: string;
    public dosyaMimeType?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public webKisiKod: number;
    public genWebKisi: GenWebKisi;

    public constructor(init?: Partial<LytWebKisi>) { super(init); (Object as any).assign(this, init); }
}

export class GenWebKisi extends CommonEntityBase
{
    public ad?: string;
    public adresBlokNo?: string;
    public adresCaddeSokakAd?: string;
    public adresDaireNo?: string;
    public adresIlceKod?: number;
    public adresKapiNo?: number;
    public adresKapiNo1?: string;
    public adresMahalleAd?: string;
    public adresMahalleCaddeKod?: number;
    public adresPostaKodu?: number;
    public adresSiteApartmanAd?: string;
    public adresTuru: string;
    public anneAd?: string;
    public babaAd?: string;
    public basvuruTuru: number;
    public belediyeKod: number;
    public cinsiyet?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public eMail?: string;
    public faxAlanKod?: number;
    public faxNo?: number;
    public gsmAlanKod?: number;
    public gsmNo?: number;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public medeniDurumKod?: number;
    public meslekAciklama?: string;
    public meslekKod?: number;
    public ogrenimTuruKod?: number;
    public onayDurumu: string;
    public sifre?: string;
    public sifreHatirlatmaCevap?: string;
    public sifreHatirlatmaSoru?: number;
    public soyad?: string;
    public tckn?: number;
    public telAlanKod?: number;
    public telNo?: number;
    public unvani?: string;
    public uyrukKod?: number;
    public vergiDairesi?: string;
    public vergiNo?: string;
    public genIlce?: GenIlce;
    public genIlceDogumYeri?: GenIlce;
    public genKodDini?: GenKodDetay;
    public genKodMedeniDurum?: GenKodDetay;
    public genKodMeslek?: GenKodDetay;
    public genKodOgrenimTuru?: GenKodDetay;
    public genKodUyruk?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public lytKampanyaIslemleris: LytKampanyaIslemleri[];
    public lytWebKisis: LytWebKisi[];

    public constructor(init?: Partial<GenWebKisi>) { super(init); (Object as any).assign(this, init); }
}

export class LytMagazaKullaniciYetki extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public magazaKod: number;
    public genKullanici: GenKullanici;
    public lytMagaza: LytMagaza;

    public constructor(init?: Partial<LytMagazaKullaniciYetki>) { super(init); (Object as any).assign(this, init); }
}

export class LytMagaza extends CommonEntityBase
{
    public ad: string;
    public aktifmi: number;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaAdi?: string;
    public dosyaMimeType?: string;
    public icerik?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kisaTanim?: string;
    public kod: number;
    public magazaTipi: number;
    public lytKampanyaIslemleris: LytKampanyaIslemleri[];
    public lytMagazaKampanyas: LytMagazaKampanya[];
    public lytMagazaKullaniciYetkis: LytMagazaKullaniciYetki[];

    public constructor(init?: Partial<LytMagaza>) { super(init); (Object as any).assign(this, init); }
}

export class LytMagazaKampanya extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kampanyaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public magazaKod: number;
    public lytKampanya: LytKampanya;
    public lytMagaza: LytMagaza;

    public constructor(init?: Partial<LytMagazaKampanya>) { super(init); (Object as any).assign(this, init); }
}

export class LytKampanya extends CommonEntityBase
{
    public aktifmi: number;
    public baslangicTarihi?: string;
    public belediyeKod?: number;
    public bitisTarihi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaAdi?: string;
    public dosyaMimeType?: string;
    public icerik?: string;
    public kampanyaTipi: number;
    public kampanyaTutari: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kisaTanim?: string;
    public kod: number;
    public kulBasinaKatilimHakki?: number;
    public maxKatilimHakki?: string;
    public tanim: string;
    public lytKampanyaIslemleris: LytKampanyaIslemleri[];
    public lytMagazaKampanyas: LytMagazaKampanya[];

    public constructor(init?: Partial<LytKampanya>) { super(init); (Object as any).assign(this, init); }
}

export class LytKampanyaIslemleri extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hostName?: string;
    public ipAdres?: string;
    public kampanyaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public magazaKod: number;
    public qrkod?: string;
    public statu?: number;
    public turu?: string;
    public tutar: number;
    public webKisiKod: number;
    public genKullanici: GenKullanici;
    public genWebKisi: GenWebKisi;
    public lytKampanya: LytKampanya;
    public lytMagaza: LytMagaza;

    public constructor(init?: Partial<LytKampanyaIslemleri>) { super(init); (Object as any).assign(this, init); }
}

export class StsKullaniciYetki extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public kurumsalKod: string;
    public genKullanici: GenKullanici;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<StsKullaniciYetki>) { super(init); (Object as any).assign(this, init); }
}

export class SysMalzemeGrupAmbar extends CommonEntityBase
{
    public ambarKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yardimKod: number;
    public sysAmbar: SysAmbar;
    public sysYardimTur: SysYardimTur;

    public constructor(init?: Partial<SysMalzemeGrupAmbar>) { super(init); (Object as any).assign(this, init); }
}

export class SysYardimPeriyod extends CommonEntityBase
{
    public ad: string;
    public aylikGunluk?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gunu: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sysBasvuruDetays: SysBasvuruDetay[];
    public sysYardimPeriyodDetays: SysYardimPeriyodDetay[];

    public constructor(init?: Partial<SysYardimPeriyod>) { super(init); (Object as any).assign(this, init); }
}

export class SysYardimPeriyodDetay extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public periyodKod: number;
    public yardimKod: number;
    public sysYardimPeriyod: SysYardimPeriyod;
    public sysYardimTur: SysYardimTur;

    public constructor(init?: Partial<SysYardimPeriyodDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysEkipDetay extends CommonEntityBase
{
    public ad?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekipKod: number;
    public gorevi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public personelKod?: number;
    public soyad?: string;
    public genKullanici: GenKullanici;
    public ikaPersonel?: IkaPersonel;
    public sysEkip: SysEkip;

    public constructor(init?: Partial<SysEkipDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysEkip extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sysEkipDetays: SysEkipDetay[];
    public sysIncelemes: SysInceleme[];

    public constructor(init?: Partial<SysEkip>) { super(init); (Object as any).assign(this, init); }
}

export class SysIncelemeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public incelemeKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public sysInceleme: SysInceleme;

    public constructor(init?: Partial<SysIncelemeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAdres extends CommonEntityBase
{
    public aciklama?: string;
    public adresKapanisKod?: number;
    public aktifEh: string;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public caddeSokakAd?: string;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelisTarih?: string;
    public gidisTarih?: string;
    public ilceKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kpsKod?: string;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public mahalleKod?: number;
    public postaKodu?: number;
    public siteApartmanAd?: string;
    public sosyalKisiKod: number;
    public tuikAdresKod?: number;
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public genIlce?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genMahalleKoy?: GenMahalleKoy;
    public sysBasvurus: SysBasvuru[];
    public sysKisi: SysKisi;

    public constructor(init?: Partial<SysKisiAdres>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiDetay extends CommonEntityBase
{
    public aktiviteKatilimEh: string;
    public ayakkabiNumara?: string;
    public aylikGelir?: number;
    public bagimlilikDurumKod?: number;
    public bakimParasiEh: string;
    public beyazKartEh: string;
    public bilBilgiAciklama?: string;
    public bilBilgiSeviyeTuru?: string;
    public calisiyorEh: string;
    public cevredenAlinanBilgi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ehliyetEh: string;
    public engelliAciklama?: string;
    public engelliBilgiAlan?: string;
    public engelliCalismaIstekEh: string;
    public engelliCihazKod?: number;
    public engelliEh: string;
    public engelliEvAsansorEh: string;
    public engelliEvRampaEh: string;
    public engelliEvWcEh: string;
    public engelliGorusmeTarh?: string;
    public engelliGorusulenKisi?: string;
    public engelliIsAsansorEh: string;
    public engelliIsRampaEh: string;
    public engelliIsWcEh: string;
    public engelliMesKursAdi?: string;
    public engelliMesKursIstekEh: string;
    public engelliMesKursKurum?: string;
    public engelliMesKursTarih?: string;
    public engelliMesKursuEh: string;
    public engelliOran?: number;
    public engelliRaporTarih?: string;
    public engelliRehabilitasyonEh: string;
    public engelliSebebiKod?: number;
    public engelliTurKod?: number;
    public genelGozlem?: string;
    public giyimBedeni?: string;
    public haneAylikGelir?: number;
    public haneAylikGider?: number;
    public haneNufusSayi?: number;
    public ihtiyacBanyoEh: string;
    public ihtiyacBezYardimEh: string;
    public ihtiyacCamasirYikamaEh: string;
    public ihtiyacDiger?: string;
    public ihtiyacEvBakimEh: string;
    public ihtiyacEvEsyaEh: string;
    public ihtiyacMedikalCihaz?: string;
    public ihtiyacSaglikEh: string;
    public ihtiyacSosyalHizmetEh: string;
    public ihtiyacSosyalMarketEh: string;
    public ihtiyacYemekEh: string;
    public isAdresi?: string;
    public isAlanKod?: number;
    public isTelefon?: string;
    public isYeriAdi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meslekAciklama?: string;
    public meslekKod?: number;
    public ozurMaasEh: string;
    public sosyalGuvenceKod?: number;
    public sosyalKisiKod: number;
    public yabanciDilKod?: number;
    public yabanciDilSeviyeKod?: number;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genKodDetay5?: GenKodDetay;
    public genKodDetay6?: GenKodDetay;
    public genKodDetay7?: GenKodDetay;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public sysKisi: SysKisi;

    public constructor(init?: Partial<SysKisiDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiGorusme extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public aileKisiKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorusmeKonuKod?: number;
    public gorusmeSonucKod?: number;
    public gorusmeTarih: string;
    public gorusmeTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sosyalKisiKod: number;
    public soyad?: string;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public sysKisi: SysKisi;
    public sysKisiAile?: SysKisiAile;

    public constructor(init?: Partial<SysKisiGorusme>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiResim extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiResim?: string;
    public kod: number;
    public sosyalKisiKod: number;
    public sysKisi: SysKisi;

    public constructor(init?: Partial<SysKisiResim>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiTurYetki extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiTurKod: number;
    public kod: number;
    public kullaniciKod: number;
    public genKullanici: GenKullanici;
    public sysKisiTur: SysKisiTur;

    public constructor(init?: Partial<SysKisiTurYetki>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiTur extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turu: string;
    public sysKisis: SysKisi[];
    public sysKisiTurYetkis: SysKisiTurYetki[];

    public constructor(init?: Partial<SysKisiTur>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisi extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public anneAd?: string;
    public babaAd?: string;
    public belediyeKod: number;
    public buyuksehirYardim?: string;
    public cinsiyet?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public ekmekYardimEh: string;
    public eMail?: string;
    public emekliTarih?: string;
    public emekliTuruKod?: number;
    public evAlanKod?: number;
    public evsahibiAdSoyad?: string;
    public evsahibiKisiKod?: number;
    public evTelefon?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public ibanNo?: string;
    public isitmaTurKod?: number;
    public iskurKaydi?: string;
    public kanGrubu?: string;
    public kariyerKaydi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kisiTurKod?: number;
    public kod: number;
    public konutTurKod?: number;
    public kpsKod?: string;
    public kpsKontrolTarih?: string;
    public kurumYardim?: string;
    public mailBilgiEh?: string;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public ogrenimTuruKod?: number;
    public olumKapanisTarih?: string;
    public oncekiSoyad?: string;
    public onemDerece?: number;
    public smsBilgiEh?: string;
    public soyad?: string;
    public tckn?: number;
    public uyrukKod?: number;
    public vakifYardim?: string;
    public vergiDairesi?: string;
    public vergiNo?: string;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genKisi?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genKodDetay5?: GenKodDetay;
    public genKodDetay6?: GenKodDetay;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public sysAmbarCikis: SysAmbarCikis[];
    public sysBasvurus: SysBasvuru[];
    public sysKisiAdres: SysKisiAdres[];
    public sysKisiAiles: SysKisiAile[];
    public sysKisiDetay: SysKisiDetay;
    public sysKisiGorusmes: SysKisiGorusme[];
    public sysKisiResim: SysKisiResim;
    public sysKisiTur?: SysKisiTur;

    public constructor(init?: Partial<SysKisi>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAileEngelli extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public engelliTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sosyalAileKod: number;
    public genKodDetay: GenKodDetay;
    public sysKisiAile: SysKisiAile;

    public constructor(init?: Partial<SysKisiAileEngelli>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAileHasta extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kronikHastaKod: number;
    public sosyalAileKod: number;
    public genKodDetay: GenKodDetay;
    public sysKisiAile: SysKisiAile;

    public constructor(init?: Partial<SysKisiAileHasta>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAileMedikal extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public medikalTurKod: number;
    public sosyalAileKod: number;
    public genKodDetay: GenKodDetay;
    public sysKisiAile: SysKisiAile;

    public constructor(init?: Partial<SysKisiAileMedikal>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAile extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public aktifPasif?: string;
    public anneAd?: string;
    public babaAd?: string;
    public cinsiyet: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public eMail?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kpsKod?: string;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public olumTarih?: string;
    public oncekiSoyad?: string;
    public sosyalKisiKod: number;
    public soyad?: string;
    public tckn?: number;
    public uyrukKod?: number;
    public yakinlikDurumu: string;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public sysKisi: SysKisi;
    public sysKisiAileDetays: SysKisiAileDetay[];
    public sysKisiAileEngellis: SysKisiAileEngelli[];
    public sysKisiAileHastas: SysKisiAileHasta[];
    public sysKisiAileMedikals: SysKisiAileMedikal[];
    public sysKisiGorusmes: SysKisiGorusme[];

    public constructor(init?: Partial<SysKisiAile>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAileDetay extends CommonEntityBase
{
    public aciklama?: string;
    public ayakNumarasi?: number;
    public aylikGelirTutar?: number;
    public calismaDurumKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerKronikHastalik?: string;
    public engelliAciklama?: string;
    public engelliBakimTutar?: number;
    public engelliBakimUcretEh: string;
    public engelliDurumu?: number;
    public engelliEgitimDurumu?: number;
    public engelliEh: string;
    public engelliKartEh: string;
    public engelliMaasEh: string;
    public engelliMaasTutar?: number;
    public engelliOran?: number;
    public engelliOzBakimDurumu?: number;
    public engelliRaporDurumu?: string;
    public engelliRaporEh: string;
    public engelliRaporSonTarih?: string;
    public engelliRaporTarih?: string;
    public engelliSebebiKod?: number;
    public engelliSeyahatKartEh: string;
    public engelliTedaviDurumu?: number;
    public gaziAilesiEh?: string;
    public gaziEh?: string;
    public giyimBedeni?: number;
    public hamileDogumTarih?: string;
    public incelemeKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ogrenimDurumKod?: number;
    public ogrenimTurKod?: number;
    public oksuzEh?: string;
    public saglikDurumu?: number;
    public saglikNotlari?: string;
    public sehitAilesiEh?: string;
    public sosyalAileKod: number;
    public sosyalGuvenceKod?: number;
    public tesetturGiyimEh: string;
    public yetimEh?: string;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public sysInceleme: SysInceleme;
    public sysKisiAile: SysKisiAile;

    public constructor(init?: Partial<SysKisiAileDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysInceleme extends CommonEntityBase
{
    public aciklama?: string;
    public atamaTarih: string;
    public belediyeKod: number;
    public cevreBeyani?: string;
    public daireDurumu?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekipKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menkulAracTespit?: string;
    public sonucTarih?: string;
    public sonucTuru?: number;
    public sosyalBasvuruKod: number;
    public tespitBilgi?: string;
    public sysBasvuru: SysBasvuru;
    public sysEkip: SysEkip;
    public sysIncelemeDetays: SysIncelemeDetay[];
    public sysIncelemePuans: SysIncelemePuan[];
    public sysKisiAileDetays: SysKisiAileDetay[];

    public constructor(init?: Partial<SysInceleme>) { super(init); (Object as any).assign(this, init); }
}

export class SysPanelSekme extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public panelKod: number;
    public sysPanel: SysPanel;
    public sysPanelSekmeSorus: SysPanelSekmeSoru[];

    public constructor(init?: Partial<SysPanelSekme>) { super(init); (Object as any).assign(this, init); }
}

export class SysPanel extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sysPanelSekmes: SysPanelSekme[];
    public sysPanelSekmeSorus: SysPanelSekmeSoru[];

    public constructor(init?: Partial<SysPanel>) { super(init); (Object as any).assign(this, init); }
}

export class SysPanelSekmeSoru extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public panelKod: number;
    public sekmeKod: number;
    public siraNo: number;
    public yardimCevapKod: number;
    public yardimSoruKod: number;
    public sysPanel: SysPanel;
    public sysPanelSekme: SysPanelSekme;
    public sysSoru: SysSoru;
    public sysSoruCevap: SysSoruCevap;

    public constructor(init?: Partial<SysPanelSekmeSoru>) { super(init); (Object as any).assign(this, init); }
}

export class SysSoruCevap extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public puan?: number;
    public veriTipi?: number;
    public yardimSoruKod: number;
    public sysIncelemePuans: SysIncelemePuan[];
    public sysPanelSekmeSorus: SysPanelSekmeSoru[];
    public sysSoru: SysSoru;

    public constructor(init?: Partial<SysSoruCevap>) { super(init); (Object as any).assign(this, init); }
}

export class SysIncelemePuan extends CommonEntityBase
{
    public cevapKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public incelemeKod?: number;
    public katsayi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public oran?: number;
    public puan?: number;
    public sayi?: number;
    public soruKod: number;
    public sosyalBasvuruKod: number;
    public tarih?: string;
    public text?: string;
    public tutar?: number;
    public sysBasvuru: SysBasvuru;
    public sysInceleme?: SysInceleme;
    public sysSoru: SysSoru;
    public sysSoruCevap: SysSoruCevap;

    public constructor(init?: Partial<SysIncelemePuan>) { super(init); (Object as any).assign(this, init); }
}

export class SysSoru extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public carpanEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public puan?: number;
    public siraNo: number;
    public turu?: number;
    public sysIncelemePuans: SysIncelemePuan[];
    public sysPanelSekmeSorus: SysPanelSekmeSoru[];
    public sysSoruCevaps: SysSoruCevap[];
    public sysYardimTurSorus: SysYardimTurSoru[];

    public constructor(init?: Partial<SysSoru>) { super(init); (Object as any).assign(this, init); }
}

export class SysYardimTurSoru extends CommonEntityBase
{
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yardimSoruKod: number;
    public yardimTurKod: number;
    public sysSoru: SysSoru;
    public sysYardimTur: SysYardimTur;

    public constructor(init?: Partial<SysYardimTurSoru>) { super(init); (Object as any).assign(this, init); }
}

export class SysYardimTurYetki extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public yardimTurKod: number;
    public genKullanici: GenKullanici;
    public sysYardimTur: SysYardimTur;

    public constructor(init?: Partial<SysYardimTurYetki>) { super(init); (Object as any).assign(this, init); }
}

export class SysYardimTur extends CommonEntityBase
{
    public ad: string;
    public ambarKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public depoKontrolEh?: string;
    public ilkPuan?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malzemeZorunluEh?: string;
    public orgKullaniciKod?: number;
    public programOtomatikEh?: string;
    public puanEh: string;
    public sonPuan?: number;
    public yardimGrupKod?: number;
    public genKodDetay?: GenKodDetay;
    public genKullanici?: GenKullanici;
    public sysAmbar?: SysAmbar;
    public sysBasvuruDetays: SysBasvuruDetay[];
    public sysMalzemes: SysMalzeme[];
    public sysMalzemeGrupAmbars: SysMalzemeGrupAmbar[];
    public sysYardimPeriyodDetays: SysYardimPeriyodDetay[];
    public sysYardimTurSorus: SysYardimTurSoru[];
    public sysYardimTurYetkis: SysYardimTurYetki[];

    public constructor(init?: Partial<SysYardimTur>) { super(init); (Object as any).assign(this, init); }
}

export class SysMalzeme extends CommonEntityBase
{
    public ad: string;
    public barkodKod?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hizmetAlimEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kod: number;
    public malzemeKod: string;
    public marka?: string;
    public maximumSeviye?: number;
    public minimumSeviye?: number;
    public notlar?: string;
    public olcuBirimKod?: number;
    public tutar?: number;
    public uretimKod?: string;
    public yardimKod: number;
    public genKodDetay?: GenKodDetay;
    public sysYardimTur: SysYardimTur;

    public constructor(init?: Partial<SysMalzeme>) { super(init); (Object as any).assign(this, init); }
}

export class SysBasvuruSonuc extends CommonEntityBase
{
    public aciklama?: string;
    public adet?: number;
    public ambarCikisAnaKod?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public islemTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malzemeKod?: string;
    public olcuBirimKod?: number;
    public sosyalBasvuruDetayKod: number;
    public sosyalBasvuruKod: number;
    public teslimEden?: string;
    public teslimPersonelKod?: number;
    public teslimTarih?: string;
    public genKodDetay?: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public sysAmbarCikis?: SysAmbarCikis;
    public sysBasvuru: SysBasvuru;
    public sysBasvuruDetay: SysBasvuruDetay;
    public sysMalzeme?: SysMalzeme;

    public constructor(init?: Partial<SysBasvuruSonuc>) { super(init); (Object as any).assign(this, init); }
}

export class SysBasvuru extends CommonEntityBase
{
    public aciklama?: string;
    public acilEh?: string;
    public basvuruSekliKod: number;
    public basvuruTarih: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durum: number;
    public iadeIptalAciklama?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiAdresKod: number;
    public kod: number;
    public sosyalKisiKod: number;
    public genKodDetay: GenKodDetay;
    public sysBasvuruDetays: SysBasvuruDetay[];
    public sysBasvuruSonucs: SysBasvuruSonuc[];
    public sysIncelemes: SysInceleme[];
    public sysIncelemePuans: SysIncelemePuan[];
    public sysKisi: SysKisi;
    public sysKisiAdres: SysKisiAdres;

    public constructor(init?: Partial<SysBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class SysBasvuruDetay extends CommonEntityBase
{
    public aciklama?: string;
    public adet?: number;
    public ambarCikisAnaKod?: number;
    public baslamaTarih?: string;
    public basvuruDurumKod?: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durumu?: number;
    public encumenKararNo?: string;
    public encumenKararTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malzemeKod?: string;
    public olcuBirimKod?: number;
    public onayEh: string;
    public onayPerKod?: number;
    public onayTarih?: string;
    public oncelikDurumu?: number;
    public randevuTarihi?: string;
    public sosyalBasvuruKod: number;
    public yardimPeriyodKod?: number;
    public yardimTurKod: number;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public ikaPersonel?: IkaPersonel;
    public sysAmbarCikis?: SysAmbarCikis;
    public sysBasvuru: SysBasvuru;
    public sysBasvuruSonucs: SysBasvuruSonuc[];
    public sysYardimPeriyod?: SysYardimPeriyod;
    public sysYardimTur: SysYardimTur;

    public constructor(init?: Partial<SysBasvuruDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarCikis extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public cikisAmbarKod?: number;
    public cikisNo: number;
    public cikisTarih: string;
    public cikisTuru: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kkyPersonelKod?: number;
    public kod: number;
    public notlar?: string;
    public sosyalKisiKod?: number;
    public teslimEden?: string;
    public teslimPersonelKod?: number;
    public yil: number;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public sysAmbar: SysAmbar;
    public sysAmbar1?: SysAmbar;
    public sysAmbarCikisDetays: SysAmbarCikisDetay[];
    public sysBasvuruDetays: SysBasvuruDetay[];
    public sysBasvuruSonucs: SysBasvuruSonuc[];
    public sysKisi?: SysKisi;

    public constructor(init?: Partial<SysAmbarCikis>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarCikisDetay extends CommonEntityBase
{
    public adet?: number;
    public ambarCikisAnaKod: number;
    public ambarKod: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public genelTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public malzemeGirisKod: number;
    public malzemeKod: string;
    public marka?: string;
    public model?: string;
    public notlar?: string;
    public olcuBirimKod?: number;
    public otvTutar?: number;
    public toplamTutar?: number;
    public yil: number;
    public genKodDetay?: GenKodDetay;
    public sysAmbar: SysAmbar;
    public sysAmbarCikis: SysAmbarCikis;
    public sysAmbarGirisDetay: SysAmbarGirisDetay;
    public sysMalzeme?: SysMalzeme;

    public constructor(init?: Partial<SysAmbarCikisDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarGiris extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public cikisAmbarKod?: number;
    public cikisNo?: number;
    public cikisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirEh: string;
    public faturaNo?: string;
    public faturaTarih?: string;
    public faturaTutar?: number;
    public girisNo: number;
    public girisTarih: string;
    public girisTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kkyPersonelKod?: number;
    public kod: number;
    public notlar?: string;
    public teslimAlanPersonelKod?: number;
    public teslimEden?: string;
    public teslimTckn?: number;
    public teslimVergiNo?: number;
    public yil: number;
    public genKisi?: GenKisi;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public sysAmbar: SysAmbar;
    public sysAmbar1?: SysAmbar;
    public sysAmbarGirisDetays: SysAmbarGirisDetay[];

    public constructor(init?: Partial<SysAmbarGiris>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarRaf extends CommonEntityBase
{
    public ad: string;
    public ambarKod: number;
    public bolumKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sysAmbar: SysAmbar;
    public sysAmbarBolum: SysAmbarBolum;
    public sysAmbarGirisDetays: SysAmbarGirisDetay[];

    public constructor(init?: Partial<SysAmbarRaf>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarGirisDetay extends CommonEntityBase
{
    public adet?: number;
    public ambarGirisAnaKod: number;
    public ambarKod: number;
    public belediyeKod: number;
    public birimFiyat?: number;
    public blokKod?: number;
    public bolumKod?: number;
    public cikisKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public genelTutar?: number;
    public iskontoTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvOran?: number;
    public kdvTutar?: number;
    public kod: number;
    public malzemeKod: string;
    public marka?: string;
    public model?: string;
    public notlar?: string;
    public olcuBirimKod?: number;
    public otvTutar?: number;
    public rafKod?: number;
    public toplamTutar?: number;
    public yil: number;
    public genKodDetay?: GenKodDetay;
    public sysAmbar: SysAmbar;
    public sysAmbarBlok?: SysAmbarBlok;
    public sysAmbarBolum?: SysAmbarBolum;
    public sysAmbarCikisDetays: SysAmbarCikisDetay[];
    public sysAmbarGiris: SysAmbarGiris;
    public sysAmbarRaf?: SysAmbarRaf;
    public sysMalzeme?: SysMalzeme;

    public constructor(init?: Partial<SysAmbarGirisDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarBolum extends CommonEntityBase
{
    public ad: string;
    public ambarKod: number;
    public blokKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sysAmbar: SysAmbar;
    public sysAmbarBlok: SysAmbarBlok;
    public sysAmbarGirisDetays: SysAmbarGirisDetay[];
    public sysAmbarRafs: SysAmbarRaf[];

    public constructor(init?: Partial<SysAmbarBolum>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarBlok extends CommonEntityBase
{
    public ad: string;
    public ambarKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sysAmbar: SysAmbar;
    public sysAmbarBolums: SysAmbarBolum[];
    public sysAmbarGirisDetays: SysAmbarGirisDetay[];

    public constructor(init?: Partial<SysAmbarBlok>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarOtoNumara extends CommonEntityBase
{
    public ambarKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public girisCikisNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public sysAmbar: SysAmbar;

    public constructor(init?: Partial<SysAmbarOtoNumara>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbar extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public aktifEh: string;
    public ambarYerTakipEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kkyPersonelKod?: number;
    public kod: number;
    public sifre?: string;
    public sysAmbarBloks: SysAmbarBlok[];
    public sysAmbarBolums: SysAmbarBolum[];
    public sysAmbarCikis: SysAmbarCikis[];
    public sysAmbarCikis1: SysAmbarCikis[];
    public sysAmbarCikisDetays: SysAmbarCikisDetay[];
    public sysAmbarGiris: SysAmbarGiris[];
    public sysAmbarGiris1: SysAmbarGiris[];
    public sysAmbarGirisDetays: SysAmbarGirisDetay[];
    public sysAmbarOtoNumaras: SysAmbarOtoNumara[];
    public sysAmbarRafs: SysAmbarRaf[];
    public sysAmbarYetkis: SysAmbarYetki[];
    public sysMalzemeGrupAmbars: SysMalzemeGrupAmbar[];
    public sysYardimTurs: SysYardimTur[];

    public constructor(init?: Partial<SysAmbar>) { super(init); (Object as any).assign(this, init); }
}

export class SysAmbarYetki extends CommonEntityBase
{
    public aktifEh: string;
    public ambarKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public genKullanici: GenKullanici;
    public sysAmbar: SysAmbar;

    public constructor(init?: Partial<SysAmbarYetki>) { super(init); (Object as any).assign(this, init); }
}

export class TebKullaniciYetki extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public kurumsalKod: string;
    public genKullanici: GenKullanici;
    public tebKurumSinif?: TebKurumSinif;

    public constructor(init?: Partial<TebKullaniciYetki>) { super(init); (Object as any).assign(this, init); }
}

export class TtsFaaliyetTur extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ttsBasvuruDetays: TtsBasvuruDetay[];

    public constructor(init?: Partial<TtsFaaliyetTur>) { super(init); (Object as any).assign(this, init); }
}

export class TtsKullanici extends CommonEntityBase
{
    public adi: string;
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ePosta?: string;
    public gsmTelefon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: string;
    public kurumKod: number;
    public sabitTelefon?: string;
    public sifre: string;
    public sistemKullaniciKod?: number;
    public soyad: string;
    public unvan?: string;
    public yoneticiEh: string;
    public genKullanici?: GenKullanici;
    public ttsBasvurus: TtsBasvuru[];
    public ttsKurum: TtsKurum;

    public constructor(init?: Partial<TtsKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class GenYardim extends CommonEntityBase
{
    public anaMenuKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public icerik?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuKod?: number;
    public genMenu?: GenMenu;

    public constructor(init?: Partial<GenYardim>) { super(init); (Object as any).assign(this, init); }
}

export class GenMenu extends CommonEntityBase
{
    public dabEh?: string;
    public dabMenuAd?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durum?: number;
    public externalUrl?: string;
    public formKod?: number;
    public kademe?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuAd: string;
    public menuAnaKod: number;
    public menuIconUrl?: string;
    public menuParam?: string;
    public siraNo: number;
    public ustKod?: number;
    public genForm?: GenForm;
    public ustGenMenu?: GenMenu;
    public genMenus: GenMenu[];
    public genMenuAna: GenMenuAna;
    public genYardims: GenYardim[];

    public constructor(init?: Partial<GenMenu>) { super(init); (Object as any).assign(this, init); }
}

export class GenMenuDab extends CommonEntityBase
{
    public dabEh?: string;
    public dabMenuAd?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durum?: number;
    public externalUrl?: string;
    public formKod?: number;
    public kademe?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuAd: string;
    public menuAnaKod: number;
    public menuIconUrl?: string;
    public menuParam?: string;
    public siraNo: number;
    public ustKod?: number;
    public genForm?: GenForm;
    public genMenuAna: GenMenuAna;
    public ustGenMenuDab?: GenMenuDab;
    public subGenMenuDabs: GenMenuDab[];

    public constructor(init?: Partial<GenMenuDab>) { super(init); (Object as any).assign(this, init); }
}

export class GenMenuAna extends CommonEntityBase
{
    public aktifEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuAd: string;
    public webUrl?: string;
    public genMenus: GenMenu[];
    public genMenuDabs: GenMenuDab[];

    public constructor(init?: Partial<GenMenuAna>) { super(init); (Object as any).assign(this, init); }
}

export class TtsUygulamaTur extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public menuKod?: number;
    public genMenuAna?: GenMenuAna;
    public ttsBasvurus: TtsBasvuru[];
    public ttsKurumUygulamas: TtsKurumUygulama[];

    public constructor(init?: Partial<TtsUygulamaTur>) { super(init); (Object as any).assign(this, init); }
}

export class TtsKurumUygulama extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumKod: number;
    public uygulamaKod: number;
    public ttsKurum: TtsKurum;
    public ttsUygulamaTur: TtsUygulamaTur;

    public constructor(init?: Partial<TtsKurumUygulama>) { super(init); (Object as any).assign(this, init); }
}

export class TtsKurum extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ePosta?: string;
    public fax?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public telefon?: string;
    public ttsBasvurus: TtsBasvuru[];
    public ttsBasvuruDetays: TtsBasvuruDetay[];
    public ttsKullanicis: TtsKullanici[];
    public ttsKurumUygulamas: TtsKurumUygulama[];

    public constructor(init?: Partial<TtsKurum>) { super(init); (Object as any).assign(this, init); }
}

export class TtsSonucTur extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ttsBasvurus: TtsBasvuru[];
    public ttsBasvuruDetays: TtsBasvuruDetay[];

    public constructor(init?: Partial<TtsSonucTur>) { super(init); (Object as any).assign(this, init); }
}

export class TtsBasvuruDetay extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public faaliyetTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: number;
    public kurumKod: number;
    public sonucAciklama?: string;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public genKullanici: GenKullanici;
    public ttsBasvuru: TtsBasvuru;
    public ttsBasvuruBelges: TtsBasvuruBelge[];
    public ttsFaaliyetTur?: TtsFaaliyetTur;
    public ttsKurum: TtsKurum;
    public ttsSonucTur?: TtsSonucTur;

    public constructor(init?: Partial<TtsBasvuruDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TtsBasvuruBelge extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruDetayKod?: number;
    public basvuruKod: number;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBelgeTip: GenBelgeTip;
    public ttsBasvuru: TtsBasvuru;
    public ttsBasvuruDetay?: TtsBasvuruDetay;

    public constructor(init?: Partial<TtsBasvuruBelge>) { super(init); (Object as any).assign(this, init); }
}

export class TtsBasvuruIade extends CommonEntityBase
{
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iadeAciklama?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ttsBasvuru: TtsBasvuru;

    public constructor(init?: Partial<TtsBasvuruIade>) { super(init); (Object as any).assign(this, init); }
}

export class TtsBasvuru extends CommonEntityBase
{
    public basvuruTarih: string;
    public basvuruTurKod: number;
    public bugEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formKod?: number;
    public gonderIpAdres?: string;
    public gonderMacAdres?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumKod: number;
    public kurumKullaniciKod?: number;
    public onayTarih?: string;
    public oncelikDurum: string;
    public planlananBitisTarih?: string;
    public redSayisi?: number;
    public sonucAciklama?: string;
    public sonucKullaniciKod?: number;
    public sonucTarih?: string;
    public sonucTurKod?: number;
    public status: number;
    public talepAciklama: string;
    public turu: number;
    public uygulamaKod?: number;
    public genForm?: GenForm;
    public genKodDetay: GenKodDetay;
    public genKullanici?: GenKullanici;
    public ttsBasvuruBelges: TtsBasvuruBelge[];
    public ttsBasvuruDetays: TtsBasvuruDetay[];
    public ttsBasvuruIades: TtsBasvuruIade[];
    public ttsKullanici?: TtsKullanici;
    public ttsKurum: TtsKurum;
    public ttsSonucTur?: TtsSonucTur;
    public ttsUygulamaTur?: TtsUygulamaTur;

    public constructor(init?: Partial<TtsBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullanici extends CommonEntityBase
{
    public adi: string;
    public aktifEh: string;
    public belediyeKod: number;
    public dabId?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekranRenk?: string;
    public goruntuRenk?: string;
    public grafikEh?: string;
    public guiId?: string;
    public kayitKullaniciKod: number;
    public kayitRenk?: string;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod: string;
    public kullaniciTip?: string;
    public ldapEh?: string;
    public personelKod?: number;
    public sifre: string;
    public sifreGunu?: number;
    public sifreTarihi?: string;
    public soyadi: string;
    public tema: number;
    public tempData?: string;
    public yaziRenk?: string;
    public arsBasvurus: ArsBasvuru[];
    public arsBasvuruBirims: ArsBasvuruBirim[];
    public arsBasvuruBirimDetays: ArsBasvuruBirimDetay[];
    public arsBasvuruGorusmes: ArsBasvuruGorusme[];
    public arsBirimKullanicis: ArsBirimKullanici[];
    public arsKonuBirims: ArsKonuBirim[];
    public bysBirimKullaniciYetkis: BysBirimKullaniciYetki[];
    public bysKullaniciKlasors: BysKullaniciKlasor[];
    public cmyBasvuruBirims: CmyBasvuruBirim[];
    public cmyBasvuruBirimDetays: CmyBasvuruBirimDetay[];
    public cmyBasvuruGorusmes: CmyBasvuruGorusme[];
    public cmyBirimKullanicis: CmyBirimKullanici[];
    public cmyCagriAgents: CmyCagriAgent[];
    public cmyKonuBirims: CmyKonuBirim[];
    public cmyKonuKullanicis: CmyKonuKullanici[];
    public cmyMuhtar: CmyMuhtar;
    public gasBirimDosyaYetkis: GasBirimDosyaYetki[];
    public gasBirimKullaniciYetkis: GasBirimKullaniciYetki[];
    public genBankas: GenBanka[];
    public genDinamikSorguYetkis: GenDinamikSorguYetki[];
    public genFavoris: GenFavori[];
    public genKullaniciErisims: GenKullaniciErisim[];
    public genKullaniciRols: GenKullaniciRol[];
    public genKullaniciYazicis: GenKullaniciYazici[];
    public gysGelirYetkis: GysGelirYetki[];
    public ikaBirimKullanicis: IkaBirimKullanici[];
    public ikaPersonel?: IkaPersonel;
    public ikaPersonelTurYetkis: IkaPersonelTurYetki[];
    public lytKampanyaIslemleris: LytKampanyaIslemleri[];
    public lytMagazaKullaniciYetkis: LytMagazaKullaniciYetki[];
    public stsKullaniciYetkis: StsKullaniciYetki[];
    public sysAmbarYetkis: SysAmbarYetki[];
    public sysEkipDetays: SysEkipDetay[];
    public sysKisiTurYetkis: SysKisiTurYetki[];
    public sysYardimTurs: SysYardimTur[];
    public sysYardimTurYetkis: SysYardimTurYetki[];
    public tebKullaniciYetkis: TebKullaniciYetki[];
    public temDefterKullanicis: TemDefterKullanici[];
    public tmsAmbarYetkis: TmsAmbarYetki[];
    public ttsBasvurus: TtsBasvuru[];
    public ttsBasvuruDetays: TtsBasvuruDetay[];
    public ttsKullanicis: TtsKullanici[];

    public constructor(init?: Partial<GenKullanici>) { super(init); (Object as any).assign(this, init); }
}

export class PysPersonelBanka extends CommonEntityBase
{
    public aktifEh?: string;
    public baslamaTarih?: string;
    public belediyeKod?: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hesapNo?: string;
    public ibanNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public promosyonKod?: number;
    public genBelediye?: GenBelediye;
    public pysBankaPromosyon?: PysBankaPromosyon;

    public constructor(init?: Partial<PysPersonelBanka>) { super(init); (Object as any).assign(this, init); }
}

export class PysBankaPromosyon extends CommonEntityBase
{
    public aciklama?: string;
    public aktifEh?: string;
    public bankaKod?: number;
    public baslamaTarih?: string;
    public belediyeKod?: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaAdi?: string;
    public dosyaDesenTur?: number;
    public dosyaTuru?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurumKodu?: string;
    public sablonTuru?: string;
    public sozlesmeTarih?: string;
    public subeKodu?: string;
    public genBanka?: GenBanka;
    public genBelediye?: GenBelediye;
    public pysPersonelBankas: PysPersonelBanka[];

    public constructor(init?: Partial<PysBankaPromosyon>) { super(init); (Object as any).assign(this, init); }
}

export class GenBanka extends CommonEntityBase
{
    public ad: string;
    public bankaKodu: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisaAd: string;
    public kod: number;
    public kullanici?: string;
    public kullaniciKod: number;
    public kurumKodu?: string;
    public sifre?: string;
    public vezneKod?: number;
    public genKullanici: GenKullanici;
    public pysBankaPromosyons: PysBankaPromosyon[];

    public constructor(init?: Partial<GenBanka>) { super(init); (Object as any).assign(this, init); }
}

export class SasBankaTalimat extends CommonEntityBase
{
    public aboneKod: number;
    public bankaKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public hesapNo?: string;
    public ibanNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public subeKodu: number;
    public talimatIptalTarih?: string;
    public talimatTarih: string;
    public genBanka: GenBanka;
    public genKisi: GenKisi;
    public sasAbone: SasAbone;
    public sasBankaTalimatDetays: SasBankaTalimatDetay[];

    public constructor(init?: Partial<SasBankaTalimat>) { super(init); (Object as any).assign(this, init); }
}

export class SasBankaTalimatDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gonderimTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public okumaKod: number;
    public tahsilTarih?: string;
    public tahsilTutar?: number;
    public talimatKod: number;
    public sasBankaTalimat: SasBankaTalimat;
    public sasSayacOkuma: SasSayacOkuma;

    public constructor(init?: Partial<SasBankaTalimatDetay>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacOkuma extends CommonEntityBase
{
    public aboneKod: number;
    public aboneninAlacagi?: number;
    public bankaTalimatiEh: string;
    public belediyeKod: number;
    public bolgeKod: number;
    public defterKod: number;
    public degisenSayacEndeks?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public donemDetayKod: number;
    public eskiEndeks?: number;
    public eskiKisiKod?: number;
    public faturaNo?: number;
    public faturaToplam?: number;
    public faturaYuvarlamaFark?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public koordinatX?: string;
    public koordinatY?: string;
    public mobilKod?: number;
    public muafM3?: number;
    public notlar?: string;
    public okumaTarih?: string;
    public oncekiOkumaTarih?: string;
    public ortalama?: number;
    public sarfiyat?: number;
    public sayacDurumKod: number;
    public sayfaNo: number;
    public sozlesmeTarih: string;
    public tarifeTurKod: number;
    public vadeTarih: string;
    public yeniEndeks?: number;
    public yil: number;
    public yuvarlamaFark?: number;
    public genKisi?: GenKisi;
    public sasBankaTalimatDetays: SasBankaTalimatDetay[];
    public sasBolge: SasBolge;
    public sasDefter: SasDefter;
    public sasSayacDurum: SasSayacDurum;
    public sasSayacKesmeDetays: SasSayacKesmeDetay[];
    public sasSayacOkumaDetays: SasSayacOkumaDetay[];
    public sasSayacOkumaLimits: SasSayacOkumaLimit[];
    public sasSayacTerkins: SasSayacTerkin[];
    public sasTarifeTur: SasTarifeTur;
    public sasDonem?: SasDonem;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacOkuma>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacTerkin extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public donemDetayKod: number;
    public endeks?: number;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public sayacOkumaKod: number;
    public sozlesmeTarih: string;
    public terkinAnaKod?: number;
    public terkinTarih: string;
    public terkinToplam?: number;
    public yil: number;
    public genKisi?: GenKisi;
    public gysTerkin?: GysTerkin;
    public sasSayacOkuma: SasSayacOkuma;
    public sasSayacTerkinDetays: SasSayacTerkinDetay[];
    public sasSayacTerkinLimits: SasSayacTerkinLimit[];
    public sasDonem?: SasDonem;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasSayacTerkin>) { super(init); (Object as any).assign(this, init); }
}

export class GysTerkin extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public cezaKat?: number;
    public cezaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaizTerkin?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public karsiTahakkukKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public matrahi?: number;
    public modulKod: number;
    public onayEh: string;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod: number;
    public tahakkukVergi?: number;
    public terkinKod: number;
    public terkinTarih: string;
    public vadeTarih: string;
    public vergiOran?: number;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysKarsiTahakkuk?: GysTahakkuk;
    public gysTahakkuk: GysTahakkuk;
    public gysTerkinAna: GysTerkinAna;
    public sasSayacTerkins: SasSayacTerkin[];

    public constructor(init?: Partial<GysTerkin>) { super(init); (Object as any).assign(this, init); }
}

export class GysTerkinAna extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public ciltNo?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public hkpIsKod?: number;
    public islemKod?: string;
    public islemTipi: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public onayEh: string;
    public sayfaNo?: number;
    public terkinTarih: string;
    public terkinTuruKod?: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysHkpIsler?: GysHkpIsler;
    public gysTerkins: GysTerkin[];
    public gysTerkinTuru?: GysTerkinTuru;
    public temFisGelirs: TemFisGelir[];

    public constructor(init?: Partial<GysTerkinAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysTerkinTuru extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysGenelParametres: GysGenelParametre[];
    public gysTaksitParametres: GysTaksitParametre[];
    public gysTerkinAnas: GysTerkinAna[];

    public constructor(init?: Partial<GysTerkinTuru>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitParametre extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecerliVadeTarih?: string;
    public gecikmeGecikmeKod?: number;
    public katsayiGelirKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taksitIlkVadeTarih?: string;
    public taksitTurKod?: number;
    public taksitVadeAy?: number;
    public terkinTurKod?: number;
    public yiufeGecikmeKod?: number;
    public yiufeGelirKod?: number;
    public genKodDetay?: GenKodDetay;
    public gysGecikme?: GysGecikme;
    public gysGecikme1?: GysGecikme;
    public gysGelirDetay?: GysGelirDetay;
    public gysGelirDetay1?: GysGelirDetay;
    public gysTerkinTuru?: GysTerkinTuru;

    public constructor(init?: Partial<GysTaksitParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysGecikme extends CommonEntityBase
{
    public aciklama: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysGecikmeDetays: GysGecikmeDetay[];
    public gysGelirDetays: GysGelirDetay[];
    public gysTahsils: GysTahsil[];
    public gysTaksits: GysTaksit[];
    public gysTaksitAnas: GysTaksitAna[];
    public gysTaksitIptals: GysTaksitIptal[];
    public gysTaksitIptalAnas: GysTaksitIptalAna[];
    public gysTaksitParametres: GysTaksitParametre[];
    public gysTaksitParametres1: GysTaksitParametre[];

    public constructor(init?: Partial<GysGecikme>) { super(init); (Object as any).assign(this, init); }
}

export class SasTeminatTerkin extends CommonEntityBase
{
    public alanAdSoyad?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirAboneKod?: number;
    public devirKisiKod?: number;
    public devirSozlesmeTarih?: string;
    public eskiKisiKod?: number;
    public iadeMahsupDevir: string;
    public iadeMahsupKod?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public teminatKod: number;
    public tutar?: number;
    public genKisi?: GenKisi;
    public sasTeminat: SasTeminat;
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasTeminatTerkin>) { super(init); (Object as any).assign(this, init); }
}

export class SasTeminat extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem?: number;
    public eskiKisiKod?: number;
    public gelenTeminatKod?: number;
    public gelirKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public makbuzNo?: number;
    public odemeAdSoyad?: string;
    public seriNo?: string;
    public sozlesmeTarih: string;
    public tahsilatKod?: number;
    public tahsilTarih: string;
    public teminatTurKod?: number;
    public tutar: number;
    public yil?: number;
    public genKisi?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public gysGelirDetay?: GysGelirDetay;
    public gysTahsil?: GysTahsil;
    public sasTeminatTerkins: SasTeminatTerkin[];
    public sasSozlesme?: SasSozlesme;

    public constructor(init?: Partial<SasTeminat>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeKod?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public makbuzNo: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public seriNo: string;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukYeniEh: string;
    public tahsilAnaKod: number;
    public tahsilGecikmeFaiz?: number;
    public tahsilGecikmeZammi?: number;
    public tahsilTarih: string;
    public tahsilVergi?: number;
    public takipliEh: string;
    public taksitKod?: number;
    public vadeTarih: string;
    public vezneKod: number;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGecikme?: GysGecikme;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysTahakkuk?: GysTahakkuk;
    public gysTahsilAna: GysTahsilAna;
    public gysVezne: GysVezne;
    public sasTeminats: SasTeminat[];

    public constructor(init?: Partial<GysTahsil>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsilAna extends CommonEntityBase
{
    public aciklama?: string;
    public bankaOnayNo?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public gecikmeZammi?: number;
    public havaleNo?: string;
    public havaleTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public krediAdSoyad?: string;
    public krediTckn?: number;
    public krediVergiNo?: string;
    public makbuzNo: number;
    public seriNo: string;
    public tahsilatTurKod: number;
    public tahsilTarih: string;
    public tahsilTutar?: number;
    public taksitAnaKod?: number;
    public taksitNo?: number;
    public toplamTutar?: number;
    public vezneKod: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysMahsupAnas: GysMahsupAna[];
    public gysTahsils: GysTahsil[];
    public gysTahsilatTur: GysTahsilatTur;
    public gysVezne: GysVezne;
    public temFisGelirs: TemFisGelir[];

    public constructor(init?: Partial<GysTahsilAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsupAna extends CommonEntityBase
{
    public aciklama?: string;
    public aktarilanKisiKod?: number;
    public belediyeKod: number;
    public birimFisKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiAktarilanKisiKod?: number;
    public eskiKisiKod?: number;
    public islemKod?: string;
    public islemTarih: string;
    public islemTipi: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mahsupNo?: number;
    public makbuzKod?: number;
    public muhasebeKod?: number;
    public genKisi: GenKisi;
    public genKisiAktarilan?: GenKisi;
    public genKisiEski?: GenKisi;
    public genKisiEskiAktarilan?: GenKisi;
    public gysMahsups: GysMahsup[];
    public gysTahsilAna?: GysTahsilAna;
    public temBirimFis?: TemBirimFis;
    public temFis?: TemFis;
    public temFisGelirs: TemFisGelir[];

    public constructor(init?: Partial<GysMahsupAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public borcAlacak: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gecikmeZammi?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mahsupAnaKod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukVergi?: number;
    public taksitKod?: number;
    public vadeTarih: string;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysMahsupAna: GysMahsupAna;
    public gysTahakkuk?: GysTahakkuk;

    public constructor(init?: Partial<GysMahsup>) { super(init); (Object as any).assign(this, init); }
}

export class SasSayacHazirlik extends CommonEntityBase
{
    public aboneKod: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public sozlesmeTarih: string;
    public tahakkukKod?: number;
    public tutar: number;
    public yil: number;
    public genKisi?: GenKisi;
    public gysGelirDetay: GysGelirDetay;
    public gysTahakkuk?: GysTahakkuk;
    public sasDonem: SasDonem;
    public sasSozlesme: SasSozlesme;

    public constructor(init?: Partial<SasSayacHazirlik>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahakkuk extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public carpanDeger?: number;
    public cezaKat?: number;
    public cezaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gecikmeFaizTerkin?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public mahsupGFaizAlacak?: number;
    public mahsupGFaizBorc?: number;
    public mahsupVergiAlacak?: number;
    public mahsupVergiBorc?: number;
    public matrahi?: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakKod?: number;
    public tahakkukTarih: string;
    public tahakkukTerkin?: number;
    public tahakkukTuru?: string;
    public tahakkukVergi?: number;
    public tahsilatGecikmeFaiz?: number;
    public tahsilatVergi?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public vergiOran?: number;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysDetayGelirDetay: GysGelirDetay;
    public gysGelirDetay: GysGelirDetay;
    public gysHacizs: GysHaciz[];
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysIcras: GysIcra[];
    public gysIhbars: GysIhbar[];
    public gysMahsups: GysMahsup[];
    public gysTahakkukAna?: GysTahakkukAna;
    public gysTahsils: GysTahsil[];
    public gysTakips: GysTakip[];
    public gysTaksits: GysTaksit[];
    public gysTaksitIptals: GysTaksitIptal[];
    public gysKarsiTerkins: GysTerkin[];
    public gysTerkins: GysTerkin[];
    public sasSayacHazirliks: SasSayacHazirlik[];

    public constructor(init?: Partial<GysTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class OmsTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezarTarifeKod: number;
    public tutar?: number;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;
    public omsTarife: OmsTarife;

    public constructor(init?: Partial<OmsTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class OmsTarife extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezarlikYerKod: number;
    public mezarTurKod: number;
    public genKodDetay: GenKodDetay;
    public omsMezars: OmsMezar[];
    public omsMezarlikYer: OmsMezarlikYer;
    public omsTarifeDetays: OmsTarifeDetay[];
    public omsUcretTahakkuks: OmsUcretTahakkuk[];

    public constructor(init?: Partial<OmsTarife>) { super(init); (Object as any).assign(this, init); }
}

export class OmsMezarlikYer extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public omsKadastros: OmsKadastro[];
    public omsMezars: OmsMezar[];
    public omsTarives: OmsTarife[];

    public constructor(init?: Partial<OmsMezarlikYer>) { super(init); (Object as any).assign(this, init); }
}

export class OmsKadastro extends CommonEntityBase
{
    public ada: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiAda?: string;
    public eskiParsel?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezarlikYerKod: number;
    public pafta?: string;
    public parsel: number;
    public omsMezars: OmsMezar[];
    public omsMezarlikYer: OmsMezarlikYer;

    public constructor(init?: Partial<OmsKadastro>) { super(init); (Object as any).assign(this, init); }
}

export class OmsDefter extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public omsOlumBelges: OmsOlumBelge[];

    public constructor(init?: Partial<OmsDefter>) { super(init); (Object as any).assign(this, init); }
}

export class OmsKurum extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kimlikNo?: number;
    public kod: number;
    public omsOlumBelges: OmsOlumBelge[];

    public constructor(init?: Partial<OmsKurum>) { super(init); (Object as any).assign(this, init); }
}

export class OmsOlumBelgeDetay extends CommonEntityBase
{
    public anneAgirlik?: number;
    public anneDogum42Eh?: string;
    public anneDogum42SonrasiEh?: string;
    public anneDogumSirasi?: number;
    public anneDogumSirasindaEh?: string;
    public anneGebelikSure?: number;
    public anneHamileEh?: string;
    public anneOlumuDegilEh?: string;
    public anneTckn?: number;
    public anneYasi?: number;
    public anonsAciklama?: string;
    public anonsYapilacakEh: string;
    public aracIstiyorEh: string;
    public bebekDogumSaat?: string;
    public bebekOlumuEh: string;
    public bildirenAd?: string;
    public bildirenAdres?: string;
    public bildirenDogumTarih?: string;
    public bildirenDogumYil?: number;
    public bildirenSoyad?: string;
    public bildirenTarih?: string;
    public bildirenTckn?: number;
    public bildirenTelefon?: string;
    public bildirenYakinlik?: string;
    public definMezarlikAdi?: string;
    public definRuhsatNo?: string;
    public definRuhsatTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public doktorAd?: string;
    public doktorDiplomaNo?: string;
    public doktorSoyad?: string;
    public doktorTarih?: string;
    public doktorTckn?: number;
    public doktorUnvan?: string;
    public gassilhaneEh: string;
    public izinAd?: string;
    public izinPerKod?: number;
    public izinSoyad?: string;
    public izinTarih?: string;
    public izinUnvan?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezarIscisiEh?: string;
    public nakilYeri?: string;
    public oluDogumEh: string;
    public olumAciklama1?: string;
    public olumAciklama2?: string;
    public olumAciklama3?: string;
    public olumAciklama4?: string;
    public olumBelgeKod: number;
    public olumDurum1?: string;
    public olumDurum2?: string;
    public olumDurumAciklama1?: string;
    public olumDurumAciklama2?: string;
    public olumNeden1?: string;
    public olumNeden2?: string;
    public olumNeden3?: string;
    public olumNeden4?: string;
    public onayAd?: string;
    public onaySoyad?: string;
    public onayTarih?: string;
    public onayTckn?: number;
    public onayUnvan?: string;
    public tasimaAracIstiyorEh: string;
    public taziyeAdres?: string;
    public taziyeAraciEh: string;
    public taziyeAraciSaat?: string;
    public tutanakKayitNo?: string;
    public tutanakKayitTarih?: string;
    public yemekIstiyorEh: string;
    public omsOlumBelge: OmsOlumBelge;

    public constructor(init?: Partial<OmsOlumBelgeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class OmsOlumBelgeMesaj extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eMail?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mesajAd?: string;
    public mesajGonderildiEh: string;
    public mesajSoyad?: string;
    public mesajTckn?: number;
    public olumBelgeKod: number;
    public talepYakinligi?: string;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public omsOlumBelge: OmsOlumBelge;

    public constructor(init?: Partial<OmsOlumBelgeMesaj>) { super(init); (Object as any).assign(this, init); }
}

export class OmsOlumBelgeNakil extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gidilecekYer?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public olumBelgeKod: number;
    public onayPerKod?: number;
    public talepAd?: string;
    public talepAnneAd?: string;
    public talepBabaAd?: string;
    public talepDogumTarih?: string;
    public talepSoyad?: string;
    public talepTarih: string;
    public talepTckn?: number;
    public talepTelefon?: string;
    public talepYakinligi?: string;
    public ikaPersonel?: IkaPersonel;
    public omsOlumBelge: OmsOlumBelge;

    public constructor(init?: Partial<OmsOlumBelgeNakil>) { super(init); (Object as any).assign(this, init); }
}

export class OmsOlumBelge extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public anneAd?: string;
    public babaAd?: string;
    public belediyeKod: number;
    public belgeNo?: string;
    public cinsiyet?: string;
    public dahaFazlaBilgiEh: string;
    public definCamiiAdi?: string;
    public defterKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public dogumYil?: number;
    public eMail?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public isYerindeYaralanmaEh: string;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mailBilgiEh?: string;
    public medeniDurumKod?: number;
    public meslekAciklama?: string;
    public meslekKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public olenBinaKod?: number;
    public olenBlokNo?: string;
    public olenBolumKod?: number;
    public olenCaddeSokak?: string;
    public olenDaireNo?: string;
    public olenGelisTarih?: string;
    public olenIlceKod?: number;
    public olenKapiNo?: number;
    public olenKapiNo1?: string;
    public olenKayitTarih?: string;
    public olenMahalleCaddeKod?: number;
    public olenMahalleKoy?: string;
    public olenSiraNo?: number;
    public olenSiteApartmanAd?: string;
    public olumNedenAciklama?: string;
    public olumNedeniOtopsiEh: string;
    public olumNedenKod?: number;
    public olumSaat: string;
    public olumSekliAciklama?: string;
    public olumSekliKod?: number;
    public olumTarih: string;
    public olumYaralanmaEh: string;
    public olumYeriKod: number;
    public oncekiSoyad?: string;
    public otopsiEh: string;
    public siraNo: number;
    public smsBilgiEh?: string;
    public soyad: string;
    public tckn?: number;
    public tesbitKurumKod: number;
    public uyrukKod?: number;
    public yaralanmaTarih?: string;
    public yaralanmaYerKod?: number;
    public yil: number;
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genIlce3?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genKodDetay5?: GenKodDetay;
    public genKodDetay6: GenKodDetay;
    public genKodDetay7?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public omsDefter: OmsDefter;
    public omsKurum: OmsKurum;
    public omsMezarDetays: OmsMezarDetay[];
    public omsOlumBelgeDetay: OmsOlumBelgeDetay;
    public omsOlumBelgeMesajs: OmsOlumBelgeMesaj[];
    public omsOlumBelgeNakil: OmsOlumBelgeNakil;

    public constructor(init?: Partial<OmsOlumBelge>) { super(init); (Object as any).assign(this, init); }
}

export class OmsMezarDetay extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public babaAd?: string;
    public belediyeKod: number;
    public cinsiyet?: string;
    public definNo?: string;
    public definTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public dogumYil?: number;
    public eskiKisiKod?: number;
    public kabirSahibiEh: string;
    public katNo?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kemikMezarNakilTarih?: string;
    public kisiKod?: number;
    public kod: number;
    public meslekAciklama?: string;
    public meslekKod?: number;
    public mezarIslemKod?: number;
    public mezarKod: number;
    public mezarOnayTarih?: string;
    public mezarTurKod?: number;
    public mezarYapanUsta?: string;
    public mezarYapimTarih?: string;
    public musade?: string;
    public nakilAciklama?: string;
    public olumAdres?: string;
    public olumBelgeKod?: number;
    public olumNedenAciklama?: string;
    public olumNedenKod?: number;
    public olumSiraNo?: number;
    public olumTarih?: string;
    public olumYil?: number;
    public plakaNo?: number;
    public siraNo?: number;
    public soyad?: string;
    public tckn?: number;
    public genIlce?: GenIlce;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public omsMezar: OmsMezar;
    public omsOlumBelge?: OmsOlumBelge;

    public constructor(init?: Partial<OmsMezarDetay>) { super(init); (Object as any).assign(this, init); }
}

export class OmsMezarResim extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezarKod: number;
    public mezarResim?: string;
    public tarih: string;
    public omsMezar: OmsMezar;

    public constructor(init?: Partial<OmsMezarResim>) { super(init); (Object as any).assign(this, init); }
}

export class OmsMezar extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public ada?: number;
    public babaAd?: string;
    public belediyeKod: number;
    public cinsiyet?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public dogumYil?: number;
    public eskiKisiKod?: number;
    public katNo?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public makbuzNo?: number;
    public makbuzSeriNo?: string;
    public makbuzTarih?: string;
    public makbuzTutar?: number;
    public mezarlikYerKod: number;
    public mezarParselKod?: number;
    public mezarTarifeKod?: number;
    public mezarTurKod: number;
    public pafta?: string;
    public parsel?: number;
    public ruhsatNo?: number;
    public ruhsatTarih?: string;
    public ruhsatTutar?: number;
    public satinalmaNo?: string;
    public satinalmaTarih?: string;
    public sayfaNo: number;
    public siraNo: number;
    public soyad?: string;
    public tckn?: number;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public genKodDetay: GenKodDetay;
    public omsKadastro?: OmsKadastro;
    public omsMezarDetays: OmsMezarDetay[];
    public omsMezarlikYer: OmsMezarlikYer;
    public omsMezarResims: OmsMezarResim[];
    public omsTarife?: OmsTarife;
    public omsUcretTahakkuks: OmsUcretTahakkuk[];

    public constructor(init?: Partial<OmsMezar>) { super(init); (Object as any).assign(this, init); }
}

export class OmsUcretTahakkuk extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mezarKod: number;
    public mezarTarifeKod?: number;
    public notlar?: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public yil: number;
    public genKisi?: GenKisi;
    public genKisi1: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;
    public omsMezar: OmsMezar;
    public omsTarife?: OmsTarife;

    public constructor(init?: Partial<OmsUcretTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class TisTarifeDetay extends CommonEntityBase
{
    public carpanUygulaEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public gelirTur?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public tarifeKod: number;
    public tutar?: number;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;
    public tisTarife: TisTarife;

    public constructor(init?: Partial<TisTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class TisTarife extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tisTarifeDetays: TisTarifeDetay[];
    public tisUcretTahakkuks: TisUcretTahakkuk[];

    public constructor(init?: Partial<TisTarife>) { super(init); (Object as any).assign(this, init); }
}

export class TisUcretTahakkuk extends CommonEntityBase
{
    public ada?: string;
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mahalleCaddeKod?: number;
    public notlar?: string;
    public parsel?: string;
    public siteApartmanAd?: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public ucretTarifeKod: number;
    public yil: number;
    public genKisi: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;
    public tisTarife: TisTarife;

    public constructor(init?: Partial<TisUcretTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class YrsTarifeLimit extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public limit: number;
    public siraNo: number;
    public tarifeDetayKod: number;
    public tarifeKod: number;
    public tutar: number;
    public yrsTarife: YrsTarife;
    public yrsTarifeDetay: YrsTarifeDetay;

    public constructor(init?: Partial<YrsTarifeLimit>) { super(init); (Object as any).assign(this, init); }
}

export class YrsTarifeDetay extends CommonEntityBase
{
    public carpan?: number;
    public carpanUygulaEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public gelirTur?: number;
    public hesapTuru?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public limitUygulaEh: string;
    public siraNo: number;
    public tarifeKod: number;
    public tutar?: number;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;
    public yrsTarife: YrsTarife;
    public yrsTarifeLimits: YrsTarifeLimit[];

    public constructor(init?: Partial<YrsTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class YrsTarife extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yrsTarifeDetays: YrsTarifeDetay[];
    public yrsTarifeLimits: YrsTarifeLimit[];
    public yrsUcretTahakkuks: YrsUcretTahakkuk[];

    public constructor(init?: Partial<YrsTarife>) { super(init); (Object as any).assign(this, init); }
}

export class YrsUcretTahakkuk extends CommonEntityBase
{
    public ada?: string;
    public belediyeKod: number;
    public binaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public dosyaNo?: number;
    public encumenNo?: string;
    public encumenTarih?: string;
    public eskiKisiKod?: number;
    public indirimOran?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mahalleCaddeKod?: number;
    public notlar?: string;
    public parsel?: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public tebligTarih?: string;
    public tutanakCiltNo?: number;
    public tutanakNo?: string;
    public tutanakSayfaNo?: number;
    public tutanakTarih?: string;
    public ucretTarifeKod: number;
    public yil: number;
    public genKisi: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;
    public yrsTarife: YrsTarife;

    public constructor(init?: Partial<YrsUcretTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahakkukAna extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public ciltNo?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public hkpIsKod?: number;
    public ihbarAnaKod?: number;
    public islemKod?: string;
    public islemTipi: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public sayfaNo?: number;
    public tahakkukTarih: string;
    public varisKod?: number;
    public etsUcretTahakkuks: EtsUcretTahakkuk[];
    public fisUcretTahakkuks: FisUcretTahakkuk[];
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genKisiVaris?: GenKisiVaris;
    public genModul: GenModul;
    public gysHkpIsler?: GysHkpIsler;
    public gysIcraAnas: GysIcraAna[];
    public gysIhbarAna?: GysIhbarAna;
    public gysTahakkuks: GysTahakkuk[];
    public omsUcretTahakkuks: OmsUcretTahakkuk[];
    public sasGeciciKapatmas: SasGeciciKapatma[];
    public sasUcretTahakkuks: SasUcretTahakkuk[];
    public temFisGelirs: TemFisGelir[];
    public tisUcretTahakkuks: TisUcretTahakkuk[];
    public yrsUcretTahakkuks: YrsUcretTahakkuk[];

    public constructor(init?: Partial<GysTahakkukAna>) { super(init); (Object as any).assign(this, init); }
}

export class HisDavaDurusma extends CommonEntityBase
{
    public avukatKod: number;
    public belediyeKod: number;
    public davaAnaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaNo: number;
    public durusmaAciklama?: string;
    public durusmaSaat?: string;
    public durusmaTarih: string;
    public durusmaYapildiEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yeniDurusmaSaat?: string;
    public yeniDurusmaTarih?: string;
    public yil: number;
    public genAvukat: GenAvukat;
    public hisDava: HisDava;

    public constructor(init?: Partial<HisDavaDurusma>) { super(init); (Object as any).assign(this, init); }
}

export class HisDavaKonu extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public hisDavas: HisDava[];

    public constructor(init?: Partial<HisDavaKonu>) { super(init); (Object as any).assign(this, init); }
}

export class HisDavali extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public telAlanKod?: number;
    public telefon?: string;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public hisDavas: HisDava[];

    public constructor(init?: Partial<HisDavali>) { super(init); (Object as any).assign(this, init); }
}

export class HisDava extends CommonEntityBase
{
    public belediyeKod: number;
    public davaciAdSoyadUnvan?: string;
    public davaciAvukatKod?: number;
    public davaciKisiKod?: number;
    public davaciVekil?: string;
    public davaKonuAciklama?: string;
    public davaKonuKod?: number;
    public davaliAdSoyadUnvan?: string;
    public davaliAvukatKod?: number;
    public davaliKisiKod?: number;
    public davaliKod?: number;
    public davaliVekil?: string;
    public davaMasraf?: number;
    public davaTarih: string;
    public davaTurKod?: number;
    public davaTuru: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaNo: number;
    public eskiDavaciKisiKod?: number;
    public eskiDavaliKisiKod?: number;
    public hifzAvukatKod?: number;
    public hifzTarih?: string;
    public kararAciklama?: string;
    public kararKesinlesmeTarih?: string;
    public kararNo?: string;
    public kararNotlari?: string;
    public kararSonucKod?: number;
    public kararTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahkemeEsasNo?: string;
    public mahkemeKod: number;
    public tashihKararAciklama?: string;
    public tashihKararTarih?: string;
    public telkinNo?: string;
    public temyizAciklama?: string;
    public temyizTarih?: string;
    public yil: number;
    public yurutmeDurdurmaDurumu?: string;
    public yurutmeDurdurmaNo?: string;
    public yurutmeDurdurmaTarih?: string;
    public genAvukat?: GenAvukat;
    public genAvukat1?: GenAvukat;
    public genAvukat2?: GenAvukat;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public genKisi2?: GenKisi;
    public genKisi3?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public hisDavaBorcs: HisDavaBorc[];
    public hisDavaDurusmas: HisDavaDurusma[];
    public hisDavaKonu?: HisDavaKonu;
    public hisDavali?: HisDavali;

    public constructor(init?: Partial<HisDava>) { super(init); (Object as any).assign(this, init); }
}

export class HisDavaBorc extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public davaAnaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public ihbarAnaKod: number;
    public ihbarKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukVergi?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public yil: number;
    public genKisi?: GenKisi;
    public genKisi1: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysIhbar: GysIhbar;
    public gysIhbarAna: GysIhbarAna;
    public hisDava: HisDava;

    public constructor(init?: Partial<HisDavaBorc>) { super(init); (Object as any).assign(this, init); }
}

export class GysIhbarAna extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public ciltNo?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public duzenlemeTarih: string;
    public eskiKisiKod?: number;
    public hkpIsKod?: number;
    public islemKod?: string;
    public islemTipi: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public sayfaNo?: number;
    public tarhiyatTuru?: number;
    public tebligSekliKod?: number;
    public tebligTarih?: string;
    public varisKod?: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genKisiVaris?: GenKisiVaris;
    public genKodDetay?: GenKodDetay;
    public genModul: GenModul;
    public gysHkpIsler?: GysHkpIsler;
    public gysIhbars: GysIhbar[];
    public gysTahakkukAnas: GysTahakkukAna[];
    public hisDavaBorcs: HisDavaBorc[];

    public constructor(init?: Partial<GysIhbarAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysIhbarTerkin extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public cezaKat?: number;
    public cezaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public ihbarKod: number;
    public islemTipi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public matrahi?: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukVergi?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public vergiOran?: number;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysIhbar: GysIhbar;

    public constructor(init?: Partial<GysIhbarTerkin>) { super(init); (Object as any).assign(this, init); }
}

export class GysIhbar extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public carpanDeger?: number;
    public cezaKat?: number;
    public cezaOran?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public ihbarAnaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public matrahi?: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukVergi?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public vergiOran?: number;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysIhbarAna: GysIhbarAna;
    public gysIhbarTerkins: GysIhbarTerkin[];
    public gysTahakkuk?: GysTahakkuk;
    public hisDavaBorc: HisDavaBorc;

    public constructor(init?: Partial<GysIhbar>) { super(init); (Object as any).assign(this, init); }
}

export class GysHkpIsler extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanToplam?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaNo?: string;
    public emlakKiymetYuzde: number;
    public encKararNo?: string;
    public encKararTarih?: string;
    public gelirKod: number;
    public isAd: string;
    public isAlinacakTutar: number;
    public isBaslangicTarih?: string;
    public isBitisTarih?: string;
    public isCarpan?: number;
    public isHibeTutar?: number;
    public isMasrafTutar: number;
    public isNo: number;
    public isSahibi: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod?: number;
    public notlar?: string;
    public yil: number;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public gysGelirDetay: GysGelirDetay;
    public gysHacizs: GysHaciz[];
    public gysHkpBeyans: GysHkpBeyan[];
    public gysHkpIslerDetays: GysHkpIslerDetay[];
    public gysHkpIslerVades: GysHkpIslerVade[];
    public gysIcras: GysIcra[];
    public gysIhbars: GysIhbar[];
    public gysIhbarAnas: GysIhbarAna[];
    public gysIhbarTerkins: GysIhbarTerkin[];
    public gysMahsups: GysMahsup[];
    public gysTahakkuks: GysTahakkuk[];
    public gysTahakkukAnas: GysTahakkukAna[];
    public gysTahsils: GysTahsil[];
    public gysTakips: GysTakip[];
    public gysTakipTerkins: GysTakipTerkin[];
    public gysTaksits: GysTaksit[];
    public gysTaksitIptals: GysTaksitIptal[];
    public gysTerkins: GysTerkin[];
    public gysTerkinAnas: GysTerkinAna[];
    public hisDavaBorcs: HisDavaBorc[];

    public constructor(init?: Partial<GysHkpIsler>) { super(init); (Object as any).assign(this, init); }
}

export class GysHkpBeyan extends CommonEntityBase
{
    public aciklama?: string;
    public ada?: number;
    public alani?: number;
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public daireNo?: string;
    public deger?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public emlakBeyanKod?: number;
    public emlakBeyanTuru: number;
    public eskiKisiKod?: number;
    public isKod: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public koseEh: string;
    public mahalleCaddeKod: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public siraNo: number;
    public siteApartmanAd?: string;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;
    public gysHacizs: GysHaciz[];
    public gysHkpIsler: GysHkpIsler;
    public gysIcras: GysIcra[];
    public gysIhbars: GysIhbar[];
    public gysIhbarTerkins: GysIhbarTerkin[];
    public gysMahsups: GysMahsup[];
    public gysTahakkuks: GysTahakkuk[];
    public gysTahsils: GysTahsil[];
    public gysTakips: GysTakip[];
    public gysTakipTerkins: GysTakipTerkin[];
    public gysTaksits: GysTaksit[];
    public gysTaksitIptals: GysTaksitIptal[];
    public gysTerkins: GysTerkin[];
    public hisDavaBorcs: HisDavaBorc[];

    public constructor(init?: Partial<GysHkpBeyan>) { super(init); (Object as any).assign(this, init); }
}

export class GysIcra extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hacizAnaKod?: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public icraAnaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukVergi?: number;
    public takipDetayKod?: number;
    public taksitKod?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHacizAna?: GysHacizAna;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysIcraAna: GysIcraAna;
    public gysTahakkuk?: GysTahakkuk;
    public gysTakip?: GysTakip;

    public constructor(init?: Partial<GysIcra>) { super(init); (Object as any).assign(this, init); }
}

export class GysHacizAna extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public duzenlemeTarih: string;
    public eskiKisiKod?: number;
    public hacizTakipNo: number;
    public icraPersonelKod?: number;
    public icraRolAd?: string;
    public islemKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mudurPersonelKod?: number;
    public mudurRolAd?: string;
    public onayPersonelKod?: number;
    public onayRolAd?: string;
    public onayTarih?: string;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysHacizs: GysHaciz[];
    public gysIcras: GysIcra[];
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;

    public constructor(init?: Partial<GysHacizAna>) { super(init); (Object as any).assign(this, init); }
}

export class GysHaciz extends CommonEntityBase
{
    public belediyeKod: number;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayGelirKod: number;
    public donem: number;
    public duzenlemeTarih: string;
    public ekVergiEh: string;
    public eskiKisiKod?: number;
    public gecikmeFaiz?: number;
    public gelirKod: number;
    public hacizAnaKod: number;
    public hkpBeyanKod?: number;
    public hkpIsKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinlesmeTarih?: string;
    public kisiKod: number;
    public kod: number;
    public modulKod: number;
    public referansAltKod?: number;
    public referansKod?: number;
    public suAboneKod?: number;
    public suOkumaKod?: number;
    public tahakkukKod?: number;
    public tahakkukVergi?: number;
    public takipDetayKod: number;
    public taksitKod?: number;
    public tebligTarih?: string;
    public vadeTarih: string;
    public yil: number;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genModul: GenModul;
    public gysBeyan?: GysBeyan;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysHacizAna: GysHacizAna;
    public gysHkpBeyan?: GysHkpBeyan;
    public gysHkpIsler?: GysHkpIsler;
    public gysTahakkuk?: GysTahakkuk;
    public gysTakip: GysTakip;

    public constructor(init?: Partial<GysHaciz>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlanGelir extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public oranTutar: number;
    public tarifeKod: number;
    public uygulamaTuru: string;
    public vadeUygulamaTuru: string;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;
    public gysIlanTarife: GysIlanTarife;

    public constructor(init?: Partial<GysIlanGelir>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlanTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hesapSekli?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public muaf?: number;
    public tarife1?: number;
    public tarife2?: number;
    public tarife3?: number;
    public tarife4?: number;
    public tarife5?: number;
    public tarifeKod: number;
    public tutar1?: number;
    public tutar2?: number;
    public tutar3?: number;
    public tutar4?: number;
    public tutar5?: number;
    public yil: number;
    public gysIlanTarife: GysIlanTarife;

    public constructor(init?: Partial<GysIlanTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlanTarife extends CommonEntityBase
{
    public ad: string;
    public adetM2: string;
    public adresKontrolTuru: string;
    public aktifEh: string;
    public belediyeKod: number;
    public cezaHesapEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public muafGrupEh: string;
    public ustTarifeEh: string;
    public gysBeyans: GysBeyan[];
    public gysGelirDetay: GysGelirDetay;
    public gysIlanGelirs: GysIlanGelir[];
    public gysIlanTarifeDetays: GysIlanTarifeDetay[];

    public constructor(init?: Partial<GysIlanTarife>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlanYer extends CommonEntityBase
{
    public ad: string;
    public adet: number;
    public aktifEh: string;
    public belediyeKod: number;
    public boy?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public en?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod: number;
    public turu: string;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;
    public gysBeyans: GysBeyan[];

    public constructor(init?: Partial<GysIlanYer>) { super(init); (Object as any).assign(this, init); }
}

export class AksTapuMahalle extends CommonEntityBase
{
    public ad?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleKod?: number;
    public aksParsels: AksParsel[];
    public genMahalleKoy?: GenMahalleKoy;
    public gysTapus: GysTapu[];

    public constructor(init?: Partial<AksTapuMahalle>) { super(init); (Object as any).assign(this, init); }
}

export class GysTapu extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemNo?: number;
    public islemTanimAd?: string;
    public islemTanimNo?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kontrolEh: string;
    public kurumNo?: number;
    public tapuMahalleAd?: string;
    public tapuMahalleKod?: number;
    public tasinmazAd?: string;
    public tasinmazAda?: number;
    public tasinmazCins?: string;
    public tasinmazNo?: number;
    public tasinmazPafta?: string;
    public tasinmazParsel?: number;
    public tasinmazSablonAd?: string;
    public tasinmazYuzolcum?: number;
    public yevmiyeNo?: number;
    public yevmiyeTarih?: string;
    public aksTapuMahalle?: AksTapuMahalle;
    public gysTapuDetays: GysTapuDetay[];

    public constructor(init?: Partial<GysTapu>) { super(init); (Object as any).assign(this, init); }
}

export class GysTapuDetay extends CommonEntityBase
{
    public ad?: string;
    public adres?: string;
    public anneAd?: string;
    public babaAd?: string;
    public beyanDavetEh: string;
    public beyanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public hisseNo?: number;
    public hissePay?: number;
    public hissePayda?: number;
    public islemBilgisi?: string;
    public islemPay?: number;
    public islemPayda?: number;
    public islemZeminHisseNo?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kaynakIslemHisseNo?: number;
    public kisiKod?: number;
    public kod: number;
    public malikNo?: number;
    public malikTipi?: number;
    public satisDeger?: number;
    public soyad?: string;
    public tapuAnaKod: number;
    public tarafTipi?: string;
    public tckn?: number;
    public vergiNo?: number;
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;
    public gysBeyan?: GysBeyan;
    public gysTapu: GysTapu;

    public constructor(init?: Partial<GysTapuDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GysYoklamaMemur extends CommonEntityBase
{
    public adi: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorev?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciKod?: number;
    public personelKod?: number;
    public soyadi: string;
    public gysBeyans: GysBeyan[];
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<GysYoklamaMemur>) { super(init); (Object as any).assign(this, init); }
}

export class GysBeyan extends CommonEntityBase
{
    public aciklama?: string;
    public ada?: number;
    public araziTurKod?: number;
    public arsaAlani?: number;
    public arsaAlani1?: number;
    public arsaHisse?: number;
    public arsaHisse1?: number;
    public arsaOran?: number;
    public arsaOran1?: number;
    public asgariHesapYil?: number;
    public belediyeKod: number;
    public beyanTipi: number;
    public bildirimSekli: string;
    public binaAsansorEh?: string;
    public binaHisse?: number;
    public binaHisse1?: number;
    public binaKaloriferEh?: string;
    public binaKod?: number;
    public binaKullanimKod?: number;
    public binaMuafEh?: string;
    public binaOran?: number;
    public binaOran1?: number;
    public binaYuzolcum?: number;
    public binaYuzolcumu1?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public ctvDerece?: number;
    public ctvGrup?: number;
    public ctvKullanimKod?: number;
    public daimiMuafiyetEh: string;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donumu?: number;
    public eglTarifeKod?: number;
    public ekaKullanimKod?: number;
    public ekVergiEh: string;
    public emlakBeyanTuru?: number;
    public eskiKisiKod?: number;
    public genelTarifeKod?: number;
    public iktisapTarih?: string;
    public iktisapTurKod?: number;
    public ilanAracPlaka?: string;
    public ilanAracSase?: string;
    public ilanBeyanTuru?: string;
    public ilanBoy?: number;
    public ilanEn?: number;
    public ilanMuaf?: number;
    public ilanNetToplam?: number;
    public ilanSponsorKod?: number;
    public ilanTarifeKod?: number;
    public ilanToplam?: number;
    public ilanYerKod?: number;
    public ilanYon?: number;
    public imarPlanNumarasi?: string;
    public imarPlanTarihi?: string;
    public insaatBitimTarih?: string;
    public insaatSinifKod?: number;
    public insaatTurKod?: number;
    public isyeriNo?: number;
    public kabulTarih: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kBaslangicTarih?: string;
    public kBitisTarih?: string;
    public kisiKod: number;
    public kod: number;
    public kriterKoltuk?: number;
    public kriterM2?: number;
    public kriterOgrenci?: number;
    public kriterPersonel?: number;
    public kriterYatak?: number;
    public kullanimSekliKod?: number;
    public kYuzdesi?: number;
    public mahalleCaddeKod: number;
    public malikAciklama?: string;
    public malikKisiKod?: number;
    public mBaslangicYil?: number;
    public mevkiiAdi?: string;
    public modulKod: number;
    public mSure?: number;
    public muafiyetTurKod?: number;
    public mukellefBitisKod?: number;
    public mukellefBitisTarih?: string;
    public netArsaAlani?: number;
    public netBinaYuzolcum?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public siraNo: number;
    public siteApartmanAd?: string;
    public tapuBagimsizNo?: string;
    public tapuCiltNo?: number;
    public tapuKod?: number;
    public tapuSayfaNo?: number;
    public vergiBaslangicTarih: string;
    public verilisNedeni: string;
    public yoklamaMemurKod?: number;
    public yoklamaNo?: string;
    public yoklamaTarihi?: string;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public genAraziTuru?: GenAraziTuru;
    public genBinaKullanim?: GenBinaKullanim;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public genKisiIlanSponsor?: GenKisi;
    public genKodIktisapTur?: GenKodDetay;
    public genKodInsaatSinif?: GenKodDetay;
    public genKodInsaatTur?: GenKodDetay;
    public genKullanimSekli?: GenKullanimSekli;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;
    public genModul: GenModul;
    public gysBeyanBagimsizs: GysBeyanBagimsiz[];
    public gysBeyanCtvDetays: GysBeyanCtvDetay[];
    public gysBeyanEglDetays: GysBeyanEglDetay[];
    public gysBeyanEkaDetays: GysBeyanEkaDetay[];
    public gysBeyanEmlakAsgaris: GysBeyanEmlakAsgari[];
    public gysBeyanEmlakTezyids: GysBeyanEmlakTezyid[];
    public gysBeyanGenelDetays: GysBeyanGenelDetay[];
    public gysBeyanIlanDetays: GysBeyanIlanDetay[];
    public gysBeyanSatis: GysBeyanSatis[];
    public gysCtvKullanim?: GysCtvKullanim;
    public gysEglTarife?: GysEglTarife;
    public gysEkaKullanim?: GysEkaKullanim;
    public gysEmlakMuafiyetTuru?: GysEmlakMuafiyetTuru;
    public gysGenelTarife?: GysGenelTarife;
    public gysHacizs: GysHaciz[];
    public gysIcras: GysIcra[];
    public gysIhbars: GysIhbar[];
    public gysIhbarTerkins: GysIhbarTerkin[];
    public gysIlanTarife?: GysIlanTarife;
    public gysIlanYer?: GysIlanYer;
    public gysMahsups: GysMahsup[];
    public gysMukellefBitisTuru?: GysMukellefBitisTuru;
    public gysTahakkuks: GysTahakkuk[];
    public gysTahsils: GysTahsil[];
    public gysTakips: GysTakip[];
    public gysTakipTerkins: GysTakipTerkin[];
    public gysTaksits: GysTaksit[];
    public gysTaksitIptals: GysTaksitIptal[];
    public gysTapuDetays: GysTapuDetay[];
    public gysTerkins: GysTerkin[];
    public gysYoklamaMemur?: GysYoklamaMemur;
    public hisDavaBorcs: HisDavaBorc[];

    public constructor(init?: Partial<GysBeyan>) { super(init); (Object as any).assign(this, init); }
}

export class GenModul extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public modulUzantisi?: string;
    public tur: string;
    public gysBeyans: GysBeyan[];

    public constructor(init?: Partial<GenModul>) { super(init); (Object as any).assign(this, init); }
}

export class EksParametre extends CommonEntityBase
{
    public arsivEh: string;
    public belediyeKod: number;
    public belgeRootPath?: string;
    public birimKod?: number;
    public calismaPath?: string;
    public cevapBelgeTuruKod?: number;
    public cevapDosyaPlanKod?: string;
    public cevapIcerik?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod?: string;
    public dysServisAdres?: string;
    public dysTuru?: string;
    public eImzaEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci?: string;
    public kod: number;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public sablonDysId?: string;
    public siniflandirmaTuru?: string;
    public surecKod?: number;
    public bysSurec?: BysSurec;
    public genBelgeTuru?: GenBelgeTuru;
    public genBirim?: GenBirim;
    public genModul: GenModul;
    public cevapDosyaPlan?: GenDosyaPlan;
    public anaDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<EksParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysIcraYazismaTurKal extends CommonEntityBase
{
    public belgeIcerik?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public icraYazismaTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysIcraYazismaTur: GysIcraYazismaTur;

    public constructor(init?: Partial<GysIcraYazismaTurKal>) { super(init); (Object as any).assign(this, init); }
}

export class GysIcraYazismaTurKoy extends CommonEntityBase
{
    public belgeIcerik?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public icraYazismaTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysIcraYazismaTur: GysIcraYazismaTur;

    public constructor(init?: Partial<GysIcraYazismaTurKoy>) { super(init); (Object as any).assign(this, init); }
}

export class GysIcraYazismaTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public dagitimBirimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hacizKalDagitimSekli: string;
    public hacizKalDosyaPlanKod?: string;
    public hacizKoyDagitimSekli: string;
    public hacizKoyDosyaPlanKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public surecKod?: number;
    public yaziBaslik?: string;
    public yaziBaslik1?: string;
    public bysSurec?: BysSurec;
    public genBirim?: GenBirim;
    public gysIcraYazismaTurKal: GysIcraYazismaTurKal;
    public gysIcraYazismaTurKoy: GysIcraYazismaTurKoy;
    public kalGenDosyaPlan?: GenDosyaPlan;
    public koyGenDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<GysIcraYazismaTur>) { super(init); (Object as any).assign(this, init); }
}

export class MksParametre extends CommonEntityBase
{
    public arsivEh: string;
    public belediyeKod: number;
    public belgeRootPath?: string;
    public birimKod?: number;
    public calismaPath?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod?: string;
    public dysServisAdres?: string;
    public dysTuru?: string;
    public eImzaEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci?: string;
    public kod: number;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public sablonDysId?: string;
    public siniflandirmaTuru?: string;
    public surecKod?: number;
    public bysSurec?: BysSurec;
    public genBirim?: GenBirim;
    public genModul: GenModul;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<MksParametre>) { super(init); (Object as any).assign(this, init); }
}

export class BysSurec extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public bysGorevs: BysGorev[];
    public bysRaporBelgeDetays: BysRaporBelgeDetay[];
    public bysSurecDetays: BysSurecDetay[];
    public eksParametres: EksParametre[];
    public genBirim: GenBirim;
    public gysIcraYazismaTurs: GysIcraYazismaTur[];
    public mksParametres: MksParametre[];
    public yisParametreDetays: YisParametreDetay[];

    public constructor(init?: Partial<BysSurec>) { super(init); (Object as any).assign(this, init); }
}

export class YisParametreDetay extends CommonEntityBase
{
    public arsivEh: string;
    public belediyeKod?: number;
    public belgeRootPath?: string;
    public birimKod?: number;
    public calismaPath?: string;
    public cevapBelgeTuruKod?: number;
    public cevapDosyaPlanKod?: string;
    public cevapIcerik?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod?: string;
    public dysServisAdres?: string;
    public dysTuru?: string;
    public eImzaEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci?: string;
    public kod: number;
    public mevzuatLink?: string;
    public parametreKod?: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public sablonDysId?: string;
    public siniflandirmaTuru?: string;
    public surecKod?: number;
    public bysSurec?: BysSurec;
    public genBelediye?: GenBelediye;
    public genBelgeTuru?: GenBelgeTuru;
    public genBirim?: GenBirim;

    public constructor(init?: Partial<YisParametreDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GenBelgeTuru extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ustKod?: number;
    public ustGenBelgeTuru?: GenBelgeTuru;
    public genBelgeTurus: GenBelgeTuru[];
    public yisKararBelges: YisKararBelge[];
    public yisParametreDetays: YisParametreDetay[];
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<GenBelgeTuru>) { super(init); (Object as any).assign(this, init); }
}

export class YisIhaleTeklif extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public teklifVrnAciklama?: string;
    public teklifVrnTc?: number;
    public teklifVrnUnvan?: string;
    public teklifVrnVergiNo?: string;
    public yisKarar?: YisKarar;

    public constructor(init?: Partial<YisIhaleTeklif>) { super(init); (Object as any).assign(this, init); }
}

export class YisImzaSurec extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ebysNo?: number;
    public ebysTarih?: string;
    public iptal?: number;
    public kararKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public onayDurumu?: number;
    public qrkod?: string;
    public yisKarar?: YisKarar;

    public constructor(init?: Partial<YisImzaSurec>) { super(init); (Object as any).assign(this, init); }
}

export class YisKararIcerik extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararIcerik?: string;
    public kararKod: number;
    public kararOzetAciklama?: string;
    public kararOzetIcerik?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yisKarar: YisKarar;

    public constructor(init?: Partial<YisKararIcerik>) { super(init); (Object as any).assign(this, init); }
}

export class YisKararKisi extends CommonEntityBase
{
    public aciklama?: string;
    public adiSoyadiUnvani?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public kararKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public tckn?: number;
    public genKisi?: GenKisi;
    public yisKarar?: YisKarar;

    public constructor(init?: Partial<YisKararKisi>) { super(init); (Object as any).assign(this, init); }
}

export class YisKararParsel extends CommonEntityBase
{
    public aciklama?: string;
    public ada: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pafta?: string;
    public parsel: number;
    public parselKod?: number;
    public aksParsel?: AksParsel;
    public yisKarar: YisKarar;

    public constructor(init?: Partial<YisKararParsel>) { super(init); (Object as any).assign(this, init); }
}

export class YisUnvan extends CommonEntityBase
{
    public adi?: string;
    public aktifEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turKod?: number;
    public yisGrupTur?: YisGrupTur;

    public constructor(init?: Partial<YisUnvan>) { super(init); (Object as any).assign(this, init); }
}

export class YisGrupTur extends CommonEntityBase
{
    public adi: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yisKonus: YisKonu[];
    public yisUnvans: YisUnvan[];

    public constructor(init?: Partial<YisGrupTur>) { super(init); (Object as any).assign(this, init); }
}

export class YisKonu extends CommonEntityBase
{
    public adi?: string;
    public aktifEh?: string;
    public anaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo?: number;
    public turKod?: number;
    public yisGrupTur?: YisGrupTur;
    public yisKarars: YisKarar[];

    public constructor(init?: Partial<YisKonu>) { super(init); (Object as any).assign(this, init); }
}

export class YisSonuc extends CommonEntityBase
{
    public ad?: string;
    public aktifEh?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisaAd?: string;
    public kod: number;
    public yisKarars: YisKarar[];

    public constructor(init?: Partial<YisSonuc>) { super(init); (Object as any).assign(this, init); }
}

export class YisKarar extends CommonEntityBase
{
    public anahtarKelime?: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durumKod?: number;
    public gelisSekliKod?: number;
    public genelArsivKod?: number;
    public grupTurKod: number;
    public gundemeIlaveEh: string;
    public gundemNo?: number;
    public gundemToplantiKod?: number;
    public ihaleBedeli?: number;
    public ihaleDuyuruSekli?: string;
    public ihaleGerekcesi?: string;
    public ihaleSiraNo?: number;
    public ihaleTurKod?: number;
    public ihaleUsulu?: string;
    public isinCinsi?: string;
    public kararAciklama?: string;
    public kararEkNo?: string;
    public kararKesinlesmeSayi?: string;
    public kararKesinlesmeTarih?: string;
    public kararNo?: string;
    public kararOnayTarih?: string;
    public kararSaati?: string;
    public kararSekliKod?: number;
    public kararTarih?: string;
    public kararToplantiKod?: number;
    public kararTuru?: string;
    public kararYerKod?: number;
    public kararYururlulukSayi?: string;
    public kararYururlulukTarih?: string;
    public katilanKisi?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kazananFirma?: string;
    public kazananFirmaKod?: number;
    public kelimeIslemci?: string;
    public kisiKod?: number;
    public kod: number;
    public komisyonKod?: number;
    public konuKod: number;
    public meclisNo?: string;
    public onayBelgeTarihNo?: string;
    public onergeMetni?: string;
    public onergeTarihi?: string;
    public oylamaTurKod?: number;
    public paraCezasiEh?: string;
    public paraCezasiTutari?: number;
    public sonucTurKod?: number;
    public tahminiBedel?: number;
    public tckn?: number;
    public webYayiniEh: string;
    public yardimEh?: string;
    public yardimTutar?: number;
    public yazimTuru?: string;
    public gasDosya?: GasDosya;
    public genBelediye: GenBelediye;
    public genBirim: GenBirim;
    public genKisi?: GenKisi;
    public yisIhaleTeklifs: YisIhaleTeklif[];
    public yisImzaSurecs: YisImzaSurec[];
    public yisKararBelges: YisKararBelge[];
    public yisKararIceriks: YisKararIcerik[];
    public yisKararKisis: YisKararKisi[];
    public yisKararParsels: YisKararParsel[];
    public yisKonu: YisKonu;
    public yisSonuc?: YisSonuc;

    public constructor(init?: Partial<YisKarar>) { super(init); (Object as any).assign(this, init); }
}

export class YisKararBelge extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgeNo?: number;
    public belgePath?: string;
    public belgeTarih?: string;
    public belgeTipKod?: number;
    public belgeTuruKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public referansKod?: number;
    public genBelgeTip?: GenBelgeTip;
    public genBelgeTuru?: GenBelgeTuru;
    public yisKarar: YisKarar;

    public constructor(init?: Partial<YisKararBelge>) { super(init); (Object as any).assign(this, init); }
}

export class GenBelgeTip extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turu: number;
    public uzanti: string;
    public yisKararBelges: YisKararBelge[];

    public constructor(init?: Partial<GenBelgeTip>) { super(init); (Object as any).assign(this, init); }
}

export class EksKararDetay extends CommonEntityBase
{
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public eksKarar: EksKarar;
    public genBelgeTip: GenBelgeTip;

    public constructor(init?: Partial<EksKararDetay>) { super(init); (Object as any).assign(this, init); }
}

export class EksKararEk extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgeNo?: number;
    public belgePath?: string;
    public belgeTarih?: string;
    public belgeTipKod?: number;
    public belgeTuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public referansKod?: number;
    public eksKarar: EksKarar;
    public genBelgeTip?: GenBelgeTip;
    public genBelgeTuru: GenBelgeTuru;
    public bysBelge?: BysBelge;

    public constructor(init?: Partial<EksKararEk>) { super(init); (Object as any).assign(this, init); }
}

export class EksKararIcerik extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararIcerik?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public eksKarar: EksKarar;

    public constructor(init?: Partial<EksKararIcerik>) { super(init); (Object as any).assign(this, init); }
}

export class EksKararOzet extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kararOzetAciklama?: string;
    public kararOzetIcerik?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public eksKarar: EksKarar;

    public constructor(init?: Partial<EksKararOzet>) { super(init); (Object as any).assign(this, init); }
}

export class EksKararParsel extends CommonEntityBase
{
    public aciklama?: string;
    public ada: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pafta?: string;
    public parsel: number;
    public parselKod?: number;
    public aksParsel?: AksParsel;
    public eksKarar: EksKarar;

    public constructor(init?: Partial<EksKararParsel>) { super(init); (Object as any).assign(this, init); }
}

export class EksKonular extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public eksKarars: EksKarar[];

    public constructor(init?: Partial<EksKonular>) { super(init); (Object as any).assign(this, init); }
}

export class EksKarar extends CommonEntityBase
{
    public altBirimKod?: number;
    public anahtarKelime?: string;
    public belediyeKod: number;
    public birimKod: number;
    public cezaTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public evrakNo?: string;
    public evrakTarih?: string;
    public genelArsivKod?: number;
    public gundemKod?: number;
    public gundemSiraNo?: number;
    public kararAciklama?: string;
    public kararNo: string;
    public kararTarih: string;
    public kararTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci?: string;
    public kisiKod?: number;
    public kod: number;
    public konuKod: number;
    public oylamaTuru: number;
    public paraCezasiEh: string;
    public saat?: string;
    public sonucTurKod?: number;
    public tcknNo?: number;
    public toplantiNo?: string;
    public webYayiniEh: string;
    public yardimEh: string;
    public yardimTutar?: number;
    public yazimTuru: string;
    public eksKararDetay: EksKararDetay;
    public eksKararEks: EksKararEk[];
    public eksKararIcerik: EksKararIcerik;
    public eksKararOzet: EksKararOzet;
    public eksKararParsels: EksKararParsel[];
    public eksKararUyes: EksKararUye[];
    public eksKonular: EksKonular;
    public gasDosya?: GasDosya;
    public genBirim?: GenBirim;
    public genBirim1: GenBirim;
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;
    public genKodDetay?: GenKodDetay;

    public constructor(init?: Partial<EksKarar>) { super(init); (Object as any).assign(this, init); }
}

export class GasDepo extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gasBloks: GasBlok[];
    public gasDosyas: GasDosya[];

    public constructor(init?: Partial<GasDepo>) { super(init); (Object as any).assign(this, init); }
}

export class GasGoz extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public rafKod: number;
    public gasDosyas: GasDosya[];
    public gasRaf: GasRaf;

    public constructor(init?: Partial<GasGoz>) { super(init); (Object as any).assign(this, init); }
}

export class GasRaf extends CommonEntityBase
{
    public ad: string;
    public blokKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gasBlok: GasBlok;
    public gasDosyas: GasDosya[];
    public gasGozs: GasGoz[];

    public constructor(init?: Partial<GasRaf>) { super(init); (Object as any).assign(this, init); }
}

export class GasBlok extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public depoKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gasDepo: GasDepo;
    public gasDosyas: GasDosya[];
    public gasRafs: GasRaf[];
    public genBirim: GenBirim;

    public constructor(init?: Partial<GasBlok>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaBelge extends CommonEntityBase
{
    public ada?: number;
    public belgeAd?: string;
    public belgeBarkod?: string;
    public belgeDysKod?: string;
    public belgeKod?: number;
    public belgeNo?: string;
    public belgePath?: string;
    public belgeTarih: string;
    public belgeTipKod: number;
    public belgeTuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKod: number;
    public dosyaPlanKod?: string;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisaNotlar?: string;
    public kisiAciklama?: string;
    public kisiKod?: number;
    public kod: number;
    public notlar?: string;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public personelKod?: number;
    public saklamaSure?: number;
    public aksParsel?: AksParsel;
    public bysBelge?: BysBelge;
    public gasDosya: GasDosya;
    public genBelgeTip: GenBelgeTip;
    public genBelgeTuru: GenBelgeTuru;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<GasDosyaBelge>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaDsQrcode extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKod: number;
    public dosyaQrcode?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gasDosya: GasDosya;

    public constructor(init?: Partial<GasDosyaDsQrcode>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaKlQrcode extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public klasorQrcode?: string;
    public kod: number;
    public gasDosya: GasDosya;

    public constructor(init?: Partial<GasDosyaKlQrcode>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaKuQrcode extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kutuQrcode?: string;
    public gasDosya: GasDosya;

    public constructor(init?: Partial<GasDosyaKuQrcode>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaTalep extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod?: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKod: number;
    public evrakNo?: number;
    public evrakTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public talepPersonelKod: number;
    public talepTarih: string;
    public gasDosya: GasDosya;
    public gasDosyaOduncs: GasDosyaOdunc[];
    public genBirim: GenBirim;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<GasDosyaTalep>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaOdunc extends CommonEntityBase
{
    public aciklama?: string;
    public beklenenTarih?: string;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKod: number;
    public dosyaTalepKod: number;
    public iadeTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public klasorAdet?: number;
    public kod: number;
    public personelKod: number;
    public turu: number;
    public verildigiTarih: string;
    public gasDosya: GasDosya;
    public gasDosyaTalep: GasDosyaTalep;
    public genBirim: GenBirim;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<GasDosyaOdunc>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakipDosya extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public genelArsivKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public gasDosya?: GasDosya;
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;

    public constructor(init?: Partial<GysTakipDosya>) { super(init); (Object as any).assign(this, init); }
}

export class PtsPazarYerAdres extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod: number;
    public pazarYerKod: number;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;
    public ptsPazarYer: PtsPazarYer;

    public constructor(init?: Partial<PtsPazarYerAdres>) { super(init); (Object as any).assign(this, init); }
}

export class PtsPazarYerTarife extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapSekli: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pazarYerKod: number;
    public tutarOran: number;
    public uygulamaTuru?: string;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;
    public ptsPazarYer: PtsPazarYer;

    public constructor(init?: Partial<PtsPazarYerTarife>) { super(init); (Object as any).assign(this, init); }
}

export class PtsPazarYer extends CommonEntityBase
{
    public ad: string;
    public alan?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gunu: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ptsBelgeDetays: PtsBelgeDetay[];
    public ptsPazarYerAdres: PtsPazarYerAdres[];
    public ptsPazarYerTarives: PtsPazarYerTarife[];

    public constructor(init?: Partial<PtsPazarYer>) { super(init); (Object as any).assign(this, init); }
}

export class PtsPazarYerYerlesim extends CommonEntityBase
{
    public aktifEh: string;
    public blokNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod: number;
    public metreKare?: number;
    public pazarYerKod: number;
    public siraNo?: string;
    public sokakBlokNo?: number;
    public tahtaSayi?: number;
    public toplam?: number;
    public yolYonu: string;
    public ptsBelgeDetays: PtsBelgeDetay[];
    public ptsPazarYerAdres?: PtsPazarYerAdres;

    public constructor(init?: Partial<PtsPazarYerYerlesim>) { super(init); (Object as any).assign(this, init); }
}

export class PtsBelgeDetay extends CommonEntityBase
{
    public aciklama?: string;
    public alisTarih: string;
    public belediyeKod: number;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirUcretEh: string;
    public isKod?: number;
    public kapanisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public metreKare?: number;
    public pazarYerKod: number;
    public pazarYerlesimKod: number;
    public tahsisUcretEh: string;
    public tahtaSayi?: number;
    public toplam: number;
    public genKodDetay?: GenKodDetay;
    public ptsBelge: PtsBelge;
    public ptsPazarYer: PtsPazarYer;
    public ptsPazarYerYerlesim: PtsPazarYerYerlesim;

    public constructor(init?: Partial<PtsBelgeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PtsIndirim extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public oran: number;
    public ptsBelges: PtsBelge[];

    public constructor(init?: Partial<PtsIndirim>) { super(init); (Object as any).assign(this, init); }
}

export class PtsBelge extends CommonEntityBase
{
    public aciklama?: string;
    public aracPlakaNo?: string;
    public baslamaTarih: string;
    public belediyeKod: number;
    public belgeNo?: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public indirimKod?: number;
    public iptalTarih?: string;
    public isKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public odaAd?: string;
    public odaKayitNo?: string;
    public sicilNo?: string;
    public taahhutNo?: number;
    public verilisTarih: string;
    public gasDosyas: GasDosya[];
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;
    public genKodDetay?: GenKodDetay;
    public ptsBelgeDetays: PtsBelgeDetay[];
    public ptsIndirim?: PtsIndirim;

    public constructor(init?: Partial<PtsBelge>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosya extends CommonEntityBase
{
    public ada?: number;
    public belediyeKod: number;
    public binaKod?: number;
    public birimDosyaKod: number;
    public birimKod: number;
    public blokNo?: string;
    public bolumKod?: number;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public depoKod?: number;
    public dosyaBarkod?: string;
    public dosyaDurum: string;
    public dosyaNo: string;
    public dosyaPlanKod: string;
    public dosyaTuru: string;
    public eskiKisiKod?: number;
    public evlenBeyanKod?: number;
    public girisTarih: string;
    public ihaleDosyaKod?: number;
    public imhaTarih?: string;
    public isyeriRuhsatKod?: number;
    public kapamaTarih?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiAciklama?: string;
    public kisiKod?: number;
    public klasorAd?: string;
    public klasorAdet?: number;
    public klasorBarkod?: string;
    public kod: number;
    public kutuAd?: string;
    public kutuBarkod?: string;
    public mahalleCaddeKod?: number;
    public notlar?: string;
    public ozelDosyaKod?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public pazarBeyanKod?: number;
    public personelKod?: number;
    public saklamaSure?: number;
    public siteApartmanAd?: string;
    public suAboneKod?: number;
    public tasinmazKod?: number;
    public tasnifYapildiEh?: string;
    public yeniDosyaKod?: number;
    public yerBlokKod?: number;
    public yerGozKod?: number;
    public yerRafKod?: number;
    public yil: number;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public bysBelges: BysBelge[];
    public bysBelgeCaprazDosyas: BysBelgeCaprazDosya[];
    public bysEvraks: BysEvrak[];
    public eksKarars: EksKarar[];
    public etsBeyan?: EtsBeyan;
    public gasBirimDosyaOzel?: GasBirimDosyaOzel;
    public gasBlok?: GasBlok;
    public gasDepo?: GasDepo;
    public gasDosyaBelges: GasDosyaBelge[];
    public gasDosyaDsQrcode: GasDosyaDsQrcode;
    public gasDosyaKlQrcode: GasDosyaKlQrcode;
    public gasDosyaKuQrcode: GasDosyaKuQrcode;
    public gasDosyaOduncs: GasDosyaOdunc[];
    public gasDosyaTaleps: GasDosyaTalep[];
    public gasGoz?: GasGoz;
    public gasRaf?: GasRaf;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public gysTakipDosyas: GysTakipDosya[];
    public ikaPersonel?: IkaPersonel;
    public mksKarars: MksKarar[];
    public ptsBelge?: PtsBelge;
    public sasAbone?: SasAbone;
    public yisKarars: YisKarar[];
    public gasBirimDosya?: GasBirimDosya;

    public constructor(init?: Partial<GasDosya>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeCaprazDosya extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeKod: number;
    public belgeTuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaPlanKod: string;
    public genelArsivKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public bysBelge: BysBelge;
    public gasDosya?: GasDosya;
    public genBelgeTuru: GenBelgeTuru;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<BysBelgeCaprazDosya>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeDetay extends CommonEntityBase
{
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgeKod: number;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogrulamaKodu?: string;
    public eimzaBelgeAd?: string;
    public eimzaBelgeDysKod?: string;
    public eimzaBelgeTipKod?: number;
    public eypDysId?: string;
    public eypStatus?: number;
    public icerikGuncelEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yaziciBelgeDysKod?: string;
    public bysBelge: BysBelge;
    public genBelgeTip: GenBelgeTip;
    public genBelgeTip1?: GenBelgeTip;

    public constructor(init?: Partial<BysBelgeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeEk extends CommonEntityBase
{
    public adetSayfa?: string;
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgeKod: number;
    public belgeNo?: number;
    public belgePath?: string;
    public belgeTarih?: string;
    public belgeTipKod?: number;
    public belgeTuruKod?: number;
    public boyut?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public fizikselBelgeEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public referansKod?: number;
    public sira?: number;
    public bysBelge: BysBelge;
    public genBelgeTip?: GenBelgeTip;
    public genBelgeTuru?: GenBelgeTuru;

    public constructor(init?: Partial<BysBelgeEk>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeIcerik extends CommonEntityBase
{
    public belgeIcerik?: string;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public bysBelge: BysBelge;

    public constructor(init?: Partial<BysBelgeIcerik>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeIlgi extends CommonEntityBase
{
    public belediyeKod: number;
    public belgeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakNo?: number;
    public evrakTarih?: string;
    public ilgiAciklama?: string;
    public ilgiTuru: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public referansKod?: number;
    public sira?: number;
    public smsEh?: string;
    public bysBelge: BysBelge;
    public genBirim: GenBirim;
    public refBysBelge?: BysBelge;

    public constructor(init?: Partial<BysBelgeIlgi>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeParsel extends CommonEntityBase
{
    public ada: number;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pafta?: string;
    public parsel: number;
    public parselKod?: number;
    public aksParsel?: AksParsel;
    public bysBelge: BysBelge;

    public constructor(init?: Partial<BysBelgeParsel>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelgeRapor extends CommonEntityBase
{
    public altReferansKod?: number;
    public altTabloAdi?: string;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public raporAdi: string;
    public referansKod?: number;
    public tabloAdi?: string;
    public bysBelge: BysBelge;

    public constructor(init?: Partial<BysBelgeRapor>) { super(init); (Object as any).assign(this, init); }
}

export class BysKepEkler extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaAdi: string;
    public dysId?: string;
    public eypAcildiEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kepId?: number;
    public kepKayitKod?: number;
    public kod: number;
    public refKey?: string;
    public sira?: number;
    public ustKod?: number;
    public bysKepKayitlar?: BysKepKayitlar;

    public constructor(init?: Partial<BysKepEkler>) { super(init); (Object as any).assign(this, init); }
}

export class BysKepKayitlar extends CommonEntityBase
{
    public belediyeKod?: number;
    public belgeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakAktarildi?: string;
    public gelenGiden?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kepCc?: string;
    public kepEventCode?: string;
    public kepEvindenceType?: string;
    public kepFrom?: string;
    public kepId?: number;
    public kepIleti?: string;
    public kepMesajId?: string;
    public kepMesajType?: string;
    public kepReceivedDatesPecified?: string;
    public kepRecevedDate?: string;
    public kepSendDate?: string;
    public kepSendDateSpecified?: string;
    public kepSubject?: string;
    public kepTo?: string;
    public kepTrgunSayac?: string;
    public kepTriletiId?: string;
    public kepTriletiTip?: string;
    public kepUamessageIdentifier?: string;
    public kod: number;
    public okundu?: string;
    public bysBelge?: BysBelge;
    public bysKepEklers: BysKepEkler[];

    public constructor(init?: Partial<BysKepKayitlar>) { super(init); (Object as any).assign(this, init); }
}

export class BysBelge extends CommonEntityBase
{
    public ada?: number;
    public anahtarKelime?: string;
    public arsivTarih?: string;
    public asliAlindiEh: string;
    public barkodNo?: string;
    public beklenenDonusTarih?: string;
    public belediyeKod: number;
    public belgeAciklama?: string;
    public belgeAdi?: string;
    public belgeIcerikKod?: number;
    public belgeNitelikTuru?: number;
    public belgeNo?: string;
    public belgeOnemDerece?: string;
    public belgeTarih?: string;
    public belgeTuru: string;
    public belgeTuruKod: number;
    public bilgiAdSoyad?: string;
    public bilgiEdinmeEh: string;
    public bilgiEPosta?: string;
    public bilgiTelNo?: string;
    public bilgiUnvani?: string;
    public birimKod: number;
    public dagitimSekli: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilekceEh?: string;
    public dilKod: number;
    public dosyaPlanKod: string;
    public eMail?: string;
    public eskiKisiKod?: number;
    public evrakNo?: number;
    public evrakTarih?: string;
    public evrakTuru?: string;
    public gecerliSure?: number;
    public gelenBirimAciklama?: string;
    public gelenBirimKod?: number;
    public gelenGiden?: string;
    public gelisTurKod?: number;
    public genelArsivKod?: number;
    public genelDosyaNo?: number;
    public gonderAlTarih?: string;
    public gsmTelefonNo?: string;
    public guvenlikDurumu: number;
    public imhaTarih?: string;
    public imzaPersonelKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kelimeIslemci?: string;
    public kisiKod?: number;
    public kisiselEh: string;
    public klasorKod?: number;
    public kod: number;
    public koordinasyonBirimKod?: number;
    public oncelikDurumu: string;
    public ozelNo?: string;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public personelKod?: number;
    public referansKod: number;
    public statusu?: number;
    public surecKod?: number;
    public taslakKod?: number;
    public tcknNo?: number;
    public telifKapsamindaEh: string;
    public transferTarih?: string;
    public uretimAciklama?: string;
    public uretimTarih?: string;
    public yazilimVersion?: string;
    public yeniEditor?: number;
    public zimmetNo?: number;
    public zimmetTarih?: string;
    public aksParsel?: AksParsel;
    public bysBelgeCaprazDosyas: BysBelgeCaprazDosya[];
    public bysBelgeDagitims: BysBelgeDagitim[];
    public bysBelgeDetay: BysBelgeDetay;
    public bysBelgeEks: BysBelgeEk[];
    public bysBelgeHavales: BysBelgeHavale[];
    public bysBelgeIcerik: BysBelgeIcerik;
    public bysBelgeIlgis: BysBelgeIlgi[];
    public bysBelgeParsels: BysBelgeParsel[];
    public bysBelgeRapor: BysBelgeRapor;
    public bysBelgeTakips: BysBelgeTakip[];
    public bysDegisens: BysDegisen[];
    public bysEvraks: BysEvrak[];
    public bysGorevs: BysGorev[];
    public bysKepKayitlars: BysKepKayitlar[];
    public gasDosya?: GasDosya;
    public gasDosyaBelges: GasDosyaBelge[];
    public genBelgeTuru: GenBelgeTuru;
    public genBirim: GenBirim;
    public genBirim_?: GenBirim;
    public genBirim1?: GenBirim;
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;
    public genKodDetay: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public gysIcraBelges: GysIcraBelge[];
    public gysIcraBelges1: GysIcraBelge[];
    public ikaPersonel?: IkaPersonel;
    public genDosyaPlan?: GenDosyaPlan;

    public constructor(init?: Partial<BysBelge>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajTalep extends CommonEntityBase
{
    public aciklama: string;
    public aktifEh: string;
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ogrenciSayisi: number;
    public okulTur: string;
    public stajDonem: string;
    public stajDonemKod?: number;
    public talepTarih?: string;
    public genBirim: GenBirim;
    public pysStajDonem?: PysStajDonem;

    public constructor(init?: Partial<PysStajTalep>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajDonem extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public baslangicTarih?: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikGunLimit: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public okulTur: string;
    public stajDonem: string;
    public pysStajOzlukBasvurus: PysStajOzlukBasvuru[];
    public pysStajTaleps: PysStajTalep[];

    public constructor(init?: Partial<PysStajDonem>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajKartDetay extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durum: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stajKartKod: number;
    public tarih: string;
    public ucretOdemeDonemKod?: number;
    public ucretOdemesiEh: string;
    public pysStajKart: PysStajKart;

    public constructor(init?: Partial<PysStajKartDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajKart extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public stajOzlukBasvuruKod: number;
    public stajToplamGun: number;
    public pysStajKartDetays: PysStajKartDetay[];
    public pysStajOzlukBasvuru: PysStajOzlukBasvuru;

    public constructor(init?: Partial<PysStajKart>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajOzluk extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public anneAd: string;
    public babaAd: string;
    public belediyeKod: number;
    public cinsiyet: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public eMail?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public mailBilgiEh?: string;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public oncekiSoyad?: string;
    public smsBilgiEh?: string;
    public soyad: string;
    public tckn: number;
    public uyrukKod?: number;
    public genIlce?: GenIlce;
    public genIlce_?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay_?: GenKodDetay;
    public genKodDetay__?: GenKodDetay;
    public pysStajOzlukBasvurus: PysStajOzlukBasvuru[];

    public constructor(init?: Partial<PysStajOzluk>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajOzlukBasvuru extends CommonEntityBase
{
    public aciklama?: string;
    public baskanlikOlurNo?: string;
    public baskanOlurEh?: string;
    public baskanOlurTarih?: string;
    public baslamaTarih: string;
    public basvuruTarih: string;
    public basvuruTip: string;
    public basvuruYili?: number;
    public bitirmeTarih: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public evrakTeslimTarih?: string;
    public ibanNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public koordinatorAdSoyad?: string;
    public koordinatorTelefon?: string;
    public okulNo?: string;
    public onayDurumEh?: string;
    public sinifi?: string;
    public siraNo: number;
    public stajBolumKod?: number;
    public stajDonemKod: number;
    public stajIptalGerekcesi?: string;
    public stajIptalTarih?: string;
    public stajOkulKod: number;
    public stajOzlukKod: number;
    public stajPeriyod?: number;
    public stajSuresi: number;
    public stajSureTip?: number;
    public veliAd?: string;
    public veliCepTelefon?: number;
    public veliDogumTarih?: string;
    public veliEvTelefon?: number;
    public veliSoyad?: string;
    public veliTc?: number;
    public veliYakinlikDerecesi?: string;
    public pysStajDonem: PysStajDonem;
    public pysStajKarts: PysStajKart[];
    public pysStajOzluk: PysStajOzluk;
    public pysStajOzlukBasvuruDetays: PysStajOzlukBasvuruDetay[];

    public constructor(init?: Partial<PysStajOzlukBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class PysStajOzlukBasvuruDetay extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaTarih: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devamsizlikGunSayisi?: number;
    public gorevliBirim: number;
    public izinGunSayisi?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sorumluPersonelKod: number;
    public stajGunSayisi?: number;
    public stajOzlukBasvuruKod: number;
    public genBirim: GenBirim;
    public ikaPersonel: IkaPersonel;
    public pysStajOzlukBasvuru: PysStajOzlukBasvuru;

    public constructor(init?: Partial<PysStajOzlukBasvuruDetay>) { super(init); (Object as any).assign(this, init); }
}

export class GenBirim extends CommonEntityBase
{
    public ad: string;
    public aktifEh: string;
    public anaBirimKod?: number;
    public belediyeKod: number;
    public birimAdres?: string;
    public birimEPosta?: string;
    public birimTuru: string;
    public birimWebAdres?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eypPaketEh?: string;
    public faxAlanKod?: number;
    public faxNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kepEposta?: string;
    public kimlikNo: number;
    public kod: number;
    public notlar?: string;
    public seviye?: number;
    public telAlanKod?: number;
    public telNo?: string;
    public yetkiliAdSoyad?: string;
    public yetkiliPersonelKod?: number;
    public yetkiliTelNo?: string;
    public yetkiliUnvani?: string;
    public atsAracGorevTaleps: AtsAracGorevTalep[];
    public atsAracGorevTaleps1: AtsAracGorevTalep[];
    public bimHizmetBinas: BimHizmetBina[];
    public bimHizmetBinas1: BimHizmetBina[];
    public bysBelges: BysBelge[];
    public anaGenBirim?: GenBirim;
    public genBirims: GenBirim[];
    public genBirimIletisims: GenBirimIletisim[];
    public pysStajOzlukBasvuruDetays: PysStajOzlukBasvuruDetay[];
    public pysStajTaleps: PysStajTalep[];
    public yisKarars: YisKarar[];
    public yisParametreDetays: YisParametreDetay[];

    public constructor(init?: Partial<GenBirim>) { super(init); (Object as any).assign(this, init); }
}

export class IkaEgitim extends CommonEntityBase
{
    public baslamaTarih: string;
    public belediyeKod: number;
    public bitisTarih: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public egitimTurKod?: number;
    public egitimVeren: string;
    public egitimYeri: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konu: string;
    public notlar?: string;
    public ucret?: number;
    public yurtDisiEh: string;
    public genKodDetay?: GenKodDetay;
    public ikaEgitimDetays: IkaEgitimDetay[];

    public constructor(init?: Partial<IkaEgitim>) { super(init); (Object as any).assign(this, init); }
}

export class IkaEgitimDetay extends CommonEntityBase
{
    public alinanSertifika?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public egitimKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public personelKod: number;
    public ikaEgitim: IkaEgitim;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaEgitimDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelDernek extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dernekKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public personelKod: number;
    public uyeBaslangicTarih: string;
    public uyeBitisTarih?: string;
    public ikaKodlar: IkaKodlar;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelDernek>) { super(init); (Object as any).assign(this, init); }
}

export class IkaKodlar extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public telAlanKod?: number;
    public telefon?: string;
    public turu: number;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public ikaPersonels: IkaPersonel[];
    public ikaPersonelDerneks: IkaPersonelDernek[];

    public constructor(init?: Partial<IkaKodlar>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemEczane extends CommonEntityBase
{
    public adres?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public telAlanKod?: number;
    public telTelefon?: string;
    public turu: string;
    public unvani: string;
    public genKisi: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public ikaMemEczaneDetays: IkaMemEczaneDetay[];

    public constructor(init?: Partial<IkaMemEczane>) { super(init); (Object as any).assign(this, init); }
}

export class IkaMemEczaneDetay extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eczaneKod: number;
    public faturaNo: string;
    public faturaTarih: string;
    public faturaTutar: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesintiDonemKod?: number;
    public kesintiTarih?: string;
    public kod: number;
    public odemeTutar?: number;
    public personelKod: number;
    public turu: string;
    public yakinlikDurumu: string;
    public ikaMemEczane: IkaMemEczane;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaMemEczaneDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelAdres extends CommonEntityBase
{
    public aciklama?: string;
    public adresKapanisKod?: number;
    public aktifEh: string;
    public blokNo?: string;
    public bolumKod?: number;
    public caddeSokakAd?: string;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelisTarih?: string;
    public gidisTarih?: string;
    public ilceKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kpsKod?: string;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public personelKod: number;
    public postaKodu?: number;
    public siteApartmanAd?: string;
    public tuikAdresKod?: number;
    public genIlce?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelAdres>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelAileResim extends CommonEntityBase
{
    public aileKod: number;
    public aileResim?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ikaPersonelAile: IkaPersonelAile;

    public constructor(init?: Partial<IkaPersonelAileResim>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanAltinMucevherat extends CommonEntityBase
{
    public akrabaKod?: number;
    public cinsi?: string;
    public degeri: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public miktari: number;
    public turu: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanAltinMucevherat>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanBankaMenkul extends CommonEntityBase
{
    public akrabaKod?: number;
    public cinsi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public miktari: number;
    public niteligi: string;
    public turu: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanBankaMenkul>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanBorcAlacak extends CommonEntityBase
{
    public akrabaKod?: number;
    public alacaklininAdiSoyadi?: string;
    public borcAlacakTutari: number;
    public borclununAdiSoyadi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public turu: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanBorcAlacak>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanDigerServet extends CommonEntityBase
{
    public akrabaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerServetleri?: string;
    public edinmeSekli?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public turu: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanDigerServet>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanKooperatif extends CommonEntityBase
{
    public akrabaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hisseDegeri: number;
    public hisseMiktari?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public koopAdiVeYeri: string;
    public malBeyanKod: number;
    public turu: number;
    public uyelikTarih?: string;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanKooperatif>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanTasinir extends CommonEntityBase
{
    public akrabaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public edinmeDegeri?: number;
    public edinmeTarihi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public marka?: string;
    public modelYili?: number;
    public plaka?: string;
    public tasinirCinsi?: string;
    public tasinirSinifi: number;
    public tasinirTur: number;
    public turu: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanTasinir>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanTasinmaz extends CommonEntityBase
{
    public adresi: string;
    public akrabaKod?: number;
    public degeri: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public edinmeTarihi?: string;
    public hisseMiktari?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public tasinmazCinsi: number;
    public turu: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanTasinmaz>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyan extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public beyanAlanPersonelKod?: number;
    public beyanTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod?: number;
    public turu?: number;
    public yil?: number;
    public ikaPersonel?: IkaPersonel;
    public pysMalBeyanAciklamas: PysMalBeyanAciklama[];
    public pysMalBeyanAltinMucevherats: PysMalBeyanAltinMucevherat[];
    public pysMalBeyanBankaMenkuls: PysMalBeyanBankaMenkul[];
    public pysMalBeyanBorcAlacaks: PysMalBeyanBorcAlacak[];
    public pysMalBeyanDigerServets: PysMalBeyanDigerServet[];
    public pysMalBeyanKooperatifs: PysMalBeyanKooperatif[];
    public pysMalBeyanTasinirs: PysMalBeyanTasinir[];
    public pysMalBeyanTasinmazs: PysMalBeyanTasinmaz[];

    public constructor(init?: Partial<PysMalBeyan>) { super(init); (Object as any).assign(this, init); }
}

export class PysMalBeyanAciklama extends CommonEntityBase
{
    public aciklama?: string;
    public akrabaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public malBeyanKod: number;
    public ikaPersonelAile?: IkaPersonelAile;
    public pysMalBeyan: PysMalBeyan;

    public constructor(init?: Partial<PysMalBeyanAciklama>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelAile extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public agiBaslangicTarih?: string;
    public agiBitisTarih?: string;
    public aileTuru?: number;
    public anneAd?: string;
    public babaAd?: string;
    public calisiyorEh: string;
    public cinsiyet: string;
    public cocukDurumu?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public eMail?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public isYeriAd?: string;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kpsKod?: string;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public ogrenimTuruKod?: number;
    public okulAd?: string;
    public okulKayitTarih?: string;
    public oncekiSoyad?: string;
    public personelKod: number;
    public sakatlikGrup?: number;
    public soyad?: string;
    public sube?: string;
    public tckn?: number;
    public uyrukKod?: number;
    public yakinlikDurumu: string;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public ikaPersonel: IkaPersonel;
    public ikaPersonelAileResim: IkaPersonelAileResim;
    public pysMalBeyanAciklamas: PysMalBeyanAciklama[];
    public pysMalBeyanAltinMucevherats: PysMalBeyanAltinMucevherat[];
    public pysMalBeyanBankaMenkuls: PysMalBeyanBankaMenkul[];
    public pysMalBeyanBorcAlacaks: PysMalBeyanBorcAlacak[];
    public pysMalBeyanDigerServets: PysMalBeyanDigerServet[];
    public pysMalBeyanKooperatifs: PysMalBeyanKooperatif[];
    public pysMalBeyanTasinirs: PysMalBeyanTasinir[];
    public pysMalBeyanTasinmazs: PysMalBeyanTasinmaz[];

    public constructor(init?: Partial<IkaPersonelAile>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelAsker extends CommonEntityBase
{
    public askerNeviKod: number;
    public astegmenNasbTarih?: string;
    public baslamaTarih: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donemSicilNo?: string;
    public gorevYeri?: string;
    public ibrazTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public muafNedeni?: string;
    public okulGirisTarih?: string;
    public personelKod: number;
    public sayilmayanGun?: number;
    public tegmenNasbTarih?: string;
    public yedeksubayGecisTarih?: string;
    public genKodDetay: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelAsker>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelBorclanma extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaTarih: string;
    public bitisTarih: string;
    public borclanmaTarih: string;
    public borcNeviKod: number;
    public borcTutar: number;
    public calistigiKurum: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public derece: number;
    public ekGosterge?: number;
    public gun: number;
    public ilceKod: number;
    public intikalTarih?: string;
    public kademe: number;
    public kanunTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public odemeNo?: string;
    public odemeTarih?: string;
    public odemeTutar?: number;
    public personelKod: number;
    public genIlce: GenIlce;
    public genKodDetay: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelBorclanma>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelCeza extends CommonEntityBase
{
    public cezaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public iptalTarih?: string;
    public kararNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahkemeKararNot?: string;
    public notlar?: string;
    public personelKod: number;
    public verilisTarih: string;
    public genKodDetay: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelCeza>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelDiger extends CommonEntityBase
{
    public aciklama?: string;
    public ayrilmaNedeni?: string;
    public bagkurMeslekAdi?: string;
    public bankaKod?: number;
    public baslamaTarih: string;
    public bitisTarih: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gun: number;
    public hakAylikEh: string;
    public intikalTarih?: string;
    public isyeriSgkNo: string;
    public kamuIsyeriAdi?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kidemTazOdeEh: string;
    public kod: number;
    public ozelIsyeriAdi?: string;
    public personelKod: number;
    public sgkTuru: number;
    public ulkeKod?: number;
    public genKodDetay?: GenKodDetay;
    public genUlke?: GenUlke;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelDiger>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelDil extends CommonEntityBase
{
    public anlamaSeviyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilSinavNot?: number;
    public dilSinavTarih?: string;
    public dilTuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public okumaSeviyeKod?: number;
    public personelKod: number;
    public yazmaSeviyeKod?: number;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelDil>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelGorev extends CommonEntityBase
{
    public belediyeKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donusTarih: string;
    public gidisAracPlaka?: string;
    public gidisTarih: string;
    public gidisYeri?: string;
    public gorevRolAd: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mudurPersonelKod?: number;
    public mudurRolAd?: string;
    public onayPersonelKod?: number;
    public onayRolAd?: string;
    public personelKod: number;
    public yapilacakIs?: string;
    public yevmiye?: number;
    public genBirim: GenBirim;
    public ikaPersonel: IkaPersonel;
    public ikaPersonelMudur?: IkaPersonel;
    public ikaPersonelOnay?: IkaPersonel;
    public gorevOrganizasyonRol?: GenOrganizasyonRol;
    public mudurOrganizasyonRol?: GenOrganizasyonRol;
    public onayOrganizasyonRol?: GenOrganizasyonRol;

    public constructor(init?: Partial<IkaPersonelGorev>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelIzinSure extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinSure: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public yil: number;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelIzinSure>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelKurs extends CommonEntityBase
{
    public bolumAdi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public denklikAdi?: string;
    public denklikBolumAdi?: string;
    public denklikTarih?: string;
    public ibrazTarih?: string;
    public icDis?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kursSuresi?: number;
    public kursTuruKod: number;
    public mezunTarih?: string;
    public okulAdi?: string;
    public personelKod: number;
    public genKodDetay: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelKurs>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelOdul extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public odulKod: number;
    public personelKod: number;
    public verilisTarih: string;
    public genKodDetay: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelOdul>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelOgrenim extends CommonEntityBase
{
    public bolumAdi?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public denklikAdi?: string;
    public denklikBolumAdi?: string;
    public denklikTarih?: string;
    public ibrazTarih?: string;
    public icDis?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezunTarih?: string;
    public ogrenimSuresi?: number;
    public ogrenimTuruKod: number;
    public okulAdi?: string;
    public personelKod: number;
    public genKodDetay: GenKodDetay;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelOgrenim>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelRapor extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public raporGun?: number;
    public yil: number;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelRapor>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelResim extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public personelResim?: string;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelResim>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelTasarruf extends CommonEntityBase
{
    public ay: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiTutar?: number;
    public kod: number;
    public kurumTutar?: number;
    public odemeBankaAdi?: string;
    public odemeDekontNo?: string;
    public odemeTarih?: string;
    public personelKod: number;
    public tasarrufMatrah?: number;
    public turu: string;
    public yil: number;
    public genBirim: GenBirim;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelTasarruf>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonelVergi extends CommonEntityBase
{
    public asgVergiIndirimMatrah?: number;
    public asgVergiIndirimTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public nakilVergiIndirimMatrah?: number;
    public nakilVergiIndirimTutar?: number;
    public nakilVergiKesinti?: number;
    public nakilVergiMatrah?: number;
    public personelKod: number;
    public vergiKesinti?: number;
    public vergiMatrah?: number;
    public yil: number;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<IkaPersonelVergi>) { super(init); (Object as any).assign(this, init); }
}

export class OmsHizmetEkipPersonel extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekipKod?: number;
    public gorevi?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public personelKod?: number;
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<OmsHizmetEkipPersonel>) { super(init); (Object as any).assign(this, init); }
}

export class OmsHizmetPersonel extends CommonEntityBase
{
    public aktifEh?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorevi?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public personelKod?: number;
    public genBelediye?: GenBelediye;
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<OmsHizmetPersonel>) { super(init); (Object as any).assign(this, init); }
}

export class PysIzinHakedis extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devredenSure: number;
    public hakedisTarih: string;
    public ikaPersonelKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public yil: number;
    public yillikSure: number;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<PysIzinHakedis>) { super(init); (Object as any).assign(this, init); }
}

export class PysKidemTanim extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod?: number;
    public brutKazancToplam: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hizmetAy: number;
    public hizmetGun: number;
    public hizmetYil: number;
    public islemTarih?: string;
    public istenCikisNedeni?: number;
    public izinGunToplam: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public odenenToplam: number;
    public personelKod?: number;
    public raporGunToplam?: number;
    public tavanMatrah: number;
    public yevmiyesi: number;
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<PysKidemTanim>) { super(init); (Object as any).assign(this, init); }
}

export class GenIcraDaire extends CommonEntityBase
{
    public adi?: string;
    public aliciBanka?: string;
    public aliciHesapNo?: string;
    public aliciIbanNo?: string;
    public aliciSube?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pysPersonelKesintis: PysPersonelKesinti[];

    public constructor(init?: Partial<GenIcraDaire>) { super(init); (Object as any).assign(this, init); }
}

export class PysPersonelKesinti extends CommonEntityBase
{
    public aciklama?: string;
    public alacakliAdiSoyadi?: string;
    public alacakliBankaHesapNo?: string;
    public alacakliBankaIbanNo?: string;
    public alacakliBankaSubeAdi?: string;
    public alacakliKisiKod?: number;
    public anaParaTutar?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaKapandiEh?: string;
    public evrakNo?: number;
    public faizTutar?: number;
    public gelisTarih?: string;
    public genBirimKod?: number;
    public icraDaireKod?: number;
    public icraDosyaNo?: string;
    public icraDosyaYili?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefil?: string;
    public kesintiKod?: number;
    public kesintiOran?: number;
    public kesintiSekli?: string;
    public kesintiTuru?: string;
    public kesintiTutar?: number;
    public kod: number;
    public personelHesTur: string;
    public personelKod: number;
    public personelTurKod: number;
    public raporAyakta?: number;
    public raporYatak?: number;
    public sgkGun?: number;
    public sgkMatrah?: number;
    public siraNo?: number;
    public taahhutEh?: string;
    public toplamTutar?: number;
    public genBirim?: GenBirim;
    public genIcraDaire?: GenIcraDaire;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<PysPersonelKesinti>) { super(init); (Object as any).assign(this, init); }
}

export class PysPersonelVergi extends CommonEntityBase
{
    public asgVergiIndirimMatrah?: number;
    public asgVergiIndirimTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public nakilGeldigiTarih?: string;
    public nakilVergiIndirimMatrah?: number;
    public nakilVergiIndirimTutar?: number;
    public nakilVergiKesinti?: number;
    public nakilVergiMatrah?: number;
    public personelKod: number;
    public vergiKesinti?: number;
    public vergiMatrah?: number;
    public yil: number;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<PysPersonelVergi>) { super(init); (Object as any).assign(this, init); }
}

export class PysSendikaPersonel extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelHareketKod?: number;
    public personelKod: number;
    public sendikaAskiTarih?: string;
    public sendikaAyrilmaTarih?: string;
    public sendikaGorev?: string;
    public sendikaSozlesmeKod: number;
    public sendikaUyeNo?: string;
    public sendikaUyeTarih?: string;
    public ikaPersonel: IkaPersonel;

    public constructor(init?: Partial<PysSendikaPersonel>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonel extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public anneAd?: string;
    public babaAd?: string;
    public belediyeKod: number;
    public cikisTarih?: string;
    public cikisTurKod?: number;
    public cinsiyet?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public ehliyetNo?: number;
    public ehliyetTarih?: string;
    public ehliyetTuruKod?: number;
    public eMail?: string;
    public emekliGorevTarih?: string;
    public emekliSandikNo?: string;
    public emekliYeniSandikNo?: string;
    public gorevBirimKod?: number;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public gssNo?: string;
    public ibanNo?: string;
    public ilkGirisTarih: string;
    public izinBaslangicTarih: string;
    public kadroBirimKod?: number;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kefaletCuzdanNo?: string;
    public kisiKod?: number;
    public kod: number;
    public kpsKod?: string;
    public kpsKontrolTarih?: string;
    public kurumGirisTarih?: string;
    public kurumSicilNo?: string;
    public mailBilgiEh?: string;
    public malulKod?: number;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public oncekiSoyad?: string;
    public personelKod: number;
    public personelTurKod: number;
    public sebepKod?: number;
    public smsBilgiEh?: string;
    public soyad?: string;
    public sskNo?: string;
    public tasarrufNo?: string;
    public taseronFirmaKod?: number;
    public tckn?: number;
    public uyrukKod?: number;
    public vergiDairesi?: string;
    public vergiNo?: string;
    public bimHizmetTelefonDetays: BimHizmetTelefonDetay[];
    public genBirimsYetkili: GenBirim[];
    public genBirimGorev?: GenBirim;
    public genBirimKadro?: GenBirim;
    public genIlceDogum?: GenIlce;
    public genIlceNidaresi?: GenIlce;
    public genIlceNkayitli?: GenIlce;
    public genKodDetayCikisTuru?: GenKodDetay;
    public genKodDetayDini?: GenKodDetay;
    public genKodDetayEhliyetTuru?: GenKodDetay;
    public genKodDetayMalul?: GenKodDetay;
    public genKodDetayMedeniDurum?: GenKodDetay;
    public genKodDetaySebep?: GenKodDetay;
    public genKodDetayUyruk?: GenKodDetay;
    public genKullanicis: GenKullanici[];
    public genRaporImzaDetays: GenRaporImzaDetay[];
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public ikaEgitimDetays: IkaEgitimDetay[];
    public ikaHuzurMaas: IkaHuzurMaas[];
    public ikaIscKadroDetays: IkaIscKadroDetay[];
    public ikaKod?: IkaKodlar;
    public ikaMemEczaneDetays: IkaMemEczaneDetay[];
    public ikaMemKadroDetays: IkaMemKadroDetay[];
    public ikaPersonelAdres: IkaPersonelAdres[];
    public ikaPersonelAiles: IkaPersonelAile[];
    public ikaPersonelAskers: IkaPersonelAsker[];
    public ikaPersonelBorclanmas: IkaPersonelBorclanma[];
    public ikaPersonelCezas: IkaPersonelCeza[];
    public ikaPersonelDerneks: IkaPersonelDernek[];
    public ikaPersonelDigers: IkaPersonelDiger[];
    public ikaPersonelDils: IkaPersonelDil[];
    public ikaPersonelGorevs: IkaPersonelGorev[];
    public ikaPersonelMudurGorevs: IkaPersonelGorev[];
    public ikaPersoneOnaylGorevs: IkaPersonelGorev[];
    public ikaPersonelIsci: IkaPersonelIsci;
    public ikaPersonelIzins: IkaPersonelIzin[];
    public ikaPersonelIzinSures: IkaPersonelIzinSure[];
    public ikaPersonelKurs: IkaPersonelKurs[];
    public ikaPersonelMemur: IkaPersonelMemur;
    public ikaPersonelOduls: IkaPersonelOdul[];
    public ikaPersonelOgrenims: IkaPersonelOgrenim[];
    public ikaPersonelRapors: IkaPersonelRapor[];
    public ikaPersonelResim: IkaPersonelResim;
    public ikaPersonelRols: IkaPersonelRol[];
    public ikaPersonelTasarrufs: IkaPersonelTasarruf[];
    public ikaPersonelTur: IkaPersonelTur;
    public ikaPersonelVergis: IkaPersonelVergi[];
    public omsHizmetEkipPersonels: OmsHizmetEkipPersonel[];
    public omsHizmetPersonels: OmsHizmetPersonel[];
    public pysBesFirmaPersonels: PysBesFirmaPersonel[];
    public pysIzinHakedis: PysIzinHakedis[];
    public pysKidemTanims: PysKidemTanim[];
    public pysMalBeyans: PysMalBeyan[];
    public pysPersonelKesintis: PysPersonelKesinti[];
    public pysPersonelVergis: PysPersonelVergi[];
    public pysSendikaPersonels: PysSendikaPersonel[];
    public pysStajOzlukBasvuruDetays: PysStajOzlukBasvuruDetay[];
    public yisUyes: YisUye[];

    public constructor(init?: Partial<IkaPersonel>) { super(init); (Object as any).assign(this, init); }
}

export class BimHizmetTelefonDetay extends CommonEntityBase
{
    public adi?: string;
    public baslamaTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorev?: string;
    public hizmetTelefonKod: number;
    public iptalTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarihi: string;
    public kod: number;
    public personelKod?: number;
    public soyadi?: string;
    public bimHizmetTelefon: BimHizmetTelefon;
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<BimHizmetTelefonDetay>) { super(init); (Object as any).assign(this, init); }
}

export class BimHizmetTelefon extends CommonEntityBase
{
    public aciklama?: string;
    public alanKod?: string;
    public binaKod: number;
    public cagriBekletmeEh?: string;
    public cagriMerkezDahiliNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public fax?: string;
    public gizliEh?: string;
    public intranetGorunsun?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public macAdresi?: string;
    public mail?: string;
    public menuTusuEh?: string;
    public otomatikCevaplamaEh?: string;
    public sesKaydiVarEh?: string;
    public siraNo?: number;
    public telefonNo?: string;
    public telesekreterVarEh?: string;
    public telsiz?: string;
    public tur?: string;
    public webSayfasiGorunsunEh?: string;
    public yetkiTur?: string;
    public bimHizmetBina: BimHizmetBina;
    public bimHizmetTelefonDetays: BimHizmetTelefonDetay[];

    public constructor(init?: Partial<BimHizmetTelefon>) { super(init); (Object as any).assign(this, init); }
}

export class BimHizmetBina extends CommonEntityBase
{
    public aciklama?: string;
    public acilmaTarih?: string;
    public belediyeKod: number;
    public birimKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kapanmaTarih?: string;
    public kapiNo?: number;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public mahalleCaddeKod?: number;
    public mudurlukKod: number;
    public bimHizmetTelefons: BimHizmetTelefon[];
    public genBelediye: GenBelediye;
    public genBirim?: GenBirim;
    public genBirim1: GenBirim;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;

    public constructor(init?: Partial<BimHizmetBina>) { super(init); (Object as any).assign(this, init); }
}

export class GenCaddeSokak extends CommonEntityBase
{
    public acilisTarih?: string;
    public ad: string;
    public aktifEh: string;
    public alani?: number;
    public altyapiElektrikEh: string;
    public altyapiGazEh: string;
    public altyapiSuEh: string;
    public altyapiTelefonEh: string;
    public anaArterEh: string;
    public belediyeKod: number;
    public ciftBaslangicNo?: number;
    public ciftBitisNo?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public egim?: number;
    public eskiAd?: string;
    public genislik?: number;
    public hizLimiti?: number;
    public kaldirimTurKod?: number;
    public kapanisTarih?: string;
    public kaplamaTurKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meclisKararNo?: string;
    public meclisKararTarih?: string;
    public parkKapasitesi?: number;
    public parklamaEh: string;
    public seritSayisi?: number;
    public tekBaslangicNo?: number;
    public tekBitisNo?: number;
    public trafikYonu?: string;
    public turKod: number;
    public uzunluk?: number;
    public yolAdiLevhasiEh: string;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2: GenKodDetay;
    public genMahalleCaddeSokaks: GenMahalleCaddeSokak[];

    public constructor(init?: Partial<GenCaddeSokak>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiAdres extends CommonEntityBase
{
    public aciklama?: string;
    public adresKapanisKod?: number;
    public aktifEh: string;
    public blokNo?: string;
    public bolumKod?: number;
    public caddeSokakAd?: string;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public gelisTarih?: string;
    public gidisTarih?: string;
    public ilceKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public kpsKod?: string;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public postaKodu?: number;
    public siteApartmanAd?: string;
    public tuikAdresKod?: number;
    public turu: string;
    public yazismaEh: string;
    public genIlce?: GenIlce;
    public genKisi: GenKisi;
    public genKodAdresKapanis?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;

    public constructor(init?: Partial<GenKisiAdres>) { super(init); (Object as any).assign(this, init); }
}

export class GenMahalleCaddeSokak extends CommonEntityBase
{
    public aktifEh: string;
    public caddeSokakKod: number;
    public ciftBaslangicNo?: number;
    public ciftBitisNo?: number;
    public ctvDerece?: number;
    public ctvGrup?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelismislikKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleKod: number;
    public tekBaslangicNo?: number;
    public tekBitisNo?: number;
    public tuikKod?: number;
    public tuikTanitimNo?: number;
    public bimHizmetBinas: BimHizmetBina[];
    public genCaddeSokak: GenCaddeSokak;
    public genKisiAdres: GenKisiAdres[];
    public genKodDetay?: GenKodDetay;
    public genMahalleKoy: GenMahalleKoy;

    public constructor(init?: Partial<GenMahalleCaddeSokak>) { super(init); (Object as any).assign(this, init); }
}

export class IrsDenetlemeIsinma extends CommonEntityBase
{
    public deger?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public denetlemeKod: number;
    public isinmaKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public irsDenetleme: IrsDenetleme;

    public constructor(init?: Partial<IrsDenetlemeIsinma>) { super(init); (Object as any).assign(this, init); }
}

export class IrsDenetlemeSonuc extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sonucKod: number;
    public irsDenetlemes: IrsDenetleme[];

    public constructor(init?: Partial<IrsDenetlemeSonuc>) { super(init); (Object as any).assign(this, init); }
}

export class IrsDenetlemeUretim extends CommonEntityBase
{
    public deger?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public denetlemeKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public uretimKod: number;
    public irsDenetleme: IrsDenetleme;

    public constructor(init?: Partial<IrsDenetlemeUretim>) { super(init); (Object as any).assign(this, init); }
}

export class IrsDenetleme extends CommonEntityBase
{
    public aciklama?: string;
    public ada?: number;
    public arsivKod?: number;
    public baslangicTarih?: string;
    public basvuruKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public daire?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public denetimYapan: string;
    public denetlemeNo: number;
    public denetlemeTarih: string;
    public encGidisTarih?: string;
    public encumenKaraNo?: string;
    public encumenKararTarih?: string;
    public eskiKisiKod?: number;
    public evrakNo?: string;
    public evrakTarih?: string;
    public faaliyet?: string;
    public isyeriUnvan?: string;
    public kapi?: number;
    public kapi1?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public kullanimAlan?: number;
    public kullanimSekliKod?: number;
    public mahalleCaddeKod?: number;
    public onayEh?: string;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public personelSayisi?: number;
    public ruhsatAciklama?: string;
    public ruhsatDurum?: number;
    public ruhsatNo?: number;
    public ruhsatTarih?: string;
    public siteApartman?: string;
    public sonucKod?: number;
    public tebligTarih?: string;
    public tutanakTarih?: string;
    public vergiDaire?: string;
    public vergiNo?: string;
    public verilenSure?: number;
    public yil: number;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public irsDenetlemeIsinmas: IrsDenetlemeIsinma[];
    public irsDenetlemeSonuc?: IrsDenetlemeSonuc;
    public irsDenetlemeUretims: IrsDenetlemeUretim[];
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsDenetleme>) { super(init); (Object as any).assign(this, init); }
}

export class IrsGurultuSeviyeTespit extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaSaat?: string;
    public baslamaTarih?: string;
    public basvuruKod: number;
    public bitisSaat?: string;
    public bitisTarih?: string;
    public c?: number;
    public c10?: number;
    public c90?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public l?: number;
    public l10?: number;
    public l90?: number;
    public olcumYerKod: number;
    public genKodDetay: GenKodDetay;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsGurultuSeviyeTespit>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsat extends CommonEntityBase
{
    public aciklama?: string;
    public acilisSaat?: string;
    public arsivNo?: string;
    public basvuruKod: number;
    public buharJenerator?: number;
    public buharKazani?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public elektrikMotor?: number;
    public encumenNo?: string;
    public encumenTarih?: string;
    public gecerlilikTarih?: string;
    public harcTahsilatNo?: string;
    public harcTahsilatTarih?: string;
    public harcTutar?: number;
    public hp?: number;
    public kanunMadde?: number;
    public kapanisSaat?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kompresor?: number;
    public kullanimSekliKod?: number;
    public kws?: number;
    public motorGucu?: number;
    public muracatTuru: string;
    public otoklav?: number;
    public projeTahsilatNo?: string;
    public projeTahsilatTarih?: string;
    public projeTutar?: number;
    public ruhsatNo: number;
    public ruhsatTarih: string;
    public sigaraRuhsatEh?: string;
    public sinifi?: number;
    public turKod: string;
    public yil: number;
    public genBinaKullanim?: GenBinaKullanim;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsat>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatBasvuruAdres extends CommonEntityBase
{
    public basvuruKod: number;
    public bolumKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBinaBolum: AksBinaBolum;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsatBasvuruAdres>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatBasvuruBelge extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public belgeEh?: string;
    public belgeTarih?: string;
    public belgeTurKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBelgeTuru: GenBelgeTuru;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsatBasvuruBelge>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatBasvuruInceleme extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelenEvrakNo?: number;
    public gelenEvrakTarih?: string;
    public gidenEvrakNo?: number;
    public gidenEvrakTarih?: string;
    public incelemeBirimKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public uygunEh: string;
    public genBirim: GenBirim;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsatBasvuruInceleme>) { super(init); (Object as any).assign(this, init); }
}

export class IrsKurulTespit extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonKod: number;
    public onayEh?: string;
    public tespit: number;
    public tespitDetay: number;
    public irsKurul: IrsKurul;
    public irsKurulDetay: IrsKurulDetay;
    public irsRuhsatBasvuruKurul: IrsRuhsatBasvuruKurul;

    public constructor(init?: Partial<IrsKurulTespit>) { super(init); (Object as any).assign(this, init); }
}

export class IrsKurulDetay extends CommonEntityBase
{
    public ad: string;
    public cevapTuru?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurulKod: number;
    public irsKurul: IrsKurul;
    public irsKurulTespits: IrsKurulTespit[];

    public constructor(init?: Partial<IrsKurulDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IrsKurul extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public irsKurulDetays: IrsKurulDetay[];
    public irsKurulTespits: IrsKurulTespit[];
    public irsRuhsatBasvuruKuruls: IrsRuhsatBasvuruKurul[];

    public constructor(init?: Partial<IrsKurul>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatBasvuruKurul extends CommonEntityBase
{
    public aciklama?: string;
    public baskan?: number;
    public baskanRolAd?: string;
    public basvuruKod: number;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonTarih: string;
    public komisyonTur: number;
    public onayEh: string;
    public ruhsatTuru?: number;
    public uye1?: number;
    public uye1RolAd?: string;
    public uye2?: number;
    public uye2RolAd?: string;
    public uye3?: number;
    public uye3RolAd?: string;
    public uye4?: number;
    public uye4RolAd?: string;
    public uye5?: number;
    public uye5RolAd?: string;
    public uye6?: number;
    public uye6RolAd?: string;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;
    public ikaPersonel3?: IkaPersonel;
    public ikaPersonel4?: IkaPersonel;
    public ikaPersonel5?: IkaPersonel;
    public ikaPersonel6?: IkaPersonel;
    public irsKurul: IrsKurul;
    public irsKurulTespits: IrsKurulTespit[];
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;
    public baskanOrganizasyonRol?: GenOrganizasyonRol;
    public uye1OrganizasyonRol?: GenOrganizasyonRol;
    public uye2OrganizasyonRol?: GenOrganizasyonRol;
    public uye3OrganizasyonRol?: GenOrganizasyonRol;
    public uye4OrganizasyonRol?: GenOrganizasyonRol;
    public uye5OrganizasyonRol?: GenOrganizasyonRol;
    public uye6OrganizasyonRol?: GenOrganizasyonRol;

    public constructor(init?: Partial<IrsRuhsatBasvuruKurul>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatBasvuruMesul extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaTarih: string;
    public basvuruKod: number;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public sira: number;
    public turKod: string;
    public genKisi: GenKisi;
    public genKisi1?: GenKisi;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsatBasvuruMesul>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatDepo extends CommonEntityBase
{
    public adresi?: string;
    public alani: number;
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sinifKod?: number;
    public genKodDetay?: GenKodDetay;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsatDepo>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatOrtak extends CommonEntityBase
{
    public adiSoyadi: string;
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tckn: string;
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsRuhsatOrtak>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTarifeLimit extends CommonEntityBase
{
    public avmTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilkLimit: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public sonLimit: number;
    public tarifeDetayKod: number;
    public tarifeKod: number;
    public tutar: number;
    public irsTarife: IrsTarife;
    public irsTarifeDetay: IrsTarifeDetay;

    public constructor(init?: Partial<IrsTarifeLimit>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTarifeDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapTuru: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sinif?: number;
    public siraNo: number;
    public tarifeKod: number;
    public tutar?: number;
    public ustTarifeEh?: string;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;
    public irsTarife: IrsTarife;
    public irsTarifeLimits: IrsTarifeLimit[];

    public constructor(init?: Partial<IrsTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTarife extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTuru?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turKod: number;
    public irsTarifeDetays: IrsTarifeDetay[];
    public irsTarifeLimits: IrsTarifeLimit[];
    public irsTur: IrsTur;

    public constructor(init?: Partial<IrsTarife>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTurBelge extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public belgeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public formSiraNo?: number;
    public formYazEh?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ruhsatSinif?: number;
    public ruhsatTurKod: number;
    public genBelgeTuru: GenBelgeTuru;
    public irsTur: IrsTur;

    public constructor(init?: Partial<IrsTurBelge>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTurInceleme extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public belgeTuruKod: number;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ruhsatTurKod: number;
    public genBelgeTuru: GenBelgeTuru;
    public genBirim: GenBirim;
    public irsTur: IrsTur;

    public constructor(init?: Partial<IrsTurInceleme>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTurOtomatik extends CommonEntityBase
{
    public basvuruNo: number;
    public belediyeKod: number;
    public daimiRuhsatNo: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public denetimNo: number;
    public geciciIzinNo: number;
    public geciciRuhsatNo: number;
    public izinNo: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public komisyonNo: number;
    public mMudurNo: number;
    public ruhsatTurKod: number;
    public yil: number;
    public irsTur: IrsTur;

    public constructor(init?: Partial<IrsTurOtomatik>) { super(init); (Object as any).assign(this, init); }
}

export class IrsTur extends CommonEntityBase
{
    public ad: string;
    public aksGuncelleEh: string;
    public birimKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosyaOzelKod?: number;
    public dosyaPlanKod?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBirim: GenBirim;
    public irsRuhsatBasvurus: IrsRuhsatBasvuru[];
    public irsTarives: IrsTarife[];
    public irsTurBelges: IrsTurBelge[];
    public irsTurIncelemes: IrsTurInceleme[];
    public irsTurOtomatiks: IrsTurOtomatik[];

    public constructor(init?: Partial<IrsTur>) { super(init); (Object as any).assign(this, init); }
}

export class IrsRuhsatBasvuru extends CommonEntityBase
{
    public acikAlan?: number;
    public aciklama?: string;
    public ada?: number;
    public alanKod?: number;
    public anaBasvuruKod?: number;
    public arsivKod?: number;
    public arsivNo?: string;
    public baskan?: number;
    public baskanRolAd?: string;
    public baskanYrd?: number;
    public baskanYrdRolAd?: string;
    public basvuruNo: number;
    public basvuruSaat?: string;
    public basvuruTarih: string;
    public belediyeKod: number;
    public belgeNo?: string;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public daire?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public devirBasvuruKod?: number;
    public digerFaaliyet?: string;
    public duzenMemur?: number;
    public elkAboneNo?: string;
    public encumenNo?: string;
    public encumenTarih?: string;
    public eposta?: string;
    public eskiKisiKod?: number;
    public esnafOdaAdi?: string;
    public esnafSicilNo?: string;
    public evrakNo?: number;
    public evrakTarih?: string;
    public faaliyetAd?: string;
    public fenniBaslamaTarih?: string;
    public fenniBitisTarih?: string;
    public gazAboneNo?: string;
    public gecerlilikTarih?: string;
    public isyeriAciklama?: string;
    public isyeriSinif?: number;
    public isyeriSinifAciklama?: string;
    public isyeriTurKod?: number;
    public isyeriUnvan: string;
    public isyeriYer?: number;
    public itfaiyeDurumKod?: number;
    public itfBaslamaTarih?: string;
    public itfBitisTarih?: string;
    public kapaliAlan?: number;
    public kapanisTarih?: string;
    public kapi?: number;
    public kapi1?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public kullanimSekliKod?: number;
    public mahalleCaddeKod: number;
    public mudur?: number;
    public mudurRolAd?: string;
    public mudurYrd?: number;
    public mudurYrdRolAd?: string;
    public mulkiyetDurum?: number;
    public muracaatTur: string;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public personelSayisi?: number;
    public projeNo?: string;
    public projeTarih?: string;
    public sef?: number;
    public sefRolAd?: string;
    public siteApartmanAd?: string;
    public sorumlulukBolgeTuru?: number;
    public sskIsyeriNo?: string;
    public suAboneNo?: string;
    public tarifeGrup?: number;
    public teknikMemur?: number;
    public teknikMemur1?: number;
    public telefon?: string;
    public ticaretSicil?: string;
    public ticaretSicilAdi?: string;
    public turKod: number;
    public vergiDaire?: string;
    public vergiNo?: string;
    public webAdres?: string;
    public yil: number;
    public yonetmelikAciklama?: string;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public genBinaKullanim?: GenBinaKullanim;
    public genKisi?: GenKisi;
    public genKisi1: GenKisi;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public ikaPersonel2?: IkaPersonel;
    public ikaPersonel3?: IkaPersonel;
    public ikaPersonel4?: IkaPersonel;
    public ikaPersonel5?: IkaPersonel;
    public ikaPersonel6?: IkaPersonel;
    public irsDenetlemes: IrsDenetleme[];
    public irsGurultuSeviyeTespits: IrsGurultuSeviyeTespit[];
    public irsIzins: IrsIzin[];
    public irsRuhsats: IrsRuhsat[];
    public anaIrsRuhsatBasvuru?: IrsRuhsatBasvuru;
    public irsRuhsatBasvurus: IrsRuhsatBasvuru[];
    public irsRuhsatBasvuru1?: IrsRuhsatBasvuru;
    public irsRuhsatBasvurus1: IrsRuhsatBasvuru[];
    public irsRuhsatBasvuruAdres: IrsRuhsatBasvuruAdres[];
    public irsRuhsatBasvuruBelges: IrsRuhsatBasvuruBelge[];
    public irsRuhsatBasvuruIncelemes: IrsRuhsatBasvuruInceleme[];
    public irsRuhsatBasvuruKuruls: IrsRuhsatBasvuruKurul[];
    public irsRuhsatBasvuruMesuls: IrsRuhsatBasvuruMesul[];
    public irsRuhsatDepos: IrsRuhsatDepo[];
    public irsRuhsatOrtaks: IrsRuhsatOrtak[];
    public irsTur: IrsTur;

    public constructor(init?: Partial<IrsRuhsatBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class IrsIzin extends CommonEntityBase
{
    public aciklama?: string;
    public acilisSaat?: string;
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public izinNo: number;
    public izinTarih: string;
    public izinTurKod: number;
    public kapanisSaat?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sonTarih?: string;
    public genKodDetay: GenKodDetay;
    public irsIzinDetays: IrsIzinDetay[];
    public irsRuhsatBasvuru: IrsRuhsatBasvuru;

    public constructor(init?: Partial<IrsIzin>) { super(init); (Object as any).assign(this, init); }
}

export class GenKodDetay extends CommonEntityBase
{
    public ad: string;
    public anaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ozelKod?: number;
    public ozelKodStr?: string;
    public atsAracGorevTaleps: AtsAracGorevTalep[];
    public genKodAna: GenKodAna;
    public irsIzins: IrsIzin[];

    public constructor(init?: Partial<GenKodDetay>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaAsansor extends CommonEntityBase
{
    public aciklama?: string;
    public adet?: number;
    public asansorTurKod: number;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kapasiteAdet?: number;
    public kapasiteKg?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaAsansor>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaDoseme extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dosemeKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaDoseme>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaDuvar extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public duvarDolguKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaDuvar>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaIsitma extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isitmaTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaIsitma>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaOrtak extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public birimi?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ortakKulKod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaOrtak>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaOtopark extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kapasite?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public otoparkTurKod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaOtopark>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaParsel extends CommonEntityBase
{
    public aciklama?: string;
    public ada?: number;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod: number;
    public aksBina: AksBina;
    public aksParsel: AksParsel;

    public constructor(init?: Partial<AksBinaParsel>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaRenk extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public renkTurKod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaRenk>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaTesisat extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tesisatTurKod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaTesisat>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaYakit extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public isitmaYakitTurKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBina: AksBina;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksBinaYakit>) { super(init); (Object as any).assign(this, init); }
}

export class AksInsaatTip extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public aksBinas: AksBina[];

    public constructor(init?: Partial<AksInsaatTip>) { super(init); (Object as any).assign(this, init); }
}

export class AksResim extends CommonEntityBase
{
    public aciklama?: string;
    public binaKod?: number;
    public bolumKod?: number;
    public caddeSokakKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public parselKod?: number;
    public resimAd?: string;
    public resimDysKod?: string;
    public resimPath?: string;
    public resimTurKod: number;
    public turu: number;
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public genCaddeSokak?: GenCaddeSokak;
    public genKodDetay: GenKodDetay;

    public constructor(init?: Partial<AksResim>) { super(init); (Object as any).assign(this, init); }
}

export class AksSite extends CommonEntityBase
{
    public acilisTarih?: string;
    public ad: string;
    public aktifEh: string;
    public alani?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kapanisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleKod: number;
    public aksBinas: AksBina[];
    public genMahalleKoy: GenMahalleKoy;

    public constructor(init?: Partial<AksSite>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruDeneyim extends CommonEntityBase
{
    public ayrilmaNedeni?: string;
    public baslamaTarih?: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorev?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konusu?: string;
    public kurumAdi?: string;
    public sure?: string;
    public ucret?: number;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruDeneyim>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruDil extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dilTuruKod?: number;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konusmaSeviye?: string;
    public okumaSeviye?: string;
    public yazmaSeviye?: string;
    public genKodDetay?: GenKodDetay;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruDil>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruEgitim extends CommonEntityBase
{
    public baslamaTarih?: string;
    public bitisTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konusu?: string;
    public kurumAdi?: string;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruEgitim>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruTalep extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meslekTurKod: number;
    public notlar?: string;
    public ibsBasvuru: IbsBasvuru;
    public ibsMeslekTur: IbsMeslekTur;

    public constructor(init?: Partial<IbsBasvuruTalep>) { super(init); (Object as any).assign(this, init); }
}

export class IbsMeslekTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ibsBasvuruFirmas: IbsBasvuruFirma[];
    public ibsBasvuruTaleps: IbsBasvuruTalep[];
    public ibsFirmaTaleps: IbsFirmaTalep[];

    public constructor(init?: Partial<IbsMeslekTur>) { super(init); (Object as any).assign(this, init); }
}

export class IbsFirmaTalep extends CommonEntityBase
{
    public adet?: number;
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public firmaKod: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meslekTurKod: number;
    public notlar?: string;
    public tercihCinsiyet: string;
    public tercihTurbanEh: string;
    public ibsFirma: IbsFirma;
    public ibsMeslekTur: IbsMeslekTur;

    public constructor(init?: Partial<IbsFirmaTalep>) { super(init); (Object as any).assign(this, init); }
}

export class IbsFirma extends CommonEntityBase
{
    public ad: string;
    public adres?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eMailAdres?: string;
    public faaliyet?: string;
    public faxAlanKod?: number;
    public faxTelefon?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public notlar?: string;
    public telAlanKod?: number;
    public telTelefon?: string;
    public vergiDairesi?: string;
    public vergiNo?: number;
    public yetkiliAdSoyad?: string;
    public yetkiliAlanKod?: number;
    public yetkiliTelefon?: string;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public genTelAlanKodlari2?: GenTelAlanKodlari;
    public ibsBasvuruFirmas: IbsBasvuruFirma[];
    public ibsFirmaTaleps: IbsFirmaTalep[];

    public constructor(init?: Partial<IbsFirma>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruFirma extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durumu: string;
    public firmaKod: number;
    public girisTarih?: string;
    public ibsBasvuruKod: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public meslekTurKod?: number;
    public notlar?: string;
    public ibsBasvuru: IbsBasvuru;
    public ibsFirma: IbsFirma;
    public ibsMeslekTur?: IbsMeslekTur;

    public constructor(init?: Partial<IbsBasvuruFirma>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruOgrenim extends CommonEntityBase
{
    public baslamaTarih?: string;
    public bitisTarihi?: string;
    public bolumAdi?: string;
    public bolumKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public durum?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ogrenimTuruKod?: number;
    public okulAdi?: string;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruOgrenim>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruRef extends CommonEntityBase
{
    public adSoyad?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gorev?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kurum?: string;
    public telefon?: string;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruRef>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruResim extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruResim?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruResim>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuruUzmanlik extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ibsBasvuruKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public seviye?: string;
    public uzmanlikTuruKod?: number;
    public genKodDetay?: GenKodDetay;
    public ibsBasvuru: IbsBasvuru;

    public constructor(init?: Partial<IbsBasvuruUzmanlik>) { super(init); (Object as any).assign(this, init); }
}

export class IbsBasvuru extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public aileKisiSayi?: number;
    public aktifEh?: string;
    public anneAd?: string;
    public anneBabaDurum?: string;
    public anneMeslekKod?: number;
    public askerlikDurum?: string;
    public babaAd?: string;
    public babaMeslekKod?: number;
    public basvuruNo: number;
    public basvuruTarih: string;
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public caddeSokakAd?: string;
    public calisiyorEh: string;
    public cinsiyet?: string;
    public cocukSayi?: number;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerTelefon?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public ehliyetEh: string;
    public ehliyetSinif?: string;
    public eMail?: string;
    public engelliAciklama?: string;
    public engelliEh: string;
    public engelliOran?: number;
    public engelliTurKod?: number;
    public engelliTuru?: string;
    public esCalisiyorEh: string;
    public evAlanKod?: number;
    public evTelefon?: string;
    public gsmAlanKod?: number;
    public gsmTelefon?: string;
    public ilceKod?: number;
    public iseBasladiEh: string;
    public isMakKullanimEh: string;
    public kanGrubu?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public konutTurKod?: number;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public medeniDurumKod?: number;
    public meslekKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public ogrenimTuruKod?: number;
    public okuyanCocukSayi?: number;
    public olumKapanisTarih?: string;
    public onayEh?: string;
    public oncekiSoyad?: string;
    public postaKodu?: number;
    public sabikaEh: string;
    public sigaraKullanimEh: string;
    public siteApartmanAd?: string;
    public soyad?: string;
    public tckn?: number;
    public tuikAdresKod?: number;
    public uyruk: string;
    public uyrukKod?: number;
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genIlce3?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genKodDetay5?: GenKodDetay;
    public genKodDetay6?: GenKodDetay;
    public genKodDetay7?: GenKodDetay;
    public genKodDetay8?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;
    public genTelAlanKodlari1?: GenTelAlanKodlari;
    public ibsBasvuruDeneyims: IbsBasvuruDeneyim[];
    public ibsBasvuruDils: IbsBasvuruDil[];
    public ibsBasvuruEgitims: IbsBasvuruEgitim[];
    public ibsBasvuruFirmas: IbsBasvuruFirma[];
    public ibsBasvuruOgrenims: IbsBasvuruOgrenim[];
    public ibsBasvuruRefs: IbsBasvuruRef[];
    public ibsBasvuruResim: IbsBasvuruResim;
    public ibsBasvuruTaleps: IbsBasvuruTalep[];
    public ibsBasvuruUzmanliks: IbsBasvuruUzmanlik[];

    public constructor(init?: Partial<IbsBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class ZysEkipDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekipKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public tarih: string;
    public zysEkip: ZysEkip;

    public constructor(init?: Partial<ZysEkipDetay>) { super(init); (Object as any).assign(this, init); }
}

export class ZysEkip extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekipKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public zysEkipDetays: ZysEkipDetay[];
    public zysKabahatlers: ZysKabahatler[];

    public constructor(init?: Partial<ZysEkip>) { super(init); (Object as any).assign(this, init); }
}

export class ZysKabahatlerBelge extends CommonEntityBase
{
    public aciklama?: string;
    public belgeAd?: string;
    public belgeDysKod?: string;
    public belgePath?: string;
    public belgeTipKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public islemTarih: string;
    public kabahatKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public genBelgeTip: GenBelgeTip;
    public zysKabahatler: ZysKabahatler;

    public constructor(init?: Partial<ZysKabahatlerBelge>) { super(init); (Object as any).assign(this, init); }
}

export class ZysKabahatlerDetay extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public indirimTarih?: string;
    public indirimTutar?: number;
    public kabahatKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public taksitSira: number;
    public tutar?: number;
    public vadeTarih?: string;
    public yil: number;
    public zysKabahatler: ZysKabahatler;

    public constructor(init?: Partial<ZysKabahatlerDetay>) { super(init); (Object as any).assign(this, init); }
}

export class ZysKabahatlerEkip extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kabahatKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public personelKod: number;
    public zysKabahatler: ZysKabahatler;

    public constructor(init?: Partial<ZysKabahatlerEkip>) { super(init); (Object as any).assign(this, init); }
}

export class ZysKanunMadde extends CommonEntityBase
{
    public ad: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod?: number;
    public kanunKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public maddeKod: number;
    public miktar?: number;
    public gysGelirDetay?: GysGelirDetay;
    public zysKanun: ZysKanun;

    public constructor(init?: Partial<ZysKanunMadde>) { super(init); (Object as any).assign(this, init); }
}

export class ZysKanun extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kanunKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public zysKabahatlers: ZysKabahatler[];
    public zysKanunMaddes: ZysKanunMadde[];

    public constructor(init?: Partial<ZysKanun>) { super(init); (Object as any).assign(this, init); }
}

export class ZysKabahatler extends CommonEntityBase
{
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public cezaOdeme?: number;
    public cezaTutar?: number;
    public cezaYil?: number;
    public cezaYilSira?: number;
    public daireNo?: string;
    public degerTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public duzenlemeTarih: string;
    public ekipKod: number;
    public eskiKisiKod?: number;
    public firmaYetkilisi?: string;
    public gelirKod?: number;
    public indirimEh?: string;
    public kanunKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kisiTurKod?: number;
    public kod: number;
    public kontrolEh?: string;
    public maddeKod?: number;
    public mahalleCaddeKod?: number;
    public olay?: string;
    public olayAciklama?: string;
    public olayDetay?: string;
    public olayYer?: string;
    public sira: number;
    public siteApartmanAd?: string;
    public taksitEh?: string;
    public taksitVade?: number;
    public tebligSaat?: string;
    public tebligTarih?: string;
    public turKod?: number;
    public vadeTarih?: string;
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public genKisi?: GenKisi;
    public genKisi1: GenKisi;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public gysGelirDetay?: GysGelirDetay;
    public zysEkip: ZysEkip;
    public zysKabahatlerBelges: ZysKabahatlerBelge[];
    public zysKabahatlerDetays: ZysKabahatlerDetay[];
    public zysKabahatlerEkips: ZysKabahatlerEkip[];
    public zysKanun?: ZysKanun;

    public constructor(init?: Partial<ZysKabahatler>) { super(init); (Object as any).assign(this, init); }
}

export class ZysVarakaKapama extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gun?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public saat?: string;
    public sira: number;
    public tarih?: string;
    public varakaKod: number;
    public zysVaraka: ZysVaraka;

    public constructor(init?: Partial<ZysVarakaKapama>) { super(init); (Object as any).assign(this, init); }
}

export class ZysVarakaMahkeme extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kararNo?: string;
    public kararTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahkemeNo?: string;
    public mahkemeTarih?: string;
    public sira: number;
    public varakaKod: number;
    public zysVaraka: ZysVaraka;

    public constructor(init?: Partial<ZysVarakaMahkeme>) { super(init); (Object as any).assign(this, init); }
}

export class ZysVarakaMudurluk extends CommonEntityBase
{
    public cevapNo?: string;
    public cevapTarih?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gonderimNo?: string;
    public gonderimTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public sira: number;
    public varakaKod: number;
    public zysVaraka: ZysVaraka;

    public constructor(init?: Partial<ZysVarakaMudurluk>) { super(init); (Object as any).assign(this, init); }
}

export class ZysVarakaTeblig extends CommonEntityBase
{
    public cezaTur: string;
    public cezaTutar?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public encumenKarar?: string;
    public encumenNo: string;
    public encumenTarih: string;
    public gelirKod: number;
    public gunSayisi?: number;
    public isyeriTur?: string;
    public kararMemur1Kod?: number;
    public kararMemurKod?: number;
    public kararTebellug?: string;
    public kararTebligTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public plakaNo?: string;
    public varakaKod: number;
    public gysGelirDetay: GysGelirDetay;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public zysVaraka: ZysVaraka;

    public constructor(init?: Partial<ZysVarakaTeblig>) { super(init); (Object as any).assign(this, init); }
}

export class ZysVaraka extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public cezaKod: number;
    public ciltNo?: number;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public encHavaleTarih?: string;
    public encumenCilt?: number;
    public encumenSayfa?: number;
    public eskiKisiKod?: number;
    public ilIlceKod?: number;
    public islemTarih?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitNo?: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public mahalleCaddeKod?: number;
    public memur?: number;
    public memur1?: number;
    public siteApartmanAd?: string;
    public sucAciklama?: string;
    public sucSaat: string;
    public sucTarih: string;
    public sucYeri?: string;
    public tebligTarih: string;
    public yil: number;
    public zabitNo: number;
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public genIlce?: GenIlce;
    public eskiGenKisi?: GenKisi;
    public genKisi?: GenKisi;
    public genKodDetay: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public ikaPersonel?: IkaPersonel;
    public ikaPersonel1?: IkaPersonel;
    public zysVarakaKapamas: ZysVarakaKapama[];
    public zysVarakaMahkemes: ZysVarakaMahkeme[];
    public zysVarakaMudurluks: ZysVarakaMudurluk[];
    public zysVarakaTebligs: ZysVarakaTeblig[];

    public constructor(init?: Partial<ZysVaraka>) { super(init); (Object as any).assign(this, init); }
}

export class AksBina extends CommonEntityBase
{
    public aciklama?: string;
    public acilisTarih?: string;
    public ada?: number;
    public aktifEh: string;
    public apartmanBlokAdi?: string;
    public arsaAlani?: number;
    public asansorEh: string;
    public atiksuTurKod?: number;
    public belediyeKod: number;
    public binaNo: number;
    public blokNo?: string;
    public bolumSayis?: number;
    public catiTurKod?: number;
    public cepheTurKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public icmesuTurKod?: number;
    public ilaveKatSayisi?: number;
    public ilaveYukseklik?: number;
    public insaatAlani?: number;
    public insaatSinifKod: number;
    public insaatTipKod?: number;
    public insaatTurKod: number;
    public kaloriferEh: string;
    public kapanisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konutSayis?: number;
    public kullanimGrupKod?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public postaKodu?: number;
    public sicaksuTurKod?: number;
    public sicaksuYakitTurKod?: number;
    public siteKod?: number;
    public suDepoKapasite?: number;
    public tabanAlani?: number;
    public tarihiEserEh: string;
    public tasiyiciSistemKod?: number;
    public toplamKatSayisi?: number;
    public toplamMaliyeti?: number;
    public toplamYukseklik?: number;
    public yolKotAltiKatSayisi?: number;
    public yolKotAltiYukseklik?: number;
    public yolKotUstuKatSayisi?: number;
    public yolKotUstuYukseklik?: number;
    public aasBasvurus: AasBasvuru[];
    public aksAdres: AksAdres[];
    public aksBinaAsansors: AksBinaAsansor[];
    public aksBinaBolums: AksBinaBolum[];
    public aksBinaDosemes: AksBinaDoseme[];
    public aksBinaDuvars: AksBinaDuvar[];
    public aksBinaIsitmas: AksBinaIsitma[];
    public aksBinaOrtaks: AksBinaOrtak[];
    public aksBinaOtoparks: AksBinaOtopark[];
    public aksBinaParsels: AksBinaParsel[];
    public aksBinaRenks: AksBinaRenk[];
    public aksBinaTesisats: AksBinaTesisat[];
    public aksBinaYakits: AksBinaYakit[];
    public aksInsaatTip?: AksInsaatTip;
    public aksResims: AksResim[];
    public aksSite?: AksSite;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4: GenKodDetay;
    public genKodDetay5: GenKodDetay;
    public genKodDetay6?: GenKodDetay;
    public genKodDetay7?: GenKodDetay;
    public genKodDetay8?: GenKodDetay;
    public genKodDetay9?: GenKodDetay;
    public gysBeyanBagimsizs: GysBeyanBagimsiz[];
    public ibsBasvurus: IbsBasvuru[];
    public omsOlumBelges: OmsOlumBelge[];
    public sysKisiAdres: SysKisiAdres[];
    public zysKabahatlers: ZysKabahatler[];
    public zysVarakas: ZysVaraka[];

    public constructor(init?: Partial<AksBina>) { super(init); (Object as any).assign(this, init); }
}

export class AksAdres extends CommonEntityBase
{
    public aciklama?: string;
    public acilisTarih?: string;
    public adresTipi: string;
    public aktifEh: string;
    public belediyeKod: number;
    public binaKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKapiNo?: number;
    public eskiKapiNo1?: string;
    public kapanisTarih?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleCaddeKod: number;
    public parselKod?: number;
    public uavtBinaKod?: number;
    public aksBina?: AksBina;
    public aksBinaBolums: AksBinaBolum[];
    public aksParsel?: AksParsel;
    public genMahalleCaddeSokak: GenMahalleCaddeSokak;

    public constructor(init?: Partial<AksAdres>) { super(init); (Object as any).assign(this, init); }
}

export class AksParsel extends CommonEntityBase
{
    public acilisTarih?: string;
    public ada: number;
    public aktifEh: string;
    public alani?: number;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public geciciAda?: string;
    public geciciParsel?: string;
    public kapanisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mahalleKod: number;
    public pafta?: string;
    public parsel: number;
    public parselBolgeKod: number;
    public parselTipiKod?: number;
    public tapuMahalleKod?: number;
    public aksAdres: AksAdres[];
    public aksBinaParsels: AksBinaParsel[];
    public aksResims: AksResim[];
    public aksTapuMahalle?: AksTapuMahalle;
    public bysBelges: BysBelge[];
    public bysBelgeParsels: BysBelgeParsel[];
    public eisTasinmazs: EisTasinmaz[];
    public eksKararParsels: EksKararParsel[];
    public gasDosyas: GasDosya[];
    public gasDosyaBelges: GasDosyaBelge[];
    public genKodDetay?: GenKodDetay;
    public genMahalleKoy: GenMahalleKoy;
    public gysBeyans: GysBeyan[];
    public gysHkpBeyans: GysHkpBeyan[];
    public irsDenetlemes: IrsDenetleme[];
    public irsRuhsatBasvurus: IrsRuhsatBasvuru[];
    public mksKararParsels: MksKararParsel[];
    public sasAbones: SasAbone[];
    public yisKararParsels: YisKararParsel[];

    public constructor(init?: Partial<AksParsel>) { super(init); (Object as any).assign(this, init); }
}

export class EisKanunMadde extends CommonEntityBase
{
    public ad?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kanun?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public madde?: number;
    public eisTasinmazs: EisTasinmaz[];

    public constructor(init?: Partial<EisKanunMadde>) { super(init); (Object as any).assign(this, init); }
}

export class EisTasinmazBagis extends CommonEntityBase
{
    public bagisAmac?: string;
    public bagisDosyaNo?: number;
    public bagisIptalEh?: string;
    public bagisIptalTarih?: string;
    public bagisKod: number;
    public bagisTutar: number;
    public baskanlikOnayEh?: string;
    public baskanlikOnayNo?: number;
    public baskanlikOnayTarih?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public encumenKararEh?: string;
    public encumenKararNo?: number;
    public encumenKararTarih?: string;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kesinEh?: string;
    public kisiKod?: number;
    public kod: number;
    public meclisKararEh?: string;
    public meclisKararNo?: number;
    public meclisKararTarih?: string;
    public sartEh?: string;
    public tasinmazKod: number;
    public teklifTarih?: string;
    public tescilTarih?: string;
    public yasalDayanak?: string;
    public eisTasinmaz: EisTasinmaz;
    public genKisi?: GenKisi;
    public genKisi1?: GenKisi;

    public constructor(init?: Partial<EisTasinmazBagis>) { super(init); (Object as any).assign(this, init); }
}

export class EisTasinmazTur extends CommonEntityBase
{
    public ad: string;
    public amortismanHesapKod?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public muhasebeHesapKod?: string;
    public tipKod: string;
    public turKod: number;

    public constructor(init?: Partial<EisTasinmazTur>) { super(init); (Object as any).assign(this, init); }
}

export class EisTasinmaz extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public ada?: number;
    public adresNo?: number;
    public aktifEh?: string;
    public arsaAlani?: number;
    public arsaHisse?: number;
    public arsaOran?: number;
    public arsivKod?: number;
    public arsivNo?: string;
    public arsivTarih?: string;
    public bati?: string;
    public belediyeKod: number;
    public belediyeSinirlariEh?: string;
    public beyanSiraNo?: number;
    public binaHisse?: number;
    public binaKod?: number;
    public binaOran?: number;
    public binaYuzolcum?: number;
    public bolumKod?: number;
    public caddeSokak?: string;
    public cinsi?: number;
    public daireNo?: string;
    public degeri?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogu?: string;
    public edinmeSekli?: string;
    public guney?: string;
    public hisseKod?: number;
    public iktisapTarih?: string;
    public ilIlceKod?: number;
    public imarliEh?: string;
    public kadastroGordumuEh?: string;
    public kanunMaddeKod?: number;
    public kapiNo?: number;
    public kapiNo1?: string;
    public katIrtifakNo?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public kullanimKod?: number;
    public kullanimSekliKod?: number;
    public kuzey?: string;
    public mahalle?: string;
    public mahalleCaddeKod?: number;
    public maliHesapKod?: string;
    public maliyetBedeli?: number;
    public mevkiiAdi?: string;
    public mulkiyetKod?: number;
    public pafta?: string;
    public parsel?: number;
    public parselKod?: number;
    public satisaSunulacakEh?: string;
    public satisTarih?: string;
    public siteApartmanAd?: string;
    public tapuBolge?: number;
    public tapuCiltNo?: number;
    public tapuCins?: string;
    public tapuKod?: number;
    public tapuSayfaNo?: number;
    public tapuTescilTarih?: string;
    public tapuTur?: string;
    public tasinmaz5018Kodu?: string;
    public tasinmazDurum?: number;
    public tasinmazKod: number;
    public terkinNedeni?: string;
    public terkinTarih?: string;
    public tipi?: number;
    public tipKod?: string;
    public turKod?: number;
    public aksBinaBolum?: AksBinaBolum;
    public aksParsel?: AksParsel;
    public eisKanunMadde?: EisKanunMadde;
    public eisTasinmazBagis: EisTasinmazBagis[];
    public genBinaKullanim?: GenBinaKullanim;
    public genIlce?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKullanimSekli?: GenKullanimSekli;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public eisTasinmazTur?: EisTasinmazTur;

    public constructor(init?: Partial<EisTasinmaz>) { super(init); (Object as any).assign(this, init); }
}

export class EisKiraSozlesme extends CommonEntityBase
{
    public aciklama?: string;
    public baslamaTarih: string;
    public belediyeKod: number;
    public bitisTarih: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public depozitoTutar?: number;
    public encumenNo?: string;
    public encumenTarih?: string;
    public eskiKisiKod?: number;
    public gelirKod?: number;
    public hisse?: number;
    public ihaleNo?: string;
    public ihaleTarih?: string;
    public kacAy: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kiraBedeli: number;
    public kisiKod: number;
    public kod: number;
    public kullanmaSekli?: string;
    public odemeAciklama?: string;
    public odemeSekli?: string;
    public oran?: number;
    public sozlesmeNo?: string;
    public tasinmazKod: number;
    public teminatTutar?: number;
    public yil?: number;
    public eisKiraArtis: EisKiraArtis[];
    public genKisi: GenKisi;
    public genKisiEski?: GenKisi;
    public gysGelirDetay?: GysGelirDetay;
    public eisTasinmaz?: EisTasinmaz;

    public constructor(init?: Partial<EisKiraSozlesme>) { super(init); (Object as any).assign(this, init); }
}

export class GysCezaTarife extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public modulKod: number;
    public tutar: number;
    public yil: number;
    public genModul: GenModul;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysCezaTarife>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtvParametre extends CommonEntityBase
{
    public adaParselZorunluEh: string;
    public adresKontrolTuru: string;
    public belediyeKod: number;
    public ctvGelirKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecikmeFaizEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public m2KontrolEh: string;
    public meskenKontrolEh: string;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public tarifeOtomatikEh: string;
    public genModul: GenModul;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysCtvParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysEkaParametre extends CommonEntityBase
{
    public adaParselZorunluEh: string;
    public adresKontrolTuru: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekaGelirKod: number;
    public gecikmeFaizEh: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public tarifeOtomatikEh: string;
    public genModul: GenModul;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysEkaParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlakGelir extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public oranTutar: number;
    public uygulamaTuru: string;
    public vadeUygulamaTuru: string;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysEmlakGelir>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlakParametre extends CommonEntityBase
{
    public adaParselZorunluEh: string;
    public adresKontrolTuru: string;
    public araziGelirKod: number;
    public arsaGelirKod: number;
    public belediyeKod: number;
    public binaArsaAlanZorunluEh: string;
    public binaGelirKod: number;
    public binaHisseKontrolEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecikmeFaizEh: string;
    public kayitKullaniciKod: number;
    public kayitSGelirKod?: number;
    public kayitTarih: string;
    public kkpKisitUygulaEh: string;
    public kod: number;
    public mevzuatLink?: string;
    public modulKod: number;
    public raporBaslik1?: string;
    public raporBaslik2?: string;
    public raporBaslik3?: string;
    public raporBaslik4?: string;
    public varisCezaEh: string;
    public varisSuretAciklama?: string;
    public zamanAsimiKontrolEh: string;
    public genModul: GenModul;
    public gysGelirDetay: GysGelirDetay;
    public gysGelirDetay1: GysGelirDetay;
    public gysGelirDetay2?: GysGelirDetay;
    public gysGelirDetay3: GysGelirDetay;

    public constructor(init?: Partial<GysEmlakParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysGelir extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public butceKodu: string;
    public dayanak?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysGelirDetays: GysGelirDetay[];

    public constructor(init?: Partial<GysGelir>) { super(init); (Object as any).assign(this, init); }
}

export class GysGelirNakit extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysGelirNakit>) { super(init); (Object as any).assign(this, init); }
}

export class GysGelirVade extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public vadeTarihi: string;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysGelirVade>) { super(init); (Object as any).assign(this, init); }
}

export class GysModulGelir extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public modulKod: number;
    public genModul: GenModul;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<GysModulGelir>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsilParametre extends CommonEntityBase
{
    public adresKontrol: string;
    public belediyeKod: number;
    public borcSorgulamaTuru: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekVerGelirKod?: number;
    public ekVerGFaizGelirKod?: number;
    public ekVerGZammiGelirKod?: number;
    public gecikmeKdvGelirKod?: number;
    public gecikmeZamTuru: number;
    public gFaizGelirKod?: number;
    public gZammiGelirKod?: number;
    public hacizFisTuru: string;
    public hacizSatir?: number;
    public icraFisTuru: string;
    public icraSatir?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kiraGecikmeKontrolEh: string;
    public kod: number;
    public kulturGelirKod?: number;
    public kulturGFaizGelirKod?: number;
    public kulturGZammiGelirKod?: number;
    public mahsupFisTuru: string;
    public mahsupSatir?: number;
    public mevzuatLink?: string;
    public minimumGecikmeZammi?: number;
    public nTahsilSatirKontrol: number;
    public oEmriFisTuru: string;
    public oEmriSatir?: number;
    public suGecikmeKontrolEh: string;
    public tahsilFisTuru: string;
    public tahsilSatir?: number;
    public tahsilSmsEh: string;
    public takipTuru: number;
    public tcknVergiNoKontrol: string;
    public tTahsilSatirKontrol: number;
    public gysGelirDetay?: GysGelirDetay;
    public gysGelirDetay1?: GysGelirDetay;
    public gysGelirDetay2?: GysGelirDetay;
    public gysGelirDetay3?: GysGelirDetay;
    public gysGelirDetay4?: GysGelirDetay;
    public gysGelirDetay5?: GysGelirDetay;
    public gysGelirDetay6?: GysGelirDetay;
    public gysGelirDetay7?: GysGelirDetay;
    public gysGelirDetay8?: GysGelirDetay;

    public constructor(init?: Partial<GysTahsilParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitHaricGlr extends CommonEntityBase
{
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih?: string;
    public kod: number;
    public gysGelirDetay?: GysGelirDetay;

    public constructor(init?: Partial<GysTaksitHaricGlr>) { super(init); (Object as any).assign(this, init); }
}

export class MezHayvanGrupCin extends CommonEntityBase
{
    public ad?: string;
    public aktifEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public grupTurKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public mezHayvanGrupTur?: MezHayvanGrupTur;

    public constructor(init?: Partial<MezHayvanGrupCin>) { super(init); (Object as any).assign(this, init); }
}

export class MezHayvanGrupTur extends CommonEntityBase
{
    public ad?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public genBelediye?: GenBelediye;
    public gysGelirDetay?: GysGelirDetay;
    public mezHayvanGrupCins: MezHayvanGrupCin[];

    public constructor(init?: Partial<MezHayvanGrupTur>) { super(init); (Object as any).assign(this, init); }
}

export class MezTarifeLimit extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ekTutar?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public limit: number;
    public siraNo: number;
    public tarifeDetayKod: number;
    public tarifeKod: number;
    public tutar: number;
    public mezTarife: MezTarife;
    public mezTarifeDetay: MezTarifeDetay;

    public constructor(init?: Partial<MezTarifeLimit>) { super(init); (Object as any).assign(this, init); }
}

export class MezTarife extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public genBelediye?: GenBelediye;
    public mezTarifeDetays: MezTarifeDetay[];
    public mezTarifeLimits: MezTarifeLimit[];

    public constructor(init?: Partial<MezTarife>) { super(init); (Object as any).assign(this, init); }
}

export class MezTarifeDetay extends CommonEntityBase
{
    public carpan?: number;
    public carpanUygulaEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod?: number;
    public gelirTur?: number;
    public hesapTuru?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public limitUygulaEh?: string;
    public siraNo?: number;
    public tarifeKod?: number;
    public tutar?: number;
    public yil?: number;
    public gysGelirDetay?: GysGelirDetay;
    public mezTarife?: MezTarife;
    public mezTarifeLimits: MezTarifeLimit[];

    public constructor(init?: Partial<MezTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class PtsDigerGelir extends CommonEntityBase
{
    public aktifEh: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public hesapSekli: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public oranTutar: number;
    public uygulamaTuru: string;
    public yil: number;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<PtsDigerGelir>) { super(init); (Object as any).assign(this, init); }
}

export class YrsIndirim extends CommonEntityBase
{
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecikmeGun: number;
    public gelirKod: number;
    public indirimOran: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<YrsIndirim>) { super(init); (Object as any).assign(this, init); }
}

export class ZysParametre extends CommonEntityBase
{
    public adresKontrolTuru: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gecikmeGun?: number;
    public gelirKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public modulKod: number;
    public otoNumaraGenelModul: string;
    public pesinIndirimOran?: number;
    public tahakFisTuru: string;
    public tahakSatir: number;
    public varakaCiltNo?: number;
    public varakaKacSayfaCilt?: number;
    public varakaSayfaNo?: number;
    public zabitCiltNo?: number;
    public zabitKacSayfaCilt?: number;
    public zabitNo?: number;
    public zabitNoOtomatikEh: string;
    public zabitSayfaNo?: number;
    public genModul: GenModul;
    public gysGelirDetay?: GysGelirDetay;

    public constructor(init?: Partial<ZysParametre>) { super(init); (Object as any).assign(this, init); }
}

export class GysGelirDetay extends CommonEntityBase
{
    public ad: string;
    public bakiyeYazEh: string;
    public cezaEh: string;
    public cezaTuru?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public detayKod: number;
    public gecikmeKdvEh?: string;
    public gecikmeKod?: number;
    public gecikmeZammiEh: string;
    public gecikmeZammiTuru?: string;
    public gelirKod: number;
    public giderYansitmaHesapKodu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kdvDahilEh: string;
    public kdvEh: string;
    public kdvGelirKod?: number;
    public kdvOrani?: number;
    public kod: number;
    public muhasebeyeDetayAktarEh: string;
    public sDonemHesapKodu?: string;
    public sDonemTecilHesapKodu?: string;
    public tahakHesapKodu?: string;
    public tahakkukEh: string;
    public tahakTarhNedeni?: string;
    public tahsilHesapKodu?: string;
    public takipHesapKodu?: string;
    public takipliEh: string;
    public takipSekli?: string;
    public tecilHesapKodu?: string;
    public terkinGiderHesapKodu?: string;
    public vadeSayisi?: number;
    public vIhbarTarhNedeni?: string;
    public zamanAsimSure?: number;
    public eisKiraSozlesmes: EisKiraSozlesme[];
    public etsUcretTarifeDetays: EtsUcretTarifeDetay[];
    public fisTarifeDetays: FisTarifeDetay[];
    public gysCezaTarives: GysCezaTarife[];
    public gysCtvParametres: GysCtvParametre[];
    public gysEglGelirs: GysEglGelir[];
    public gysEglTarives: GysEglTarife[];
    public gysEkaKullanims: GysEkaKullanim[];
    public gysEkaParametres: GysEkaParametre[];
    public gysEmlakGelirs: GysEmlakGelir[];
    public gysEmlakParametres: GysEmlakParametre[];
    public gysEmlakParametres1: GysEmlakParametre[];
    public gysEmlakParametres2: GysEmlakParametre[];
    public gysEmlakParametres3: GysEmlakParametre[];
    public gysGecikme?: GysGecikme;
    public gysGelir: GysGelir;
    public kdvGysGelirDetay?: GysGelirDetay;
    public gysGelirDetays: GysGelirDetay[];
    public gysGelirNakits: GysGelirNakit[];
    public gysGelirVades: GysGelirVade[];
    public gysGenelParametres: GysGenelParametre[];
    public gysGenelParametres1: GysGenelParametre[];
    public gysGenelParametres2: GysGenelParametre[];
    public gysGenelParametres3: GysGenelParametre[];
    public gysGenelParametres4: GysGenelParametre[];
    public gysGenelTarives: GysGenelTarife[];
    public gysHacizs: GysHaciz[];
    public gysHacizs1: GysHaciz[];
    public gysHkpIslers: GysHkpIsler[];
    public gysIcras: GysIcra[];
    public gysIcras1: GysIcra[];
    public gysIhbars: GysIhbar[];
    public gysIhbars1: GysIhbar[];
    public gysIhbarTerkins: GysIhbarTerkin[];
    public gysIhbarTerkins1: GysIhbarTerkin[];
    public gysIlanGelirs: GysIlanGelir[];
    public gysIlanTarives: GysIlanTarife[];
    public gysMahsups: GysMahsup[];
    public gysMahsups1: GysMahsup[];
    public gysModulGelirs: GysModulGelir[];
    public gysTahsils: GysTahsil[];
    public gysTahsils1: GysTahsil[];
    public gysTahsilParametres: GysTahsilParametre[];
    public gysTahsilParametres1: GysTahsilParametre[];
    public gysTahsilParametres2: GysTahsilParametre[];
    public gysTahsilParametres3: GysTahsilParametre[];
    public gysTahsilParametres4: GysTahsilParametre[];
    public gysTahsilParametres5: GysTahsilParametre[];
    public gysTahsilParametres6: GysTahsilParametre[];
    public gysTahsilParametres7: GysTahsilParametre[];
    public gysTahsilParametres8: GysTahsilParametre[];
    public gysTakips: GysTakip[];
    public gysTakips1: GysTakip[];
    public gysTakipTerkins: GysTakipTerkin[];
    public gysTakipTerkins1: GysTakipTerkin[];
    public gysTaksits: GysTaksit[];
    public gysTaksits1: GysTaksit[];
    public gysTaksitHaricGlrs: GysTaksitHaricGlr[];
    public gysTaksitIptals: GysTaksitIptal[];
    public gysTaksitIptals1: GysTaksitIptal[];
    public gysTaksitParametres: GysTaksitParametre[];
    public gysTaksitParametres1: GysTaksitParametre[];
    public gysTerkins: GysTerkin[];
    public gysTerkins1: GysTerkin[];
    public hisDavaBorcs: HisDavaBorc[];
    public hisDavaBorcs1: HisDavaBorc[];
    public irsTarifeDetays: IrsTarifeDetay[];
    public mezHayvanGrupTurs: MezHayvanGrupTur[];
    public mezTarifeDetays: MezTarifeDetay[];
    public omsTarifeDetays: OmsTarifeDetay[];
    public ptsDigerGelirs: PtsDigerGelir[];
    public ptsPazarYerTarives: PtsPazarYerTarife[];
    public sasAssTarifeDetays: SasAssTarifeDetay[];
    public sasGelirs: SasGelir[];
    public sasParametres: SasParametre[];
    public sasParametres1: SasParametre[];
    public sasParametres2: SasParametre[];
    public sasParametres3: SasParametre[];
    public sasSayacHazirliks: SasSayacHazirlik[];
    public sasTeminats: SasTeminat[];
    public sasUcretTarifeDetays: SasUcretTarifeDetay[];
    public tisTarifeDetays: TisTarifeDetay[];
    public yrsIndirims: YrsIndirim[];
    public yrsTarifeDetays: YrsTarifeDetay[];
    public zysKabahatlers: ZysKabahatler[];
    public zysKanunMaddes: ZysKanunMadde[];
    public zysParametres: ZysParametre[];
    public zysVarakaTebligs: ZysVarakaTeblig[];

    public constructor(init?: Partial<GysGelirDetay>) { super(init); (Object as any).assign(this, init); }
}

export class FisTarifeDetay extends CommonEntityBase
{
    public carpanUygulaEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelirKod: number;
    public gelirTur?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public siraNo: number;
    public tarifeKod: number;
    public tutar?: number;
    public yil: number;
    public fisTarife: FisTarife;
    public gysGelirDetay: GysGelirDetay;

    public constructor(init?: Partial<FisTarifeDetay>) { super(init); (Object as any).assign(this, init); }
}

export class FisTarife extends CommonEntityBase
{
    public aciklama?: string;
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public fisTarifeDetays: FisTarifeDetay[];
    public fisUcretTahakkuks: FisUcretTahakkuk[];
    public genBelediye: GenBelediye;

    public constructor(init?: Partial<FisTarife>) { super(init); (Object as any).assign(this, init); }
}

export class FisUcretTahakkuk extends CommonEntityBase
{
    public ada?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donem: number;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public parsel?: string;
    public tahakkukAnaKod?: number;
    public tahakkukTarih: string;
    public ucretTarifeKod: number;
    public yil: number;
    public fisTarife: FisTarife;
    public genBelediye: GenBelediye;
    public genKisi: GenKisi;
    public gysTahakkukAna?: GysTahakkukAna;

    public constructor(init?: Partial<FisUcretTahakkuk>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiBirles extends CommonEntityBase
{
    public birlesenKisiKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public genKisi: GenKisi;
    public genKisi1: GenKisi;

    public constructor(init?: Partial<GenKisiBirles>) { super(init); (Object as any).assign(this, init); }
}

export class GenIletisimTuru extends CommonEntityBase
{
    public ad?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public turu: number;
    public genKisiIletisims: GenKisiIletisim[];

    public constructor(init?: Partial<GenIletisimTuru>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiIletisim extends CommonEntityBase
{
    public aktifEh: string;
    public alanAd?: string;
    public alanKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public iletisimTuruKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public mailBilgiEh: string;
    public muhatapAd?: string;
    public muhatapSoyad?: string;
    public notlar?: string;
    public smsBilgiEh: string;
    public genIletisimTuru?: GenIletisimTuru;
    public genKisi: GenKisi;
    public genTelAlanKodlari?: GenTelAlanKodlari;

    public constructor(init?: Partial<GenKisiIletisim>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiMesaj extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisaMesaj: string;
    public kisiKod: number;
    public kod: number;
    public notlar?: string;
    public genKisi: GenKisi;

    public constructor(init?: Partial<GenKisiMesaj>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiResim extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public islemTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public resimDysKod?: string;
    public resimPath?: string;
    public genKisi: GenKisi;

    public constructor(init?: Partial<GenKisiResim>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiTuru extends CommonEntityBase
{
    public aciklama: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public tur: string;

    public constructor(init?: Partial<GenKisiTuru>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisiYetkili extends CommonEntityBase
{
    public adiSoyadi?: string;
    public aktifEh: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public eskiYetkiliKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod: number;
    public kod: number;
    public vekaletBaslaTarih: string;
    public vekaletBitisTarih?: string;
    public vekaletNo?: string;
    public yetkiliKisiKod: number;
    public yetkiliTuru?: string;
    public genKisi: GenKisi;
    public genKisiYetkiliOlan: GenKisi;

    public constructor(init?: Partial<GenKisiYetkili>) { super(init); (Object as any).assign(this, init); }
}

export class MezHayvanBilgileri extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public gelisTarihi?: string;
    public hayvanGrupTurKod?: number;
    public hayvanKabulKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kesilmeTarihi?: string;
    public kesimDetaySecimDurumu?: number;
    public kesimTuru?: number;
    public kestirenKisiKod?: number;
    public kod: number;
    public kulakKupeNo?: string;
    public secimDurumu?: number;
    public mezMortemHayvanBilgileris: MezMortemHayvanBilgileri[];

    public constructor(init?: Partial<MezHayvanBilgileri>) { super(init); (Object as any).assign(this, init); }
}

export class MezMortemHayvanBilgileri extends CommonEntityBase
{
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public hayvanKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public mortemKod?: number;
    public mezHayvanBilgileri?: MezHayvanBilgileri;
    public mezMortemBilgileri?: MezMortemBilgileri;

    public constructor(init?: Partial<MezMortemHayvanBilgileri>) { super(init); (Object as any).assign(this, init); }
}

export class MezMezbahaVeteriner extends CommonEntityBase
{
    public aciklama?: string;
    public ayrilmaTarih?: string;
    public baslamaTarih?: string;
    public belediyeKod?: number;
    public calismaSekli?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public mezbahaKod?: number;
    public veterinerKod?: number;
    public genBelediye?: GenBelediye;
    public mezVeteriner?: MezVeteriner;

    public constructor(init?: Partial<MezMezbahaVeteriner>) { super(init); (Object as any).assign(this, init); }
}

export class MezVeteriner extends CommonEntityBase
{
    public adi?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diplomaNo?: string;
    public dogumTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitliOdaAdi?: string;
    public kayitTarihi?: string;
    public kod: number;
    public odaUyeNo?: string;
    public soyadi?: string;
    public tckn?: string;
    public veterinerKisiKod?: number;
    public mezMezbahaVeteriners: MezMezbahaVeteriner[];
    public mezMortemBilgileris: MezMortemBilgileri[];

    public constructor(init?: Partial<MezVeteriner>) { super(init); (Object as any).assign(this, init); }
}

export class MezMortemBilgileri extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod?: number;
    public bulguLabaratuvarTeyidi?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public digerDurumlar?: string;
    public hayvanKabulKod?: number;
    public kararAciklama?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kesimDurumKod?: number;
    public kod: number;
    public mezbahaKod?: number;
    public mortemTip?: string;
    public muayeneTarihi?: string;
    public nakliyeVeBekletilmeSirasi?: number;
    public soruGrupKod?: number;
    public veterinerKod?: number;
    public yetistiriciKisiKod?: number;
    public genBelediye?: GenBelediye;
    public genKisi?: GenKisi;
    public mezMezbaha?: MezMezbaha;
    public mezMortemHayvanBilgileris: MezMortemHayvanBilgileri[];
    public mezVeteriner?: MezVeteriner;

    public constructor(init?: Partial<MezMortemBilgileri>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisi extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public anneAd?: string;
    public babaAd?: string;
    public belediyeKod: number;
    public cinsiyet?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public ehliyetNo?: string;
    public ehliyetTarih?: string;
    public ehliyetTuruKod?: number;
    public emekliTarih?: string;
    public emekliTuruKod?: number;
    public isyeriTuruKod?: number;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiTurKod: number;
    public kod: number;
    public kpsKod?: string;
    public kpsKontrolTarih?: string;
    public kpsSonucTur?: number;
    public medeniDurumKod?: number;
    public meslekAciklama?: string;
    public meslekKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: string;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public ogrenimTuruKod?: number;
    public olumKapanisTarih?: string;
    public oncekiSoyad?: string;
    public sicilKod: number;
    public soyad?: string;
    public tckn?: number;
    public unvani?: string;
    public uyrukKod?: number;
    public varisEh?: string;
    public vergiDairesi?: string;
    public vergiNo?: string;
    public fisUcretTahakkuks: FisUcretTahakkuk[];
    public fisUcretTahakkuks1: FisUcretTahakkuk[];
    public genIlceDogumYeri?: GenIlce;
    public genIlceNidaresi?: GenIlce;
    public genIlceNkayitliYer?: GenIlce;
    public genKisiAdres: GenKisiAdres[];
    public genKisiBirlesen: GenKisiBirles;
    public genKisiBirlestirilen: GenKisiBirles[];
    public genKisiIletisims: GenKisiIletisim[];
    public genKisiMesajs: GenKisiMesaj[];
    public genKisiResims: GenKisiResim[];
    public genKisiTuru: GenKisiTuru;
    public genKisiVaris: GenKisiVaris[];
    public genKisiYetkilis: GenKisiYetkili[];
    public genKisiYetkiliOlunans: GenKisiYetkili[];
    public genKodDini?: GenKodDetay;
    public genKodEhliyetTuru?: GenKodDetay;
    public genKodEmekliTuru?: GenKodDetay;
    public genKodIsyeriTuru?: GenKodDetay;
    public genKodMedeniDurum?: GenKodDetay;
    public genKodMeslek?: GenKodDetay;
    public genKodOgrenimTuru?: GenKodDetay;
    public genKodUyruk?: GenKodDetay;
    public mezMortemBilgileris: MezMortemBilgileri[];
    public adSoyadUnvan?: string;

    public constructor(init?: Partial<GenKisi>) { super(init); (Object as any).assign(this, init); }
}

export class AtsMulkiyetTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public eskiKisiKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiKod?: number;
    public kod: number;
    public turu: string;
    public atsAracs: AtsArac[];
    public genKisi?: GenKisi;
    public genKisiEski?: GenKisi;

    public constructor(init?: Partial<AtsMulkiyetTur>) { super(init); (Object as any).assign(this, init); }
}

export class AtsArac extends CommonEntityBase
{
    public ad?: string;
    public aracSinifKod?: number;
    public aracTurKod?: number;
    public ayaktaYolcuSayi?: number;
    public aylikKira?: number;
    public azamiAgirlik?: number;
    public baslangicKm?: number;
    public belediyeKod?: number;
    public birimKod?: number;
    public cikisNeden?: string;
    public cikisNo?: string;
    public cikisTarih?: string;
    public cikisYer?: string;
    public cinsKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public demirbasSicilKod?: string;
    public edinmeSekli?: string;
    public gorevTurKod?: number;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kiraBaslamaTarih?: string;
    public kiraBitisTarih?: string;
    public kiraLimit?: number;
    public kod: number;
    public koltukSayi?: number;
    public kullanmaAmaci?: string;
    public lastikEbadi?: string;
    public maliyetDolar?: number;
    public maliyetTl?: number;
    public markaKod?: number;
    public model?: number;
    public motorGucu?: number;
    public motorNo?: string;
    public mulkiyetTurKod?: number;
    public netAgirlik?: number;
    public notlar?: string;
    public plaka?: string;
    public rektefeTarih?: string;
    public renk?: string;
    public romorkAzamiAgirlik?: number;
    public ruhsatNo?: string;
    public saseNo?: string;
    public silindirHacmi?: number;
    public tescilIlceKod?: number;
    public tescilNo?: string;
    public tescilSiraNo?: string;
    public tescilTarih?: string;
    public trafikCikisTarih?: string;
    public yakitTankKapasite?: number;
    public yakitTur1Kod?: number;
    public yakitTurKod?: number;
    public atsGorevTur?: AtsGorevTur;
    public atsMulkiyetTur?: AtsMulkiyetTur;
    public genBirim?: GenBirim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genKodDetay5?: GenKodDetay;

    public constructor(init?: Partial<AtsArac>) { super(init); (Object as any).assign(this, init); }
}

export class AtsGorevTur extends CommonEntityBase
{
    public ad: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public atsAracs: AtsArac[];
    public atsAracGorevTaleps: AtsAracGorevTalep[];

    public constructor(init?: Partial<AtsGorevTur>) { super(init); (Object as any).assign(this, init); }
}

export class AtsAracGorevTalep extends CommonEntityBase
{
    public aciklama?: string;
    public aracTurKod?: number;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public donusTarihi?: string;
    public gidecegiYer?: string;
    public gidisTarihi?: string;
    public gorevAciklamasi?: string;
    public gorevTurKod?: number;
    public hareketSaati?: string;
    public hareketYeri?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public talepEden?: string;
    public talepEdenBirimKod?: number;
    public talepEdilenBirimKod?: number;
    public atsGorevTur?: AtsGorevTur;
    public genBelediye?: GenBelediye;
    public genBirim?: GenBirim;
    public genBirim1?: GenBirim;
    public genKodDetay?: GenKodDetay;

    public constructor(init?: Partial<AtsAracGorevTalep>) { super(init); (Object as any).assign(this, init); }
}

export class MezKesim extends CommonEntityBase
{
    public aciklama?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kestirenKisiKod?: number;
    public kod: number;
    public mezbahaKod?: number;
    public tarih?: string;
    public veterinerHekimKod?: number;
    public genBelediye?: GenBelediye;
    public mezMezbaha?: MezMezbaha;

    public constructor(init?: Partial<MezKesim>) { super(init); (Object as any).assign(this, init); }
}

export class MezMuayeneSoruGrupDetay extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public soruGrupKod?: number;
    public soruKod?: number;
    public mezMuayeneSoruGrup?: MezMuayeneSoruGrup;

    public constructor(init?: Partial<MezMuayeneSoruGrupDetay>) { super(init); (Object as any).assign(this, init); }
}

export class MezMuayeneSoruGrup extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public aktifEh?: string;
    public belediyeKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public mortemTip?: string;
    public genBelediye?: GenBelediye;
    public mezMuayeneSoruGrupDetays: MezMuayeneSoruGrupDetay[];

    public constructor(init?: Partial<MezMuayeneSoruGrup>) { super(init); (Object as any).assign(this, init); }
}

export class MezMuayeneSoruCevap extends CommonEntityBase
{
    public aciklama?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public puan?: number;
    public soruKod?: number;
    public veriTipi?: number;
    public mezMortemSoruCevaps: MezMortemSoruCevap[];
    public mezMuayeneSoruTanim?: MezMuayeneSoruTanim;

    public constructor(init?: Partial<MezMuayeneSoruCevap>) { super(init); (Object as any).assign(this, init); }
}

export class MezMortemSoruCevap extends CommonEntityBase
{
    public cevapKod?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarih?: string;
    public kod: number;
    public mortemKod?: number;
    public soruKod?: number;
    public mezMuayeneSoruCevap?: MezMuayeneSoruCevap;
    public mezMuayeneSoruTanim?: MezMuayeneSoruTanim;

    public constructor(init?: Partial<MezMortemSoruCevap>) { super(init); (Object as any).assign(this, init); }
}

export class MezMuayeneSoruTanim extends CommonEntityBase
{
    public ad?: string;
    public aktifEh?: string;
    public belediyeKod?: number;
    public carpanEh?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod?: number;
    public kayitTarihi?: string;
    public kod: number;
    public puan?: number;
    public siraNo?: number;
    public soruTip?: string;
    public genBelediye?: GenBelediye;
    public mezMortemSoruCevaps: MezMortemSoruCevap[];
    public mezMuayeneSoruCevaps: MezMuayeneSoruCevap[];

    public constructor(init?: Partial<MezMuayeneSoruTanim>) { super(init); (Object as any).assign(this, init); }
}

export class GenBelediye extends CommonEntityBase
{
    public aciklama: string;
    public belediyeKodu?: string;
    public belediyeResim?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilceKod?: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public atsAracGorevTaleps: AtsAracGorevTalep[];
    public bimHizmetBinas: BimHizmetBina[];
    public fisTarives: FisTarife[];
    public fisUcretTahakkuks: FisUcretTahakkuk[];
    public mezHayvanGrupTurs: MezHayvanGrupTur[];
    public mezKesims: MezKesim[];
    public mezMezbahas: MezMezbaha[];
    public mezMezbahaVeteriners: MezMezbahaVeteriner[];
    public mezMortemBilgileris: MezMortemBilgileri[];
    public mezMuayeneSoruGrups: MezMuayeneSoruGrup[];
    public mezMuayeneSoruTanims: MezMuayeneSoruTanim[];
    public mezTarives: MezTarife[];
    public omsHizmetPersonels: OmsHizmetPersonel[];

    public constructor(init?: Partial<GenBelediye>) { super(init); (Object as any).assign(this, init); }
}

export class MezMezbaha extends CommonEntityBase
{
    public acilisTarih?: string;
    public adi: string;
    public adres?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public faks?: string;
    public ilceKod: number;
    public isletmeNo?: string;
    public kapanisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public mezbahaTip: string;
    public ruhsatNo?: string;
    public telefon?: string;
    public genBelediye: GenBelediye;
    public genIlce: GenIlce;
    public mezKesims: MezKesim[];
    public mezMortemBilgileris: MezMortemBilgileri[];

    public constructor(init?: Partial<MezMezbaha>) { super(init); (Object as any).assign(this, init); }
}

export class GenIlce extends CommonEntityBase
{
    public aciklama: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public ilKod: number;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public nufusKodu?: number;
    public genIl: GenIl;
    public mezMezbahas: MezMezbaha[];

    public constructor(init?: Partial<GenIlce>) { super(init); (Object as any).assign(this, init); }
}

export class AasBasvuruAile extends CommonEntityBase
{
    public aciklama?: string;
    public ad?: string;
    public anneAd?: string;
    public babaAd?: string;
    public basvuruKod: number;
    public calisiyorEh: string;
    public cinsiyet: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public kanGrubu?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public ogrenimTuruKod?: number;
    public oncekiSoyad?: string;
    public soyad?: string;
    public tckn?: number;
    public uyrukKod?: number;
    public yakinlikDurumuKod: number;
    public yardimAlanEh: string;
    public aasBasvuru: AasBasvuru;
    public aasOdemes: AasOdeme[];
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4: GenKodDetay;

    public constructor(init?: Partial<AasBasvuruAile>) { super(init); (Object as any).assign(this, init); }
}

export class AasBasvuruInceleme extends CommonEntityBase
{
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dusunceler?: string;
    public incelemeTarih: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public konutDurumu?: string;
    public personelKod?: number;
    public talepDurumu?: string;
    public tasinirDurumu?: string;
    public aasBasvuru: AasBasvuru;
    public ikaPersonel?: IkaPersonel;

    public constructor(init?: Partial<AasBasvuruInceleme>) { super(init); (Object as any).assign(this, init); }
}

export class AasBasvuruResim extends CommonEntityBase
{
    public aciklama?: string;
    public basvuruKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kisiResim?: string;
    public kod: number;
    public aasBasvuru: AasBasvuru;

    public constructor(init?: Partial<AasBasvuruResim>) { super(init); (Object as any).assign(this, init); }
}

export class AasBasvuru extends CommonEntityBase
{
    public ad?: string;
    public adresAciklama?: string;
    public anneAd?: string;
    public askerDegisimTarih?: string;
    public askerKardesAdSoyad?: string;
    public askerNeviKod?: number;
    public askerOnceGelir?: number;
    public askerOnceMeslekKod?: number;
    public askerSevkTarih?: string;
    public askerSinifKod?: number;
    public askerSube?: string;
    public askerTerhisTarih?: string;
    public askerTuru?: number;
    public babaAd?: string;
    public bankaIbanNo?: string;
    public baslangicAylik?: number;
    public basvuruAd: string;
    public basvuruDurum: number;
    public basvuruNo: number;
    public basvuruSoyad: string;
    public basvuruTarih: string;
    public belediyeKod: number;
    public binaKod?: number;
    public blokNo?: string;
    public bolumKod?: number;
    public caddeSokakAd?: string;
    public cinsiyet?: string;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diniKod?: number;
    public dogumTarih?: string;
    public dogumYeriAciklama?: string;
    public dogumYeriKod?: number;
    public dusunceler?: string;
    public encumenKararNo?: string;
    public encumenKararTarih?: string;
    public gecimDurumu?: string;
    public ilceKod?: number;
    public kanGrubu?: string;
    public kapiNo?: number;
    public kapiNo1?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kiraTutar?: number;
    public kiraYardimEh: string;
    public kisiKod?: number;
    public kisiSayi?: number;
    public kod: number;
    public konutTurKod?: number;
    public mahalleAd?: string;
    public mahalleCaddeKod?: number;
    public medeniDurumKod?: number;
    public nAileSiraNo?: string;
    public nCiltNo?: string;
    public nCuzdanKayitNo?: number;
    public nCuzdanSeriNo?: string;
    public nCuzdanSiraNo?: number;
    public nCuzdanVerilisKod?: number;
    public nIdaresiKod?: number;
    public nKayitliMahalleKoy?: string;
    public nKayitliYerKod?: number;
    public nSiraNo?: string;
    public nVerildigiTarih?: string;
    public oncekiSoyad?: string;
    public postaKodu?: number;
    public siteApartmanAd?: string;
    public sosyalGuvenceKod?: number;
    public sosyalGuvenceNo?: string;
    public soyad?: string;
    public tckn?: number;
    public telAlanKod?: number;
    public telefonNo?: string;
    public uyrukKod?: number;
    public yardimBaslamaTarih?: string;
    public yardimBitisTarih?: string;
    public aasBasvuruAiles: AasBasvuruAile[];
    public aasBasvuruIncelemes: AasBasvuruInceleme[];
    public aasBasvuruResim: AasBasvuruResim;
    public aasOdemes: AasOdeme[];
    public aksBina?: AksBina;
    public aksBinaBolum?: AksBinaBolum;
    public genIlce?: GenIlce;
    public genIlce1?: GenIlce;
    public genIlce2?: GenIlce;
    public genIlce3?: GenIlce;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public genKodDetay3?: GenKodDetay;
    public genKodDetay4?: GenKodDetay;
    public genKodDetay5?: GenKodDetay;
    public genKodDetay6?: GenKodDetay;
    public genKodDetay7?: GenKodDetay;
    public genMahalleCaddeSokak?: GenMahalleCaddeSokak;
    public genTelAlanKodlari?: GenTelAlanKodlari;

    public constructor(init?: Partial<AasBasvuru>) { super(init); (Object as any).assign(this, init); }
}

export class AksBinaBolum extends CommonEntityBase
{
    public aciklama?: string;
    public acilisTarih: string;
    public adresKod: number;
    public aktifEh: string;
    public belediyeKod: number;
    public bilgiAdiSoyadi?: string;
    public binaKod: number;
    public bolumAdi?: string;
    public brutYuzolcum?: number;
    public calisanKisiAdet?: number;
    public daireNo?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public elektrikNo?: string;
    public gazNo?: string;
    public haneHalkiAdet?: number;
    public isitmaTurKod?: number;
    public isyeriEh: string;
    public kaloriferEh: string;
    public kapanisTarih?: string;
    public katNo?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public koltukAdet?: number;
    public konutTurKod?: number;
    public kullanimTurKod?: number;
    public malikAdiSoyadi?: string;
    public netYuzolcum?: number;
    public odaAdet?: number;
    public ogrenciAdet?: number;
    public personelAdet?: number;
    public plakaNo?: number;
    public suNo?: string;
    public tapuBagimsizNo?: string;
    public uavtAdresNo?: number;
    public uavtKod?: number;
    public yakitTurKod?: number;
    public yatakAdet?: number;
    public aasBasvurus: AasBasvuru[];
    public aksAdres: AksAdres;
    public aksBina: AksBina;
    public aksResims: AksResim[];
    public eisTasinmazs: EisTasinmaz[];
    public etsBeyans: EtsBeyan[];
    public etsBeyanDetays: EtsBeyanDetay[];
    public gasDosyas: GasDosya[];
    public genBinaKullanim?: GenBinaKullanim;
    public genKodDetay?: GenKodDetay;
    public genKodDetay1?: GenKodDetay;
    public genKodDetay2?: GenKodDetay;
    public gysBeyans: GysBeyan[];
    public gysBeyanBagimsizs: GysBeyanBagimsiz[];
    public gysHkpBeyans: GysHkpBeyan[];
    public ibsBasvurus: IbsBasvuru[];
    public irsDenetlemes: IrsDenetleme[];
    public irsRuhsatBasvurus: IrsRuhsatBasvuru[];
    public irsRuhsatBasvuruAdres: IrsRuhsatBasvuruAdres[];
    public omsOlumBelges: OmsOlumBelge[];
    public sasAbones: SasAbone[];
    public sysKisiAdres: SysKisiAdres[];
    public zysKabahatlers: ZysKabahatler[];
    public zysVarakas: ZysVaraka[];

    public constructor(init?: Partial<AksBinaBolum>) { super(init); (Object as any).assign(this, init); }
}

export class BaseResponse
{
    public result: boolean;
    public errorCode: string;
    public errorMessage: string;
    public errors: string[];
    public warnings: string[];
    public errorDetails: string[];
    public totalPages: number;
    public totalCount: number;
    public pageSize: number;
    public vError: ValidationResult;

    public constructor(init?: Partial<BaseResponse>) { (Object as any).assign(this, init); }
}

export class TemSayistay_Dosya_Response extends BaseResponse
{
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<TemSayistay_Dosya_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsKisiAile extends CommonEntityBase
{
    public adi?: string;
    public aileSiraNo?: number;
    public anaKod?: number;
    public anneAdi?: string;
    public babaAdi?: string;
    public belediyeKod: number;
    public bireySiraNo?: number;
    public bosanmaTarihi?: string;
    public ciltNo?: number;
    public cinsiyeti?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogumTarihi?: string;
    public dogumYeri?: string;
    public durumBilgisi?: string;
    public evlenmeTarihi?: string;
    public hata?: string;
    public ip?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public medeniDurumu?: string;
    public nufusIl?: string;
    public nufusIlce?: string;
    public nufusKoy?: string;
    public olumTarihi?: string;
    public soyadi?: string;
    public tckn: number;
    public tescilTarihi?: string;
    public tur?: string;
    public yakinlikDurum?: string;

    public constructor(init?: Partial<GenKpsKisiAile>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsAdres extends CommonEntityBase
{
    public acikadres?: string;
    public adrestipi?: string;
    public belediyeKod: number;
    public beyandabulunankimlikno?: number;
    public beyantarihi?: string;
    public binaada?: string;
    public binablokadi?: string;
    public binakodu?: number;
    public binapafta?: string;
    public binaparsel?: string;
    public binasiteadi?: string;
    public bucak?: string;
    public bucakkodu?: number;
    public csbm?: string;
    public csbmkodu?: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public diskapino?: string;
    public hata?: string;
    public ickapino?: string;
    public ilad?: string;
    public ilcead?: string;
    public ilcekodu?: string;
    public ilkodu?: string;
    public ip?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public koy?: string;
    public koykayitno?: number;
    public koykodu?: number;
    public mahalle?: string;
    public mahallekodu?: string;
    public tasinmatarihi?: string;
    public tckn: string;
    public tesciltarihi?: string;

    public constructor(init?: Partial<GenKpsAdres>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsKisiAileDto
{
    public adi?: string;
    public aileSiraNo?: number;
    public anaKod?: number;
    public anneAdi?: string;
    public babaAdi?: string;
    public belediyeKod: number;
    public bireySiraNo?: number;
    public bosanmaTarihi?: string;
    public ciltNo?: number;
    public cinsiyeti?: string;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public dogumTarihi?: string;
    public dogumYeri?: string;
    public dogumYerKod?: number;
    public durumBilgisi?: string;
    public evlenmeTarihi?: string;
    public hata?: string;
    public ip?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public medeniDurumu?: string;
    public nufusIl?: string;
    public nufusIlce?: string;
    public nufusKoy?: string;
    public olumTarihi?: string;
    public soyadi?: string;
    public tckn: number;
    public tescilTarihi?: string;
    public tur?: string;
    public yakinlikDurum?: string;
    public kpsAdress?: GenKpsAdres;

    public constructor(init?: Partial<GenKpsKisiAileDto>) { (Object as any).assign(this, init); }
}

export class GenKpsKisiAileFromKpsDto extends BaseResponse
{
    public anaKod?: number;
    public genKpsKisiKendisi: GenKpsKisiAileDto;
    public genKpsKisiAileListesi: GenKpsKisiAileDto[];

    public constructor(init?: Partial<GenKpsKisiAileFromKpsDto>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsVedop extends CommonEntityBase
{
    public acilisTarih?: string;
    public adi?: string;
    public babaAdi?: string;
    public belediyeKod: number;
    public degisKullaniciKod?: number;
    public degisTarih?: string;
    public faalTerk?: string;
    public hata?: string;
    public ikametCaddeSokakAd?: string;
    public ikametDaireNo?: string;
    public ikametIlceAd?: string;
    public ikametIlKod?: string;
    public ikametKapiNo?: string;
    public ikametMahalleAd?: string;
    public ip?: string;
    public isCaddeSokakAd?: string;
    public isDaireNo?: string;
    public isIlceAd?: string;
    public isIlKod?: string;
    public isKapiNo?: string;
    public isMahalleAd?: string;
    public kapanisTarih?: string;
    public kayitKullaniciKod: number;
    public kayitTarih: string;
    public kod: number;
    public kullaniciTckn?: number;
    public meslekAd?: string;
    public meslekKod?: string;
    public sirketTuru?: string;
    public soyadi?: string;
    public tcknVergiNo: number;
    public tur: string;
    public vergiDaire?: string;
    public vergiDaireKod?: string;
    public vergiNo?: string;

    public constructor(init?: Partial<GenKpsVedop>) { super(init); (Object as any).assign(this, init); }
}

export class PersonData
{
    public tc?: number;
    public ad: string;
    public soyad: string;
    public cinsiyet: string;
    public dogumYeri: string;
    public dogumYerKod?: number;
    public dogumTarihi: string;
    public olumTarihi: string;
    public medeniDurumu: string;
    public medeniDurumKod?: number;
    public nufusIl: string;
    public nufusIlce: string;
    public nufusIlceKod?: number;
    public mahalleKoy: string;
    public aileSiraNo?: number;
    public bireySiraNo?: number;
    public cilt?: number;
    public anneAdi: string;
    public babaAdi: string;
    public hata: string;
    public yakınlık: string;
    public durumBilgisi: string;
    public bosanmaTarihi: string;
    public evlenmeTarihi: string;
    public tescilTarihi: string;
    public dogumYeriIlceKod: string;
    public dogumYeriIlceAciklama: string;
    public nufusKayitIlceKod: string;
    public nufusKayitIlceAciklama: string;
    public verildigiNufusIdareIlceKod: string;
    public verildigiNufusIdareIlceAciklama: string;
    public cuzdanSeriNo: string;
    public cuzdanNo: string;
    public cuzdanVerilisTarih: string;
    public cuzdanKayitNo: string;

    public constructor(init?: Partial<PersonData>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export interface IBaseCursorDto
{
}

export class CmyGenel_SpBirimDagilim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpBirimDagilim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpCagriDetayKaydet_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<CmyGenel_SpCagriDetayKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpSevkBirimler_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpSevkBirimler_Response>) { super(init); (Object as any).assign(this, init); }
}

export class FnIntResponse extends BaseResponse
{
    public fnResult: number;

    public constructor(init?: Partial<FnIntResponse>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpSokakBasvuruBirim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpSokakBasvuruBirim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpSokakBasvuruDagilim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpSokakBasvuruDagilim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpMahalleDagilim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpMahalleDagilim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpTcknKisiKontrol_Response extends BaseResponse
{
    public piTckn: number;
    public poKisiKod: number;
    public poKisiAd: string;
    public poKisiSoyad: string;
    public poKisiMahalleCaddeKod: number;
    public poKisiCaddeSokakAd: string;
    public poKisiKapiNo: number;
    public poKisiKapiNo1: string;
    public poKisiDaireNo: string;
    public poKisiSiteApartmanAd: string;
    public poKisiBlokNo: string;
    public poKisiBolumKod: number;
    public poKisiBinaKod: number;
    public poGsmAlanKod: number;
    public poGsmTelefon: string;
    public poEMail: string;

    public constructor(init?: Partial<CmyGenel_SpTcknKisiKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpMahalleDagilimBirim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpMahalleDagilimBirim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpBirimPersonelListe_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpBirimPersonelListe_Response>) { super(init); (Object as any).assign(this, init); }
}

export class CmyGenel_SpKonuDagilim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<CmyGenel_SpKonuDagilim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Aks_SpAdresKontrol_Response extends BaseResponse
{

    public constructor(init?: Partial<Aks_SpAdresKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Aks_SpArsivOlustur_Response extends BaseResponse
{

    public constructor(init?: Partial<Aks_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Aks_SpKapiKontrol_Response extends BaseResponse
{

    public constructor(init?: Partial<Aks_SpKapiKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakip_SpArsivOlustur_Response extends BaseResponse
{

    public constructor(init?: Partial<GysTakip_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakip_SpOdemeEmriHazirla_Response extends BaseResponse
{
  public pHata: string;
  public islemKod: string;

  public constructor(init?: Partial<GysTakip_SpOdemeEmriHazirla_Response>) { super(init); (Object as any).assign(this, init); }
}


export class GysTakip_SpOdemeTakipIsle_Response extends BaseResponse
{

    public constructor(init?: Partial<GysTakip_SpOdemeTakipIsle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakip_SpOdemeTakipIsleDkl_Response extends BaseResponse
{

    public constructor(init?: Partial<GysTakip_SpOdemeTakipIsleDkl_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTakip_SpTakipTebligGetir_Response extends BaseResponse
{

    public constructor(init?: Partial<GysTakip_SpTakipTebligGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpHizmetSureAl_Response extends BaseResponse
{
    public poHizmetYil: number;
    public poHizmetAy: number;
    public poHizmetGun: number;

    public constructor(init?: Partial<IkaGenel_SpHizmetSureAl_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIzinDurum2_Response extends BaseResponse
{
    public poDurum: BaseCursorDto[];

    public constructor(init?: Partial<IkaGenel_SpIzinDurum2_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpArsivOlustur_Response extends BaseResponse
{
    public poArsivKod: number;

    public constructor(init?: Partial<IkaGenel_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIlkSonPersonel_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<IkaGenel_SpIlkSonPersonel_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIzinKontrol_Response extends BaseResponse
{
    public poSure: number;
    public poIseBaslamaTarih: string;

    public constructor(init?: Partial<IkaGenel_SpIzinKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpMailSmsAl_Response extends BaseResponse
{
    public poMail: string;
    public poGsmTel: string;

    public constructor(init?: Partial<IkaGenel_SpMailSmsAl_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIkaIzinImza_Response extends BaseResponse
{
    public poBelgeKod: number;
    public poDosyaAdi: string;
    public poImzaDysId: string;
    public poRaporAd: string;

    public constructor(init?: Partial<IkaGenel_SpIkaIzinImza_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIzinDurum1_Response extends BaseResponse
{
    public poDurum: BaseCursorDto[];

    public constructor(init?: Partial<IkaGenel_SpIzinDurum1_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIzinDurum_Response extends BaseResponse
{
    public poIzinDurum: Object;

    public constructor(init?: Partial<IkaGenel_SpIzinDurum_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaGenel_SpIzinSure_Response extends BaseResponse
{
    public poIzinSure: number;
    public poKullanilan: number;

    public constructor(init?: Partial<IkaGenel_SpIzinSure_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IrsGenel_SpArsivOlustur_Response extends BaseResponse
{
    public poArsivKod: number;

    public constructor(init?: Partial<IrsGenel_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IrsGenel_SpCiltSayfa_Response extends BaseResponse
{
    public poCiltNo: number;
    public poSayfaNo: number;

    public constructor(init?: Partial<IrsGenel_SpCiltSayfa_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsButon_SpYakMaliyetOlustur_Response extends BaseResponse
{

    public constructor(init?: Partial<StsButon_SpYakMaliyetOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTasinirAktar_SpGirisBirimFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemTasinirAktar_SpGirisBirimFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTasinirAktar_SpCikisBirimFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemTasinirAktar_SpCikisBirimFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTasinirAktar_SpTmsCikisSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemTasinirAktar_SpTmsCikisSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTasinirAktar_SpTmsGirisSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemTasinirAktar_SpTmsGirisSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsButon_SpZimmetTerkinYap_Response extends BaseResponse
{
    public poTerkinKod: number;

    public constructor(init?: Partial<TmsButon_SpZimmetTerkinYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsButon_SpTopluTerkinImhaSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TmsButon_SpTopluTerkinImhaSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsButon_SpTopluZimmetYap_Response extends BaseResponse
{
    public poZimmetKod: number;

    public constructor(init?: Partial<TmsButon_SpTopluZimmetYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsButon_SpDemirbasSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TmsButon_SpDemirbasSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpAlthesapVarmi_Response extends BaseResponse
{
    public poSonuc: number;

    public constructor(init?: Partial<TemGenel_SpAlthesapVarmi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpBankaAlacakSorgulaToplu_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemGenel_SpBankaAlacakSorgulaToplu_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpImzaYetkiliGetir_Response extends BaseResponse
{
    public poDuzenleyenKod: number;
    public poMaliKontrolKod: number;
    public poHarcamaYetkilisiKod: number;
    public poOnaylayanMemurKod: number;
    public poOnaylayanSefKod: number;
    public poOnaylayanYetkiliKod: number;
    public poVezneYetkiliKod: number;
    public poMuhasebeYetkilisiKod: number;

    public constructor(init?: Partial<TemGenel_SpImzaYetkiliGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpDogrudanTeminKontrol_Response extends BaseResponse
{
    public poOdenekTutar: number;
    public poHarcamaTutar: number;

    public constructor(init?: Partial<TemGenel_SpDogrudanTeminKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpFisOlusturToplu_Response extends BaseResponse
{
    public piFisNo: number;
    public piFisNo1: number;
    public poFisKod: number;

    public constructor(init?: Partial<TemGenel_SpFisOlusturToplu_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpBelgeNoUret_Response extends BaseResponse
{
    public poBelgeNo: number;
    public poBelgeNo1: number;
    public poBelgeNo2: number;

    public constructor(init?: Partial<TemGenel_SpBelgeNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpDefterNoUret_Response extends BaseResponse
{
    public poDefterNo: number;

    public constructor(init?: Partial<TemGenel_SpDefterNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemGenel_SpFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGenel_SpImzaYetkiliDoldur_Response extends BaseResponse
{
    public poSonuc: TemImzaYetkiDto[];

    public constructor(init?: Partial<TemGenel_SpImzaYetkiliDoldur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemHuzurAktar_SpMksOdemeBelgeSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemHuzurAktar_SpMksOdemeBelgeSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemHuzurAktar_SpBirimFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemHuzurAktar_SpBirimFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public poIslemKod: string;

    public constructor(init?: Partial<TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemIsciAktar_SpBirimFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemIsciAktar_SpBirimFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemMahsupAktar_SpMahsupSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemMahsupAktar_SpMahsupSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemMahsupAktar_SpFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemMahsupAktar_SpFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemMemurAktar_SpBirimFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemMemurAktar_SpBirimFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSatinAktar_SpOdemeBelgeSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemSatinAktar_SpOdemeBelgeSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSatinAktar_SpBirimFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemSatinAktar_SpBirimFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpMizan_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpMizan_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpMuhasebeYetkilisi_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpMuhasebeYetkilisi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpGelirButcesi_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpGelirButcesi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpTasinirKesinCetvel_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpTasinirKesinCetvel_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpTasinirKesinIcmal_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpTasinirKesinIcmal_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpAlinanCeklerSayim_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpAlinanCeklerSayim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpTemMekSayim_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpTemMekSayim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpBilanco_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpBilanco_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpButceGelirEkonoomik_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpButceGelirEkonoomik_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpButceGiderOdenek_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpButceGiderOdenek_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpBankaHesaplari_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpBankaHesaplari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpFaaliyetSonuclari_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpFaaliyetSonuclari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpKasaSayimTutanagi_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpKasaSayimTutanagi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpBankaSayimTutanagi_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpBankaSayimTutanagi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpBirlestirilmisVeriDefteri_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpBirlestirilmisVeriDefteri_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemSayistay_SpGiderButcesi_Response extends TemSayistay_Dosya_Response
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<TemSayistay_SpGiderButcesi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTahakAktar_SpTahakGiderGelir_Response extends BaseResponse
{
    public poGiderTutar: number;
    public poTahakTutar: number;

    public constructor(init?: Partial<TemTahakAktar_SpTahakGiderGelir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTahakAktar_SpTahakSorgula_Response extends BaseResponse
{
    public poToplamTahak: number;
    public poIslemKod: string;

    public constructor(init?: Partial<TemTahakAktar_SpTahakSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTahakAktar_SpTerkinSorgula_Response extends BaseResponse
{
    public poToplamTahak: number;
    public poIslemKod: string;

    public constructor(init?: Partial<TemTahakAktar_SpTerkinSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTahsilAktar_SpTahsilSorgula_Response extends BaseResponse
{
    public poToplamTahsilat: number;
    public poIslemKod: string;

    public constructor(init?: Partial<TemTahsilAktar_SpTahsilSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTahsilAktar_SpTahsilKontrol_Response extends BaseResponse
{
    public poToplamTahsilat: number;

    public constructor(init?: Partial<TemTahsilAktar_SpTahsilKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTahsilAktar_SpFisOlustur_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemTahsilAktar_SpFisOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaksitAktar_SpTaksitSorgula_Response extends BaseResponse
{
    public poToplamTahak: number;
    public poIslemKod: string;

    public constructor(init?: Partial<TemTaksitAktar_SpTaksitSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemTaksitAktar_SpTerkinSorgula_Response extends BaseResponse
{
    public poToplamTahak: number;
    public poIslemKod: string;

    public constructor(init?: Partial<TemTaksitAktar_SpTerkinSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GasGenel_SpGasParametreSorgula_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<GasGenel_SpGasParametreSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_GysTahsilat_Response extends BaseResponse
{
    public adresAciklama: string;
    public gysBeyan: GysBeyan;
    public ilkYil: number;
    public sonYil: number;
    public telefonResponse: string[];
    public tahsilTur: number;
    public tahsilTarih: string;
    public aciklama: string;

    public constructor(init?: Partial<GysGUI_GysTahsilat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysOrtak_SpTahakkuk_Response extends BaseResponse
{
  public poIslemYapildiEh: string;
  public poIslemKod: string;
  public poRaporAdi: string;
  public poCezaRaporAdi: string;
  public poTerkinRaporAdi: string;
  public poAnaTahakkukKod?: number;
  public poAnaTerkinKod?: number;
  public poCezaTahakkukKod?: number;

  public constructor(init?: Partial<GysOrtak_SpTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_TaksitYapilandirTaksit_Response extends BaseResponse
{
    public anaPara?: number;
    public yiufeGelir?: number;
    public katSayiGelir?: number;
    public islemKod: string;

    public constructor(init?: Partial<GysGUI_TaksitYapilandirTaksit_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_TaksitIptalIsleTamam_Response extends BaseResponse
{
    public kodList: number[];

    public constructor(init?: Partial<GysGUI_TaksitIptalIsleTamam_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_MakbuzDuzelt_Response extends BaseResponse
{
    public gysVezne: GysVezne;

    public constructor(init?: Partial<GysGUI_MakbuzDuzelt_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_IcraHesapla_Response extends BaseResponse
{
    public bakiye: number;

    public constructor(init?: Partial<GysGUI_IcraHesapla_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_TahakkukFisGoster_Response extends BaseResponse
{
    public yevmiyeNo: string;
    public yevmiyeTarih: string;

    public constructor(init?: Partial<GysGUI_TahakkukFisGoster_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpMahalle_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpMahalle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpTcknVergiSorgu_Response extends BaseResponse
{
    public poKisiKod: number;
    public poKisiAdSoyadUnvan: string;
    public poGsmAlanKod: string;
    public poGsmTelefon: string;
    public poEMail: string;

    public constructor(init?: Partial<Gen_SpTcknVergiSorgu_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpVergiTcknKontrol_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpVergiTcknKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpSmsTelKontrol_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpSmsTelKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpIller_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpIller_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpMahalleCaddeKontrol_Response extends BaseResponse
{
    public poMahalleCaddeKod: number;
    public poMahalleKod: number;

    public constructor(init?: Partial<Gen_SpMahalleCaddeKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpCaddeSokak_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpCaddeSokak_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpRaporUrl_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpRaporUrl_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpIlceler_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpIlceler_Response>) { super(init); (Object as any).assign(this, init); }
}

export class Gen_SpLockSession_Response extends BaseResponse
{
    public pSonuc: BaseCursorDto[];

    public constructor(init?: Partial<Gen_SpLockSession_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpAmbarKontrol_Response extends BaseResponse
{
    public pioKod: number;

    public constructor(init?: Partial<SysGenel_SpAmbarKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpArsivSorgula_Response extends BaseResponse
{
    public poArsivKod: number;
    public poDosyaKod: number;

    public constructor(init?: Partial<SysGenel_SpArsivSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpBasvuruYardimlari_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpBasvuruYardimlari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpDepodakiMalzeme_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpDepodakiMalzeme_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpGorevlerim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpGorevlerim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpYardimMalzemeleri_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpYardimMalzemeleri_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpYardimSonuc_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpYardimSonuc_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSosyalKisiler_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpSosyalKisiler_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpArsivOlustur_Response extends BaseResponse
{
    public poArsivKod: number;

    public constructor(init?: Partial<SysGenel_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpIncelemelerSonuc_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpIncelemelerSonuc_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpIptalBasvurular_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpIptalBasvurular_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSysPanelSekmeSoru_Response extends BaseResponse
{
    public poPanel: BaseCursorDto[];
    public poSekme: BaseCursorDto[];
    public poSoruCevap: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpSysPanelSekmeSoru_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpBasvuruIcelemeleri_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpBasvuruIcelemeleri_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpCikisTeslimEden_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpCikisTeslimEden_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpIncelemeler_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpIncelemeler_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpKisiBilgiSorgula_Response extends BaseResponse
{
    public poBasvuru: number;
    public poAdres: number;
    public poAile: number;

    public constructor(init?: Partial<SysGenel_SpKisiBilgiSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpPlanlanacakRandevular_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpPlanlanacakRandevular_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpPlanlanacakYardimlar_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpPlanlanacakYardimlar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSysPanelSekmeSorgula_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpSysPanelSekmeSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpIadeBasvurular_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpIadeBasvurular_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpIncelemelerSonucIptal_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpIncelemelerSonucIptal_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpMahalleDagilim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpMahalleDagilim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpNakitYardimListesi_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpNakitYardimListesi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSokakYardimDagilim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpSokakYardimDagilim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSysPanelSorgula_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpSysPanelSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpYardimPeriyod_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpYardimPeriyod_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpAktifAdresSorgula_Response extends BaseResponse
{
    public poAdresKod: number;

    public constructor(init?: Partial<SysGenel_SpAktifAdresSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSysKisiKontrol_Response extends BaseResponse
{
    public poDonenDeger: number;
    public poDonenAciklama: string;

    public constructor(init?: Partial<SysGenel_SpSysKisiKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpYardimMalzeme_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpYardimMalzeme_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpAktifAmbarlarGetir_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpAktifAmbarlarGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpAmbarMalzemeCikis_Response extends BaseResponse
{
    public piMasterKod: number;

    public constructor(init?: Partial<SysGenel_SpAmbarMalzemeCikis_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpEkipIsyuku_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpEkipIsyuku_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpKullaniciAmbarlari_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpKullaniciAmbarlari_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpSysPanelSekmeSoruTum_Response extends BaseResponse
{
    public poPanel: BaseCursorDto[];
    public poSekme: BaseCursorDto[];
    public poSoruCevap: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpSysPanelSekmeSoruTum_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpGorevAta_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpGorevAta_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysGenel_SpMalzeler_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];

    public constructor(init?: Partial<SysGenel_SpMalzeler_Response>) { super(init); (Object as any).assign(this, init); }
}

export class DabIdUserChangePassword_Response extends BaseResponse
{

    public constructor(init?: Partial<DabIdUserChangePassword_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_TeklifGetir_Response extends BaseResponse
{
    public fileBytes: string;
    public mime: string;

    public constructor(init?: Partial<ExcelGUI_TeklifGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_IhaleGet_Response extends BaseResponse
{
  public fileBytes: string;
  public mime: string;

  public constructor(init?: Partial<ExcelGUI_IhaleGet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtv_SpCtvTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysCtv_SpCtvTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtv_SpCtvCezaTmp_Response extends BaseResponse
{
    public pioCezaKontrol: number;

    public constructor(init?: Partial<GysCtv_SpCtvCezaTmp_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtv_SpCtvTarifeBul_Response extends BaseResponse
{
    public poCtvGrup: number;
    public poCtvDerece: number;

    public constructor(init?: Partial<GysCtv_SpCtvTarifeBul_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtv_SpCtvTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysCtv_SpCtvTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysCtv_SpCtvIhbar_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysCtv_SpCtvIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEgl_SpEglCezaTmp_Response extends BaseResponse
{
    public pioCezaKontrol: number;

    public constructor(init?: Partial<GysEgl_SpEglCezaTmp_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEgl_SpEglIhbar_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEgl_SpEglIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEgl_SpEglTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEgl_SpEglTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEgl_SpEglTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEgl_SpEglTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEka_SpEkaCezaTmp_Response extends BaseResponse
{
    public pioCezaKontrol: number;

    public constructor(init?: Partial<GysEka_SpEkaCezaTmp_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEka_SpEkaTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEka_SpEkaTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEka_SpEkaIhbar_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEka_SpEkaIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEka_SpEkaTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEka_SpEkaTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEka_SpEkaTarifeBul_Response extends BaseResponse
{
    public poEkaGrup: number;
    public poEkaDerece: number;

    public constructor(init?: Partial<GysEka_SpEkaTarifeBul_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakCezaTmp_Response extends BaseResponse
{
    public pioCezaKontrol: number;

    public constructor(init?: Partial<GysEmlak_SpEmlakCezaTmp_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakIhbar_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;
    public poIslemKod: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakTahakkukYeni_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakTahakkukYeni_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakVergiOran_Response extends BaseResponse
{
    public poEVergiOran: number;
    public poVergiOran: number;

    public constructor(init?: Partial<GysEmlak_SpEmlakVergiOran_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysEmlak_SpEmlakKisitIsle_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakKisitIsle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpGelirKodBul_Response extends BaseResponse
{
    public poGelirKod: number;

    public constructor(init?: Partial<GysGenel_SpGelirKodBul_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpTahakkukSorgula_Response extends BaseResponse
{
    public poTahakkuk: Object;

    public constructor(init?: Partial<GysGenel_SpTahakkukSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpArsivOlustur_Response extends BaseResponse
{
    public poArsivKod: number;

    public constructor(init?: Partial<GysGenel_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpIhbarTahakkukYap_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysGenel_SpIhbarTahakkukYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpDosyaNoUret_Response extends BaseResponse
{
    public poDosyaNo: number;

    public constructor(init?: Partial<GysGenel_SpDosyaNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpTakipNoUret_Response extends BaseResponse
{
    public poTakipNo: number;

    public constructor(init?: Partial<GysGenel_SpTakipNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpTerkinYap_Response extends BaseResponse
{
    public poTerkinAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpTerkinYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpCiltSayfa_Response extends BaseResponse
{
    public poCiltNo: number;
    public poSayfaNo: number;

    public constructor(init?: Partial<GysGenel_SpCiltSayfa_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpGecikme_Response extends BaseResponse
{
    public poBulunanTutar: number;

    public constructor(init?: Partial<GysGenel_SpGecikme_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpCalismaGunBul_Response extends BaseResponse
{
    public piDonenTarih: string;

    public constructor(init?: Partial<GysGenel_SpCalismaGunBul_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpCezaIndirimIsle_Response extends BaseResponse
{
    public poTerkinKod: number;

    public constructor(init?: Partial<GysGenel_SpCezaIndirimIsle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGta_SpGtaIhbar_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysGta_SpGtaIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGta_SpGtaTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysGta_SpGtaTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGta_SpGtaTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysGta_SpGtaTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGta_SpGtaCezaTmp_Response extends BaseResponse
{
    public pioCezaKontrol: number;

    public constructor(init?: Partial<GysGta_SpGtaCezaTmp_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysHkp_SpHkpIndirimKontrol_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysHkp_SpHkpIndirimKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysHkp_SpHkpIhbarTahakkukYap_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysHkp_SpHkpIhbarTahakkukYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlan_SpIlanIhbar_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysIlan_SpIlanIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlan_SpIlanTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysIlan_SpIlanTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlan_SpIlanCezaTmp_Response extends BaseResponse
{
    public pioCezaKontrol: number;

    public constructor(init?: Partial<GysIlan_SpIlanCezaTmp_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysIlan_SpIlanTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<GysIlan_SpIlanTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpBorcSorgula_Response extends BaseResponse
{
    public poBorc: Object;
    public poIslemKod: string;

    public constructor(init?: Partial<GysMahsup_SpBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpBorcSorgulaTutarEsitle_Response extends BaseResponse
{
    public poBorc: Object;
    public poIslemKod: string;

    public constructor(init?: Partial<GysMahsup_SpBorcSorgulaTutarEsitle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpMahsupToplamAl_Response extends BaseResponse
{
    public poBorcToplam: number;
    public poAlacakToplam: number;

    public constructor(init?: Partial<GysMahsup_SpMahsupToplamAl_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpTahakGiderGelir_Response extends BaseResponse
{
    public poGiderTutar: number;
    public poTahakTutar: number;

    public constructor(init?: Partial<GysMahsup_SpTahakGiderGelir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpAlacakSorgula_Response extends BaseResponse
{
    public poAlacak: Object;
    public poIslemKod: string;

    public constructor(init?: Partial<GysMahsup_SpAlacakSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpBorcSorgulaTutar_Response extends BaseResponse
{
    public poBorc: Object;
    public poIslemKod: string;

    public constructor(init?: Partial<GysMahsup_SpBorcSorgulaTutar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpIadeMahsupKaydet_Response extends BaseResponse
{
    public poMahsupKod: number;

    public constructor(init?: Partial<GysMahsup_SpIadeMahsupKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysMahsup_SpTaksitBorcSorgula_Response extends BaseResponse
{
    public poBorc: Object;
    public poIslemKod: string;

    public constructor(init?: Partial<GysMahsup_SpTaksitBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpBorcBordro_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpBorcBordro_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpEkatiatikBeyan_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpEkatiatikBeyan_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpEmlBeyanMuaf_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpEmlBeyanMuaf_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpOdemeEmri_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpOdemeEmri_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpCtvBeyan_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpCtvBeyan_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpIlanBeyan_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpIlanBeyan_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpKisiListe_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpKisiListe_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpBorcSms_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpBorcSms_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpEmlBeyanThk_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpEmlBeyanThk_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysSayistay_SpTahsilatBordro_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poHata: string;

    public constructor(init?: Partial<GysSayistay_SpTahsilatBordro_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilatDetay_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<GysTahsil_SpTahsilatDetay_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilKontrolSatir_Response extends BaseResponse
{
    public poVergi: number;
    public poFaiz: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilKontrolSatir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpKisiDefaultDeger_Response extends BaseResponse
{
    public poBinaSayisi: number;
    public poArsaSayisi: number;
    public poAraziSayisi: number;
    public poCtvSayisi: number;
    public poIrvSayisi: number;
    public poIlkYil: number;
    public poSonYil: number;
    public poIlkVade: string;
    public poSonVade: string;
    public poIcraVar: number;
    public poIcraMesj: string;
    public poTaksitGelecekVar: number;
    public poTaksitGelecekMesaj: string;
    public poTaksitGecmisVar: number;
    public poTaksitGecmisMesaj: string;
    public poIhbarVar: number;
    public poIhbarMesaj: string;
    public poDegerVar1: number;
    public poDegerMesaj1: string;
    public poDegerVar2: number;
    public poDegerMesaj2: string;
    public poDegerVar3: number;
    public poDegerMesaj3: string;
    public poDegerVar4: number;
    public poDegerMesaj4: string;
    public poDegerVar5: number;
    public poDegerMesaj5: string;

    public constructor(init?: Partial<GysTahsil_SpKisiDefaultDeger_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilatTur_Response extends BaseResponse
{
    public poDefTur: number;
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<GysTahsil_SpTahsilatTur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilatYap_Response extends BaseResponse
{
    public poTahsilAnaKodList: string;

    public constructor(init?: Partial<GysTahsil_SpTahsilatYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilSatirKontrol_Response extends BaseResponse
{
    public poVergi: number;
    public poFaiz: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilSatirKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilKontrol_Response extends BaseResponse
{
    public poAdet: number;
    public poGecikmeZamFark: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpVezneTahsilToplam_Response extends BaseResponse
{
    public poMakbuzAdet: number;
    public poToplamTutar: number;

    public constructor(init?: Partial<GysTahsil_SpVezneTahsilToplam_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilatlarim_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<GysTahsil_SpTahsilatlarim_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpMakbuzNoUret_Response extends BaseResponse
{
    public poSeriNo: string;
    public poMakbuzNo: number;

    public constructor(init?: Partial<GysTahsil_SpMakbuzNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpWebTahsilKontrol_Response extends BaseResponse
{
    public poKisiKod: number;
    public poAd: string;
    public poSoyad: string;
    public poBabaAd: string;
    public poUnvani: string;

    public constructor(init?: Partial<GysTahsil_SpWebTahsilKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTahsil_SpTahsilatMasterGetir_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<GysTahsil_SpTahsilatMasterGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksit_SpTaksitBoz_Response extends BaseResponse
{
    public poDonenDeger: number;

    public constructor(init?: Partial<GysTaksit_SpTaksitBoz_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksit_SpTaksitDurumSorgula_Response extends BaseResponse
{
    public poBilgi: string;

    public constructor(init?: Partial<GysTaksit_SpTaksitDurumSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitWeb_SpTaksitWebKaydet_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public poMesajKod: string;
    public poMesaj: string;

    public constructor(init?: Partial<GysTaksitWeb_SpTaksitWebKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysTaksitWeb_SpBorcSorgulaTaksitWeb_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public poMesajKod: string;
    public poMesaj: string;

    public constructor(init?: Partial<GysTaksitWeb_SpBorcSorgulaTaksitWeb_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisi_KpsOlustur_Response extends BaseResponse
{
    public kisiKod?: number;

    public constructor(init?: Partial<GenKisi_KpsOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisi_KpsGuncelle_Response extends BaseResponse
{

    public constructor(init?: Partial<GenKisi_KpsGuncelle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKisi_KpsTopluGuncelle_Response extends BaseResponse
{

    public constructor(init?: Partial<GenKisi_KpsTopluGuncelle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisi_KpsOlustur_Response extends BaseResponse
{
    public sysKisiKod?: number;

    public constructor(init?: Partial<SysKisi_KpsOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisi_KpsGuncelle_Response extends BaseResponse
{

    public constructor(init?: Partial<SysKisi_KpsGuncelle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonel_KpsOlustur_Response extends BaseResponse
{
    public ikaPersonelKod?: number;

    public constructor(init?: Partial<IkaPersonel_KpsOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class IkaPersonel_KpsGuncelle_Response extends BaseResponse
{

    public constructor(init?: Partial<IkaPersonel_KpsGuncelle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsKisiAile_Sorgula_Response extends BaseResponse
{
    public genKpsKisiAileFromKpsDto: GenKpsKisiAileFromKpsDto;

    public constructor(init?: Partial<GenKpsKisiAile_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsVedopSorgula_Sorgula_Response extends BaseResponse
{
    public genKpsVedop: GenKpsVedop;

    public constructor(init?: Partial<GenKpsVedopSorgula_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKpsKisi_Sorgula_Response extends BaseResponse
{
    public personData: PersonData;

    public constructor(init?: Partial<GenKpsKisi_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullanici_DabIdSenkron_Response extends BaseResponse
{

    public constructor(init?: Partial<GenKullanici_DabIdSenkron_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullaniciProfile_ChangePassword_Response extends BaseResponse
{

    public constructor(init?: Partial<GenKullaniciProfile_ChangePassword_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenKullanici_ChangePassword_Response extends BaseResponse
{

    public constructor(init?: Partial<GenKullanici_ChangePassword_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenWebKisi_DabIdSenkron_Response extends BaseResponse
{

    public constructor(init?: Partial<GenWebKisi_DabIdSenkron_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GenDetsisTanim_Senkron_Response extends BaseResponse
{

    public constructor(init?: Partial<GenDetsisTanim_Senkron_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGenel_SpKullaniciKurumGetir_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<StsGenel_SpKullaniciKurumGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGenel_SpArsivOlustur_Response extends BaseResponse
{
    public poArsivKod: number;

    public constructor(init?: Partial<StsGenel_SpArsivOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGenel_SpYakMaliyetOlustur_Response extends BaseResponse
{
    public poIslem: string;

    public constructor(init?: Partial<StsGenel_SpYakMaliyetOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TifCikisIsle_Response extends BaseResponse
{
    public tifGirisKod: number;

    public constructor(init?: Partial<TifCikisIsle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_MuhasebeAktarSorgula_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<StsGUI_MuhasebeAktarSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_Sorgula_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<StsGUI_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_Aktar2_Response extends BaseResponse
{
    public ihaleKod: number;
    public arsivKod: number;
    public birimKod: number;
    public poFisKod: number;

    public constructor(init?: Partial<StsGUI_Aktar2_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_TifCikisForm_Response extends BaseResponse
{

    public constructor(init?: Partial<StsGUI_TifCikisForm_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_StsMuhasebeAktarForm_Response extends BaseResponse
{
    public ihaleKod?: number;
    public arsivKod?: number;
    public birimKod?: number;
    public poFisKod?: number;

    public constructor(init?: Partial<StsGUI_StsMuhasebeAktarForm_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_TifForm_Response extends BaseResponse
{
    public poKontrol: number;
    public piTifGirisKod: number;
    public piTifGirisKodList:[];

    public constructor(init?: Partial<StsGUI_TifForm_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_OtomatikAktarSonra_Response extends BaseResponse
{
    public poDuzenleyenKod: number;
    public poMaliKontrolKod: number;
    public poHarcamaYetkilisiKod: number;
    public poOnaylayanMemurKod: number;
    public poOnaylayanSefKod: number;
    public poOnaylayanYetkiliKod: number;
    public poVezneYetkiliKod: number;
    public poMuhasebeYetkilisiKod: number;
    public aciklama: string;
    public adSoyad: string;
    public kisiBankaSubesi: string;
    public kisiBankaHesapNo: string;
    public kisiIbanNo: string;
    public adres: string;
    public fisIslemKod?: number;

    public constructor(init?: Partial<StsGUI_OtomatikAktarSonra_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemButon_SpBankaAlacakSorgula_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemButon_SpBankaAlacakSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemFisKontrol_PrcImzaYetkiliDoldur_Response extends BaseResponse
{
    public poSonuc: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<TemFisKontrol_PrcImzaYetkiliDoldur_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_Sorgula_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_TahsilAktar_Response extends BaseResponse
{

    public constructor(init?: Partial<TemGUI_TahsilAktar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_FisTopluOnay_Response extends BaseResponse
{
    public birimFisList: TemBirimFis[];

    public constructor(init?: Partial<TemGUI_FisTopluOnay_Response>) { super(init); (Object as any).assign(this, init); }
}

export class BaseRequest
{
    public deviceUUID: string;
    public cmd: string;

    public constructor(init?: Partial<BaseRequest>) { (Object as any).assign(this, init); }
}

export class TemGUI_FisDetayTutarGetir_Response extends BaseResponse
{
    public toplamBorcTutar: number;
    public toplamAlacakTutar: number;

    public constructor(init?: Partial<TemGUI_FisDetayTutarGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_BankaDefterTutarGoster_Response extends BaseResponse
{
    public borcTutar: number;
    public alacakTutar: number;
    public bankaBorcTutar: number;
    public bankaAlacakTutar: number;

    public constructor(init?: Partial<TemGUI_BankaDefterTutarGoster_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_OtomatikDefaultGetir_Response extends BaseResponse
{
  public fisIslemKod: number;
  /** Cedric 21.10: tahsil aktarımı fiş işlem türü (GEN_RAPOR_PARAMETRE.TAHSILAT_FIS_TURU); yoksa null */
  public tahsilFisIslemKod: number;
  public ilktTarih: string;
  public kurumsalKod: string;
  public sonTarih: string;
  public ilkVezne: number;
  public sonVezne: number;
  public ilkMakbuzNo: number;
  public sonMakbuzNo: number;
  public islemTarih: string;

    public constructor(init?: Partial<TemGUI_OtomatikDefaultGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_YeniFisEkle_Response extends BaseResponse
{
    public temFis: TemFis;

    public constructor(init?: Partial<TemGUI_YeniFisEkle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_KisiEkstreRapor_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_KisiEkstreRapor_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_FisTutarGetir_Response extends BaseResponse
{
    public borcTutar?: number;
    public alacakTutar?: number;

    public constructor(init?: Partial<TemGUI_FisTutarGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemYilsonu_SpTem570Kapat_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemYilsonu_SpTem570Kapat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemYilsonu_SpTem600Kapat_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemYilsonu_SpTem600Kapat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemYilsonu_SpTem800Kapat_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemYilsonu_SpTem800Kapat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemYilsonu_SpTem900Kapat_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemYilsonu_SpTem900Kapat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemYilsonu_SpTemTumKapat_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemYilsonu_SpTemTumKapat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemYilsonu_SpTemYilsonuDevir_Response extends BaseResponse
{
    public poFisKod: number;

    public constructor(init?: Partial<TemYilsonu_SpTemYilsonuDevir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTifCikisYap_Response extends BaseResponse
{
    public poTifCikisKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifCikisYap_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpZimmetKontrol_Response extends BaseResponse
{
    public poKontrol: number;

    public constructor(init?: Partial<TmsGenel_SpZimmetKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTutanakNoUret_Response extends BaseResponse
{
    public poTutanakNo: number;

    public constructor(init?: Partial<TmsGenel_SpTutanakNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTifNoUret_Response extends BaseResponse
{
    public poGirisCikisNo: number;

    public constructor(init?: Partial<TmsGenel_SpTifNoUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTifGirisKontrol_Response extends BaseResponse
{
    public poKontrol: number;

    public constructor(init?: Partial<TmsGenel_SpTifGirisKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTifGirisBul_Response extends BaseResponse
{
    public poTifGirisKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifGirisBul_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTifMasterUret_Response extends BaseResponse
{
    public poTifGirisKod: number;
    public poKontrol: number;

    public constructor(init?: Partial<TmsGenel_SpTifMasterUret_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGenel_SpTifSatinAktar_Response extends BaseResponse
{
    public poKontrol: number;

    public constructor(init?: Partial<TmsGenel_SpTifSatinAktar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGUI_Sorgula_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TmsGUI_TasinirFisIslemDoldur_Response extends BaseResponse
{
    public faturaTarih?: string;
    public faturaAciklama?: string;
    public faturaTutari?: number;
    public kisiKod?: number;
    public faturaNo?: string;
    public bankaIbanNo?: string;
    public bankaHesapKod?: string;
    public bankaSubeKod?: string;
    public yetkiliKisiKod: number;

    public constructor(init?: Partial<TmsGUI_TasinirFisIslemDoldur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=13)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBildirimKapat")
export class CmyGenel_SpBildirimKapat_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIslemTarih: string;
    public piSonucTurKod: number;
    public piSonucAciklama: string;
    public piPlanKod: number;
    public piGorusmeTurKod: number;

    public constructor(init?: Partial<CmyGenel_SpBildirimKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBildirimKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimDagilim")
export class CmyGenel_SpBirimDagilim_Request extends BaseRequest_1<CmyGenel_SpBirimDagilim_Response> implements IReturn<CmyGenel_SpBirimDagilim_Response>
{
    public piYil: number;
    public piSonYil: number;
    public piDurum: string;

    public constructor(init?: Partial<CmyGenel_SpBirimDagilim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimDagilim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpBirimDagilim_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimGorevKapat")
export class CmyGenel_SpBirimGorevKapat_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruBirimKod: number;
    public piIslemTarih: string;
    public piSonucTurKod: number;
    public piSonucAciklama: string;
    public piBildirimKapatEh: string;
    public piPlanKod: number;

    public constructor(init?: Partial<CmyGenel_SpBirimGorevKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimGorevKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class Cmy_BirimSmsGonder_Request implements IReturn<BaseResponse>
{
    public basvuruBirimKod: number;
    public mesajIcerigi: string;

    public constructor(init?: Partial<Cmy_BirimSmsGonder_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Cmy_BirimSmsGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimPersonelTemp")
export class CmyGenel_SpBirimPersonelTemp_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimKod: number;
    public piBasvuruKod: number;
    public piBasvuruBirimKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<CmyGenel_SpBirimPersonelTemp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimPersonelTemp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpCagriDetayKaydet")
export class CmyGenel_SpCagriDetayKaydet_Request extends BaseRequest_1<CmyGenel_SpCagriDetayKaydet_Response> implements IReturn<CmyGenel_SpCagriDetayKaydet_Response>
{
    public piIslemType: number;
    public piCagriKod: number;
    public piIslemTuru: string;
    public piCagriTurKod: number;
    public piAgentKod: number;
    public piCagriAciklama: string;
    public piSesKaydiPath: string;
    public piBaslangicTarih: string;
    public piBitisTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisKullaniciKod: number;
    public piColumnList: string;

    public constructor(init?: Partial<CmyGenel_SpCagriDetayKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpCagriDetayKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpCagriDetayKaydet_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpCmyPathAl")
export class CmyGenel_SpCmyPathAl_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<CmyGenel_SpCmyPathAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpCmyPathAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpSevkBirimler")
export class CmyGenel_SpSevkBirimler_Request extends BaseRequest_1<CmyGenel_SpSevkBirimler_Response> implements IReturn<CmyGenel_SpSevkBirimler_Response>
{
    public piBasvuruKod: number;
    public piKonuKod: number;
    public piStartDeger: number;
    public piStopDeger: number;

    public constructor(init?: Partial<CmyGenel_SpSevkBirimler_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpSevkBirimler_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpSevkBirimler_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBasvuruKontrol")
export class CmyGenel_FnBasvuruKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<CmyGenel_FnBasvuruKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBasvuruKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpIbbyYonlendir")
export class CmyGenel_SpIbbyYonlendir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<CmyGenel_SpIbbyYonlendir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpIbbyYonlendir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpKonuBirimYonlendir")
export class CmyGenel_SpKonuBirimYonlendir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<CmyGenel_SpKonuBirimYonlendir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpKonuBirimYonlendir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpSokakBasvuruBirim")
export class CmyGenel_SpSokakBasvuruBirim_Request extends BaseRequest_1<CmyGenel_SpSokakBasvuruBirim_Response> implements IReturn<CmyGenel_SpSokakBasvuruBirim_Response>
{
    public piMahalleKod: number;
    public piYil: number;
    public piSonYil: number;
    public piBirimKod: number;
    public piDurum: string;

    public constructor(init?: Partial<CmyGenel_SpSokakBasvuruBirim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpSokakBasvuruBirim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpSokakBasvuruBirim_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpSokakBasvuruDagilim")
export class CmyGenel_SpSokakBasvuruDagilim_Request extends BaseRequest_1<CmyGenel_SpSokakBasvuruDagilim_Response> implements IReturn<CmyGenel_SpSokakBasvuruDagilim_Response>
{
    public piMahalleKod: number;
    public piYil: number;
    public piSonYil: number;
    public piKonuKod: number;
    public piDurum: string;

    public constructor(init?: Partial<CmyGenel_SpSokakBasvuruDagilim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpSokakBasvuruDagilim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpSokakBasvuruDagilim_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBasvuruPersonelKontrol")
export class CmyGenel_FnBasvuruPersonelKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruKod: number;
    public piBasvuruBirimKod: number;
    public piIsSiraNo: number;

    public constructor(init?: Partial<CmyGenel_FnBasvuruPersonelKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBasvuruPersonelKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBasvuruSorguKontrol")
export class CmyGenel_FnBasvuruSorguKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruKod: number;
    public piSorguTuru: string;

    public constructor(init?: Partial<CmyGenel_FnBasvuruSorguKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBasvuruSorguKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBildirimKapatTum")
export class CmyGenel_SpBildirimKapatTum_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIslemTarih: string;
    public piSonucTurKod: number;
    public piSonucAciklama: string;
    public piPlanKod: number;
    public piGorusmeTurKod: number;

    public constructor(init?: Partial<CmyGenel_SpBildirimKapatTum_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBildirimKapatTum_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimDetaySil")
export class CmyGenel_SpBirimDetaySil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: number;

    public constructor(init?: Partial<CmyGenel_SpBirimDetaySil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimDetaySil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBirimSorguKontrol")
export class CmyGenel_FnBirimSorguKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruBirimKod: number;
    public piSorguTuru: string;

    public constructor(init?: Partial<CmyGenel_FnBirimSorguKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBirimSorguKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBirimStatuKontrol")
export class CmyGenel_FnBirimStatuKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruBirimKod: number;

    public constructor(init?: Partial<CmyGenel_FnBirimStatuKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBirimStatuKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnAnketKontrol")
export class CmyGenel_FnAnketKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<CmyGenel_FnAnketKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnAnketKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBasvuruBirimKontrol")
export class CmyGenel_FnBasvuruBirimKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruKod: number;
    public piIsSiraNo: number;

    public constructor(init?: Partial<CmyGenel_FnBasvuruBirimKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBasvuruBirimKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBasvuruStatuKontrol")
export class CmyGenel_FnBasvuruStatuKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<CmyGenel_FnBasvuruStatuKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBasvuruStatuKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpMahalleDagilim")
export class CmyGenel_SpMahalleDagilim_Request extends BaseRequest_1<CmyGenel_SpMahalleDagilim_Response> implements IReturn<CmyGenel_SpMahalleDagilim_Response>
{
    public piYil: number;
    public piSonYil: number;
    public piDurum: string;
    public piKonuKod: number;

    public constructor(init?: Partial<CmyGenel_SpMahalleDagilim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpMahalleDagilim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpMahalleDagilim_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpTcknKisiKontrol")
export class CmyGenel_SpTcknKisiKontrol_Request extends BaseRequest_1<CmyGenel_SpTcknKisiKontrol_Response> implements IReturn<CmyGenel_SpTcknKisiKontrol_Response>
{

    public constructor(init?: Partial<CmyGenel_SpTcknKisiKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpTcknKisiKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpTcknKisiKontrol_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnBirimDetayKontrol")
export class CmyGenel_FnBirimDetayKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruBirimKod: number;

    public constructor(init?: Partial<CmyGenel_FnBirimDetayKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnBirimDetayKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpAnketHazirla")
export class CmyGenel_SpAnketHazirla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<CmyGenel_SpAnketHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpAnketHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBildirimSil")
export class CmyGenel_SpBildirimSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<CmyGenel_SpBildirimSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBildirimSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpKonuBirimTemp")
export class CmyGenel_SpKonuBirimTemp_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKonuKod: number;
    public piBasvuruKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<CmyGenel_SpKonuBirimTemp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpKonuBirimTemp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/FnPersonelSorguKontrol")
export class CmyGenel_FnPersonelSorguKontrol_Request implements IReturn<FnIntResponse>
{
    public piBasvuruBirimDetayKod: number;
    public piSorguTuru: string;

    public constructor(init?: Partial<CmyGenel_FnPersonelSorguKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_FnPersonelSorguKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBasvuruKonuDegistir")
export class CmyGenel_SpBasvuruKonuDegistir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piKonuKod: number;
    public piBirimKod: number;
    public piKonuDegis: string;

    public constructor(init?: Partial<CmyGenel_SpBasvuruKonuDegistir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBasvuruKonuDegistir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimGorevAta")
export class CmyGenel_SpBirimGorevAta_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piBirimler: string;

    public constructor(init?: Partial<CmyGenel_SpBirimGorevAta_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimGorevAta_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpMahalleDagilimBirim")
export class CmyGenel_SpMahalleDagilimBirim_Request extends BaseRequest_1<CmyGenel_SpMahalleDagilimBirim_Response> implements IReturn<CmyGenel_SpMahalleDagilimBirim_Response>
{
    public piYil: number;
    public piSonYil: number;
    public piDurum: string;
    public piBirimKod: number;

    public constructor(init?: Partial<CmyGenel_SpMahalleDagilimBirim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpMahalleDagilimBirim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpMahalleDagilimBirim_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpNobetciEczaneGuncelle")
export class CmyGenel_SpNobetciEczaneGuncelle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<CmyGenel_SpNobetciEczaneGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpNobetciEczaneGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpAnketKaydet")
export class CmyGenel_SpAnketKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<CmyGenel_SpAnketKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpAnketKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimDetayYonlendir")
export class CmyGenel_SpBirimDetayYonlendir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<CmyGenel_SpBirimDetayYonlendir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimDetayYonlendir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimDetayYonlendirNet")
export class CmyGenel_SpBirimDetayYonlendirNet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piBasvuruBirimKod: number;
    public piIsSiraNo: number;
    public piPerKullanici: number;

    public constructor(init?: Partial<CmyGenel_SpBirimDetayYonlendirNet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimDetayYonlendirNet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpBirimPersonelListe")
export class CmyGenel_SpBirimPersonelListe_Request extends BaseRequest_1<CmyGenel_SpBirimPersonelListe_Response> implements IReturn<CmyGenel_SpBirimPersonelListe_Response>
{
    public piBirimKod: number;
    public piBasvuruKod: number;
    public piBasvuruBirimKod: number;

    public constructor(init?: Partial<CmyGenel_SpBirimPersonelListe_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpBirimPersonelListe_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpBirimPersonelListe_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpKonuDagilim")
export class CmyGenel_SpKonuDagilim_Request extends BaseRequest_1<CmyGenel_SpKonuDagilim_Response> implements IReturn<CmyGenel_SpKonuDagilim_Response>
{
    public piYil: number;
    public piSonYil: number;
    public piDurum: string;

    public constructor(init?: Partial<CmyGenel_SpKonuDagilim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpKonuDagilim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CmyGenel_SpKonuDagilim_Response(); }
}

// @Route("/CMY/PgdCmyGenelServis/SpPersonelGorevKapat")
export class CmyGenel_SpPersonelGorevKapat_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruBirimDetayKod: number;
    public piIslemTarih: string;
    public piSonucTurKod: number;
    public piSonucAciklama: string;

    public constructor(init?: Partial<CmyGenel_SpPersonelGorevKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CmyGenel_SpPersonelGorevKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DAK/PgdAksServis/FnBinaBeyanKontrol")
export class Aks_FnBinaBeyanKontrol_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<Aks_FnBinaBeyanKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Aks_FnBinaBeyanKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DAK/PgdAksServis/FnCtvBeyanKontrol")
export class Aks_FnCtvBeyanKontrol_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<Aks_FnCtvBeyanKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Aks_FnCtvBeyanKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DAK/PgdAksServis/SpAdresKontrol")
export class Aks_SpAdresKontrol_Request extends BaseRequest_1<Aks_SpAdresKontrol_Response> implements IReturn<Aks_SpAdresKontrol_Response>
{

    public constructor(init?: Partial<Aks_SpAdresKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Aks_SpAdresKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Aks_SpAdresKontrol_Response(); }
}

// @Route("/DAK/PgdAksServis/SpArsivOlustur")
export class Aks_SpArsivOlustur_Request extends BaseRequest_1<Aks_SpArsivOlustur_Response> implements IReturn<Aks_SpArsivOlustur_Response>
{

    public constructor(init?: Partial<Aks_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Aks_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Aks_SpArsivOlustur_Response(); }
}

// @Route("/DAK/PgdAksServis/SpKapiKontrol")
export class Aks_SpKapiKontrol_Request extends BaseRequest_1<Aks_SpKapiKontrol_Response> implements IReturn<Aks_SpKapiKontrol_Response>
{

    public constructor(init?: Partial<Aks_SpKapiKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Aks_SpKapiKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Aks_SpKapiKontrol_Response(); }
}

// @Route("/DAK/PgdAksServis/SpResimYaz")
export class Aks_SpResimYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<Aks_SpResimYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Aks_SpResimYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/FnTakipGecikmeBul")
export class GysTakip_FnTakipGecikmeBul_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<GysTakip_FnTakipGecikmeBul_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_FnTakipGecikmeBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpArsivOlustur")
export class GysTakip_SpArsivOlustur_Request extends BaseRequest_1<GysTakip_SpArsivOlustur_Response> implements IReturn<GysTakip_SpArsivOlustur_Response>
{

    public constructor(init?: Partial<GysTakip_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTakip_SpArsivOlustur_Response(); }
}

// @Route("/DGY/PgdGysTakipServis/SpHacizIsle")
export class GysTakip_SpHacizIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpHacizIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpHacizIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpHacizSil")
export class GysTakip_SpHacizSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpHacizSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpHacizSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpIcraAktar")
export class GysTakip_SpIcraAktar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

      public piHacizAnaKod:number;
      public piAvukatKod:number

    public constructor(init?: Partial<GysTakip_SpIcraAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpIcraAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpIcraDosyaSil")
export class GysTakip_SpIcraDosyaSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpIcraDosyaSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpIcraDosyaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpIlanTebligIsle")
export class GysTakip_SpIlanTebligIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpIlanTebligIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpIlanTebligIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgdGysTakipServis/SpOdemeEmriHazirla")
export class GysTakip_SpOdemeEmriHazirla_Request extends BaseRequest_1<GysTakip_SpOdemeEmriHazirla_Response> implements IReturn<GysTakip_SpOdemeEmriHazirla_Response>
{
  public pIlkKisi: number;
  public pSonKisi: number;
  public pModuller: number[];
  public pGelirler: number[];
  public pVadeIlk: string;
  public pVadeSon: string;
  public pTutar: number;
  public pTutar1: number;
  public pTutar2: number;
  public pKullaniciKod: number;
  public pDuzenlemeTarih: string;
  public pBelediyeSinir: string;
  public pMahalleKod: number;
  public pIlkYil: number;
  public pIlkDonem: number;
  public pSonYil: number;
  public pSonDonem: number;
  public pTaksitEh: string;
  public pIslemKod: string;

  public constructor(init?: Partial<GysTakip_SpOdemeEmriHazirla_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysTakip_SpOdemeEmriHazirla_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysTakip_SpOdemeEmriHazirla_Response(); }
}

export class GysTakip_SpOdemeEmriIsle_Request extends BaseRequest_1<GysTakip_SpOdemeEmriIsle_Request> implements IReturn<BaseResponse>
{
  public PiKodList: number[];
  public PiDuzenlemeTarih: string;
  public PiIslemKod: string;
  public PiKisiKod: number;


  public constructor(init?: Partial<GysTakip_SpOdemeEmriIsle_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysTakip_SpOdemeEmriIsle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}
// @Route("/DGY/PgdGysTakipServis/SpOdemeTakipIsle")
export class GysTakip_SpOdemeTakipIsle_Request extends BaseRequest_1<GysTakip_SpOdemeTakipIsle_Response> implements IReturn<GysTakip_SpOdemeTakipIsle_Response>
{

    public constructor(init?: Partial<GysTakip_SpOdemeTakipIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpOdemeTakipIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTakip_SpOdemeTakipIsle_Response(); }
}

// @Route("/DGY/PgdGysTakipServis/SpOdemeTakipIsleDkl")
export class GysTakip_SpOdemeTakipIsleDkl_Request extends BaseRequest_1<GysTakip_SpOdemeTakipIsleDkl_Response> implements IReturn<GysTakip_SpOdemeTakipIsleDkl_Response>
{

    public constructor(init?: Partial<GysTakip_SpOdemeTakipIsleDkl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpOdemeTakipIsleDkl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTakip_SpOdemeTakipIsleDkl_Response(); }
}

// @Route("/DGY/PgdGysTakipServis/SpTakipArsivYarat")
export class GysTakip_SpTakipArsivYarat_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpTakipArsivYarat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpTakipArsivYarat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpTakipSatirSil")
export class GysTakip_SpTakipSatirSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpTakipSatirSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpTakipSatirSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpTakipSatirSilKontrol")
export class GysTakip_SpTakipSatirSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpTakipSatirSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpTakipSatirSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpTakipSil")
export class GysTakip_SpTakipSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpTakipSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpTakipSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpTakipSilKontrol")
export class GysTakip_SpTakipSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysTakip_SpTakipSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpTakipSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DGY/PgdGysTakipServis/SpTakipTebligGetir")
export class GysTakip_SpTakipTebligGetir_Request extends BaseRequest_1<GysTakip_SpTakipTebligGetir_Response> implements IReturn<GysTakip_SpTakipTebligGetir_Response>
{

    public constructor(init?: Partial<GysTakip_SpTakipTebligGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTakip_SpTakipTebligGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTakip_SpTakipTebligGetir_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/FnPersonelUnvan")
export class IkaGenel_FnPersonelUnvan_Request implements IReturn<FnIntResponse>
{
    public piPersonelKod: number;
    public piTarih: string;

    public constructor(init?: Partial<IkaGenel_FnPersonelUnvan_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnPersonelUnvan_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIkaIzinSurec")
export class IkaGenel_SpIkaIzinSurec_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIzinKod: number;
    public piBelgeKod: number;
    public piDysId: number;
    public piDosyaAdi: string;
    public piGuncelleme: string;

    public constructor(init?: Partial<IkaGenel_SpIkaIzinSurec_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIkaIzinSurec_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/FnArsivSorgula")
export class IkaGenel_FnArsivSorgula_Request implements IReturn<FnIntResponse>
{
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_FnArsivSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnArsivSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/FnPersonelTuru")
export class IkaGenel_FnPersonelTuru_Request implements IReturn<FnIntResponse>
{
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_FnPersonelTuru_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnPersonelTuru_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpHizmetKaydet")
export class IkaGenel_SpHizmetKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTckn: number;
    public piPersonelKod: number;
    public piBaslamaTarih: string;
    public piBitisTarih: string;
    public piBirimKod: number;
    public piGorevYeri: string;
    public piUnvanKod: number;
    public piHizmetSinif: string;
    public piUcret: number;
    public piYevmiye: number;
    public piKadroDerece: number;
    public piAylikDerece: number;
    public piAylikKademe: number;
    public piAylikEkGosterge: number;
    public piKazanDerece: number;
    public piKazanKademe: number;
    public piKazanEkGosterge: number;
    public piEmekDerece: number;
    public piEmekKademe: number;
    public piEmekEkGosterge: number;
    public piHizmetSebepKod: number;
    public piKurumOnayTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<IkaGenel_SpHizmetKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpHizmetKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpHizmetSureAl")
export class IkaGenel_SpHizmetSureAl_Request extends BaseRequest_1<IkaGenel_SpHizmetSureAl_Response> implements IReturn<IkaGenel_SpHizmetSureAl_Response>
{
    public piPersonelKod: number;
    public piTarih: string;

    public constructor(init?: Partial<IkaGenel_SpHizmetSureAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpHizmetSureAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpHizmetSureAl_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIkaAileKaydet")
export class IkaGenel_SpIkaAileKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piPersonelKod: number;
    public piAnaKod: number;

    public constructor(init?: Partial<IkaGenel_SpIkaAileKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIkaAileKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIzinDurum2")
export class IkaGenel_SpIzinDurum2_Request extends BaseRequest_1<IkaGenel_SpIzinDurum2_Response> implements IReturn<IkaGenel_SpIzinDurum2_Response>
{
    public piPersonelKod: number;
    public piIzinTurKod: number;

    public constructor(init?: Partial<IkaGenel_SpIzinDurum2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIzinDurum2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIzinDurum2_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpArsivOlustur")
export class IkaGenel_SpArsivOlustur_Request extends BaseRequest_1<IkaGenel_SpArsivOlustur_Response> implements IReturn<IkaGenel_SpArsivOlustur_Response>
{
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpArsivOlustur_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpHuzurHesap")
export class IkaGenel_SpHuzurHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_SpHuzurHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpHuzurHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIlkSonPersonel")
export class IkaGenel_SpIlkSonPersonel_Request extends BaseRequest_1<IkaGenel_SpIlkSonPersonel_Response> implements IReturn<IkaGenel_SpIlkSonPersonel_Response>
{
    public piBirimKod: number;

    public constructor(init?: Partial<IkaGenel_SpIlkSonPersonel_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIlkSonPersonel_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIlkSonPersonel_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIzinKontrol")
export class IkaGenel_SpIzinKontrol_Request extends BaseRequest_1<IkaGenel_SpIzinKontrol_Response> implements IReturn<IkaGenel_SpIzinKontrol_Response>
{
    public piPersonelKod: number;
    public piIzinTurKod: number;
    public piIzinYil: number;
    public piBaslangicTarih: string;
    public piBitisTarih: string;

    public constructor(init?: Partial<IkaGenel_SpIzinKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIzinKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIzinKontrol_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpMailSmsAl")
export class IkaGenel_SpMailSmsAl_Request extends BaseRequest_1<IkaGenel_SpMailSmsAl_Response> implements IReturn<IkaGenel_SpMailSmsAl_Response>
{
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_SpMailSmsAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpMailSmsAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpMailSmsAl_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/FnPersonelRol")
export class IkaGenel_FnPersonelRol_Request implements IReturn<FnIntResponse>
{
    public piPersonelKod: number;
    public piRolAd: string;
    public piTarih: string;

    public constructor(init?: Partial<IkaGenel_FnPersonelRol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnPersonelRol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIkaIzinImza")
export class IkaGenel_SpIkaIzinImza_Request extends BaseRequest_1<IkaGenel_SpIkaIzinImza_Response> implements IReturn<IkaGenel_SpIkaIzinImza_Response>
{
    public piIzinKod: number;
    public piGuncelleme: string;

    public constructor(init?: Partial<IkaGenel_SpIkaIzinImza_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIkaIzinImza_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIkaIzinImza_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIzinDurum1")
export class IkaGenel_SpIzinDurum1_Request extends BaseRequest_1<IkaGenel_SpIzinDurum1_Response> implements IReturn<IkaGenel_SpIzinDurum1_Response>
{
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_SpIzinDurum1_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIzinDurum1_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIzinDurum1_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpVergiMatTasi")
export class IkaGenel_SpVergiMatTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piVergiYil: number;

    public constructor(init?: Partial<IkaGenel_SpVergiMatTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpVergiMatTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/FnPersonelTcknGetir")
export class IkaGenel_FnPersonelTcknGetir_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<IkaGenel_FnPersonelTcknGetir_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnPersonelTcknGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpEncumenMaasTasi")
export class IkaGenel_SpEncumenMaasTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piYazDonem: number;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piCalismaGun: number;

    public constructor(init?: Partial<IkaGenel_SpEncumenMaasTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpEncumenMaasTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIzinDurum")
export class IkaGenel_SpIzinDurum_Request extends BaseRequest_1<IkaGenel_SpIzinDurum_Response> implements IReturn<IkaGenel_SpIzinDurum_Response>
{
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_SpIzinDurum_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIzinDurum_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIzinDurum_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIzinIslet")
export class IkaGenel_SpIzinIslet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemKod: string;
    public piPersonelTur: string;
    public piIlkGorevBirimKod: number;
    public piSonGorevBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;

    public constructor(init?: Partial<IkaGenel_SpIzinIslet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIzinIslet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpIzinSure")
export class IkaGenel_SpIzinSure_Request extends BaseRequest_1<IkaGenel_SpIzinSure_Response> implements IReturn<IkaGenel_SpIzinSure_Response>
{
    public piPersonelKod: number;
    public piYil: number;

    public constructor(init?: Partial<IkaGenel_SpIzinSure_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpIzinSure_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaGenel_SpIzinSure_Response(); }
}

// @Route("/IKA/PgIkaGenelServis/SpMeclisMaasTasi")
export class IkaGenel_SpMeclisMaasTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piYazDonem: number;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piCalismaGun: number;
    public piAgiEh: string;

    public constructor(init?: Partial<IkaGenel_SpMeclisMaasTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpMeclisMaasTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/FnPersonelUnvanKod")
export class IkaGenel_FnPersonelUnvanKod_Request implements IReturn<FnIntResponse>
{
    public piPersonelKod: number;
    public piTarih: string;

    public constructor(init?: Partial<IkaGenel_FnPersonelUnvanKod_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnPersonelUnvanKod_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpHuzurMaasSil")
export class IkaGenel_SpHuzurMaasSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piPersonelKod: number;
    public piDonemKod: number;

    public constructor(init?: Partial<IkaGenel_SpHuzurMaasSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpHuzurMaasSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/FnPersonelSorguKontrol")
export class IkaGenel_FnPersonelSorguKontrol_Request implements IReturn<FnIntResponse>
{
    public piPersonelKod: number;
    public piSorguTuru: string;

    public constructor(init?: Partial<IkaGenel_FnPersonelSorguKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_FnPersonelSorguKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/IKA/PgIkaGenelServis/SpStajyerMaasTasi")
export class IkaGenel_SpStajyerMaasTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piYazDonem: number;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piCalismaGun: number;

    public constructor(init?: Partial<IkaGenel_SpStajyerMaasTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGenel_SpStajyerMaasTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpTopluKazancIsle")
export class IkaIscGenel_SpTopluKazancIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piKazancKod: number;
    public piPuan: number;
    public piTutar: number;

    public constructor(init?: Partial<IkaIscGenel_SpTopluKazancIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpTopluKazancIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpMaasDetayYaz")
export class IkaIscGenel_SpMaasDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaIscGenel_SpMaasDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpMaasDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpMaasNetHesap")
export class IkaIscGenel_SpMaasNetHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpMaasNetHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpMaasNetHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpHizliMaasHesap")
export class IkaIscGenel_SpHizliMaasHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piHizliPuantajKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaIscGenel_SpHizliMaasHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpHizliMaasHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpMaasDetayTemp")
export class IkaIscGenel_SpMaasDetayTemp_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaIscGenel_SpMaasDetayTemp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpMaasDetayTemp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class IkaIscGenel_SpHizliMaasTemp_Response extends BaseResponse
{
    public piIslemKod: string;

    public constructor(init?: Partial<IkaIscGenel_SpHizliMaasTemp_Response>) { super(init); (Object as any).assign(this, init); }
}
export class IkaMemGenel_SpHizliMaasTemp_Response extends BaseResponse
{
    public piIslemKod: string;

    public constructor(init?: Partial<IkaMemGenel_SpHizliMaasTemp_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpHizliMaasTemp")
export class IkaIscGenel_SpHizliMaasTemp_Request extends BaseRequest_1<IkaIscGenel_SpHizliMaasTemp_Response> implements IReturn<IkaIscGenel_SpHizliMaasTemp_Response>
{
    public piDonemKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaIscGenel_SpHizliMaasTemp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpHizliMaasTemp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaIscGenel_SpHizliMaasTemp_Response(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpHizliMaasTemp")
export class IkaMemGenel_SpHizliMaasTemp_Request extends BaseRequest_1<IkaMemGenel_SpHizliMaasTemp_Response> implements IReturn<IkaIscGenel_SpHizliMaasTemp_Response>
{
    public piDonemKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaMemGenel_SpHizliMaasTemp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpHizliMaasTemp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaIscGenel_SpHizliMaasTemp_Response(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpKazancBurutHesap")
export class IkaIscGenel_SpKazancBurutHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpKazancBurutHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpKazancBurutHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpKesintiBurutHesap")
export class IkaIscGenel_SpKesintiBurutHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpKesintiBurutHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpKesintiBurutHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpDonemTasi")
export class IkaIscGenel_SpDonemTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<IkaIscGenel_SpDonemTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpDonemTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpTopluKesintiIsle")
export class IkaIscGenel_SpTopluKesintiIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piKesintiKod: number;
    public piPuan: number;
    public piTutar: number;

    public constructor(init?: Partial<IkaIscGenel_SpTopluKesintiIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpTopluKesintiIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpMaasBurutHesap")
export class IkaIscGenel_SpMaasBurutHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpMaasBurutHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpMaasBurutHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpMaasTasi")
export class IkaIscGenel_SpMaasTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimKod: number;
    public piBirimKodList: number[];
    public piOkuDonem: number;
    public piYazDonem: number;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piPersonelTur: number;
    public piSigortaGun: number;
    public piCalismaGun: number;
    public piCalismaHizmetGun: number;
    public piTaseronFirmaKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpMaasTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpMaasTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpMaasSil")
export class IkaIscGenel_SpMaasSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piPersonelKod: number;
    public piDonemKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpMaasSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpMaasSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpYevmiyeIsle")
export class IkaIscGenel_SpYevmiyeIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piArtisYuzde: number;
    public piArtisTutar: number;
    public piKidemTutar: number;
    public piKidemTarih: string;
    public piTabanYevmiye: number;

    public constructor(init?: Partial<IkaIscGenel_SpYevmiyeIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpYevmiyeIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaIscGenelServis/SpEkOdemeTasi")
export class IkaIscGenel_SpEkOdemeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimKod: number;
    public piYazDonem: number;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piPersonelTur: number;
    public piSigortaGun: number;
    public piCalismaGun: number;
    public piMatrah: number;
    public piBirimKodList: number[];
    public piTaseronFirmaKod: number;

    public constructor(init?: Partial<IkaIscGenel_SpEkOdemeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaIscGenel_SpEkOdemeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpMaasDetayYaz")
export class IkaMemGenel_SpMaasDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaMemGenel_SpMaasDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpMaasDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpMaasDetayTemp")
export class IkaMemGenel_SpMaasDetayTemp_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaMemGenel_SpMaasDetayTemp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpMaasDetayTemp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpRaporTasi")
export class IkaMemGenel_SpRaporTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piYil: number;

    public constructor(init?: Partial<IkaMemGenel_SpRaporTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpRaporTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpKazancBurutHesap")
export class IkaMemGenel_SpKazancBurutHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaMemGenel_SpKazancBurutHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpKazancBurutHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpKesintiBurutHesap")
export class IkaMemGenel_SpKesintiBurutHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaMemGenel_SpKesintiBurutHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpKesintiBurutHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpDonemTasi")
export class IkaMemGenel_SpDonemTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<IkaMemGenel_SpDonemTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpDonemTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpMaasBurutHesap")
export class IkaMemGenel_SpMaasBurutHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piPersonelKod: number;

    public constructor(init?: Partial<IkaMemGenel_SpMaasBurutHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpMaasBurutHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpMaasTasi")
export class IkaMemGenel_SpMaasTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimKod: number;
    public piBirimKodList: number[];
    public piOkuDonem: number;
    public piYazDonem: number;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piPersonelTur: number;
    public piCalismaGun: number;
    public piTaseronFirmaKod: number;

    public constructor(init?: Partial<IkaMemGenel_SpMaasTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpMaasTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgIkaMemGenelServis/SpMaasSil")
export class IkaMemGenel_SpMaasSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piPersonelKod: number;
    public piDonemKod: number;

    public constructor(init?: Partial<IkaMemGenel_SpMaasSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpMaasSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DIR/PgdIrsGenelServis/SpArsivOlustur")
export class IrsGenel_SpArsivOlustur_Request extends BaseRequest_1<IrsGenel_SpArsivOlustur_Response> implements IReturn<IrsGenel_SpArsivOlustur_Response>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<IrsGenel_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IrsGenel_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IrsGenel_SpArsivOlustur_Response(); }
}

// @Route("/DIR/PgdIrsGenelServis/SpCiltSayfa")
export class IrsGenel_SpCiltSayfa_Request extends BaseRequest_1<IrsGenel_SpCiltSayfa_Response> implements IReturn<IrsGenel_SpCiltSayfa_Response>
{
    public piIslemTuru: string;
    public piModulKod: number;

    public constructor(init?: Partial<IrsGenel_SpCiltSayfa_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IrsGenel_SpCiltSayfa_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IrsGenel_SpCiltSayfa_Response(); }
}

// @Route("/DIR/PgdIrsGenelServis/SpDevirBasvuru")
export class IrsGenel_SpDevirBasvuru_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piTurKod: number;
    public piDevirTarih: string;
    public piYil: number;
    public piBasvuruNo: number;
    public piKisiKod: number;

    public constructor(init?: Partial<IrsGenel_SpDevirBasvuru_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IrsGenel_SpDevirBasvuru_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DIR/PgdIrsGenelServis/SpOlcumOlustur")
export class IrsGenel_SpOlcumOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<IrsGenel_SpOlcumOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IrsGenel_SpOlcumOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DIR/PgdIrsGenelServis/SpIncelemeBasla")
export class IrsGenel_SpIncelemeBasla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piTurKod: number;

    public constructor(init?: Partial<IrsGenel_SpIncelemeBasla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IrsGenel_SpIncelemeBasla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsButon/SpYakMaliyetOlustur")
export class StsButon_SpYakMaliyetOlustur_Request extends BaseRequest_1<StsButon_SpYakMaliyetOlustur_Response> implements IReturn<StsButon_SpYakMaliyetOlustur_Response>
{

    public constructor(init?: Partial<StsButon_SpYakMaliyetOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsButon_SpYakMaliyetOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsButon_SpYakMaliyetOlustur_Response(); }
}

// @Route("/DST/PgdStsButon/SpKurumsalBirimTasi")
export class StsButon_SpKurumsalBirimTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<StsButon_SpKurumsalBirimTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsButon_SpKurumsalBirimTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsButon/SpMuayeneDetayOlustur")
export class StsButon_SpMuayeneDetayOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<StsButon_SpMuayeneDetayOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsButon_SpMuayeneDetayOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsButon/SpIhaleDetayDuzelt")
export class StsButon_SpIhaleDetayDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<StsButon_SpIhaleDetayDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsButon_SpIhaleDetayDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsButon/SpStsFisYansimaIsle")
export class StsButon_SpStsFisYansimaIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

  public piDonem: number;
  public piIslemKod: string;

    public constructor(init?: Partial<StsButon_SpStsFisYansimaIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsButon_SpStsFisYansimaIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTasinirAktarServis/SpGirisBirimFisOlustur", "POST")
export class TemTasinirAktar_SpGirisBirimFisOlustur_Request extends BaseRequest_1<TemTasinirAktar_SpGirisBirimFisOlustur_Response> implements IReturn<TemTasinirAktar_SpGirisBirimFisOlustur_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemTasinirAktar_SpGirisBirimFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpGirisBirimFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTasinirAktar_SpGirisBirimFisOlustur_Response(); }
}

// @Route("/TEM/PgTemTasinirAktarServis/SpAmortismanHesapla", "POST")
export class TemTasinirAktar_SpAmortismanHesapla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemKod: string;
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTasinirAktar_SpAmortismanHesapla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpAmortismanHesapla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTasinirAktarServis/SpCikisBirimFisOlustur", "POST")
export class TemTasinirAktar_SpCikisBirimFisOlustur_Request extends BaseRequest_1<TemTasinirAktar_SpCikisBirimFisOlustur_Response> implements IReturn<TemTasinirAktar_SpCikisBirimFisOlustur_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemTasinirAktar_SpCikisBirimFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpCikisBirimFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTasinirAktar_SpCikisBirimFisOlustur_Response(); }
}

// DKM-4163: taşınır otomatik muhasebe aktarımında "Muhasebe fişine" (yevmiyeli) seçeneği — servisteki DTO'ların karşılığı
export class TemTasinirAktar_SpCikisYevmiyeOlustur_Response extends BaseResponse
{
    public poFisKod: number;
    public poFisNo: number;

    public constructor(init?: Partial<TemTasinirAktar_SpCikisYevmiyeOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemTasinirAktarServis/SpCikisYevmiyeOlustur")
export class TemTasinirAktar_SpCikisYevmiyeOlustur_Request extends BaseRequest_1<TemTasinirAktar_SpCikisYevmiyeOlustur_Response> implements IReturn<TemTasinirAktar_SpCikisYevmiyeOlustur_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemTasinirAktar_SpCikisYevmiyeOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpCikisYevmiyeOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTasinirAktar_SpCikisYevmiyeOlustur_Response(); }
}

export class TemTasinirAktar_SpGirisYevmiyeOlustur_Response extends BaseResponse
{
    public poFisKod: number;
    public poFisNo: number;

    public constructor(init?: Partial<TemTasinirAktar_SpGirisYevmiyeOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemTasinirAktarServis/SpGirisYevmiyeOlustur")
export class TemTasinirAktar_SpGirisYevmiyeOlustur_Request extends BaseRequest_1<TemTasinirAktar_SpGirisYevmiyeOlustur_Response> implements IReturn<TemTasinirAktar_SpGirisYevmiyeOlustur_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemTasinirAktar_SpGirisYevmiyeOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpGirisYevmiyeOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTasinirAktar_SpGirisYevmiyeOlustur_Response(); }
}

// @Route("/TEM/PgTemTasinirAktarServis/SpTmsCikisSorgula", "POST")
export class TemTasinirAktar_SpTmsCikisSorgula_Request extends BaseRequest_1<TemTasinirAktar_SpTmsCikisSorgula_Response> implements IReturn<TemTasinirAktar_SpTmsCikisSorgula_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTasinirAktar_SpTmsCikisSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpTmsCikisSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTasinirAktar_SpTmsCikisSorgula_Response(); }
}

// @Route("/TEM/PgTemTasinirAktarServis/SpTmsGirisSorgula", "POST")
export class TemTasinirAktar_SpTmsGirisSorgula_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTasinirAktar_SpTmsGirisSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpTmsGirisSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTasinirAktarServis/SpTmsGirisSorgula2", "POST")
export class TemTasinirAktar_SpTmsGirisSorgula2_Request extends BaseRequest_1<TemTasinirAktar_SpTmsGirisSorgula_Response> implements IReturn<TemTasinirAktar_SpTmsGirisSorgula_Response>
{
    public piDonem: number;
    public piIslemKod: string;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTasinirAktar_SpTmsGirisSorgula2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTasinirAktar_SpTmsGirisSorgula2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTasinirAktar_SpTmsGirisSorgula_Response(); }
}

// @Route("/DTM/PgdTmsButon/SpTasinirCikisTrnsfrKayit")
export class TmsButon_SpTasinirCikisTrnsfrKayit_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piAmbarCikisAnaKod: number;
    public piAmbarKod: number;
    public piDonem: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TmsButon_SpTasinirCikisTrnsfrKayit_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTasinirCikisTrnsfrKayit_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTM/PgdTmsButon/SpZimmetTerkinYap")
export class TmsButon_SpZimmetTerkinYap_Request extends BaseRequest_1<TmsButon_SpZimmetTerkinYap_Response> implements IReturn<TmsButon_SpZimmetTerkinYap_Response>
{
    public piZimmetTerkinKod: number;
    public piIslemTarih: string;
    public piIslemTuru: string;
    public piTerkinTurKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TmsButon_SpZimmetTerkinYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpZimmetTerkinYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsButon_SpZimmetTerkinYap_Response(); }
}

// @Route("/DTM/PgdTmsButon/SpZimmetYap")
export class TmsButon_SpZimmetYap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piAmbarKod: number;
    public piZimmetAnaKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TmsButon_SpZimmetYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpZimmetYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTM/PgdTmsButon/SpTerkinImhaKayit")
export class TmsButon_SpTerkinImhaKayit_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTerkinImhaAnaKod: number;
    public piAmbarKod: number;
    public piDonem: number;
    public piIslemKod: string;
    public piKodList:[]

    public constructor(init?: Partial<TmsButon_SpTerkinImhaKayit_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTerkinImhaKayit_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTM/PgdTmsButon/SpTifIstekAktar")
export class TmsButon_SpTifIstekAktar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTifCikisKod: number;
    public piIstekFisTarih: string;
    public piIstekFisNo: number;

    public constructor(init?: Partial<TmsButon_SpTifIstekAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTifIstekAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTM/PgdTmsButon/SpTasinirCikisKayit")
export class TmsButon_SpTasinirCikisKayit_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piAmbarCikisAnaKod: number;
    public piAmbarKod: number;
    public piDonem: number;
    public piIslemKod: string;
    public piKodList:[]

    public constructor(init?: Partial<TmsButon_SpTasinirCikisKayit_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTasinirCikisKayit_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTM/PgdTmsButon/SpTopluTerkinImhaSorgula")
export class TmsButon_SpTopluTerkinImhaSorgula_Request extends BaseRequest_1<TmsButon_SpTopluTerkinImhaSorgula_Response> implements IReturn<TmsButon_SpTopluTerkinImhaSorgula_Response>
{
    public piAmbarKod: number;
    public piDonem: number;
    public piTasinirGrup: string;
    public piIlkTasinir: string;
    public piSonTasinir: string;

    public constructor(init?: Partial<TmsButon_SpTopluTerkinImhaSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTopluTerkinImhaSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsButon_SpTopluTerkinImhaSorgula_Response(); }
}

// @Route("/DTM/PgdTmsButon/SpTopluZimmetYap")
export class TmsButon_SpTopluZimmetYap_Request extends BaseRequest_1<TmsButon_SpTopluZimmetYap_Response> implements IReturn<TmsButon_SpTopluZimmetYap_Response>
{
    public piZimmetTerkinKod: number;
    public piIslemTarih: string;
    public piVerilenPersonel: number;
    public piVerilenRolAd: string;

    public constructor(init?: Partial<TmsButon_SpTopluZimmetYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTopluZimmetYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsButon_SpTopluZimmetYap_Response(); }
}

// @Route("/DTM/PgdTmsButon/SpDemirbasSorgula")
export class TmsButon_SpDemirbasSorgula_Request extends BaseRequest_1<TmsButon_SpDemirbasSorgula_Response> implements IReturn<TmsButon_SpDemirbasSorgula_Response>
{
    public piAmbarKod: number;

    public constructor(init?: Partial<TmsButon_SpDemirbasSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpDemirbasSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsButon_SpDemirbasSorgula_Response(); }
}

// @Route("/DTM/PgdTmsButon/SpTasinirCikisSorgula")
export class TmsButon_SpTasinirCikisSorgula_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piAmbarKod: number;
    public piDonem: number;
    public piTasinirGrup: string;
    public piIlkTasinir: string;
    public piSonTasinir: string;

    public constructor(init?: Partial<TmsButon_SpTasinirCikisSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsButon_SpTasinirCikisSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpAlthesapVarmi", "POST")
export class TemGenel_SpAlthesapVarmi_Request extends BaseRequest_1<TemGenel_SpAlthesapVarmi_Response> implements IReturn<TemGenel_SpAlthesapVarmi_Response>
{
    public pDonemKod: number;
    public pHesapKod: string;

    public constructor(init?: Partial<TemGenel_SpAlthesapVarmi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpAlthesapVarmi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpAlthesapVarmi_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBankaAlacakSorgula", "POST")
export class TemGenel_SpBankaAlacakSorgula_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piHesapKod: string;

    public constructor(init?: Partial<TemGenel_SpBankaAlacakSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBankaAlacakSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBankaAlacakSorgulaToplu", "POST")
export class TemGenel_SpBankaAlacakSorgulaToplu_Request extends BaseRequest_1<TemGenel_SpBankaAlacakSorgulaToplu_Response> implements IReturn<TemGenel_SpBankaAlacakSorgulaToplu_Response>
{
    public piDonem: number;
    public piIslemKod: string;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;

    public constructor(init?: Partial<TemGenel_SpBankaAlacakSorgulaToplu_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBankaAlacakSorgulaToplu_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpBankaAlacakSorgulaToplu_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBirimFisOnayRed", "POST")
export class TemGenel_SpBirimFisOnayRed_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod: number;
    public piIslemTuru: string;
    public piSebebi: string;

    public constructor(init?: Partial<TemGenel_SpBirimFisOnayRed_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBirimFisOnayRed_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBirimFisYansimaSil", "POST")
export class TemGenel_SpBirimFisYansimaSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod: number;

    public constructor(init?: Partial<TemGenel_SpBirimFisYansimaSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBirimFisYansimaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisSilKontrol", "POST")
export class TemGenel_SpFisSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFisKod: number;
    public piDonem: number;

    public constructor(init?: Partial<TemGenel_SpFisSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpImzaYetkiliGetir", "POST")
export class TemGenel_SpImzaYetkiliGetir_Request extends BaseRequest_1<TemGenel_SpImzaYetkiliGetir_Response> implements IReturn<TemGenel_SpImzaYetkiliGetir_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;

    public constructor(init?: Partial<TemGenel_SpImzaYetkiliGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpImzaYetkiliGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpImzaYetkiliGetir_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpDogrudanTeminKontrol", "POST")
export class TemGenel_SpDogrudanTeminKontrol_Request extends BaseRequest_1<TemGenel_SpDogrudanTeminKontrol_Response> implements IReturn<TemGenel_SpDogrudanTeminKontrol_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFonksiyonelKod: string;
    public piFinansmanKod: string;
    public piEkoGiderKod: string;
    public piDogrudanTeminTuru: string;

    public constructor(init?: Partial<TemGenel_SpDogrudanTeminKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpDogrudanTeminKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpDogrudanTeminKontrol_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpHesapDuzelt", "POST")
export class TemGenel_SpHesapDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piHesapKod: string;
    public piIslemTuru: number;
    public piDefterKod: number;
    public piHesapBakiyeTuru: string;

    public constructor(init?: Partial<TemGenel_SpHesapDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpHesapDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpHesapIslem", "POST")
export class TemGenel_SpHesapIslem_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piHesapKod: string;
    public piAy: number;
    public piYevmiyeDefter: string;
    public piArtiEksi: string;
    public piBorcTutar: number;
    public piAlacakTutar: number;

    public constructor(init?: Partial<TemGenel_SpHesapIslem_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpHesapIslem_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpHesapIslet", "POST")
export class TemGenel_SpHesapIslet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;

    public constructor(init?: Partial<TemGenel_SpHesapIslet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpHesapIslet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBirimFisDetayYaz", "POST")
export class TemGenel_SpBirimFisDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod: number;
    public piKurumsalKod: string;
    public piHesapKod: string;
    public piDevirButcesiEh: string;
    public piFonksiyonelKod: string;
    public piFinansmanKod: string;
    public piEkonomikKod: string;
    public piAciklama: string;
    public piBorcTutar: number;
    public piAlacakTutar: number;
    public piYatirimKod: string;
    public piDogrudanTeminTuru: string;

    public constructor(init?: Partial<TemGenel_SpBirimFisDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBirimFisDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpEkstreOlustur", "POST")
export class TemGenel_SpEkstreOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemKod: string;
    public piIlkKisiKod: number;
    public piSonKisiKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkTutar: number;
    public piSonTutar: number;
    public piSifirEh: string;
    public piBirimDosyaEh: string;

    public constructor(init?: Partial<TemGenel_SpEkstreOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpEkstreOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisOlusturToplu", "POST")
export class TemGenel_SpFisOlusturToplu_Request extends BaseRequest_1<TemGenel_SpFisOlusturToplu_Response> implements IReturn<TemGenel_SpFisOlusturToplu_Response>
{   public piFisNo:number;
    public piFisNo1:number;
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod?: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod?: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemGenel_SpFisOlusturToplu_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisOlusturToplu_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpFisOlusturToplu_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisYansimaSil", "POST")
export class TemGenel_SpFisYansimaSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;

    public constructor(init?: Partial<TemGenel_SpFisYansimaSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisYansimaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpHesapKontrol", "POST")
export class TemGenel_SpHesapKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piHesapKod: string;

    public constructor(init?: Partial<TemGenel_SpHesapKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpHesapKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBelgeNoUret", "POST")
export class TemGenel_SpBelgeNoUret_Request extends BaseRequest_1<TemGenel_SpBelgeNoUret_Response> implements IReturn<TemGenel_SpBelgeNoUret_Response>
{
    public piIslemTuru: string;
    public piDonem: number;
    public piAltNo: number;

    public constructor(init?: Partial<TemGenel_SpBelgeNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBelgeNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpBelgeNoUret_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBirimFisOnayla", "POST")
export class TemGenel_SpBirimFisOnayla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod?: number;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;

    public constructor(init?: Partial<TemGenel_SpBirimFisOnayla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBirimFisOnayla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpDTeminKodTasi", "POST")
export class TemGenel_SpDTeminKodTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TemGenel_SpDTeminKodTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpDTeminKodTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisTeslimatYaz", "POST")
export class TemGenel_SpFisTeslimatYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;

    public constructor(init?: Partial<TemGenel_SpFisTeslimatYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisTeslimatYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/FnCalismaSet", "POST")
export class TemGenel_FnCalismaSet_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<TemGenel_FnCalismaSet_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_FnCalismaSet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBirimFisSil", "POST")
export class TemGenel_SpBirimFisSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod: number;

    public constructor(init?: Partial<TemGenel_SpBirimFisSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBirimFisSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpDonemTasi", "POST")
export class TemGenel_SpDonemTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TemGenel_SpDonemTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpDonemTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpCalismaYil", "POST")
export class TemGenel_SpCalismaYil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pYil: number;

    public constructor(init?: Partial<TemGenel_SpCalismaYil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpCalismaYil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpDefterNoUret", "POST")
export class TemGenel_SpDefterNoUret_Request extends BaseRequest_1<TemGenel_SpDefterNoUret_Response> implements IReturn<TemGenel_SpDefterNoUret_Response>
{
    public piDonem: number;
    public piHesapKod: string;
    public piBorcTutar: number;
    public piAlacakTutar: number;

    public constructor(init?: Partial<TemGenel_SpDefterNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpDefterNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpDefterNoUret_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisDetayYaz", "POST")
export class TemGenel_SpFisDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piHesapKod: string;
    public piDevirButcesiEh: string;
    public piFonksiyonelKod: string;
    public piFinansmanKod: string;
    public piEkonomikKod: string;
    public piAciklama: string;
    public piBorcTutar: number;
    public piAlacakTutar: number;
    public piYatirimKod: string;
    public piDogrudanTeminTuru: string;

    public constructor(init?: Partial<TemGenel_SpFisDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisSil", "POST")
export class TemGenel_SpFisSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;

    public constructor(init?: Partial<TemGenel_SpFisSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpBankaAlacakIsle", "POST")
export class TemGenel_SpBankaAlacakIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piHesapKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piIslemKod: string;
    public piKisaAciklama: string;
    public piAciklama: string;
    public piOdenenTarih: string;
    public piDetayAktarEh: string;

    public constructor(init?: Partial<TemGenel_SpBankaAlacakIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpBankaAlacakIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisDuzelt", "POST")
export class TemGenel_SpFisDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;

    public constructor(init?: Partial<TemGenel_SpFisDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpHesapTasi", "POST")
export class TemGenel_SpHesapTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TemGenel_SpHesapTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpHesapTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpImzaYetkiTasi", "POST")
export class TemGenel_SpImzaYetkiTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TemGenel_SpImzaYetkiTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpImzaYetkiTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpTahhutKesintiTasi", "POST")
export class TemGenel_SpTahhutKesintiTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TemGenel_SpTahhutKesintiTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTahhutKesintiTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/FnCalismaYil", "POST")
export class TemGenel_FnCalismaYil_Request implements IReturn<FnIntResponse>
{

    public constructor(init?: Partial<TemGenel_FnCalismaYil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_FnCalismaYil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemGenelServis/SpFisOlustur", "POST")
export class TemGenel_SpFisOlustur_Request extends BaseRequest_1<TemGenel_SpFisOlustur_Response> implements IReturn<TemGenel_SpFisOlustur_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod?: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod?: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemGenel_SpFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpFisOlustur_Response(); }
}

// @Route("/TEM/PgdTemGenelServis/SpImzaYetkiliDoldur", "POST")
export class TemGenel_SpImzaYetkiliDoldur_Request extends BaseRequest_1<TemGenel_SpImzaYetkiliDoldur_Response> implements IReturn<TemGenel_SpImzaYetkiliDoldur_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;

    public constructor(init?: Partial<TemGenel_SpImzaYetkiliDoldur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpImzaYetkiliDoldur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpImzaYetkiliDoldur_Response(); }
}

// @Route("/TEM/PgTemHuzurAktarServis/SpFisYansimaIsle", "POST")
export class TemHuzurAktar_SpFisYansimaIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemHuzurAktar_SpFisYansimaIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemHuzurAktar_SpFisYansimaIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemHuzurAktarServis/SpMksOdemeBelgeSorgula", "POST")
export class TemHuzurAktar_SpMksOdemeBelgeSorgula_Request extends BaseRequest_1<TemHuzurAktar_SpMksOdemeBelgeSorgula_Response> implements IReturn<TemHuzurAktar_SpMksOdemeBelgeSorgula_Response>
{
    public piDonem: number;
    public piDonemKod?: number;
    public piBirimKod?: number;
    public piIlkPersonelKod?: number;
    public piSonPersonelKod?: number;
    public piBankaHesapKod: string;
    public piAgiHesapEh: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemHuzurAktar_SpMksOdemeBelgeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemHuzurAktar_SpMksOdemeBelgeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemHuzurAktar_SpMksOdemeBelgeSorgula_Response(); }
}

// @Route("/TEM/PgTemHuzurAktarServis/SpBirimFisOlustur", "POST")
export class TemHuzurAktar_SpBirimFisOlustur_Request extends BaseRequest_1<TemHuzurAktar_SpBirimFisOlustur_Response> implements IReturn<TemHuzurAktar_SpBirimFisOlustur_Response>
{
    public piDonem: number;
    public piDonemKod?: number;
    public piBirimKod?: number;
    public piIlkPersonelKod?: number;
    public piSonPersonelKod?: number;
    public piBankaHesapKod: string;
    public piAgiHesapEh: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod?: number;
    public piKisiKod?: number;
    public piKisiTckn?: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemHuzurAktar_SpBirimFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemHuzurAktar_SpBirimFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemHuzurAktar_SpBirimFisOlustur_Response(); }
}

// @Route("/TEM/PgTemHuzurAktarServis/SpHuzurOdemeBelgeSorgula", "POST")
export class TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Request extends BaseRequest_1<TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Response> implements IReturn<TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Response>
{
    public piDonem: number;
    public piDonemKod?: number;
    public piBirimKod?: number;
    public piIlkPersonelKod?: number;
    public piSonPersonelKod?: number;
    public piBankaHesapKod: string;
    public piAgiHesapEh: string;
    public piAciklama: string;
    public piYansitma: string;

    public constructor(init?: Partial<TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemHuzurAktar_SpHuzurOdemeBelgeSorgula_Response(); }
}

// @Route("/TEM/PgTemIsciAktarServis/SpIscOdemeBelgeSorgula", "POST")
export class TemIsciAktar_SpIscOdemeBelgeSorgula_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piDonemKod?: number;
    public piAktarmaSekli: string;
    public piBirimKod?: number;
    public piIlkPersonelKod?: number;
    public piSonPersonelKod?: number;
    public piBankaHesapKod: string;
    public piAgiHesapEh: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemIsciAktar_SpIscOdemeBelgeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemIsciAktar_SpIscOdemeBelgeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemIsciAktarServis/SpBirimFisOlustur", "POST")
export class TemIsciAktar_SpBirimFisOlustur_Request extends BaseRequest_1<TemIsciAktar_SpBirimFisOlustur_Response> implements IReturn<TemIsciAktar_SpBirimFisOlustur_Response>
{
    public piDonem: number;
    public piDonemKod?: number;
    public piAktarmaSekli: string;
    public piBirimKod?: number;
    public piIlkPersonelKod?: number;
    public piSonPersonelKod?: number;
    public piBankaHesapKod: string;
    public piAgiHesapEh: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod?: number;
    public piKisiKod?: number;
    public piKisiTckn?: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo?: number;
    public piSonDefterNo?: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemIsciAktar_SpBirimFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemIsciAktar_SpBirimFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemIsciAktar_SpBirimFisOlustur_Response(); }
}

// @Route("/TEM/PgTemMahsupAktarServis/SpFisMahsupYaz", "POST")
export class TemMahsupAktar_SpFisMahsupYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;

    public constructor(init?: Partial<TemMahsupAktar_SpFisMahsupYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemMahsupAktar_SpFisMahsupYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemMahsupAktarServis/SpMahsupSorgula", "POST")
export class TemMahsupAktar_SpMahsupSorgula_Request extends BaseRequest_1<TemMahsupAktar_SpMahsupSorgula_Response> implements IReturn<TemMahsupAktar_SpMahsupSorgula_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemMahsupAktar_SpMahsupSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemMahsupAktar_SpMahsupSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemMahsupAktar_SpMahsupSorgula_Response(); }
}

// @Route("/TEM/PgTemMahsupAktarServis/SpFisOlustur", "POST")
export class TemMahsupAktar_SpFisOlustur_Request extends BaseRequest_1<TemMahsupAktar_SpFisOlustur_Response> implements IReturn<TemMahsupAktar_SpFisOlustur_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemMahsupAktar_SpFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemMahsupAktar_SpFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemMahsupAktar_SpFisOlustur_Response(); }
}

// @Route("/TEM/PgTemMemurAktarServis/SpBirimFisOlustur", "POST")
export class TemMemurAktar_SpBirimFisOlustur_Request extends BaseRequest_1<TemMemurAktar_SpBirimFisOlustur_Response> implements IReturn<TemMemurAktar_SpBirimFisOlustur_Response>
{
    public piDonem: number;
    public piDonemKod: number;
    public piAktarmaSekli: string;
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piBankaHesapKod: string;
    public piAgiHesapEh: string;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemMemurAktar_SpBirimFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemMemurAktar_SpBirimFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemMemurAktar_SpBirimFisOlustur_Response(); }
}

// @Route("/TEM/PgTemMemurAktarServis/SpMemOdemeBelgeSorgula", "POST")
export class TemMemurAktar_SpMemOdemeBelgeSorgula_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piDonemKod: number;
    public piAktarmaSekli: string;
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piBankaHesapKod: string;
    public piAvansHesapKod: string;
    public piAvansOran: number;
    public piAgiHesapEh: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemMemurAktar_SpMemOdemeBelgeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemMemurAktar_SpMemOdemeBelgeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemSatinAktarServis/SpOdemeBelgeSorgula", "POST")
export class TemSatinAktar_SpOdemeBelgeSorgula_Request extends BaseRequest_1<TemSatinAktar_SpOdemeBelgeSorgula_Response> implements IReturn<TemSatinAktar_SpOdemeBelgeSorgula_Response>
{
    public piDonem: number;
    public piIhaleDonem: number;
    public piIhaleDosyaNo: number;
    public piMuayeneKod: number;
    public piTeklifKod: number;
    public piIndirKdvHesapKod: string;
    public piTevKdvHesapKod: string;
    public piTevKdvTuru: number;
    public piTevKdvTutar: number;
    public piKes1HesapKod: string;
    public piKes1Oran: number;
    public piKes2HesapKod: string;
    public piKes2Oran: number;
    public piDigerHesapKod: string;
    public piDigerTutar: number;
    public piBankaHesapKod: string;
    public piBelgeTurKod: number;

    public constructor(init?: Partial<TemSatinAktar_SpOdemeBelgeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSatinAktar_SpOdemeBelgeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSatinAktar_SpOdemeBelgeSorgula_Response(); }
}

// @Route("/TEM/PgTemSatinAktarServis/SpBirimFisOlustur", "POST")
export class TemSatinAktar_SpBirimFisOlustur_Request extends BaseRequest_1<TemSatinAktar_SpBirimFisOlustur_Response> implements IReturn<TemSatinAktar_SpBirimFisOlustur_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisTuru: string;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;
    public piMuayeneKod: number;

    public constructor(init?: Partial<TemSatinAktar_SpBirimFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSatinAktar_SpBirimFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSatinAktar_SpBirimFisOlustur_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpMizan", "POST")
export class TemSayistay_SpMizan_Request extends BaseRequest_1<TemSayistay_SpMizan_Response> implements IReturn<TemSayistay_SpMizan_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piDuzenleyen: string;
    public piMuhYetYrd: string;
    public piMuhYetkilisi: string;
    public piKapanis: string;

    public constructor(init?: Partial<TemSayistay_SpMizan_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpMizan_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpMizan_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpMuhasebeYetkilisi", "POST")
export class TemSayistay_SpMuhasebeYetkilisi_Request extends BaseRequest_1<TemSayistay_SpMuhasebeYetkilisi_Response> implements IReturn<TemSayistay_SpMuhasebeYetkilisi_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piMuhYetAdi: string;
    public piMuhYetUnvan: string;
    public piMuhYetEmail: string;

    public constructor(init?: Partial<TemSayistay_SpMuhasebeYetkilisi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpMuhasebeYetkilisi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpMuhasebeYetkilisi_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpGelirButcesi", "POST")
export class TemSayistay_SpGelirButcesi_Request extends BaseRequest_1<TemSayistay_SpGelirButcesi_Response> implements IReturn<TemSayistay_SpGelirButcesi_Response>
{
    public sorguTuru: number;
    public piDonem: number;

    public constructor(init?: Partial<TemSayistay_SpGelirButcesi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpGelirButcesi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpGelirButcesi_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpTasinirKesinCetvel", "POST")
export class TemSayistay_SpTasinirKesinCetvel_Request extends BaseRequest_1<TemSayistay_SpTasinirKesinCetvel_Response> implements IReturn<TemSayistay_SpTasinirKesinCetvel_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piTasinirKonsolideGorev: string;

    public constructor(init?: Partial<TemSayistay_SpTasinirKesinCetvel_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpTasinirKesinCetvel_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpTasinirKesinCetvel_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpTasinirKesinIcmal", "POST")
export class TemSayistay_SpTasinirKesinIcmal_Request extends BaseRequest_1<TemSayistay_SpTasinirKesinIcmal_Response> implements IReturn<TemSayistay_SpTasinirKesinIcmal_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piTasinirKonsolideGorev: string;
    public piUstYonetici: string;

    public constructor(init?: Partial<TemSayistay_SpTasinirKesinIcmal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpTasinirKesinIcmal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpTasinirKesinIcmal_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpAlinanCeklerSayim", "POST")
export class TemSayistay_SpAlinanCeklerSayim_Request extends BaseRequest_1<TemSayistay_SpAlinanCeklerSayim_Response> implements IReturn<TemSayistay_SpAlinanCeklerSayim_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piBaskan: string;
    public piUye1: string;
    public piUye2: string;

    public constructor(init?: Partial<TemSayistay_SpAlinanCeklerSayim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpAlinanCeklerSayim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpAlinanCeklerSayim_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpTemizle", "POST")
export class TemSayistay_SpTemizle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public deger: string;

    public constructor(init?: Partial<TemSayistay_SpTemizle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpTemizle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemSayistay/SpTemMekSayim", "POST")
export class TemSayistay_SpTemMekSayim_Request extends BaseRequest_1<TemSayistay_SpTemMekSayim_Response> implements IReturn<TemSayistay_SpTemMekSayim_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piBaskan: string;
    public piUye1: string;
    public piUye2: string;

    public constructor(init?: Partial<TemSayistay_SpTemMekSayim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpTemMekSayim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpTemMekSayim_Response(); }
}

// @Route("/TEM/PgTemSayistay/HesapToplamiBul", "POST")
export class TemSayistay_HesapToplamiBul_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pDonem: number;
    public pHesapKod: string;
    public deger: string;

    public constructor(init?: Partial<TemSayistay_HesapToplamiBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_HesapToplamiBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemSayistay/SpBilanco", "POST")
export class TemSayistay_SpBilanco_Request extends BaseRequest_1<TemSayistay_SpBilanco_Response> implements IReturn<TemSayistay_SpBilanco_Response>
{
    public sorguTuru: number;
    public piDonem: number;

    public constructor(init?: Partial<TemSayistay_SpBilanco_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpBilanco_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpBilanco_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpButceGelirEkonoomik", "POST")
export class TemSayistay_SpButceGelirEkonoomik_Request extends BaseRequest_1<TemSayistay_SpButceGelirEkonoomik_Response> implements IReturn<TemSayistay_SpButceGelirEkonoomik_Response>
{
    public sorguTuru: number;
    public piDonem: number;

    public constructor(init?: Partial<TemSayistay_SpButceGelirEkonoomik_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpButceGelirEkonoomik_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpButceGelirEkonoomik_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpButceGiderOdenek", "POST")
export class TemSayistay_SpButceGiderOdenek_Request extends BaseRequest_1<TemSayistay_SpButceGiderOdenek_Response> implements IReturn<TemSayistay_SpButceGiderOdenek_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piMuhasebeYetkilisi: string;

    public constructor(init?: Partial<TemSayistay_SpButceGiderOdenek_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpButceGiderOdenek_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpButceGiderOdenek_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpBankaHesaplari", "POST")
export class TemSayistay_SpBankaHesaplari_Request extends BaseRequest_1<TemSayistay_SpBankaHesaplari_Response> implements IReturn<TemSayistay_SpBankaHesaplari_Response>
{
    public sorguTuru: number;
    public piDonem: number;

    public constructor(init?: Partial<TemSayistay_SpBankaHesaplari_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpBankaHesaplari_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpBankaHesaplari_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpFaaliyetSonuclari", "POST")
export class TemSayistay_SpFaaliyetSonuclari_Request extends BaseRequest_1<TemSayistay_SpFaaliyetSonuclari_Response> implements IReturn<TemSayistay_SpFaaliyetSonuclari_Response>
{
    public sorguTuru: number;
    public piDonem: number;

    public constructor(init?: Partial<TemSayistay_SpFaaliyetSonuclari_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpFaaliyetSonuclari_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpFaaliyetSonuclari_Response(); }
}
export class TemGUI_YeniBirimFisEkle_Response extends BaseResponse
{
  public temBirimFis: TemBirimFis;

  public constructor(init?: Partial<TemGUI_YeniBirimFisEkle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_YeniBirimFisEkle_Request extends BaseRequest_1<TemGUI_YeniBirimFisEkle_Response> implements IReturn<TemGUI_YeniBirimFisEkle_Response>
{
  public birimFisKod: number;

  public constructor(init?: Partial<TemGUI_YeniBirimFisEkle_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'TemGUI_YeniBirimFisEkle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new TemGUI_YeniBirimFisEkle_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpKasaSayimTutanagi", "POST")
export class TemSayistay_SpKasaSayimTutanagi_Request extends BaseRequest_1<TemSayistay_SpKasaSayimTutanagi_Response> implements IReturn<TemSayistay_SpKasaSayimTutanagi_Response>
{
    public sorguTuru:number;
    public piDonem: number;
    public piTarih: string;
    public piBaskan: string;
    public piUye1: string;
    public piUye2: string;

    public constructor(init?: Partial<TemSayistay_SpKasaSayimTutanagi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpKasaSayimTutanagi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpKasaSayimTutanagi_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpBankaSayimTutanagi", "POST")
export class TemSayistay_SpBankaSayimTutanagi_Request extends BaseRequest_1<TemSayistay_SpBankaSayimTutanagi_Response> implements IReturn<TemSayistay_SpBankaSayimTutanagi_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piBaskan: string;
    public piUye1: string;
    public piUye2: string;

    public constructor(init?: Partial<TemSayistay_SpBankaSayimTutanagi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpBankaSayimTutanagi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpBankaSayimTutanagi_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpBirlestirilmisVeriDefteri", "POST")
export class TemSayistay_SpBirlestirilmisVeriDefteri_Request extends BaseRequest_1<TemSayistay_SpBirlestirilmisVeriDefteri_Response> implements IReturn<TemSayistay_SpBirlestirilmisVeriDefteri_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piKapanis: string;

    public constructor(init?: Partial<TemSayistay_SpBirlestirilmisVeriDefteri_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpBirlestirilmisVeriDefteri_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpBirlestirilmisVeriDefteri_Response(); }
}

// @Route("/TEM/PgTemSayistay/SpGiderButcesi", "POST")
export class TemSayistay_SpGiderButcesi_Request extends BaseRequest_1<TemSayistay_SpGiderButcesi_Response> implements IReturn<TemSayistay_SpGiderButcesi_Response>
{
    public sorguTuru: number;
    public piDonem: number;

    public constructor(init?: Partial<TemSayistay_SpGiderButcesi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpGiderButcesi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpGiderButcesi_Response(); }
}


// @Route("/DTE/PgdTemSayistay/SpKesinMizan")
export class TemSayistay_SpKesinMizan_Request extends BaseRequest_1<TemSayistay_SpMizan_Response> implements IReturn<TemSayistay_SpMizan_Response>
{
    public sorguTuru: number;
    public piDonem: number;
    public piTarih: string;
    public piDuzenleyen: string;
    public piMuhYetYrd: string;
    public piMuhYetkilisi: string;
    public piDosyaAdi: string;
    public piKapanis: string;

    public constructor(init?: Partial<TemSayistay_SpKesinMizan_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistay_SpKesinMizan_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistay_SpMizan_Response(); }
}

// @Route("/TEM/PgTemTahakAktarServis/SpFisTahakYaz", "POST")
export class TemTahakAktar_SpFisTahakYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;

    public constructor(init?: Partial<TemTahakAktar_SpFisTahakYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahakAktar_SpFisTahakYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTahakAktarServis/SpTahakGiderGelir", "POST")
export class TemTahakAktar_SpTahakGiderGelir_Request extends BaseRequest_1<TemTahakAktar_SpTahakGiderGelir_Response> implements IReturn<TemTahakAktar_SpTahakGiderGelir_Response>
{
    public piTahakkukKod: number;
    public piDonem: number;
    public piVergiFaiz: string;
    public piTutar: number;

    public constructor(init?: Partial<TemTahakAktar_SpTahakGiderGelir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahakAktar_SpTahakGiderGelir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTahakAktar_SpTahakGiderGelir_Response(); }
}

// @Route("/TEM/PgTemTahakAktarServis/SpFisTerkinYaz", "POST")
export class TemTahakAktar_SpFisTerkinYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;

    public constructor(init?: Partial<TemTahakAktar_SpFisTerkinYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahakAktar_SpFisTerkinYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTahakAktarServis/SpTahakSorgula", "POST")
export class TemTahakAktar_SpTahakSorgula_Request extends BaseRequest_1<TemTahakAktar_SpTahakSorgula_Response> implements IReturn<TemTahakAktar_SpTahakSorgula_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTahakAktar_SpTahakSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahakAktar_SpTahakSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTahakAktar_SpTahakSorgula_Response(); }
}

// @Route("/TEM/PgTemTahakAktarServis/SpTerkinSorgula", "POST")
export class TemTahakAktar_SpTerkinSorgula_Request extends BaseRequest_1<TemTahakAktar_SpTerkinSorgula_Response> implements IReturn<TemTahakAktar_SpTerkinSorgula_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTahakAktar_SpTerkinSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahakAktar_SpTerkinSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTahakAktar_SpTerkinSorgula_Response(); }
}

// @Route("/TEM/PgTemTahsilAktarServis/SpTahsilSorgula", "POST")
export class TemTahsilAktar_SpTahsilSorgula_Request extends BaseRequest_1<TemTahsilAktar_SpTahsilSorgula_Response> implements IReturn<TemTahsilAktar_SpTahsilSorgula_Response>
{
    public piDonem: number;
    public piIlkVezne: number;
    public piSonVezne: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkMakbuzNo: number;
    public piSonMakbuzNo: number;
    public piTahsilTurKod: number;
    // DKM-5395: coklu tahsilat turu (bos = tum turler)
    public piTahsilTurKodlari: number[];
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTahsilAktar_SpTahsilSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahsilAktar_SpTahsilSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTahsilAktar_SpTahsilSorgula_Response(); }
}

// @Route("/TEM/PgTemTahsilAktarServis/SpFisTahsilYaz", "POST")
export class TemTahsilAktar_SpFisTahsilYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piIlkVezne: number;
    public piSonVezne: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkMakbuzNo: number;
    public piSonMakbuzNo: number;
    public piTahsilTurKod: number;
    // DKM-5395: coklu tahsilat turu (bos = tum turler)
    public piTahsilTurKodlari: number[];

    public constructor(init?: Partial<TemTahsilAktar_SpFisTahsilYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahsilAktar_SpFisTahsilYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTahsilAktarServis/SpTahsilKontrol", "POST")
export class TemTahsilAktar_SpTahsilKontrol_Request extends BaseRequest_1<TemTahsilAktar_SpTahsilKontrol_Response> implements IReturn<TemTahsilAktar_SpTahsilKontrol_Response>
{
    public piDonem: number;
    public piIlkVezne: number;
    public piSonVezne: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkMakbuzNo: number;
    public piSonMakbuzNo: number;
    public piTahsilTurKod: number;
    // DKM-5395: coklu tahsilat turu (bos = tum turler)
    public piTahsilTurKodlari: number[];

    public constructor(init?: Partial<TemTahsilAktar_SpTahsilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahsilAktar_SpTahsilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTahsilAktar_SpTahsilKontrol_Response(); }
}

// @Route("/TEM/PgTemTahsilAktarServis/SpFisOlustur", "POST")
export class TemTahsilAktar_SpFisOlustur_Request extends BaseRequest_1<TemTahsilAktar_SpFisOlustur_Response> implements IReturn<TemTahsilAktar_SpFisOlustur_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemTahsilAktar_SpFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTahsilAktar_SpFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTahsilAktar_SpFisOlustur_Response(); }
}

// @Route("/TEM/PgTemTaksitAktarServis/SpTaksitSorgula", "POST")
export class TemTaksitAktar_SpTaksitSorgula_Request extends BaseRequest_1<TemTaksitAktar_SpTaksitSorgula_Response> implements IReturn<TemTaksitAktar_SpTaksitSorgula_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTaksitAktar_SpTaksitSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTaksitAktar_SpTaksitSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTaksitAktar_SpTaksitSorgula_Response(); }
}

// @Route("/TEM/PgTemTaksitAktarServis/SpFisTahakYaz", "POST")
export class TemTaksitAktar_SpFisTahakYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;

    public constructor(init?: Partial<TemTaksitAktar_SpFisTahakYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTaksitAktar_SpFisTahakYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTaksitAktarServis/SpFisTerkinYaz", "POST")
export class TemTaksitAktar_SpFisTerkinYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;

    public constructor(init?: Partial<TemTaksitAktar_SpFisTerkinYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTaksitAktar_SpFisTerkinYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgTemTaksitAktarServis/SpTerkinSorgula", "POST")
export class TemTaksitAktar_SpTerkinSorgula_Request extends BaseRequest_1<TemTaksitAktar_SpTerkinSorgula_Response> implements IReturn<TemTaksitAktar_SpTerkinSorgula_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piKurumsalKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<TemTaksitAktar_SpTerkinSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemTaksitAktar_SpTerkinSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemTaksitAktar_SpTerkinSorgula_Response(); }
}

// @Route("/TEB/PgdTebGenelServis/FncEskiKurumsal")
export class TebGenel_FncEskiKurumsal_Request implements IReturn<FnIntResponse>
{
    public pBelediye: number;
    public pDonem: number;
    public pKurumsal: string;
    public pEskiDonem: number;

    public constructor(init?: Partial<TebGenel_FncEskiKurumsal_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_FncEskiKurumsal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGelirUcayTasi")
export class TebGenel_SpGelirUcayTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piYazDonem: number;
    public piOran1: number;
    public piOran2: number;
    public piOran3: number;
    public piOran4: number;
    public piIslemTuru: number;

    public constructor(init?: Partial<TebGenel_SpGelirUcayTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGelirUcayTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGiderButceToplam")
export class TebGenel_SpGiderButceToplam_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pBelediye: number;
    public pYil: number;

    public constructor(init?: Partial<TebGenel_SpGiderButceToplam_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGiderButceToplam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGiderYevmiyeAta")
export class TebGenel_SpGiderYevmiyeAta_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piButceTuru: number;

    public constructor(init?: Partial<TebGenel_SpGiderYevmiyeAta_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGiderYevmiyeAta_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpKullaniciYetkiTasi")
export class TebGenel_SpKullaniciYetkiTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpKullaniciYetkiTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpKullaniciYetkiTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpEkoFinansmanTasi")
export class TebGenel_SpEkoFinansmanTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpEkoFinansmanTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpEkoFinansmanTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpFinansmanButceTasi")
export class TebGenel_SpFinansmanButceTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpFinansmanButceTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpFinansmanButceTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpFinansmanDegerTasi")
export class TebGenel_SpFinansmanDegerTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemTuru: number;

    public constructor(init?: Partial<TebGenel_SpFinansmanDegerTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpFinansmanDegerTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGelirButceToplam")
export class TebGenel_SpGelirButceToplam_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pBelediye: number;
    public pYil: number;

    public constructor(init?: Partial<TebGenel_SpGelirButceToplam_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGelirButceToplam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGelirDegerTasi")
export class TebGenel_SpGelirDegerTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemTuru: number;
    public piDegerTipi: number;
    public piDegerArtis: number;
    public piButceTuru: number;

    public constructor(init?: Partial<TebGenel_SpGelirDegerTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGelirDegerTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGiderDegerTasi")
export class TebGenel_SpGiderDegerTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKurumsalKod: string;
    public piDonem: number;
    public piIslemTuru: number;
    public piDegerTipi: number;
    public piDegerArtis: number;
    public piButceTuru: number;

    public constructor(init?: Partial<TebGenel_SpGiderDegerTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGiderDegerTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGiderUcayTasi")
export class TebGenel_SpGiderUcayTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKurumsalKod: string;
    public piYazDonem: number;
    public piOran1: number;
    public piOran2: number;
    public piOran3: number;
    public piOran4: number;
    public piIslemTuru: number;

    public constructor(init?: Partial<TebGenel_SpGiderUcayTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGiderUcayTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpT1CetvelTasi")
export class TebGenel_SpT1CetvelTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpT1CetvelTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpT1CetvelTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpFonksiyonTasi")
export class TebGenel_SpFonksiyonTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpFonksiyonTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpFonksiyonTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGiderButceTasi")
export class TebGenel_SpGiderButceTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKurumsalKod: string;
    public piOkuDonem: number;
    public piYazDonem: number;
    public piDetayTasiEh: string;

    public constructor(init?: Partial<TebGenel_SpGiderButceTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGiderButceTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpKurumSinifTasi")
export class TebGenel_SpKurumSinifTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpKurumSinifTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpKurumSinifTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/FnKurumKullaniciKontrol")
export class TebGenel_FnKurumKullaniciKontrol_Request implements IReturn<FnIntResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;

    public constructor(init?: Partial<TebGenel_FnKurumKullaniciKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_FnKurumKullaniciKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpEkoGelirTasi")
export class TebGenel_SpEkoGelirTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpEkoGelirTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpEkoGelirTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpFinansmanTasi")
export class TebGenel_SpFinansmanTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpFinansmanTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpFinansmanTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpEkoGiderTasi")
export class TebGenel_SpEkoGiderTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpEkoGiderTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpEkoGiderTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpOdenekCetIslet")
export class TebGenel_SpOdenekCetIslet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pBelediye: number;
    public pYil: number;

    public constructor(init?: Partial<TebGenel_SpOdenekCetIslet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpOdenekCetIslet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpFaaliyetDegerTasi")
export class TebGenel_SpFaaliyetDegerTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKurumsalKod: string;
    public piDonem: number;
    public piIslemTuru: number;

    public constructor(init?: Partial<TebGenel_SpFaaliyetDegerTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpFaaliyetDegerTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpK1CetvelTasi")
export class TebGenel_SpK1CetvelTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpK1CetvelTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpK1CetvelTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpK2CetvelTasi")
export class TebGenel_SpK2CetvelTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpK2CetvelTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpK2CetvelTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpT2CetvelTasi")
export class TebGenel_SpT2CetvelTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TebGenel_SpT2CetvelTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpT2CetvelTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebGenelServis/SpGelirButceTasi")
export class TebGenel_SpGelirButceTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;
    public piDetayTasiEh: string;
    public piButceTuru: number;

    public constructor(init?: Partial<TebGenel_SpGelirButceTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebGenel_SpGelirButceTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebOdenekCetvYilodenek")
export class TebRaporFormul_TebOdenekCetvYilodenek_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piKurumsal: string;
    public piFonksiyonel: string;
    public piEkoGider: string;
    public piGecenYil: string;
    public piFinans: string;

    public constructor(init?: Partial<TebRaporFormul_TebOdenekCetvYilodenek_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebOdenekCetvYilodenek_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebFonkEkoRapToplamIzl")
export class TebRaporFormul_TebFonkEkoRapToplamIzl_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piYil: number;
    public piButceTur: number;
    public piIcmal: string;
    public piKurumsal: string;
    public piTur: number;
    public piFonksiyonel: string;
    public piEkoTip: string;

    public constructor(init?: Partial<TebRaporFormul_TebFonkEkoRapToplamIzl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebFonkEkoRapToplamIzl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebFonkEkoRapToplam")
export class TebRaporFormul_TebFonkEkoRapToplam_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piButceTur: number;
    public piIcmal: string;
    public piKurumsal: string;
    public piTur: number;
    public piFonksiyonel: string;
    public piEkoTip: string;

    public constructor(init?: Partial<TebRaporFormul_TebFonkEkoRapToplam_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebFonkEkoRapToplam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebOdenekCtvOnceki")
export class TebRaporFormul_TebOdenekCtvOnceki_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFonksiyonelKod: string;
    public piFinans: string;
    public piGiderKod: string;

    public constructor(init?: Partial<TebRaporFormul_TebOdenekCtvOnceki_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebOdenekCtvOnceki_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebOdenekCtvOnckYlodenek")
export class TebRaporFormul_TebOdenekCtvOnckYlodenek_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFonksiyonelKod: string;
    public piFinans: string;
    public piGiderKod: string;
    public piGecenyil: string;

    public constructor(init?: Partial<TebRaporFormul_TebOdenekCtvOnckYlodenek_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebOdenekCtvOnckYlodenek_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebOdenekCtvHaziran")
export class TebRaporFormul_TebOdenekCtvHaziran_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFonksiyonelKod: string;
    public piFinans: string;
    public piGiderKod: string;

    public constructor(init?: Partial<TebRaporFormul_TebOdenekCtvHaziran_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebOdenekCtvHaziran_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEB/PgdTebRaporFormul/TebOdenekOncekiHarcama")
export class TebRaporFormul_TebOdenekOncekiHarcama_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFonksiyonelKod: string;
    public piFinans: string;
    public piGiderKod: string;

    public constructor(init?: Partial<TebRaporFormul_TebOdenekOncekiHarcama_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TebRaporFormul_TebOdenekOncekiHarcama_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpKurumArsiv")
export class GasGenel_SpKurumArsiv_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piArsivDosyaKod: number;
    public piDepoKod: number;
    public piBlokKod: number;
    public piRafKod: number;
    public piGozKod: number;
    public piKutuAd: string;
    public piKlasorAd: string;
    public piKutuBarkod: string;
    public piKlasorBarkod: string;
    public piDosyaBarkod: string;
    public piKlasorAdet: number;
    public piSaklamaSure: number;

    public constructor(init?: Partial<GasGenel_SpKurumArsiv_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpKurumArsiv_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/FnBirimKullaniciKontrol")
export class GasGenel_FnBirimKullaniciKontrol_Request implements IReturn<FnIntResponse>
{
    public piBirimKod: number;

    public constructor(init?: Partial<GasGenel_FnBirimKullaniciKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_FnBirimKullaniciKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpBelgeYaz")
export class GasGenel_SpBelgeYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piBelgeAd: string;
    public piBelgeTipKod: number;

    public constructor(init?: Partial<GasGenel_SpBelgeYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpBelgeYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpArsivKaydet")
export class GasGenel_SpArsivKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public tbArsiv: Object;

    public constructor(init?: Partial<GasGenel_SpArsivKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpArsivKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpBelgeTaramaYaz")
export class GasGenel_SpBelgeTaramaYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBelgeKod: number;
    public piBelgeAd: string;
    public piBelgeTipKod: number;

    public constructor(init?: Partial<GasGenel_SpBelgeTaramaYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpBelgeTaramaYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpDosyaTalep")
export class GasGenel_SpDosyaTalep_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piArsivDosyaKod: number;
    public piPersonelKod: number;
    public piBirimKod: number;
    public piTalepTarih: string;
    public piEvrakTarih: string;
    public piEvrakNo: number;
    public piAciklama: string;

    public constructor(init?: Partial<GasGenel_SpDosyaTalep_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpDosyaTalep_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpGasDosyaBelgeUpdate")
export class GasGenel_SpGasDosyaBelgeUpdate_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: number;
    public piDysId: string;
    public piBelgePath: string;
    public piBelgeAd: string;
    public piDegisKullanici: number;

    public constructor(init?: Partial<GasGenel_SpGasDosyaBelgeUpdate_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpGasDosyaBelgeUpdate_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GAS/PgGasGenelServis/FnDosyaTalepKontrol")
export class GasGenel_FnDosyaTalepKontrol_Request implements IReturn<FnIntResponse>
{
    public piTalepKod: number;

    public constructor(init?: Partial<GasGenel_FnDosyaTalepKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_FnDosyaTalepKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpGasParametreSorgula")
export class GasGenel_SpGasParametreSorgula_Request extends BaseRequest_1<GasGenel_SpGasParametreSorgula_Response> implements IReturn<GasGenel_SpGasParametreSorgula_Response>
{

    public constructor(init?: Partial<GasGenel_SpGasParametreSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpGasParametreSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GasGenel_SpGasParametreSorgula_Response(); }
}

// @Route("/GAS/PgGasGenelServis/FnDosyaKontrol")
export class GasGenel_FnDosyaKontrol_Request implements IReturn<FnIntResponse>
{
    public piArsivDosyaKod: number;

    public constructor(init?: Partial<GasGenel_FnDosyaKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_FnDosyaKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GAS/PgGasGenelServis/SpGasPathAl")
export class GasGenel_SpGasPathAl_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDosyaKod: number;

    public constructor(init?: Partial<GasGenel_SpGasPathAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasGenel_SpGasPathAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SetSwagger")
export class GetSwaggerUI
{

    public constructor(init?: Partial<GetSwaggerUI>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSwaggerUI'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/getSwagger")
export class GetOpenApiJson
{

    public constructor(init?: Partial<GetOpenApiJson>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpenApiJson'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

export class GysGUI_GysTahsilat_Request extends BaseRequest_1<GysGUI_GysTahsilat_Response> implements IReturn<GysGUI_GysTahsilat_Response>
{
    public sorguTuru: number;
    public sorguKod: string;
    public vezneKod: number;
    public uygulamaKod: number;
    public taksitNo: number;

    public constructor(init?: Partial<GysGUI_GysTahsilat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_GysTahsilat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_GysTahsilat_Response(); }
}

export class GysEmlak_SpBayindirlikTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
  public piOkuYil: number;
  public piYazYil: number;

  public constructor(init?: Partial<GysEmlak_SpBayindirlikTasi_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysEmlak_SpBayindirlikTasi_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysOrtakServis/SpTahakkuk")
export class GysOrtak_SpTahakkuk_Request extends BaseRequest_1<GysOrtak_SpTahakkuk_Response> implements IReturn<GysOrtak_SpTahakkuk_Response>
{
     public piChkFisBas: string;
    public piKabulTarih: string;
    public piModulKod: number;
    public piBeyanTuru: number;
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIlkYil: number;
    public piSonYil: number;
    public piDonem?: number;
    public piBeyanKodListe: number[];
    public piYillikTahakEh: string;


    public constructor(init?: Partial<GysOrtak_SpTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysOrtak_SpTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysOrtak_SpTahakkuk_Response(); }
}

// @Route("/Gys/Suret", "POST")
export class GysGUI_Suret_Request implements IReturn<BaseResponse>
{
    public belediyeKod: number;
    public yil: number;
    public kisiKod: number;
    public siraNo: number;
    public emlakBeyanTuru: number;

    public constructor(init?: Partial<GysGUI_Suret_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_Suret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/Terkin", "POST")
export class GysGUI_Terkin_Request implements IReturn<BaseResponse>
{
    public modulKod: number;
    public mulkBitisTarih: string;
    public sicilKod: number;
    public ilkSiraNo: number;
    public sonSiraNo: number;
    public emlakBeyanTuru: number;

    public constructor(init?: Partial<GysGUI_Terkin_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_Terkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/TopluTerkin", "POST")
export class GysGUI_TopluTerkin_Request implements IReturn<BaseResponse>
{
    public modulKod: number;
    public mulkBitisTarih: string;
    public sicilKod: number;

    public constructor(init?: Partial<GysGUI_TopluTerkin_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TopluTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/IhbarTahakkuk", "POST")
export class GysGUI_IhbarTahakkuk_Request implements IReturn<BaseResponse>
{
    public gysIhbarAnaKod: number;

    public constructor(init?: Partial<GysGUI_IhbarTahakkuk_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_IhbarTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/TaksitYapilandir", "POST")
export class GysGUI_TaksitYapilandir_Request implements IReturn<BaseResponse>
{
    public gysTaksitAnaKod: number;

    public constructor(init?: Partial<GysGUI_TaksitYapilandir_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TaksitYapilandir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/aksitYapilandirTaksit", "POST")
export class GysGUI_TaksitYapilandirTaksit_Request extends BaseRequest_1<GysGUI_TaksitYapilandirTaksit_Response> implements IReturn<GysGUI_TaksitYapilandirTaksit_Response>
{
    public gysTaksitAnaKod: number;
    public kisiKod: number;

    public constructor(init?: Partial<GysGUI_TaksitYapilandirTaksit_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TaksitYapilandirTaksit_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_TaksitYapilandirTaksit_Response(); }
}

// @Route("/Gys/TaksitYapilandirYap", "POST")
export class GysGUI_TaksitYapilandirYap_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<GysGUI_TaksitYapilandirYap_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TaksitYapilandirYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/TaksitIptalIsleTamam", "POST")
export class GysGUI_TaksitIptalIsleTamam_Request extends BaseRequest_1<GysGUI_TaksitIptalIsleTamam_Response> implements IReturn<GysGUI_TaksitIptalIsleTamam_Response>
{
    public ilkKisiKod: number;
    public sonKisiKod: number;
    public taksitTurKod: number;
    public kontrolTuru: number;

    public constructor(init?: Partial<GysGUI_TaksitIptalIsleTamam_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TaksitIptalIsleTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_TaksitIptalIsleTamam_Response(); }
}

// @Route("/Gys/MakbuzDuzelt", "POST")
export class GysGUI_MakbuzDuzelt_Request extends BaseRequest_1<GysGUI_MakbuzDuzelt_Response> implements IReturn<GysGUI_MakbuzDuzelt_Response>
{
    public seriNo: string;
    public makbuzNo: number;
    public makbuzBaslamaNo: number;
    public makbuzBitisNo: number;
    public vezneKod: number;

    public constructor(init?: Partial<GysGUI_MakbuzDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_MakbuzDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_MakbuzDuzelt_Response(); }
}

// @Route("/Gys/KisiKontrol", "POST")
export class GysGUI_KisiKontrol_Request implements IReturn<BaseResponse>
{
    public kisiKod: number;

    public constructor(init?: Partial<GysGUI_KisiKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_KisiKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gys/IcraHesapla", "POST")
export class GysGUI_IcraHesapla_Request extends BaseRequest_1<GysGUI_IcraHesapla_Response> implements IReturn<GysGUI_IcraHesapla_Response>
{
    public kisiKod: number;
    public icraAnaKod: number;

    public constructor(init?: Partial<GysGUI_IcraHesapla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_IcraHesapla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_IcraHesapla_Response(); }
}

// @Route("/Gys/TahakkukFisGoster", "POST")
export class GysGUI_TahakkukFisGoster_Request extends BaseRequest_1<GysGUI_TahakkukFisGoster_Response> implements IReturn<GysGUI_TahakkukFisGoster_Response>
{
    public tahakAnaKod: number;

    public constructor(init?: Partial<GysGUI_TahakkukFisGoster_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TahakkukFisGoster_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_TahakkukFisGoster_Response(); }
}

// @Route("/Gys/IcraHesapla", "POST")


// @Route("/Gys/BeyanBorcSorgula", "POST")
export class GysGUI_BeyanBorcSorgula_Request
{
    public kisiKod: number;

    public constructor(init?: Partial<GysGUI_BeyanBorcSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_BeyanBorcSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/Gys/TahakkukBeyansizHesapla", "POST")
export class GysGUI_TahakkukBeyansizHesapla_Request implements IReturn<BaseResponse>
{
    public gelirDetayKod: number;
    public tahakkukKod: number;

    public constructor(init?: Partial<GysGUI_TahakkukBeyansizHesapla_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_TahakkukBeyansizHesapla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gen/GenTatilEkle", "POST")
export class Gen_TatilEkle_Request implements IReturn<BaseResponse>
{
    public yil: number;
    public gunTuru: number;
    public tarih: string;

    public constructor(init?: Partial<Gen_TatilEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_TatilEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenServis/SpHaftaSonuIslet", "POST")
export class Gen_SpHaftaSonuIslet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTarih: string;
    public piSure: number;
    public piKayitKullaniciKod: number;

    public constructor(init?: Partial<Gen_SpHaftaSonuIslet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpHaftaSonuIslet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenServis/SpLockSessionOldur", "POST")
export class Gen_SpLockSessionOldur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSid: number;
    public piSerial: number;
    public piBlock: number;

    public constructor(init?: Partial<Gen_SpLockSessionOldur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpLockSessionOldur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenServis/SpMahalle", "POST")
export class Gen_SpMahalle_Request extends BaseRequest_1<Gen_SpMahalle_Response> implements IReturn<Gen_SpMahalle_Response>
{

    public constructor(init?: Partial<Gen_SpMahalle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpMahalle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpMahalle_Response(); }
}

// @Route("/Packages/PgGenServis/SpTcknVergiSorgu", "POST")
export class Gen_SpTcknVergiSorgu_Request extends BaseRequest_1<Gen_SpTcknVergiSorgu_Response> implements IReturn<Gen_SpTcknVergiSorgu_Response>
{
    public piTcknVergiNo: number;

    public constructor(init?: Partial<Gen_SpTcknVergiSorgu_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpTcknVergiSorgu_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpTcknVergiSorgu_Response(); }
}

// @Route("/Packages/PgGenServis/SpTurkcekaldirupper", "POST")
export class Gen_SpTurkcekaldirupper_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piGelenDeger: string;

    public constructor(init?: Partial<Gen_SpTurkcekaldirupper_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpTurkcekaldirupper_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenServis/FnBelgeTipKontrol", "POST")
export class Gen_FnBelgeTipKontrol_Request implements IReturn<FnIntResponse>
{
    public piBelgeTip: string;

    public constructor(init?: Partial<Gen_FnBelgeTipKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_FnBelgeTipKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/Packages/PgGenServis/SpOrganizasyonSil", "POST")
export class Gen_SpOrganizasyonSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOrgKod: number;

    public constructor(init?: Partial<Gen_SpOrganizasyonSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpOrganizasyonSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenServis/SpVergiTcknKontrol", "POST")
export class Gen_SpVergiTcknKontrol_Request extends BaseRequest_1<Gen_SpVergiTcknKontrol_Response> implements IReturn<Gen_SpVergiTcknKontrol_Response>
{
    public piTur: string;
    public piTcknVergiNo: number;
    public piKisiKod: number;

    public constructor(init?: Partial<Gen_SpVergiTcknKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpVergiTcknKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpVergiTcknKontrol_Response(); }
}

// @Route("/Packages/PgGenServis/SpSmsTelKontrol", "POST")
export class Gen_SpSmsTelKontrol_Request extends BaseRequest_1<Gen_SpSmsTelKontrol_Response> implements IReturn<Gen_SpSmsTelKontrol_Response>
{
    public piKisiKod: number;

    public constructor(init?: Partial<Gen_SpSmsTelKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpSmsTelKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpSmsTelKontrol_Response(); }
}

// @Route("/Packages/PgGenServis/SpIller", "POST")
export class Gen_SpIller_Request extends BaseRequest_1<Gen_SpIller_Response> implements IReturn<Gen_SpIller_Response>
{

    public constructor(init?: Partial<Gen_SpIller_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpIller_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpIller_Response(); }
}

// @Route("/Packages/PgGenServis/SpMahalleCaddeKontrol", "POST")
export class Gen_SpMahalleCaddeKontrol_Request extends BaseRequest_1<Gen_SpMahalleCaddeKontrol_Response> implements IReturn<Gen_SpMahalleCaddeKontrol_Response>
{
    public piTuikKod: number;

    public constructor(init?: Partial<Gen_SpMahalleCaddeKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpMahalleCaddeKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpMahalleCaddeKontrol_Response(); }
}

// @Route("/Packages/PgGenServis/SpCaddeSokak", "POST")
export class Gen_SpCaddeSokak_Request extends BaseRequest_1<Gen_SpCaddeSokak_Response> implements IReturn<Gen_SpCaddeSokak_Response>
{
    public piMahalleKod: number;

    public constructor(init?: Partial<Gen_SpCaddeSokak_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpCaddeSokak_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpCaddeSokak_Response(); }
}

// @Route("/Packages/PgGenServis/SpMailGonder", "POST")
export class Gen_SpMailGonder_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMailAdresi: string;
    public piMailBaslik: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<Gen_SpMailGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpMailGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenServis/SpRaporUrl", "POST")
export class Gen_SpRaporUrl_Request extends BaseRequest_1<Gen_SpRaporUrl_Response> implements IReturn<Gen_SpRaporUrl_Response>
{
    public piParametreAdi: string;

    public constructor(init?: Partial<Gen_SpRaporUrl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpRaporUrl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpRaporUrl_Response(); }
}

// @Route("/Packages/PgGenServis/SpIlceler", "POST")
export class Gen_SpIlceler_Request extends BaseRequest_1<Gen_SpIlceler_Response> implements IReturn<Gen_SpIlceler_Response>
{
    public piIlkod: number;

    public constructor(init?: Partial<Gen_SpIlceler_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpIlceler_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpIlceler_Response(); }
}

// @Route("/Packages/PgGenServis/SpLockSession", "POST")
export class Gen_SpLockSession_Request extends BaseRequest_1<Gen_SpLockSession_Response> implements IReturn<Gen_SpLockSession_Response>
{

    public constructor(init?: Partial<Gen_SpLockSession_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Gen_SpLockSession_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Gen_SpLockSession_Response(); }
}

// @Route("/Packages/PgGenYetkiServis/RolYetkiKaydet", "POST")
export class GenYetki_RolYetkiKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;
    public piYetkiAd: string;

    public constructor(init?: Partial<GenYetki_RolYetkiKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_RolYetkiKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpBagimsizFormYetki", "POST")
export class GenYetki_SpBagimsizFormYetki_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemType: number;
    public piFormKod: number;
    public piKayitKullaniciKod: number;
    public piMenuAnaKod: number;

    public constructor(init?: Partial<GenYetki_SpBagimsizFormYetki_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpBagimsizFormYetki_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpRolMenuSil", "POST")
export class GenYetki_SpRolMenuSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piRolMenuKod: number;
    public piRolKod: number;
    public piFormKod: number;

    public constructor(init?: Partial<GenYetki_SpRolMenuSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpRolMenuSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpFormYetkiKaydet", "POST")
export class GenYetki_SpFormYetkiKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;

    public constructor(init?: Partial<GenYetki_SpFormYetkiKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpFormYetkiKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpKullaniciFormSil", "POST")
export class GenYetki_SpKullaniciFormSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;
    public piKayitKullaniciKod: number;

    public constructor(init?: Partial<GenYetki_SpKullaniciFormSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpKullaniciFormSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpRolMenuYetkiKaydet", "POST")
export class GenYetki_SpRolMenuYetkiKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piRolKod: number;
    public piFormKod: number;
    public piMenuAnaKod: number;

    public constructor(init?: Partial<GenYetki_SpRolMenuYetkiKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpRolMenuYetkiKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/RolKullaniciYetkiKaydet", "POST")
export class GenYetki_RolKullaniciYetkiKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;
    public piYetkiAd: string;

    public constructor(init?: Partial<GenYetki_RolKullaniciYetkiKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_RolKullaniciYetkiKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpFormRolYetkiKaydet", "POST")
export class GenYetki_SpFormRolYetkiKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;
    public piFormYetkiAd: string;

    public constructor(init?: Partial<GenYetki_SpFormRolYetkiKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpFormRolYetkiKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpFormRolYetkiSil", "POST")
export class GenYetki_SpFormRolYetkiSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;
    public piFormYetkiAd: string;

    public constructor(init?: Partial<GenYetki_SpFormRolYetkiSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpFormRolYetkiSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpKullanciRolAktar", "POST")
export class GenYetki_SpKullanciRolAktar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTasiKullaniciKod: number;
    public piKayitKullaniciKod: number;

    public constructor(init?: Partial<GenYetki_SpKullanciRolAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpKullanciRolAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpRolMenuYetkiDuzelt", "POST")
export class GenYetki_SpRolMenuYetkiDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piRolKod: number;
    public piMenuAnaKod: number;
    public piFormKod: number;
    public piYetkiAd: string;
    public piYetkiTur: string;

    public constructor(init?: Partial<GenYetki_SpRolMenuYetkiDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpRolMenuYetkiDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpKullaniciRolSil", "POST")
export class GenYetki_SpKullaniciRolSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piRolKod: number;

    public constructor(init?: Partial<GenYetki_SpKullaniciRolSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpKullaniciRolSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpFormDetaySil", "POST")
export class GenYetki_SpFormDetaySil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;

    public constructor(init?: Partial<GenYetki_SpFormDetaySil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpFormDetaySil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Packages/PgGenYetkiServis/SpFormSil", "POST")
export class GenYetki_SpFormSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piFormKod: number;

    public constructor(init?: Partial<GenYetki_SpFormSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenYetki_SpFormSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Lyt/AddBalanceForLytWebKisi", "POST")
export class Lyt_AddBalanceForLytWebKisi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public webKisiKod: number;
    public kullaniciKod: number;
    public balance: number;

    public constructor(init?: Partial<Lyt_AddBalanceForLytWebKisi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Lyt_AddBalanceForLytWebKisi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpAmbarKontrol")
export class SysGenel_SpAmbarKontrol_Request extends BaseRequest_1<SysGenel_SpAmbarKontrol_Response> implements IReturn<SysGenel_SpAmbarKontrol_Response>
{
    public piSifre: string;

    public constructor(init?: Partial<SysGenel_SpAmbarKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpAmbarKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpAmbarKontrol_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpArsivSorgula")
export class SysGenel_SpArsivSorgula_Request extends BaseRequest_1<SysGenel_SpArsivSorgula_Response> implements IReturn<SysGenel_SpArsivSorgula_Response>
{
    public piSosyalKisiKod: number;

    public constructor(init?: Partial<SysGenel_SpArsivSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpArsivSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpArsivSorgula_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpBasvuruYardimlari")
export class SysGenel_SpBasvuruYardimlari_Request extends BaseRequest_1<SysGenel_SpBasvuruYardimlari_Response> implements IReturn<SysGenel_SpBasvuruYardimlari_Response>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<SysGenel_SpBasvuruYardimlari_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpBasvuruYardimlari_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpBasvuruYardimlari_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpDepodakiMalzeme")
export class SysGenel_SpDepodakiMalzeme_Request extends BaseRequest_1<SysGenel_SpDepodakiMalzeme_Response> implements IReturn<SysGenel_SpDepodakiMalzeme_Response>
{
    public piMalzemeKod: string;
    public piAmbarKod: number;

    public constructor(init?: Partial<SysGenel_SpDepodakiMalzeme_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpDepodakiMalzeme_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpDepodakiMalzeme_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpGorevlerim")
export class SysGenel_SpGorevlerim_Request extends BaseRequest_1<SysGenel_SpGorevlerim_Response> implements IReturn<SysGenel_SpGorevlerim_Response>
{
    public piDurum: number;
    public piMahalleKod?: number;
    public piEkipKod?: number;
    public piAd: string;
    public piSoyad: string;
    public piBasvuruKod?: number;
    public piIlkBasvuruTarih?: string;
    public piSonBasvuruTarih?: string;
    public piTck?: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpGorevlerim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpGorevlerim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpGorevlerim_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpPeriyodIptal")
export class SysGenel_SpPeriyodIptal_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalBasvuruKod: number;
    public piSosyalBasvuruDetayKod: number;

    public constructor(init?: Partial<SysGenel_SpPeriyodIptal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpPeriyodIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpYardimMalzemeleri")
export class SysGenel_SpYardimMalzemeleri_Request extends BaseRequest_1<SysGenel_SpYardimMalzemeleri_Response> implements IReturn<SysGenel_SpYardimMalzemeleri_Response>
{
    public piYardimKod: number;

    public constructor(init?: Partial<SysGenel_SpYardimMalzemeleri_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpYardimMalzemeleri_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpYardimMalzemeleri_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpYardimSonuc")
export class SysGenel_SpYardimSonuc_Request extends BaseRequest_1<SysGenel_SpYardimSonuc_Response> implements IReturn<SysGenel_SpYardimSonuc_Response>
{
    public piYardimTuru: string;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAd: string;
    public piSoyad: string;
    public piMahalle: string;
    public piIslemTuru: number;
    public piTck: number;
    public piDosyaNo: number;
    public piMalzemeKod: string;
    public piAcilEh: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpYardimSonuc_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpYardimSonuc_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpYardimSonuc_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpSosyalKisiler")
export class SysGenel_SpSosyalKisiler_Request extends BaseRequest_1<SysGenel_SpSosyalKisiler_Response> implements IReturn<SysGenel_SpSosyalKisiler_Response>
{

    public constructor(init?: Partial<SysGenel_SpSosyalKisiler_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSosyalKisiler_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSosyalKisiler_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpArsivOlustur")
export class SysGenel_SpArsivOlustur_Request extends BaseRequest_1<SysGenel_SpArsivOlustur_Response> implements IReturn<SysGenel_SpArsivOlustur_Response>
{
    public piSosyalKisiKod: number;

    public constructor(init?: Partial<SysGenel_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpArsivOlustur_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpBasvuruIadeIptal")
export class SysGenel_SpBasvuruIadeIptal_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piKayitKullaniciKod: number;
    public piDurum: number;
    public piNeden: string;

    public constructor(init?: Partial<SysGenel_SpBasvuruIadeIptal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpBasvuruIadeIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpIncelemelerSonuc")
export class SysGenel_SpIncelemelerSonuc_Request extends BaseRequest_1<SysGenel_SpIncelemelerSonuc_Response> implements IReturn<SysGenel_SpIncelemelerSonuc_Response>
{
    public piSosyalBasvuruKod: number;
    public piSosyalBasvuruDetayKod: number;

    public constructor(init?: Partial<SysGenel_SpIncelemelerSonuc_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIncelemelerSonuc_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpIncelemelerSonuc_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpIncelemePuanKaydet")
export class SysGenel_SpIncelemePuanKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIncelemeKod: number;
    public piSoruCevapKod: Object;
    public piKayitKullaniciKod?: number;

    public constructor(init?: Partial<SysGenel_SpIncelemePuanKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIncelemePuanKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpIptalBasvurular")
export class SysGenel_SpIptalBasvurular_Request extends BaseRequest_1<SysGenel_SpIptalBasvurular_Response> implements IReturn<SysGenel_SpIptalBasvurular_Response>
{
    public piKisiKod: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpIptalBasvurular_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIptalBasvurular_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpIptalBasvurular_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpNakitRed")
export class SysGenel_SpNakitRed_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<SysGenel_SpNakitRed_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpNakitRed_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpRandevuKaydet")
export class SysGenel_SpRandevuKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pioKod: number;
    public piRandevuTarih: string;

    public constructor(init?: Partial<SysGenel_SpRandevuKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpRandevuKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpRandevuTamamla")
export class SysGenel_SpRandevuTamamla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pioKod: number;

    public constructor(init?: Partial<SysGenel_SpRandevuTamamla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpRandevuTamamla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysIncelemeKaydet")
export class SysGenel_SpSysIncelemeKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piIncelemeKod: number;
    public piMenkulAracTespit: string;
    public piCevreBeyani: string;
    public piDaireDurumu: string;
    public piTespitBilgi: string;
    public piDurum: number;
    public piYardimDetay: string;
    public piKayitKullaniciKod?: number;

    public constructor(init?: Partial<SysGenel_SpSysIncelemeKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysIncelemeKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysPanelSekmeSoru")
export class SysGenel_SpSysPanelSekmeSoru_Request extends BaseRequest_1<SysGenel_SpSysPanelSekmeSoru_Response> implements IReturn<SysGenel_SpSysPanelSekmeSoru_Response>
{

    public constructor(init?: Partial<SysGenel_SpSysPanelSekmeSoru_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysPanelSekmeSoru_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSysPanelSekmeSoru_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SysBasvuruDetayTopluKayit")
export class SysGenel_SysBasvuruDetayTopluKayit_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalBasvuruKod?: number;
    public piYardimTurleri: string;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;

    public constructor(init?: Partial<SysGenel_SysBasvuruDetayTopluKayit_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SysBasvuruDetayTopluKayit_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpBasvuruIcelemeleri")
export class SysGenel_SpBasvuruIcelemeleri_Request extends BaseRequest_1<SysGenel_SpBasvuruIcelemeleri_Response> implements IReturn<SysGenel_SpBasvuruIcelemeleri_Response>
{
    public piBasvuruKod?: number;

    public constructor(init?: Partial<SysGenel_SpBasvuruIcelemeleri_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpBasvuruIcelemeleri_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpBasvuruIcelemeleri_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpBasvuruIptalKaldir")
export class SysGenel_SpBasvuruIptalKaldir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;
    public piKullaniciKo: number;

    public constructor(init?: Partial<SysGenel_SpBasvuruIptalKaldir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpBasvuruIptalKaldir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpCikisTeslimEden")
export class SysGenel_SpCikisTeslimEden_Request extends BaseRequest_1<SysGenel_SpCikisTeslimEden_Response> implements IReturn<SysGenel_SpCikisTeslimEden_Response>
{

    public constructor(init?: Partial<SysGenel_SpCikisTeslimEden_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpCikisTeslimEden_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpCikisTeslimEden_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpIncelemeler")
export class SysGenel_SpIncelemeler_Request extends BaseRequest_1<SysGenel_SpIncelemeler_Response> implements IReturn<SysGenel_SpIncelemeler_Response>
{
    public piSosyalKisiKod: number;

    public constructor(init?: Partial<SysGenel_SpIncelemeler_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIncelemeler_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpIncelemeler_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpIncelemeAta")
export class SysGenel_SpIncelemeAta_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKodlari: string;
    public piEkipKod: number;
    public piKayitKullaniciKod: number;

    public constructor(init?: Partial<SysGenel_SpIncelemeAta_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIncelemeAta_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpKisiBilgiSorgula")
export class SysGenel_SpKisiBilgiSorgula_Request extends BaseRequest_1<SysGenel_SpKisiBilgiSorgula_Response> implements IReturn<SysGenel_SpKisiBilgiSorgula_Response>
{
    public piSosyalKisiKod: number;

    public constructor(init?: Partial<SysGenel_SpKisiBilgiSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpKisiBilgiSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpKisiBilgiSorgula_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpPeriyodDegistir")
export class SysGenel_SpPeriyodDegistir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalBasvuruKod: number;
    public piSosyalBasvuruDetayKod: number;
    public piPeriyodKod: number;

    public constructor(init?: Partial<SysGenel_SpPeriyodDegistir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpPeriyodDegistir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpPlanlanacakRandevular")
export class SysGenel_SpPlanlanacakRandevular_Request extends BaseRequest_1<SysGenel_SpPlanlanacakRandevular_Response> implements IReturn<SysGenel_SpPlanlanacakRandevular_Response>
{
    public piTur: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAd: string;
    public piSoyadi: string;
    public piTckn: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpPlanlanacakRandevular_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpPlanlanacakRandevular_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpPlanlanacakRandevular_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpPlanlanacakYardimlar")
export class SysGenel_SpPlanlanacakYardimlar_Request extends BaseRequest_1<SysGenel_SpPlanlanacakYardimlar_Response> implements IReturn<SysGenel_SpPlanlanacakYardimlar_Response>
{
    public piTur: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAd: string;
    public piSoyadi: string;
    public piTckn: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpPlanlanacakYardimlar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpPlanlanacakYardimlar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpPlanlanacakYardimlar_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysKisiAileIslem")
export class SysGenel_SpSysKisiAileIslem_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalKisiKod?: number;
    public piYakinlik: string;
    public piTckn?: number;
    public piAd: string;
    public piSoyad: string;
    public piBabaAd: string;
    public piAnneAd: string;
    public piCinsiyet: string;
    public piDogumTarih?: string;
    public piDogumIlceKod: number;
    public piDogumYeriAciklama: string;
    public piMedeniDurumu: string;
    public piOlumTarih?: string;

    public constructor(init?: Partial<SysGenel_SpSysKisiAileIslem_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysKisiAileIslem_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysPanelSekmeSorgula")
export class SysGenel_SpSysPanelSekmeSorgula_Request extends BaseRequest_1<SysGenel_SpSysPanelSekmeSorgula_Response> implements IReturn<SysGenel_SpSysPanelSekmeSorgula_Response>
{
    public piPanelKod?: number;

    public constructor(init?: Partial<SysGenel_SpSysPanelSekmeSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysPanelSekmeSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSysPanelSekmeSorgula_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpIadeBasvurular")
export class SysGenel_SpIadeBasvurular_Request extends BaseRequest_1<SysGenel_SpIadeBasvurular_Response> implements IReturn<SysGenel_SpIadeBasvurular_Response>
{
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpIadeBasvurular_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIadeBasvurular_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpIadeBasvurular_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpIadeBasvuruTamam")
export class SysGenel_SpIadeBasvuruTamam_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBasvuruKod: number;

    public constructor(init?: Partial<SysGenel_SpIadeBasvuruTamam_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIadeBasvuruTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpIncelemelerSonucIptal")
export class SysGenel_SpIncelemelerSonucIptal_Request extends BaseRequest_1<SysGenel_SpIncelemelerSonucIptal_Response> implements IReturn<SysGenel_SpIncelemelerSonucIptal_Response>
{
    public piSosyalBasvuruKod: number;
    public piSosyalBasvuruDetayKod: number;

    public constructor(init?: Partial<SysGenel_SpIncelemelerSonucIptal_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpIncelemelerSonucIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpIncelemelerSonucIptal_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpMahalleDagilim")
export class SysGenel_SpMahalleDagilim_Request extends BaseRequest_1<SysGenel_SpMahalleDagilim_Response> implements IReturn<SysGenel_SpMahalleDagilim_Response>
{
    public piYil: number;

    public constructor(init?: Partial<SysGenel_SpMahalleDagilim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpMahalleDagilim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpMahalleDagilim_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpNakitYardimListesi")
export class SysGenel_SpNakitYardimListesi_Request extends BaseRequest_1<SysGenel_SpNakitYardimListesi_Response> implements IReturn<SysGenel_SpNakitYardimListesi_Response>
{
    public piKisiKod: number;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpNakitYardimListesi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpNakitYardimListesi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpNakitYardimListesi_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpSokakYardimDagilim")
export class SysGenel_SpSokakYardimDagilim_Request extends BaseRequest_1<SysGenel_SpSokakYardimDagilim_Response> implements IReturn<SysGenel_SpSokakYardimDagilim_Response>
{
    public piMahalleKod: number;
    public piYil: number;

    public constructor(init?: Partial<SysGenel_SpSokakYardimDagilim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSokakYardimDagilim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSokakYardimDagilim_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysPanelSorgula")
export class SysGenel_SpSysPanelSorgula_Request extends BaseRequest_1<SysGenel_SpSysPanelSorgula_Response> implements IReturn<SysGenel_SpSysPanelSorgula_Response>
{

    public constructor(init?: Partial<SysGenel_SpSysPanelSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysPanelSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSysPanelSorgula_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpYardimPeriyod")
export class SysGenel_SpYardimPeriyod_Request extends BaseRequest_1<SysGenel_SpYardimPeriyod_Response> implements IReturn<SysGenel_SpYardimPeriyod_Response>
{
    public piYardimKod: number;

    public constructor(init?: Partial<SysGenel_SpYardimPeriyod_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpYardimPeriyod_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpYardimPeriyod_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpAktifAdresSorgula")
export class SysGenel_SpAktifAdresSorgula_Request extends BaseRequest_1<SysGenel_SpAktifAdresSorgula_Response> implements IReturn<SysGenel_SpAktifAdresSorgula_Response>
{
    public piSosyalKisiKod: number;

    public constructor(init?: Partial<SysGenel_SpAktifAdresSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpAktifAdresSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpAktifAdresSorgula_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysKisiKontrol")
export class SysGenel_SpSysKisiKontrol_Request extends BaseRequest_1<SysGenel_SpSysKisiKontrol_Response> implements IReturn<SysGenel_SpSysKisiKontrol_Response>
{
    public piTckn: number;

    public constructor(init?: Partial<SysGenel_SpSysKisiKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysKisiKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSysKisiKontrol_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpYardimEkle")
export class SysGenel_SpYardimEkle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalBasvuruKod: number;
    public piYardimKod: number;
    public piPeriyodKod: number;
    public piMalzemeler: string;
    public piIslemTarih: string;
    public piAdet?: number;

    public constructor(init?: Partial<SysGenel_SpYardimEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpYardimEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpYardimMalzeme")
export class SysGenel_SpYardimMalzeme_Request extends BaseRequest_1<SysGenel_SpYardimMalzeme_Response> implements IReturn<SysGenel_SpYardimMalzeme_Response>
{
    public piYardimKod: number;

    public constructor(init?: Partial<SysGenel_SpYardimMalzeme_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpYardimMalzeme_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpYardimMalzeme_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpAktifAmbarlarGetir")
export class SysGenel_SpAktifAmbarlarGetir_Request extends BaseRequest_1<SysGenel_SpAktifAmbarlarGetir_Response> implements IReturn<SysGenel_SpAktifAmbarlarGetir_Response>
{

    public constructor(init?: Partial<SysGenel_SpAktifAmbarlarGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpAktifAmbarlarGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpAktifAmbarlarGetir_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpAmbarMalzemeCikis")
export class SysGenel_SpAmbarMalzemeCikis_Request extends BaseRequest_1<SysGenel_SpAmbarMalzemeCikis_Response> implements IReturn<SysGenel_SpAmbarMalzemeCikis_Response>
{
    public piKisiKod: number;
    public piAmbarKod: number;
    public piMalzemeler: string;

    public constructor(init?: Partial<SysGenel_SpAmbarMalzemeCikis_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpAmbarMalzemeCikis_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpAmbarMalzemeCikis_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpEkipIsyuku")
export class SysGenel_SpEkipIsyuku_Request extends BaseRequest_1<SysGenel_SpEkipIsyuku_Response> implements IReturn<SysGenel_SpEkipIsyuku_Response>
{

    public constructor(init?: Partial<SysGenel_SpEkipIsyuku_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpEkipIsyuku_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpEkipIsyuku_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpKullaniciAmbarlari")
export class SysGenel_SpKullaniciAmbarlari_Request extends BaseRequest_1<SysGenel_SpKullaniciAmbarlari_Response> implements IReturn<SysGenel_SpKullaniciAmbarlari_Response>
{

    public constructor(init?: Partial<SysGenel_SpKullaniciAmbarlari_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpKullaniciAmbarlari_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpKullaniciAmbarlari_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpMalzemeEkle")
export class SysGenel_SpMalzemeEkle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalBasvuruDetayKod: number;
    public piMalzemeler: string;
    public piIslemTarih: string;
    public piPeriyodKod: number;
    public piAdet?: number;

    public constructor(init?: Partial<SysGenel_SpMalzemeEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpMalzemeEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpMalzemeKontrol")
export class SysGenel_SpMalzemeKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMalzemeKod: string;

    public constructor(init?: Partial<SysGenel_SpMalzemeKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpMalzemeKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpPlanlamaTamamla")
export class SysGenel_SpPlanlamaTamamla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public pioKod: number;

    public constructor(init?: Partial<SysGenel_SpPlanlamaTamamla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpPlanlamaTamamla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysAileDetayYaz")
export class SysGenel_SpSysAileDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSosyalAileKod?: number;
    public piIncelemeKod?: number;
    public piCalismaDurumKod?: number;
    public piSosyalGuvenceKod?: number;
    public piSaglikDurumu?: number;
    public piDigerKronikHastalik: string;
    public piSaglikNotlari: string;
    public piEngelliEh: string;
    public piEngelliDurumu?: number;
    public piEngelliSebebiKod?: number;
    public piEngelliEgitimDurumu?: number;
    public piEngelliRaporEh: string;
    public piEngelliRaporTarih?: string;
    public piEngelliOran?: number;
    public piEngelliRaporDurumu: string;
    public piEngelliRaporSonTarih?: string;
    public piEngelliTedaviDurumu?: number;
    public piEngelliOzBakimDurumu?: number;
    public piEngelliKartEh: string;
    public piEngelliMaasEh: string;
    public piEngelliMaasTutar?: number;
    public piEngelliBakimUcretEh: string;
    public piEngelliBakimTutar?: number;
    public piEngelliSeyahatKartEh: string;
    public piEngelliAciklama: string;
    public piOgrenimDurumKod?: number;
    public piOgrenimTurKod?: number;
    public piHamileDogumTarih?: string;
    public piAyakNumarasi?: number;
    public piGiyimBedeni?: number;
    public piTesetturGiyimEh: string;
    public piAylikGelirTutar?: number;
    public piAciklama: string;
    public piKronikHastalik: string;
    public piEngelliTurleri: string;
    public piEngelliMedMalzemeler: string;
    public piSehitAilesiEh: string;
    public piYetimEh: string;
    public piOksuzEh: string;
    public piGaziEh: string;
    public piGaziAilesiEh: string;

    public constructor(init?: Partial<SysGenel_SpSysAileDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysAileDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpSysPanelSekmeSoruTum")
export class SysGenel_SpSysPanelSekmeSoruTum_Request extends BaseRequest_1<SysGenel_SpSysPanelSekmeSoruTum_Response> implements IReturn<SysGenel_SpSysPanelSekmeSoruTum_Response>
{

    public constructor(init?: Partial<SysGenel_SpSysPanelSekmeSoruTum_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpSysPanelSekmeSoruTum_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpSysPanelSekmeSoruTum_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpYardimSonucKaydet")
export class SysGenel_SpYardimSonucKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTur: number;
    public piAciklama: string;
    public piKodlar: string;
    public piIslemTur: number;
    public piTeslimEden: string;
    public piTeslimTarih: string;
    public piDegisKullaniciKod: number;
    public piDegisTarih: string;

    public constructor(init?: Partial<SysGenel_SpYardimSonucKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpYardimSonucKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/PgSysGenelServis/SpGorevAta")
export class SysGenel_SpGorevAta_Request extends BaseRequest_1<SysGenel_SpGorevAta_Response> implements IReturn<SysGenel_SpGorevAta_Response>
{
    public piTur: number;
    public piMahalleKod: string;
    public piEkipKod: number;
    public piAd: string;
    public piSoyad: string;
    public piBasvuruKod: number;
    public piIlkBasvuruTarih: string;
    public piSonBasvuruTarih: string;
    public piTck: number;
    public piAcilEh: string;
    public piStartDeger?: number;
    public piStopDeger?: number;

    public constructor(init?: Partial<SysGenel_SpGorevAta_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpGorevAta_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpGorevAta_Response(); }
}

// @Route("/SYS/PgSysGenelServis/SpMalzeler")
export class SysGenel_SpMalzeler_Request extends BaseRequest_1<SysGenel_SpMalzeler_Response> implements IReturn<SysGenel_SpMalzeler_Response>
{

    public constructor(init?: Partial<SysGenel_SpMalzeler_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysGenel_SpMalzeler_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysGenel_SpMalzeler_Response(); }
}

// @Route("/DabId/UserChangePassword", "POST")
export class DabIdUserChangePassword_Request extends BaseRequest_1<DabIdUserChangePassword_Response> implements IReturn<DabIdUserChangePassword_Response>
{
    public input: DabIdUserChangePasswordApiDto;
    public detayYn: boolean;

    public constructor(init?: Partial<DabIdUserChangePassword_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DabIdUserChangePassword_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DabIdUserChangePassword_Response(); }
}

// // @Route("/Gen/IhaleGetir", "Get")
// export class ExcelGUI_IhaleGetir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
// {
//     public ihaleKod: number;
//
//     public constructor(init?: Partial<ExcelGUI_IhaleGetir_Request>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'ExcelGUI_IhaleGetir_Request'; }
//     public getMethod() { return 'GET'; }
//     public createResponse() { return new BaseResponse(); }
// }

// @Route("/Gen/IhaleTeklifGetir", "Get")
export class ExcelGUI_IhaleTeklifGetir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public ihaleKod: number;

    public constructor(init?: Partial<ExcelGUI_IhaleTeklifGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_IhaleTeklifGetir_Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gen/TeklifGetir", "Get")
export class ExcelGUI_TeklifGetir_Request extends BaseRequest_1<ExcelGUI_TeklifGetir_Response> implements IReturn<ExcelGUI_TeklifGetir_Response>
{
    public sorguTuru: number;
    public teklifKod: number;

    public constructor(init?: Partial<ExcelGUI_TeklifGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_TeklifGetir_Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExcelGUI_TeklifGetir_Response(); }
}

export class ExcelGUI_IhaleGet_Request extends BaseRequest_1<ExcelGUI_IhaleGet_Response> implements IReturn<ExcelGUI_IhaleGet_Response>
{
  public sorguTuru: number;
  public ihaleKod: number;

  public constructor(init?: Partial<ExcelGUI_IhaleGet_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'ExcelGUI_IhaleGet_Request'; }
  public getMethod() { return 'GET'; }
  public createResponse() { return new ExcelGUI_IhaleGet_Response(); }
}

// @Route("/Gen/TeklifDetayOku", "Get")
export class ExcelGUI_TeklifDetayOku_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public fileName: string;
    public fileContent: string;

    public constructor(init?: Partial<ExcelGUI_TeklifDetayOku_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_TeklifDetayOku_Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Gen/TeklifOku", "Get")
export class ExcelGUI_TeklifOku_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public ihaleKod: number;
    public fileName: string;
    public fileContent: string;

    public constructor(init?: Partial<ExcelGUI_TeklifOku_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_TeklifOku_Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysCtvServis/SpCtvTahakkuk")
export class GysCtv_SpCtvTahakkuk_Request extends BaseRequest_1<GysCtv_SpCtvTahakkuk_Response> implements IReturn<GysCtv_SpCtvTahakkuk_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piYillikTahakEh: string;

    public constructor(init?: Partial<GysCtv_SpCtvTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpCtvTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysCtv_SpCtvTahakkuk_Response(); }
}

// @Route("/GYS/PgGysCtvServis/SpCtvTarifeKontrol")
export class GysCtv_SpCtvTarifeKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piCtvGrup: number;
    public piCtvDerece: number;
    public piCtvKullanimKod: number;
    public piMahalleCaddeKod: number;
    public piKriterM2: number;
    public piKriterPersonel: number;
    public piKriterOgrenci: number;
    public piKriterKoltuk: number;
    public piKriterYatak: number;
    public piBinaKaloriferEh: string;
    public piVergiBaslangicTarih: string;
    public piMukellefBitisTarih: string;

    public constructor(init?: Partial<GysCtv_SpCtvTarifeKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpCtvTarifeKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysCtvServis/SpBeyanYilTasi")
export class GysCtv_SpBeyanYilTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piBeyanKod: number;
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<GysCtv_SpBeyanYilTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpBeyanYilTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysCtvServis/SpCtvCezaTmp")
export class GysCtv_SpCtvCezaTmp_Request extends BaseRequest_1<GysCtv_SpCtvCezaTmp_Response> implements IReturn<GysCtv_SpCtvCezaTmp_Response>
{
    public piKisiKod: number;
    public piModulKod: number;
    public piBeyanKod: number;
    public piYil: number;
    public piIslemKod: string;
    public piTahakVergi: number;
    public piCezaTur: string;

    public constructor(init?: Partial<GysCtv_SpCtvCezaTmp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpCtvCezaTmp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysCtv_SpCtvCezaTmp_Response(); }
}

// @Route("/GYS/PgGysCtvServis/SpTarifeTasi")
export class GysCtv_SpTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;
    public piArtisOran: number;

    public constructor(init?: Partial<GysCtv_SpTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysCtvServis/SpCtvTarifeBul")
export class GysCtv_SpCtvTarifeBul_Request extends BaseRequest_1<GysCtv_SpCtvTarifeBul_Response> implements IReturn<GysCtv_SpCtvTarifeBul_Response>
{
    public piYil: number;
    public piCtvKullanimKod: number;
    public piMahalleCaddeKod: number;
    public piKriterM2: number;
    public piKriterPersonel: number;
    public piKriterOgrenci: number;
    public piKriterKoltuk: number;
    public piKriterYatak: number;
    public piBinaKaloriferEh: string;

    public constructor(init?: Partial<GysCtv_SpCtvTarifeBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpCtvTarifeBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysCtv_SpCtvTarifeBul_Response(); }
}

// @Route("/GYS/PgGysCtvServis/SpCtvTerkin")
export class GysCtv_SpCtvTerkin_Request extends BaseRequest_1<GysCtv_SpCtvTerkin_Response> implements IReturn<GysCtv_SpCtvTerkin_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piMukBitisTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piMukBitisKod: number;
    public piAlanKisiKod: number;
    public piAlanKisiAcik: string;
    public piTerkinTarih: string;
    public piTerkinTuruKod: number;
    public piTerkinAciklama: string;
    public piKisitliIslemTuru: string;

    public constructor(init?: Partial<GysCtv_SpCtvTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpCtvTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysCtv_SpCtvTerkin_Response(); }
}

// @Route("/GYS/PgGysCtvServis/SpCtvIhbar")
export class GysCtv_SpCtvIhbar_Request extends BaseRequest_1<GysCtv_SpCtvIhbar_Response> implements IReturn<GysCtv_SpCtvIhbar_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piTarhiyatTuru: number;

    public constructor(init?: Partial<GysCtv_SpCtvIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysCtv_SpCtvIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysCtv_SpCtvIhbar_Response(); }
}

// @Route("/GYS/PgGysEglServis/SpEglCezaTmp")
export class GysEgl_SpEglCezaTmp_Request extends BaseRequest_1<GysEgl_SpEglCezaTmp_Response> implements IReturn<GysEgl_SpEglCezaTmp_Response>
{
    public piKisiKod: number;
    public piModulKod: number;
    public piBeyanKod: number;
    public piYil: number;
    public piIslemKod: string;
    public piTahakVergi: number;
    public piCezaTur: string;

    public constructor(init?: Partial<GysEgl_SpEglCezaTmp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEgl_SpEglCezaTmp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEgl_SpEglCezaTmp_Response(); }
}

// @Route("/GYS/PgGysEglServis/SpEglIhbar")
export class GysEgl_SpEglIhbar_Request extends BaseRequest_1<GysEgl_SpEglIhbar_Response> implements IReturn<GysEgl_SpEglIhbar_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piTarhiyatTuru: number;

    public constructor(init?: Partial<GysEgl_SpEglIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEgl_SpEglIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEgl_SpEglIhbar_Response(); }
}

// @Route("/GYS/PgGysEglServis/SpEglTahakkuk")
export class GysEgl_SpEglTahakkuk_Request extends BaseRequest_1<GysEgl_SpEglTahakkuk_Response> implements IReturn<GysEgl_SpEglTahakkuk_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;

    public constructor(init?: Partial<GysEgl_SpEglTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEgl_SpEglTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEgl_SpEglTahakkuk_Response(); }
}

// @Route("/GYS/PgGysEglServis/SpEglTerkin")
export class GysEgl_SpEglTerkin_Request extends BaseRequest_1<GysEgl_SpEglTerkin_Response> implements IReturn<GysEgl_SpEglTerkin_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piMukBitisTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piMukBitisKod: number;
    public piAlanKisiKod: number;
    public piAlanKisiAcik: string;
    public piTerkinTarih: string;
    public piTerkinTuruKod: number;
    public piTerkinAciklama: string;
    public piKisitliIslemTuru: string;

    public constructor(init?: Partial<GysEgl_SpEglTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEgl_SpEglTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEgl_SpEglTerkin_Response(); }
}

// @Route("/GYS/PgGysEkaServis/SpEkaCezaTmp")
export class GysEka_SpEkaCezaTmp_Request extends BaseRequest_1<GysEka_SpEkaCezaTmp_Response> implements IReturn<GysEka_SpEkaCezaTmp_Response>
{
    public piKisiKod: number;
    public piModulKod: number;
    public piBeyanKod: number;
    public piYil: number;
    public piIslemKod: string;
    public piTahakVergi: number;
    public piCezaTur: string;

    public constructor(init?: Partial<GysEka_SpEkaCezaTmp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpEkaCezaTmp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEka_SpEkaCezaTmp_Response(); }
}

// @Route("/GYS/PgGysEkaServis/SpEkaTahakkuk")
export class GysEka_SpEkaTahakkuk_Request extends BaseRequest_1<GysEka_SpEkaTahakkuk_Response> implements IReturn<GysEka_SpEkaTahakkuk_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piYillikTahakEh: string;

    public constructor(init?: Partial<GysEka_SpEkaTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpEkaTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEka_SpEkaTahakkuk_Response(); }
}

// @Route("/GYS/PgGysEkaServis/SpBeyanYilTasi")
export class GysEka_SpBeyanYilTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piBeyanKod?: number;
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<GysEka_SpBeyanYilTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpBeyanYilTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEkaServis/SpTarifeTasi")
export class GysEka_SpTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;
    public piArtisOran: number;

    public constructor(init?: Partial<GysEka_SpTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEkaServis/SpEkaIhbar")
export class GysEka_SpEkaIhbar_Request extends BaseRequest_1<GysEka_SpEkaIhbar_Response> implements IReturn<GysEka_SpEkaIhbar_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piTarhiyatTuru: number;

    public constructor(init?: Partial<GysEka_SpEkaIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpEkaIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEka_SpEkaIhbar_Response(); }
}

// @Route("/GYS/PgGysEkaServis/SpEkaTarifeKontrol")
export class GysEka_SpEkaTarifeKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piEkaGrup: number;
    public piEkaDerece: number;
    public piEkaKullanimKod: number;
    public piMahalleCaddeKod: number;
    public piKriterM2: number;
    public piKriterPersonel: number;
    public piKriterOgrenci: number;
    public piKriterKoltuk: number;
    public piKriterYatak: number;
    public piBinaKaloriferEh: string;
    public piVergiBaslangicTarih: string;
    public piMukellefBitisTarih: string;

    public constructor(init?: Partial<GysEka_SpEkaTarifeKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpEkaTarifeKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEkaServis/SpEkaTerkin")
export class GysEka_SpEkaTerkin_Request extends BaseRequest_1<GysEka_SpEkaTerkin_Response> implements IReturn<GysEka_SpEkaTerkin_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piMukBitisTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piMukBitisKod: number;
    public piAlanKisiKod: number;
    public piAlanKisiAcik: string;
    public piTerkinTarih: string;
    public piTerkinTuruKod: number;
    public piTerkinAciklama: string;
    public piKisitliIslemTuru: string;

    public constructor(init?: Partial<GysEka_SpEkaTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpEkaTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEka_SpEkaTerkin_Response(); }
}

// @Route("/GYS/PgGysEkaServis/SpEkaTarifeBul")
export class GysEka_SpEkaTarifeBul_Request extends BaseRequest_1<GysEka_SpEkaTarifeBul_Response> implements IReturn<GysEka_SpEkaTarifeBul_Response>
{
    public piYil: number;
    public piEkaKullanimKod: number;
    public piMahalleCaddeKod: number;
    public piKriterM2: number;
    public piKriterPersonel: number;
    public piKriterOgrenci: number;
    public piKriterKoltuk: number;
    public piKriterYatak: number;
    public piBinaKaloriferEh: string;

    public constructor(init?: Partial<GysEka_SpEkaTarifeBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEka_SpEkaTarifeBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEka_SpEkaTarifeBul_Response(); }
}

// @Route("/GYS/PgGysEmlakServis/SpBeyanYilTasi")
export class GysEmlak_SpBeyanYilTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piBeyanKod?: number;
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<GysEmlak_SpBeyanYilTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpBeyanYilTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEmlakServis/SpRayicAktar")
export class GysEmlak_SpRayicAktar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIlkMahalleCaddeKod?: number;
    public piSonMahalleCaddeKod?: number;

    public constructor(init?: Partial<GysEmlak_SpRayicAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpRayicAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEmlakServis/SpRayicTasi")
export class GysEmlak_SpRayicTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIlkMahalle: number;
    public piSonMahalle: number;
    public piOkuYil: number;
    public piYazYil: number;
    public piOran: number;

    public constructor(init?: Partial<GysEmlak_SpRayicTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpRayicTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEmlakServis/SpEmlakCezaTmp")
export class GysEmlak_SpEmlakCezaTmp_Request extends BaseRequest_1<GysEmlak_SpEmlakCezaTmp_Response> implements IReturn<GysEmlak_SpEmlakCezaTmp_Response>
{
    public piKisiKod: number;
    public piModulKod?: number;
    public piBeyanKod?: number;
    public piDonemKod?: number;
    public piYil: number;
    public piIslemKod: string;
    public piEkVergi: string;
    public piTahakVergi: number;
    public piCezaTur: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakCezaTmp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakCezaTmp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakCezaTmp_Response(); }
}

// @Route("/GYS/PgGysEmlakServis/SpEmlakIhbar")
export class GysEmlak_SpEmlakIhbar_Request extends BaseRequest_1<GysEmlak_SpEmlakIhbar_Response> implements IReturn<GysEmlak_SpEmlakIhbar_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTuru: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piTarhiyatTuru: number;

    public constructor(init?: Partial<GysEmlak_SpEmlakIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakIhbar_Response(); }
}

// @Route("/GYS/PgGysEmlakServis/SpEmlakTerkin")
export class GysEmlak_SpEmlakTerkin_Request extends BaseRequest_1<GysEmlak_SpEmlakTerkin_Response> implements IReturn<GysEmlak_SpEmlakTerkin_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTuru: number;
    public piMukBitisTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piMukBitisKod?: number;
    public piAlanKisiKod?: number;
    public piAlanKisiAcik: string;
    public piTerkinTarih: string;
    public piTerkinTuruKod: number;
    public piTerkinAciklama: string;
    public piKisitliIslemTuru: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakTerkin_Response(); }
}

// @Route("/GYS/PgGysEmlakServis/SpEmlakTahakkuk")
export class GysEmlak_SpEmlakTahakkuk_Request extends BaseRequest_1<GysEmlak_SpEmlakTahakkuk_Response> implements IReturn<GysEmlak_SpEmlakTahakkuk_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTuru: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piYillikTahakEh: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakTahakkuk_Response(); }
}

// @Route("/GYS/PgdGysEmlakServis/SpEmlakTahakkukYeni")
export class GysEmlak_SpEmlakTahakkukYeni_Request extends BaseRequest_1<GysEmlak_SpEmlakTahakkukYeni_Response> implements IReturn<GysEmlak_SpEmlakTahakkukYeni_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTuru: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piBeyanListesi: string;
    public piIlkYil: number;
    public piSonYil: number;
    public piYillikTahakEh: string;

    public constructor(init?: Partial<GysEmlak_SpEmlakTahakkukYeni_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakTahakkukYeni_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakTahakkukYeni_Response(); }
}

// @Route("/GYS/PgGysEmlakServis/SpBeyanDonemTasi")
export class GysEmlak_SpBeyanDonemTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piBeyanKod?: number;
    public piDonemKod?: number;

    public constructor(init?: Partial<GysEmlak_SpBeyanDonemTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpBeyanDonemTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEmlakServis/SpEmlakVergiOran")
export class GysEmlak_SpEmlakVergiOran_Request extends BaseRequest_1<GysEmlak_SpEmlakVergiOran_Response> implements IReturn<GysEmlak_SpEmlakVergiOran_Response>
{
    public piYil: number;
    public piBeyanTuru: number;
    public piKullanimSekli: number;
    public piYuzolcum: number;
    public piEmekliEh: string;
    public piEmekliTarih: string;
    public piBeyanSayisi: number;

    public constructor(init?: Partial<GysEmlak_SpEmlakVergiOran_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakVergiOran_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakVergiOran_Response(); }
}

// @Route("/GYS/PgGysEmlakServis/SpAsinmaTasi")
export class GysEmlak_SpAsinmaTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<GysEmlak_SpAsinmaTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpAsinmaTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysEmlakServis/SpEmlakKisitIsle")
export class GysEmlak_SpEmlakKisitIsle_Request extends BaseRequest_1<GysEmlak_SpEmlakKisitIsle_Response> implements IReturn<GysEmlak_SpEmlakKisitIsle_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTuru: number;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;

    public constructor(init?: Partial<GysEmlak_SpEmlakKisitIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysEmlak_SpEmlakKisitIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysEmlak_SpEmlakKisitIsle_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpCezaTahakkuk")
export class GysGenel_SpCezaTahakkuk_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piModulKod?: number;
    public piTahakTarih: string;
    public piIslemKod: string;

    public constructor(init?: Partial<GysGenel_SpCezaTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCezaTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpGelirKodBul")
export class GysGenel_SpGelirKodBul_Request extends BaseRequest_1<GysGenel_SpGelirKodBul_Response> implements IReturn<GysGenel_SpGelirKodBul_Response>
{
    public piModulKod?: number;
    public piBeyanKod?: number;
    public piEmlakBeyanTuru: number;

    public constructor(init?: Partial<GysGenel_SpGelirKodBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpGelirKodBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpGelirKodBul_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpTahakkukSil")
export class GysGenel_SpTahakkukSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTahakAnaKod?: number;
    public piTahakIptalKod?: number;
    public piTahakIptalAciklama: string;

    public constructor(init?: Partial<GysGenel_SpTahakkukSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTahakkukSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpTahakkukSorgula")
export class GysGenel_SpTahakkukSorgula_Request extends BaseRequest_1<GysGenel_SpTahakkukSorgula_Response> implements IReturn<GysGenel_SpTahakkukSorgula_Response>
{
    public piTahakAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpTahakkukSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTahakkukSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpTahakkukSorgula_Response(); }
}

// @Route("/GYS/PgGysGenelServis/FnGecikmeZamBul")
export class GysGenel_FnGecikmeZamBul_Request implements IReturn<FnIntResponse>
{
    public piTahakkukKod: number;
    public piTaksitKod?: number;
    public piTahsilTarih: string;

    public constructor(init?: Partial<GysGenel_FnGecikmeZamBul_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnGecikmeZamBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnTahakkukBeyansizKontrol")
export class GysGenel_FnTahakkukBeyansizKontrol_Request implements IReturn<FnIntResponse>
{
    public piTahakAnaKod: number;

    public constructor(init?: Partial<GysGenel_FnTahakkukBeyansizKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnTahakkukBeyansizKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpArsivOlustur")
export class GysGenel_SpArsivOlustur_Request extends BaseRequest_1<GysGenel_SpArsivOlustur_Response> implements IReturn<GysGenel_SpArsivOlustur_Response>
{
    public piKisiKod: number;

    public constructor(init?: Partial<GysGenel_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpArsivOlustur_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpIhbarSilKontrol")
export class GysGenel_SpIhbarSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIhbarAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpIhbarSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpIhbarSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpTahakkukSilKontrol")
export class GysGenel_SpTahakkukSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTahakAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpTahakkukSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTahakkukSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpTerkinSilKontrol")
export class GysGenel_SpTerkinSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTerkinAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpTerkinSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTerkinSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnIhbarTahakkukKontrol")
export class GysGenel_FnIhbarTahakkukKontrol_Request implements IReturn<FnIntResponse>
{
    public piIhbarAnaKod: number;

    public constructor(init?: Partial<GysGenel_FnIhbarTahakkukKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnIhbarTahakkukKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnRakamYaziCevir")
export class GysGenel_FnRakamYaziCevir_Request implements IReturn<FnIntResponse>
{
    public piRakam: number;

    public constructor(init?: Partial<GysGenel_FnRakamYaziCevir_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnRakamYaziCevir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpIhbarTahakkukYap")
export class GysGenel_SpIhbarTahakkukYap_Request extends BaseRequest_1<GysGenel_SpIhbarTahakkukYap_Response> implements IReturn<GysGenel_SpIhbarTahakkukYap_Response>
{
    public piIhbarAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpIhbarTahakkukYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpIhbarTahakkukYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpIhbarTahakkukYap_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpTahakkukSatirSil")
export class GysGenel_SpTahakkukSatirSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTahakkukKod: number;

    public constructor(init?: Partial<GysGenel_SpTahakkukSatirSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTahakkukSatirSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpTerkinOnay")
export class GysGenel_SpTerkinOnay_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTerkinKod: number;

    public constructor(init?: Partial<GysGenel_SpTerkinOnay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTerkinOnay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpCezaIhbarKontrol")
export class GysGenel_SpCezaIhbarKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piModulKod?: number;
    public piBeyanKod?: number;

    public constructor(init?: Partial<GysGenel_SpCezaIhbarKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCezaIhbarKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpDosyaNoOlustur")
export class GysGenel_SpDosyaNoOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piModulKod?: number;

    public constructor(init?: Partial<GysGenel_SpDosyaNoOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpDosyaNoOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpDosyaNoUret")
export class GysGenel_SpDosyaNoUret_Request extends BaseRequest_1<GysGenel_SpDosyaNoUret_Response> implements IReturn<GysGenel_SpDosyaNoUret_Response>
{
    public piKisiKod: number;
    public piModulKod?: number;

    public constructor(init?: Partial<GysGenel_SpDosyaNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpDosyaNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpDosyaNoUret_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpTahakkukSatirSilKontrol")
export class GysGenel_SpTahakkukSatirSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTahakkukKod: number;

    public constructor(init?: Partial<GysGenel_SpTahakkukSatirSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTahakkukSatirSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpTakipNoUret")
export class GysGenel_SpTakipNoUret_Request extends BaseRequest_1<GysGenel_SpTakipNoUret_Response> implements IReturn<GysGenel_SpTakipNoUret_Response>
{
    public piIslemTuru: string;

    public constructor(init?: Partial<GysGenel_SpTakipNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTakipNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpTakipNoUret_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpTerkinYap")
export class GysGenel_SpTerkinYap_Request extends BaseRequest_1<GysGenel_SpTerkinYap_Response> implements IReturn<GysGenel_SpTerkinYap_Response>
{
  public piKisiKod: number;
  public piModulKod?: number;
  public piTahakkukListe: number[];
  public piIslemKod: string;
  public piTerkinTurKod?: number;
  public piAciklama: string;

    public constructor(init?: Partial<GysGenel_SpTerkinYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTerkinYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpTerkinYap_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpCiltSayfa")
export class GysGenel_SpCiltSayfa_Request extends BaseRequest_1<GysGenel_SpCiltSayfa_Response> implements IReturn<GysGenel_SpCiltSayfa_Response>
{
    public piIslemTuru: string;
    public piModulKod?: number;

    public constructor(init?: Partial<GysGenel_SpCiltSayfa_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCiltSayfa_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpCiltSayfa_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpGecikme")
export class GysGenel_SpGecikme_Request extends BaseRequest_1<GysGenel_SpGecikme_Response> implements IReturn<GysGenel_SpGecikme_Response>
{
    public piIslemTuru: string;
    public piGelirKod?: number;
    public piVadeTarih: string;
    public piIslemTarih: string;
    public piAnaTutar: number;
    public piGecikmeKod?: number;

    public constructor(init?: Partial<GysGenel_SpGecikme_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpGecikme_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpGecikme_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpTerkinSil")
export class GysGenel_SpTerkinSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTerkinAnaKod?: number;
    public piTerkinIptalKod?: number;
    public piTerkinIptalAciklama: string;

    public constructor(init?: Partial<GysGenel_SpTerkinSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTerkinSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnTerkinKontrol")
export class GysGenel_FnTerkinKontrol_Request implements IReturn<FnIntResponse>
{
    public piBeyanKod: number;

    public constructor(init?: Partial<GysGenel_FnTerkinKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnTerkinKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpIhbarSil")
export class GysGenel_SpIhbarSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIhbarAnaKod?: number;
    public piIhbarIptalKod?: number;
    public piIhbarIptalAciklama: string;

    public constructor(init?: Partial<GysGenel_SpIhbarSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpIhbarSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnBeyanAdresSorgula")
export class GysGenel_FnBeyanAdresSorgula_Request implements IReturn<FnIntResponse>
{
    public piBeyanKod?: number;
    public piModulKod?: number;

    public constructor(init?: Partial<GysGenel_FnBeyanAdresSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnBeyanAdresSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnIhbarBeyanKontrol")
export class GysGenel_FnIhbarBeyanKontrol_Request implements IReturn<FnIntResponse>
{
    public piBeyanKod: number;

    public constructor(init?: Partial<GysGenel_FnIhbarBeyanKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnIhbarBeyanKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/FnTahakTerkinTutar")
export class GysGenel_FnTahakTerkinTutar_Request implements IReturn<FnIntResponse>
{
    public piTahakkukKod: number;
    public piTerkinKod?: number;
    public piVergiFaiz: string;

    public constructor(init?: Partial<GysGenel_FnTahakTerkinTutar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_FnTahakTerkinTutar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpBeyanSil")
export class GysGenel_SpBeyanSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBeyanKod: number;

    public constructor(init?: Partial<GysGenel_SpBeyanSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpBeyanSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpCalismaGunBul")
export class GysGenel_SpCalismaGunBul_Request extends BaseRequest_1<GysGenel_SpCalismaGunBul_Response> implements IReturn<GysGenel_SpCalismaGunBul_Response>
{
    public piTarih: string;

    public constructor(init?: Partial<GysGenel_SpCalismaGunBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCalismaGunBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpCalismaGunBul_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpCezaIhbar")
export class GysGenel_SpCezaIhbar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piModulKod?: number;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIhbarAnaKod: number;

    public constructor(init?: Partial<GysGenel_SpCezaIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCezaIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpCezaIndirimIsle")
export class GysGenel_SpCezaIndirimIsle_Request extends BaseRequest_1<GysGenel_SpCezaIndirimIsle_Response> implements IReturn<GysGenel_SpCezaIndirimIsle_Response>
{
    public piKisiKod: number;
    public piTahakAnaKod?: number;
    public piIndirimTuru: number;
    public piIndirimOran: number;
    public piAciklama: string;

    public constructor(init?: Partial<GysGenel_SpCezaIndirimIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCezaIndirimIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpCezaIndirimIsle_Response(); }
}

// @Route("/GYS/PgGysGenelServis/SpCezaIndirimKontrol")
export class GysGenel_SpCezaIndirimKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GysGenel_SpCezaIndirimKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCezaIndirimKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGenelServis/SpCezaTmpYaz")
export class GysGenel_SpCezaTmpYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKod: string;
    public piKisiKod: number;
    public piModulKod?: number;
    public piBeyanKod?: number;
    public piDonemKod?: number;
    public piEkVergiEh: string;
    public piYil: number;
    public piGelirKod?: number;
    public piMatrah: number;
    public piTutar: number;
    public piTuru: number;

    public constructor(init?: Partial<GysGenel_SpCezaTmpYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpCezaTmpYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysGtaServis/SpGtaIhbar")
export class GysGta_SpGtaIhbar_Request extends BaseRequest_1<GysGta_SpGtaIhbar_Response> implements IReturn<GysGta_SpGtaIhbar_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piTarhiyatTuru: number;

    public constructor(init?: Partial<GysGta_SpGtaIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGta_SpGtaIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGta_SpGtaIhbar_Response(); }
}

// @Route("/GYS/PgGysGtaServis/SpGtaTahakkuk")
export class GysGta_SpGtaTahakkuk_Request extends BaseRequest_1<GysGta_SpGtaTahakkuk_Response> implements IReturn<GysGta_SpGtaTahakkuk_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;

    public constructor(init?: Partial<GysGta_SpGtaTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGta_SpGtaTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGta_SpGtaTahakkuk_Response(); }
}

// @Route("/GYS/PgGysGtaServis/SpGtaTerkin")
export class GysGta_SpGtaTerkin_Request extends BaseRequest_1<GysGta_SpGtaTerkin_Response> implements IReturn<GysGta_SpGtaTerkin_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piMukBitisTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piMukBitisKod: number;
    public piAlanKisiKod: number;
    public piAlanKisiAcik: string;
    public piTerkinTarih: string;
    public piTerkinTuruKod: number;
    public piTerkinAciklama: string;
    public piKisitliIslemTuru: string;

    public constructor(init?: Partial<GysGta_SpGtaTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGta_SpGtaTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGta_SpGtaTerkin_Response(); }
}

// @Route("/GYS/PgGysGtaServis/SpGtaCezaTmp")
export class GysGta_SpGtaCezaTmp_Request extends BaseRequest_1<GysGta_SpGtaCezaTmp_Response> implements IReturn<GysGta_SpGtaCezaTmp_Response>
{
    public piKisiKod: number;
    public piModulKod: number;
    public piBeyanKod: number;
    public piYil: number;
    public piIslemKod: string;
    public piTahakVergi: number;
    public piCezaTur: string;

    public constructor(init?: Partial<GysGta_SpGtaCezaTmp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGta_SpGtaCezaTmp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGta_SpGtaCezaTmp_Response(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpIndirimIsle")
export class GysHkp_SpHkpIndirimIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piTerkinTarih: string;
    public piTerkinTuruKod?: number;
    public piTerkinAciklama: string;
    public piIslemKod: string;
    public piHkpIndirim: Object;

    public constructor(init?: Partial<GysHkp_SpHkpIndirimIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpIndirimIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpIndirimKontrol")
export class GysHkp_SpHkpIndirimKontrol_Request extends BaseRequest_1<GysHkp_SpHkpIndirimKontrol_Response> implements IReturn<GysHkp_SpHkpIndirimKontrol_Response>
{
    public piIlkKisiKod: number;
    public piSonKisiKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<GysHkp_SpHkpIndirimKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpIndirimKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysHkp_SpHkpIndirimKontrol_Response(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpIhbar")
export class GysHkp_SpHkpIhbar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIsKod: number;
    public piIlkKisiKod?: number;
    public piSonKisiKod?: number;
    public piDuzenlemeTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<GysHkp_SpHkpIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpIhbarTahakkukYap")
export class GysHkp_SpHkpIhbarTahakkukYap_Request extends BaseRequest_1<GysHkp_SpHkpIhbarTahakkukYap_Response> implements IReturn<GysHkp_SpHkpIhbarTahakkukYap_Response>
{
    public piIhbarAnaKod: number;

    public constructor(init?: Partial<GysHkp_SpHkpIhbarTahakkukYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpIhbarTahakkukYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysHkp_SpHkpIhbarTahakkukYap_Response(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpCarpanBul")
export class GysHkp_SpHkpCarpanBul_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIsKod: number;

    public constructor(init?: Partial<GysHkp_SpHkpCarpanBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpCarpanBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpBeyanTasi")
export class GysHkp_SpHkpBeyanTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIsKod: number;
    public piYil: number;

    public constructor(init?: Partial<GysHkp_SpHkpBeyanTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpBeyanTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysHkpServis/SpHkpTebligIsle")
export class GysHkp_SpHkpTebligIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIsKod: number;
    public piIlkKisiKod?: number;
    public piSonKisiKod?: number;
    public piTebligTarih: string;
    public piTebligSekliKod?: number;

    public constructor(init?: Partial<GysHkp_SpHkpTebligIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysHkp_SpHkpTebligIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysIlanServis/SpIlanIhbar")
export class GysIlan_SpIlanIhbar_Request extends BaseRequest_1<GysIlan_SpIlanIhbar_Response> implements IReturn<GysIlan_SpIlanIhbar_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piTarhiyatTuru: number;

    public constructor(init?: Partial<GysIlan_SpIlanIhbar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysIlan_SpIlanIhbar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysIlan_SpIlanIhbar_Response(); }
}

// @Route("/GYS/PgGysIlanServis/SpIlanTerkin")
export class GysIlan_SpIlanTerkin_Request extends BaseRequest_1<GysIlan_SpIlanTerkin_Response> implements IReturn<GysIlan_SpIlanTerkin_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piMukBitisTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piMukBitisKod: number;
    public piAlanKisiKod: number;
    public piAlanKisiAcik: string;
    public piTerkinTarih: string;
    public piTerkinTuruKod: number;
    public piTerkinAciklama: string;
    public piKisitliIslemTuru: string;

    public constructor(init?: Partial<GysIlan_SpIlanTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysIlan_SpIlanTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysIlan_SpIlanTerkin_Response(); }
}

// @Route("/GYS/PgGysIlanServis/SpIlanCezaTmp")
export class GysIlan_SpIlanCezaTmp_Request extends BaseRequest_1<GysIlan_SpIlanCezaTmp_Response> implements IReturn<GysIlan_SpIlanCezaTmp_Response>
{
    public piKisiKod: number;
    public piModulKod: number;
    public piBeyanKod: number;
    public piYil: number;
    public piIslemKod: string;
    public piTahakVergi: number;
    public piCezaTur: string;

    public constructor(init?: Partial<GysIlan_SpIlanCezaTmp_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysIlan_SpIlanCezaTmp_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysIlan_SpIlanCezaTmp_Response(); }
}

// @Route("/GYS/PgGysIlanServis/SpIlanTahakkuk")
export class GysIlan_SpIlanTahakkuk_Request extends BaseRequest_1<GysIlan_SpIlanTahakkuk_Response> implements IReturn<GysIlan_SpIlanTahakkuk_Response>
{
    public piIslemTuru: string;
    public piKisiKod: number;
    public piBeyanTarih: string;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piIlkSiraNo: number;
    public piSonSiraNo: number;
    public piIlkYil: number;
    public piSonYil: number;

    public constructor(init?: Partial<GysIlan_SpIlanTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysIlan_SpIlanTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysIlan_SpIlanTahakkuk_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupSatirSilKontrol")
export class GysMahsup_SpMahsupSatirSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMahsupKod: number;

    public constructor(init?: Partial<GysMahsup_SpMahsupSatirSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupSatirSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupSil")
export class GysMahsup_SpMahsupSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMahsupAnaKod?: number;
    public piMahsupIptalKod?: number;
    public piMahsupIptalAciklama: string;

    public constructor(init?: Partial<GysMahsup_SpMahsupSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupKaydet")
export class GysMahsup_SpMahsupKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;
    public piMahsupAnaKod?: number;
    public piAktarKisiKod?: number;
    public piIslemKod: string;
    public piBorc: Object;
    public piAlacak: Object;

    public constructor(init?: Partial<GysMahsup_SpMahsupKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpBorcSorgula")
export class GysMahsup_SpBorcSorgula_Request extends BaseRequest_1<GysMahsup_SpBorcSorgula_Response> implements IReturn<GysMahsup_SpBorcSorgula_Response>
{
    public piKisiKod: number;
    public piTahsilTarih: string;
    public piIlkYil: number;
    public piIlkDonem: number;
    public piSonYil: number;
    public piSonDonem: number;
    public piGecikmeEh: string;

    public constructor(init?: Partial<GysMahsup_SpBorcSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpBorcSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpBorcSorgula_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpBorcSorgulaTutarEsitle")
export class GysMahsup_SpBorcSorgulaTutarEsitle_Request extends BaseRequest_1<GysMahsup_SpBorcSorgulaTutarEsitle_Response> implements IReturn<GysMahsup_SpBorcSorgulaTutarEsitle_Response>
{
    public piKisiKod: number;
    public piIslemKod: string;
    public piTahsilTarih: string;
    public piTutar: number;

    public constructor(init?: Partial<GysMahsup_SpBorcSorgulaTutarEsitle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpBorcSorgulaTutarEsitle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpBorcSorgulaTutarEsitle_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupSatirSil")
export class GysMahsup_SpMahsupSatirSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMahsupKod: number;

    public constructor(init?: Partial<GysMahsup_SpMahsupSatirSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupSatirSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupToplamAl")
export class GysMahsup_SpMahsupToplamAl_Request extends BaseRequest_1<GysMahsup_SpMahsupToplamAl_Response> implements IReturn<GysMahsup_SpMahsupToplamAl_Response>
{
    public piMahsupAnaKod: number;

    public constructor(init?: Partial<GysMahsup_SpMahsupToplamAl_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupToplamAl_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpMahsupToplamAl_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupBirimFisKaydet")
export class GysMahsup_SpMahsupBirimFisKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimFisKod: number;
    public piMahsupAnaKod?: number;
    public piIslemTuru: string;

    public constructor(init?: Partial<GysMahsup_SpMahsupBirimFisKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupBirimFisKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpTahakGiderGelir")
export class GysMahsup_SpTahakGiderGelir_Request extends BaseRequest_1<GysMahsup_SpTahakGiderGelir_Response> implements IReturn<GysMahsup_SpTahakGiderGelir_Response>
{
    public piTahakkukKod?: number;
    public piDonem: number;
    public piMahsupAnaKod?: number;
    public piVergiFaiz: string;
    public piTutar: number;

    public constructor(init?: Partial<GysMahsup_SpTahakGiderGelir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpTahakGiderGelir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpTahakGiderGelir_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpAlacakSorgula")
export class GysMahsup_SpAlacakSorgula_Request extends BaseRequest_1<GysMahsup_SpAlacakSorgula_Response> implements IReturn<GysMahsup_SpAlacakSorgula_Response>
{
    public piKisiKod: number;
    public piTahsilatKod?: number;

    public constructor(init?: Partial<GysMahsup_SpAlacakSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpAlacakSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpAlacakSorgula_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpBorcSorgulaTutar")
export class GysMahsup_SpBorcSorgulaTutar_Request extends BaseRequest_1<GysMahsup_SpBorcSorgulaTutar_Response> implements IReturn<GysMahsup_SpBorcSorgulaTutar_Response>
{
    public piKisiKod: number;
    public piIslemKod: string;
    public piTahsilTarih: string;
    public piModulKod?: number;
    public piGelirKod?: number;
    public piReferansKod?: number;

    public constructor(init?: Partial<GysMahsup_SpBorcSorgulaTutar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpBorcSorgulaTutar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpBorcSorgulaTutar_Response(); }
}

// @Route("/GYS/PgGysMahsupServis/SpIadeBirimFisKaydet")
export class GysMahsup_SpIadeBirimFisKaydet_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piBirimFisKod?: number;
    public piMahsupAnaKod?: number;
    public piIslemTuru: string;

    public constructor(init?: Partial<GysMahsup_SpIadeBirimFisKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpIadeBirimFisKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpIadeMahsupKaydet")
export class GysMahsup_SpIadeMahsupKaydet_Request extends BaseRequest_1<GysMahsup_SpIadeMahsupKaydet_Response> implements IReturn<GysMahsup_SpIadeMahsupKaydet_Response>
{
  public piKisiKod: number;
  public piBirimFisKod?: number;
  public piIslemTuru: string;
  public piIslemKod: string;
  public piTahsilKod?: number;
  public piAlacakKodList: number[];
  public piBorcKodList: number[];

  public constructor(init?: Partial<GysMahsup_SpIadeMahsupKaydet_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysMahsup_SpIadeMahsupKaydet_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysMahsup_SpIadeMahsupKaydet_Response(); }
}
// @Route("/GYS/PgGysMahsupServis/SpMahsupDengele")
export class GysMahsup_SpMahsupDengele_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemKod: string;

    public constructor(init?: Partial<GysMahsup_SpMahsupDengele_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupDengele_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpMahsupSilKontrol")
export class GysMahsup_SpMahsupSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMahsupAnaKod: number;

    public constructor(init?: Partial<GysMahsup_SpMahsupSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpMahsupSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysMahsupServis/SpTaksitBorcSorgula")
export class GysMahsup_SpTaksitBorcSorgula_Request extends BaseRequest_1<GysMahsup_SpTaksitBorcSorgula_Response> implements IReturn<GysMahsup_SpTaksitBorcSorgula_Response>
{
    public piKisiKod: number;
    public piTahsilTarih: string;
    public piIlkYil: number;
    public piIlkDonem: number;
    public piSonYil: number;
    public piSonDonem: number;
    public piGecikmeEh: string;
    public piTaksitNo: number;

    public constructor(init?: Partial<GysMahsup_SpTaksitBorcSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysMahsup_SpTaksitBorcSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysMahsup_SpTaksitBorcSorgula_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpBorcBordro")
export class GysSayistay_SpBorcBordro_Request extends BaseRequest_1<GysSayistay_SpBorcBordro_Response> implements IReturn<GysSayistay_SpBorcBordro_Response>
{
    public piIlkKisi: number;
    public piSonKisi: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piIlkDonem: number;
    public piSonDonem: number;
    public piIlkVade: string;
    public piSonVade: string;

    public constructor(init?: Partial<GysSayistay_SpBorcBordro_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpBorcBordro_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpBorcBordro_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpEkatiatikBeyan")
export class GysSayistay_SpEkatiatikBeyan_Request extends BaseRequest_1<GysSayistay_SpEkatiatikBeyan_Response> implements IReturn<GysSayistay_SpEkatiatikBeyan_Response>
{
    public piDonem: number;

    public constructor(init?: Partial<GysSayistay_SpEkatiatikBeyan_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpEkatiatikBeyan_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpEkatiatikBeyan_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpEmlBeyanMuaf")
export class GysSayistay_SpEmlBeyanMuaf_Request extends BaseRequest_1<GysSayistay_SpEmlBeyanMuaf_Response> implements IReturn<GysSayistay_SpEmlBeyanMuaf_Response>
{
    public piDonem: number;

    public constructor(init?: Partial<GysSayistay_SpEmlBeyanMuaf_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpEmlBeyanMuaf_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpEmlBeyanMuaf_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpOdemeEmri")
export class GysSayistay_SpOdemeEmri_Request extends BaseRequest_1<GysSayistay_SpOdemeEmri_Response> implements IReturn<GysSayistay_SpOdemeEmri_Response>
{
    public piIlkKisi: number;
    public piSonKisi: number;
    public piIlkTarih: string;
    public piSonTarih: string;

    public constructor(init?: Partial<GysSayistay_SpOdemeEmri_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpOdemeEmri_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpOdemeEmri_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpCtvBeyan")
export class GysSayistay_SpCtvBeyan_Request extends BaseRequest_1<GysSayistay_SpCtvBeyan_Response> implements IReturn<GysSayistay_SpCtvBeyan_Response>
{
    public piDonem: number;

    public constructor(init?: Partial<GysSayistay_SpCtvBeyan_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpCtvBeyan_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpCtvBeyan_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpGysTemizle")
export class GysSayistay_SpGysTemizle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public deger: string;

    public constructor(init?: Partial<GysSayistay_SpGysTemizle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpGysTemizle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysSayistay/SpIlanBeyan")
export class GysSayistay_SpIlanBeyan_Request extends BaseRequest_1<GysSayistay_SpIlanBeyan_Response> implements IReturn<GysSayistay_SpIlanBeyan_Response>
{
    public piDonem: number;

    public constructor(init?: Partial<GysSayistay_SpIlanBeyan_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpIlanBeyan_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpIlanBeyan_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpKisiListe")
export class GysSayistay_SpKisiListe_Request extends BaseRequest_1<GysSayistay_SpKisiListe_Response> implements IReturn<GysSayistay_SpKisiListe_Response>
{
    public piIlkKisi: number;
    public piSonKisi: number;

    public constructor(init?: Partial<GysSayistay_SpKisiListe_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpKisiListe_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpKisiListe_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpBorcSms")
export class GysSayistay_SpBorcSms_Request extends BaseRequest_1<GysSayistay_SpBorcSms_Response> implements IReturn<GysSayistay_SpBorcSms_Response>
{
    public piIlkKisi: number;
    public piSonKisi: number;
    public piIlkYil: number;
    public piSonYil: number;
    public piIlkDonem: number;
    public piSonDonem: number;
    public piIlkVade: string;
    public piSonVade: string;

    public constructor(init?: Partial<GysSayistay_SpBorcSms_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpBorcSms_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpBorcSms_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpEmlBeyanThk")
export class GysSayistay_SpEmlBeyanThk_Request extends BaseRequest_1<GysSayistay_SpEmlBeyanThk_Response> implements IReturn<GysSayistay_SpEmlBeyanThk_Response>
{
    public piDonem: number;

    public constructor(init?: Partial<GysSayistay_SpEmlBeyanThk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpEmlBeyanThk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpEmlBeyanThk_Response(); }
}

// @Route("/GYS/PgGysSayistay/SpTahsilatBordro")
export class GysSayistay_SpTahsilatBordro_Request extends BaseRequest_1<GysSayistay_SpTahsilatBordro_Response> implements IReturn<GysSayistay_SpTahsilatBordro_Response>
{
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkVezne: number;
    public piSonVezne: number;

    public constructor(init?: Partial<GysSayistay_SpTahsilatBordro_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysSayistay_SpTahsilatBordro_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysSayistay_SpTahsilatBordro_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilatDetay")
export class GysTahsil_SpTahsilatDetay_Request extends BaseRequest_1<GysTahsil_SpTahsilatDetay_Response> implements IReturn<GysTahsil_SpTahsilatDetay_Response>
{
    public piKod: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilatDetay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilatDetay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilatDetay_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilKontrolSatir")
export class GysTahsil_SpTahsilKontrolSatir_Request extends BaseRequest_1<GysTahsil_SpTahsilKontrolSatir_Response> implements IReturn<GysTahsil_SpTahsilKontrolSatir_Response>
{
    public piMakbuzAnaKod: number;
    public piTaksitNo: number;
    public piModulKod: number;
    public piDetayGelirKod: number;
    public piYil: number;
    public piDonem: number;
    public piEkVergiEh: string;

    public constructor(init?: Partial<GysTahsil_SpTahsilKontrolSatir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilKontrolSatir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilKontrolSatir_Response(); }
}

// @Route("/DGY/PgdGysTahsilServis/SpKisiDefaultDeger")
export class GysTahsil_SpKisiDefaultDeger_Request extends BaseRequest_1<GysTahsil_SpKisiDefaultDeger_Response> implements IReturn<GysTahsil_SpKisiDefaultDeger_Response>
{
    public piKisiKod: number;

    public constructor(init?: Partial<GysTahsil_SpKisiDefaultDeger_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpKisiDefaultDeger_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpKisiDefaultDeger_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilSilKontrol")
export class GysTahsil_SpTahsilSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTahsilAnaKod: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilatDengele")
export class GysTahsil_SpTahsilatDengele_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIslemKod: string;
    public piTutar: number;
    public piVezneKod: number;
    public piTaksitNo: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilatDengele_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilatDengele_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilatTur")
export class GysTahsil_SpTahsilatTur_Request extends BaseRequest_1<GysTahsil_SpTahsilatTur_Response> implements IReturn<GysTahsil_SpTahsilatTur_Response>
{
    public piVezneKod: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilatTur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilatTur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilatTur_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilatYap")
export class GysTahsil_SpTahsilatYap_Request extends BaseRequest_1<GysTahsil_SpTahsilatYap_Response> implements IReturn<GysTahsil_SpTahsilatYap_Response>
{
    public piIslemKod: string;
    public piKisiKod: number;
    public piModulKod?: number;
    public piVezneKod?: number;
    public piTaksitNo: number;
    public piTaksitAnaKod: number;
    public piTahsilTarih: string;
    public piHavaleTarih?: string;
    public piHavaleNo: string;
    public piTahsilatTurKod: number;
    public piSeriNo: string;
    public piMakbuzNo: number;
    public piKrediAdSoyad: string;
    public piKrediTckn: number;
    public piKrediVergiNo: string;
    public piAciklama: string;
    public piBankaOnayNo: string;
    public piToplamTahsilTutar: number;
    public piTahsilKodList: number[];

    public constructor(init?: Partial<GysTahsil_SpTahsilatYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilatYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilatYap_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilSatirKontrol")
export class GysTahsil_SpTahsilSatirKontrol_Request extends BaseRequest_1<GysTahsil_SpTahsilSatirKontrol_Response> implements IReturn<GysTahsil_SpTahsilSatirKontrol_Response>
{
    public piMakbuzAnaKod: number;
    public piTaksitNo: number;
    public piModulKod?: number;
    public piDetayGelirKod?: number;
    public piYil: number;
    public piDonem: number;
    public piEkVergiEh: string;

    public constructor(init?: Partial<GysTahsil_SpTahsilSatirKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilSatirKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilSatirKontrol_Response(); }
}

export enum DabSeverity
{
  Error = 'Error',
  Warning = 'Warning',
  Info = 'Info',
}

export class DWarningDto
{
  public level: number;
  public message: string;
  public severity: DabSeverity;
  public errorCode: string;

  public constructor(init?: Partial<DWarningDto>) { (Object as any).assign(this, init); }
}

export class GysTahsil_SpBorcSorgula_Response extends BaseResponse
{
  public poIslemKod: string;
  public poTahsilTarih: string;
  public poNakitTahsilatZorunluEh: string;
  public poIndirimEh: string;
  public poIcraEh: string;
  public poIhbarEh: string;
  public poGecikmisTaksitEh: string;
  // DKM-5204: su abonesinin banka otomatik ödeme talimatı var mı (E/H)
  public poBankaTalimatEh?: string;
  public poUyariList: DWarningDto[];
  public poAciklama: string;

  public constructor(init?: Partial<GysTahsil_SpBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/GYS/GysTahsilServis/SpBorcSorgula")
export class GysTahsil_SpBorcSorgula_Request extends BaseRequest_1<GysTahsil_SpBorcSorgula_Response> implements IReturn<GysTahsil_SpBorcSorgula_Response>
{
  public piKisiKod: number;
  public piVezneKod?: number;
  public piModulKod?: number;
  // Doluysa backend SP_BORC_SORGULA_V2'yi çağırır, piModulKod dikkate alınmaz
  public piModulKodListe?: number[];
  public piTaksitAnaKod?: number;
  public piTaksit?: number;
  public piIlkSira: number;
  public piSonSira: number;
  public piIlkYil: number;
  public piSonYil: number;
  public piIlkDonem: number;
  public piSonDonem: number;
  public piSuAboneKod?: number;
  public piReferansKod?: number;
  public piGelirTuru: number;
  public piGelirKod?: number;
  public piTahsilTarih: string;
  public piHavaleTarih?: string;
  public piSiralamaTuru: number;

  public constructor(init?: Partial<GysTahsil_SpBorcSorgula_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysTahsil_SpBorcSorgula_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysTahsil_SpBorcSorgula_Response(); }
}



// @Route("/GYS/GysTahsilServis/SpTahsilKontrol")
export class GysTahsil_SpTahsilKontrol_Request extends BaseRequest_1<GysTahsil_SpTahsilKontrol_Response> implements IReturn<GysTahsil_SpTahsilKontrol_Response>
{
    public piVezneKod?: number;
    public piTaksitNo: number;
    public piIslemKod: string;

    public constructor(init?: Partial<GysTahsil_SpTahsilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilKontrol_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilSil")
export class GysTahsil_SpTahsilSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTahsilAnaKod?: number;
    public piMakbuzIptalKod?: number;
    public piMakbuzIptalAciklama: string;

    public constructor(init?: Partial<GysTahsil_SpTahsilSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/GysTahsilServis/SpVezneTahsilToplam")
export class GysTahsil_SpVezneTahsilToplam_Request extends BaseRequest_1<GysTahsil_SpVezneTahsilToplam_Response> implements IReturn<GysTahsil_SpVezneTahsilToplam_Response>
{
    public piVezneKod?: number;
    public piTarih: string;

    public constructor(init?: Partial<GysTahsil_SpVezneTahsilToplam_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpVezneTahsilToplam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpVezneTahsilToplam_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilatlarim")
export class GysTahsil_SpTahsilatlarim_Request extends BaseRequest_1<GysTahsil_SpTahsilatlarim_Response> implements IReturn<GysTahsil_SpTahsilatlarim_Response>
{
    public piKisiKod: number;
    public piVezneKod: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilatlarim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilatlarim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilatlarim_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpMakbuzNoUret")
export class GysTahsil_SpMakbuzNoUret_Request extends BaseRequest_1<GysTahsil_SpMakbuzNoUret_Response> implements IReturn<GysTahsil_SpMakbuzNoUret_Response>
{
    public piVezneKod: number;

    public constructor(init?: Partial<GysTahsil_SpMakbuzNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpMakbuzNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpMakbuzNoUret_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpWebTahsilKontrol")
export class GysTahsil_SpWebTahsilKontrol_Request extends BaseRequest_1<GysTahsil_SpWebTahsilKontrol_Response> implements IReturn<GysTahsil_SpWebTahsilKontrol_Response>
{
    public piIslemTuru: number;
    public piSorguKodu: string;

    public constructor(init?: Partial<GysTahsil_SpWebTahsilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpWebTahsilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpWebTahsilKontrol_Response(); }
}

// @Route("/GYS/GysTahsilServis/SpTahsilatMasterGetir")
export class GysTahsil_SpTahsilatMasterGetir_Request extends BaseRequest_1<GysTahsil_SpTahsilatMasterGetir_Response> implements IReturn<GysTahsil_SpTahsilatMasterGetir_Response>
{
    public piKod: number;

    public constructor(init?: Partial<GysTahsil_SpTahsilatMasterGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilatMasterGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTahsil_SpTahsilatMasterGetir_Response(); }
}

// @Route("/GYS/PgGysTaksitServis/SpTaksitSil")
export class GysTaksit_SpTaksitSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTaksitAnaKod?: number;
    public piTaksitIptalKod?: number;
    public piTaksitIptalAciklama: string;

    public constructor(init?: Partial<GysTaksit_SpTaksitSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTaksit_SpTaksitSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysTaksitServis/SpTaksitBoz")
export class GysTaksit_SpTaksitBoz_Request extends BaseRequest_1<GysTaksit_SpTaksitBoz_Response> implements IReturn<GysTaksit_SpTaksitBoz_Response>
{
    public piTaksitAnaKod: number;
    public piTaksitKontrolTur: number;
    public piIptalTur: string;

    public constructor(init?: Partial<GysTaksit_SpTaksitBoz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTaksit_SpTaksitBoz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTaksit_SpTaksitBoz_Response(); }
}

// @Route("/GYS/PgGysTaksitServis/SpTaksitDurumSorgula")
export class GysTaksit_SpTaksitDurumSorgula_Request extends BaseRequest_1<GysTaksit_SpTaksitDurumSorgula_Response> implements IReturn<GysTaksit_SpTaksitDurumSorgula_Response>
{
    public piTaksitAnaKod: number;

    public constructor(init?: Partial<GysTaksit_SpTaksitDurumSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTaksit_SpTaksitDurumSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTaksit_SpTaksitDurumSorgula_Response(); }
}

// @Route("/GYS/PgGysTaksitServis/SpTaksitSilKontrol")
export class GysTaksit_SpTaksitSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTaksitAnaKod: number;

    public constructor(init?: Partial<GysTaksit_SpTaksitSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTaksit_SpTaksitSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GYS/PgGysTaksitWebServis/SpTaksitWebKaydet")
export class GysTaksitWeb_SpTaksitWebKaydet_Request extends BaseRequest_1<GysTaksitWeb_SpTaksitWebKaydet_Response> implements IReturn<GysTaksitWeb_SpTaksitWebKaydet_Response>
{
    public piKisiKod: number;
    public piTaksitSayisi: number;
    public piAciklama1: string;
    public piAciklama2: string;

    public constructor(init?: Partial<GysTaksitWeb_SpTaksitWebKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTaksitWeb_SpTaksitWebKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTaksitWeb_SpTaksitWebKaydet_Response(); }
}

// @Route("/GYS/PgGysTaksitWebServis/SpBorcSorgulaTaksitWeb")
export class GysTaksitWeb_SpBorcSorgulaTaksitWeb_Request extends BaseRequest_1<GysTaksitWeb_SpBorcSorgulaTaksitWeb_Response> implements IReturn<GysTaksitWeb_SpBorcSorgulaTaksitWeb_Response>
{
    public piKisiKod?: number;
    public piSorguTuru: number;
    public piSuAboneKod?: number;
    public piModulKod?: number;
    public piBankaKod: number;

    public constructor(init?: Partial<GysTaksitWeb_SpBorcSorgulaTaksitWeb_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTaksitWeb_SpBorcSorgulaTaksitWeb_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysTaksitWeb_SpBorcSorgulaTaksitWeb_Response(); }
}

// @Route("/Kps/GenKisiKpsOlustur", "POST")
export class GenKisi_KpsOlustur_Request extends BaseRequest_1<GenKisi_KpsOlustur_Response> implements IReturn<GenKisi_KpsOlustur_Response>
{
    public tckn: string;
    public vergiNo: string;
    public dogumTarihi?: string;
    public detayYn: boolean;
    public kisiTuru: KisiTurleri;

    public constructor(init?: Partial<GenKisi_KpsOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKisi_KpsOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKisi_KpsOlustur_Response(); }
}

// @Route("/Kps/GenKisiKpsGuncelle", "POST")
export class GenKisi_KpsGuncelle_Request extends BaseRequest_1<GenKisi_KpsGuncelle_Response> implements IReturn<GenKisi_KpsGuncelle_Response>
{
    public kisiKod: number;
    public detayYn: boolean;
    public forceYn: boolean;

    public constructor(init?: Partial<GenKisi_KpsGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKisi_KpsGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKisi_KpsGuncelle_Response(); }
}

// @Route("/Kps/GenKisiKpsTopluGuncelle", "POST")
export class GenKisi_KpsTopluGuncelle_Request extends BaseRequest_1<GenKisi_KpsTopluGuncelle_Response> implements IReturn<GenKisi_KpsTopluGuncelle_Response>
{
    public kisiKodStart: number;
    public kisiKodEnd: number;
    public detayYn: boolean;
    public forceYn: boolean;

    public constructor(init?: Partial<GenKisi_KpsTopluGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKisi_KpsTopluGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKisi_KpsTopluGuncelle_Response(); }
}

// @Route("/Kps/SysKisiKpsOlustur", "POST")
export class SysKisi_KpsOlustur_Request extends BaseRequest_1<SysKisi_KpsOlustur_Response> implements IReturn<SysKisi_KpsOlustur_Response>
{
    public tckn: string;
    public vergiNo: string;
    public dogumTarihi?: string;
    public detayYn: boolean;
    public kisiTuru: KisiTurleri;

    public constructor(init?: Partial<SysKisi_KpsOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysKisi_KpsOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysKisi_KpsOlustur_Response(); }
}

// @Route("/Kps/SysKisiKpsGuncelle", "POST")
export class SysKisi_KpsGuncelle_Request extends BaseRequest_1<SysKisi_KpsGuncelle_Response> implements IReturn<SysKisi_KpsGuncelle_Response>
{
    public sysKisiKod: number;
    public detayYn: boolean;
    public forceYn: boolean;

    public constructor(init?: Partial<SysKisi_KpsGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysKisi_KpsGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysKisi_KpsGuncelle_Response(); }
}

// @Route("/Kps/IkaPersonelKpsOlustur", "POST")
export class IkaPersonel_KpsOlustur_Request extends BaseRequest_1<IkaPersonel_KpsOlustur_Response> implements IReturn<IkaPersonel_KpsOlustur_Response>
{
    public tckn: string;
    public vergiNo: string;
    public dogumTarihi?: string;
    public detayYn: boolean;
    public kisiTuru: KisiTurleri;
    public personelTurKod: number;
    public emekliSandikNo: string;
    public personelKod?:number;
    public ilkGirisTarih?: string;
    public izinBaslangicTarih?: string;

    public constructor(init?: Partial<IkaPersonel_KpsOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaPersonel_KpsOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaPersonel_KpsOlustur_Response(); }
}

// @Route("/Kps/IkaPersonelKpsGuncelle", "POST")
export class IkaPersonel_KpsGuncelle_Request extends BaseRequest_1<IkaPersonel_KpsGuncelle_Response> implements IReturn<IkaPersonel_KpsGuncelle_Response>
{
    public ikaPersonelKod: number;
    public detayYn: boolean;
    public forceYn: boolean;

    public constructor(init?: Partial<IkaPersonel_KpsGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaPersonel_KpsGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaPersonel_KpsGuncelle_Response(); }
}

// @Route("/Kps/GenKpsKisiAileSorgula", "POST")
export class GenKpsKisiAile_Sorgula_Request extends BaseRequest_1<GenKpsKisiAile_Sorgula_Response> implements IReturn<GenKpsKisiAile_Sorgula_Response>
{
    public tckn: string;
    public dogumTarihi: string;

    public constructor(init?: Partial<GenKpsKisiAile_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKpsKisiAile_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKpsKisiAile_Sorgula_Response(); }
}

// @Route("/Kps/GenKpsVedopSorgula", "POST")
export class GenKpsVedopSorgula_Sorgula_Request extends BaseRequest_1<GenKpsVedopSorgula_Sorgula_Response> implements IReturn<GenKpsVedopSorgula_Sorgula_Response>
{
    public tckn: string;
    public vergiNo: string;

    public constructor(init?: Partial<GenKpsVedopSorgula_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKpsVedopSorgula_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKpsVedopSorgula_Sorgula_Response(); }
}

// @Route("/Kps/GenKpsKisiSorgula", "POST")
export class GenKpsKisi_Sorgula_Request extends BaseRequest_1<GenKpsKisi_Sorgula_Response> implements IReturn<GenKpsKisi_Sorgula_Response>
{
    public tckn: string;
    public dogumTarihi: string;

    public constructor(init?: Partial<GenKpsKisi_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKpsKisi_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKpsKisi_Sorgula_Response(); }
}

// @Route("/Gen/GenKullaniciDabIdSenkron", "POST")
export class GenKullanici_DabIdSenkron_Request extends BaseRequest_1<GenKullanici_DabIdSenkron_Response> implements IReturn<GenKullanici_DabIdSenkron_Response>
{

    public constructor(init?: Partial<GenKullanici_DabIdSenkron_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKullanici_DabIdSenkron_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKullanici_DabIdSenkron_Response(); }
}

// @Route("/Gen/GenKullaniciProfileChangePassword", "POST")
export class GenKullaniciProfile_ChangePassword_Request extends BaseRequest_1<GenKullaniciProfile_ChangePassword_Response> implements IReturn<GenKullaniciProfile_ChangePassword_Response>
{
    public username: string;
    public currentPassword: string;
    public newPassword: string;
    public confirmNewPassword: string;

    public constructor(init?: Partial<GenKullaniciProfile_ChangePassword_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKullaniciProfile_ChangePassword_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKullaniciProfile_ChangePassword_Response(); }
}

// @Route("/Gen/GenKullaniciChangePassword", "POST")
export class GenKullanici_ChangePassword_Request extends BaseRequest_1<GenKullanici_ChangePassword_Response> implements IReturn<GenKullanici_ChangePassword_Response>
{
    public username: string;
    public password: string;
    public confirmPassword: string;

    public constructor(init?: Partial<GenKullanici_ChangePassword_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKullanici_ChangePassword_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKullanici_ChangePassword_Response(); }
}

// @Route("/Gen/GenWebKisiDabIdSenkron", "POST")
export class GenWebKisi_DabIdSenkron_Request extends BaseRequest_1<GenWebKisi_DabIdSenkron_Response> implements IReturn<GenWebKisi_DabIdSenkron_Response>
{

    public constructor(init?: Partial<GenWebKisi_DabIdSenkron_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenWebKisi_DabIdSenkron_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenWebKisi_DabIdSenkron_Response(); }
}

// @Route("/Gen/GenDetsisTanimSenkron", "POST")
export class GenDetsisTanim_Senkron_Request extends BaseRequest_1<GenDetsisTanim_Senkron_Response> implements IReturn<GenDetsisTanim_Senkron_Response>
{

    public constructor(init?: Partial<GenDetsisTanim_Senkron_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenDetsisTanim_Senkron_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenDetsisTanim_Senkron_Response(); }
}

// @Route("/DST/PgdStsGenelServis/SpTeklifDetayOlustur")
export class StsGenel_SpTeklifDetayOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIhaleKod: number;
    public piTeklifKod: number;

    public constructor(init?: Partial<StsGenel_SpTeklifDetayOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpTeklifDetayOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpKullaniciKurumGetir")
export class StsGenel_SpKullaniciKurumGetir_Request extends BaseRequest_1<StsGenel_SpKullaniciKurumGetir_Response> implements IReturn<StsGenel_SpKullaniciKurumGetir_Response>
{
    public piDonem: number;

    public constructor(init?: Partial<StsGenel_SpKullaniciKurumGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpKullaniciKurumGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGenel_SpKullaniciKurumGetir_Response(); }
}

// @Route("/DST/PgdStsGenelServis/SpTaleptenIhaleDetayYaz")
export class StsGenel_SpTaleptenIhaleDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem:number;
    public piIstekKod:number;
    public piIhaleKod:number;

    public constructor(init?: Partial<StsGenel_SpTaleptenIhaleDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpTaleptenIhaleDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class StsGUI_TaleptenIhaleDetayYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public Donem:number;
    public IstekKod:number;
    public IhaleKod:number;

    public constructor(init?: Partial<StsGUI_TaleptenIhaleDetayYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_TaleptenIhaleDetayYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpArsivOlustur")
export class StsGenel_SpArsivOlustur_Request extends BaseRequest_1<StsGenel_SpArsivOlustur_Response> implements IReturn<StsGenel_SpArsivOlustur_Response>
{
    public piIhaleKod: number;

    public constructor(init?: Partial<StsGenel_SpArsivOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGenel_SpArsivOlustur_Response(); }
}

// @Route("/DST/PgdStsGenelServis/SpTeklifKurusDuzelt")
export class StsGenel_SpTeklifKurusDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIhaleKod: number;
    public piTeklifKod: number;

    public constructor(init?: Partial<StsGenel_SpTeklifKurusDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpTeklifKurusDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpYakMaliyetOlustur")
export class StsGenel_SpYakMaliyetOlustur_Request extends BaseRequest_1<StsGenel_SpYakMaliyetOlustur_Response> implements IReturn<StsGenel_SpYakMaliyetOlustur_Response>
{
    public piDonem: number;
    public piIhaleKod: number;
    public piIslemTuru: number;

    public constructor(init?: Partial<StsGenel_SpYakMaliyetOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpYakMaliyetOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGenel_SpYakMaliyetOlustur_Response(); }
}

// @Route("/DST/PgdStsGenelServis/FnKurumKullaniciKontrol")
export class StsGenel_FnKurumKullaniciKontrol_Request implements IReturn<FnIntResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;

    public constructor(init?: Partial<StsGenel_FnKurumKullaniciKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_FnKurumKullaniciKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DST/PgdStsGenelServis/FnIhaleDetayKontrol")
export class StsGenel_FnIhaleDetayKontrol_Request implements IReturn<FnIntResponse>
{
    public piIhaleKod: number;

    public constructor(init?: Partial<StsGenel_FnIhaleDetayKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_FnIhaleDetayKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpTeklifSil")
export class StsGenel_SpTeklifSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTeklifKod: number;

    public constructor(init?: Partial<StsGenel_SpTeklifSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpTeklifSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/FnIhaleKontrol")
export class StsGenel_FnIhaleKontrol_Request implements IReturn<FnIntResponse>
{
    public piIhaleKod: number;

    public constructor(init?: Partial<StsGenel_FnIhaleKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_FnIhaleKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpIhaleSil")
export class StsGenel_SpIhaleSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIhaleKod: number;

    public constructor(init?: Partial<StsGenel_SpIhaleSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpIhaleSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpMuayeneDetayOlustur")
export class StsGenel_SpMuayeneDetayOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIhaleKod: number;
    public piTeklifKod: number;
    public piMuayeneKod: number;

    public constructor(init?: Partial<StsGenel_SpMuayeneDetayOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpMuayeneDetayOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpMuayeneSil")
export class StsGenel_SpMuayeneSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMuayeneKod: number;

    public constructor(init?: Partial<StsGenel_SpMuayeneSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpMuayeneSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpMuayeneSilKontrol")
export class StsGenel_SpMuayeneSilKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piMuayeneKod: number;

    public constructor(init?: Partial<StsGenel_SpMuayeneSilKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpMuayeneSilKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/FnTeklifKontrol")
export class StsGenel_FnTeklifKontrol_Request implements IReturn<FnIntResponse>
{
    public piIhaleKod: number;

    public constructor(init?: Partial<StsGenel_FnTeklifKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_FnTeklifKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpIhaleDetayDuzelt")
export class StsGenel_SpIhaleDetayDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{


  public piDonem: number;
  public piIhaleKod: number;
  public piIhaleDetayKod: number;
  public piTasinirKod: string;
  public piHesapKod: string;
  public piFonksiyonelKod: string;
  public piFinansmanKod: string;
  public piEkoGiderKod: string;
  public piDevirButceEh: string;


    public constructor(init?: Partial<StsGenel_SpIhaleDetayDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpIhaleDetayDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/FnTemButceKontrol")
export class StsGenel_FnTemButceKontrol_Request implements IReturn<FnIntResponse>
{
    public piDonem?: number;
    public piKurumsalKod?: string;
    public piFonksiyonelKod?: string;
    public piFinansmanKod?: string;
    public piEkonomikKod?: string;
    public piDevirButceEh?: string;

    public constructor(init?: Partial<StsGenel_FnTemButceKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_FnTemButceKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpIstekSil")
export class StsGenel_SpIstekSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIstekKod: number;

    public constructor(init?: Partial<StsGenel_SpIstekSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpIstekSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DST/PgdStsGenelServis/SpMuayeneKurusDuzelt")
export class StsGenel_SpMuayeneKurusDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piIhaleKod: number;
    public piMuayeneKod: number;

    public constructor(init?: Partial<StsGenel_SpMuayeneKurusDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGenel_SpMuayeneKurusDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/ArsivOlustur", "POST")
export class StsGUI_ArsivOlustur_Request implements IReturn<BaseResponse>
{
    public arsivKod: number;
    public ihaleKod: number;

    public constructor(init?: Partial<StsGUI_ArsivOlustur_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_ArsivOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/DetayDuzelt", "POST")
export class StsGUI_DetayDuzelt_Request implements IReturn<BaseResponse>
{
    public ihaleDetayKod: number;
    public donem: number;
    public arsivKod: number;

    public constructor(init?: Partial<StsGUI_DetayDuzelt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_DetayDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/TifCikisIsle", "POST")
export class StsGUI_TifCikisIsle_Request extends BaseRequest_1<TifCikisIsle_Response> implements IReturn<TifCikisIsle_Response>
{
    public muayeneKod: number;

    public constructor(init?: Partial<StsGUI_TifCikisIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_TifCikisIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TifCikisIsle_Response(); }
}

// @Route("/Sts/MuayeneKurusDuzelt", "POST")
export class StsGUI_MuayeneKurusDuzelt_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public muayeneKod: number;

    public constructor(init?: Partial<StsGUI_MuayeneKurusDuzelt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_MuayeneKurusDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class StsGUI_MuayeneTasinirIsle_Request implements IReturn<BaseResponse>
{
    public muayeneKod: number;

    public constructor(init?: Partial<StsGUI_MuayeneTasinirIsle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_MuayeneTasinirIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/MuayeneCikis", "POST")
export class StsGUI_MuayeneCikis_Request implements IReturn<BaseResponse>
{
    public tifKod: number;
    public muayeneKod: number;
    public cikisTarih: string;
    public cikisTurKod: number;

    public constructor(init?: Partial<StsGUI_MuayeneCikis_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_MuayeneCikis_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/TeklifKurusDuzelt", "POST")
export class StsGUI_TeklifKurusDuzelt_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public teklifKod: number;

    public constructor(init?: Partial<StsGUI_TeklifKurusDuzelt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_TeklifKurusDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/MuhasebeAktarSorgula", "POST")
export class StsGUI_MuhasebeAktarSorgula_Request extends BaseRequest_1<StsGUI_MuhasebeAktarSorgula_Response> implements IReturn<StsGUI_MuhasebeAktarSorgula_Response>
{
    public belgeTurKod: number;

    public constructor(init?: Partial<StsGUI_MuhasebeAktarSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_MuhasebeAktarSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_MuhasebeAktarSorgula_Response(); }
}

// @Route("/Sts/MuhasebeAktarYansitmaSil", "POST")
export class StsGUI_MuhasebeAktarYansitmaSil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<StsGUI_MuhasebeAktarYansitmaSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_MuhasebeAktarYansitmaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/Sorgula2", "POST")
export class StsGUI_Sorgula2_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<StsGUI_Sorgula2_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_Sorgula2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/Sorgula", "POST")
export class StsGUI_Sorgula_Request extends BaseRequest_1<StsGUI_Sorgula_Response> implements IReturn<StsGUI_Sorgula_Response>
{
    public donem: number;
    public belgeTurKod: number;
    public yansitmaKaydetEh: string;

    public constructor(init?: Partial<StsGUI_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_Sorgula_Response(); }
}

// @Route("/Sts/YansimaSil", "POST")
export class StsGUI_YansimaSil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<StsGUI_YansimaSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_YansimaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/Aktar", "POST")
export class StsGUI_Aktar_Request implements IReturn<BaseResponse>
{
    public temFisKod: number;
    public islemKod: string;

    public constructor(init?: Partial<StsGUI_Aktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_Aktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class StsGUI_Aktar2_Request extends BaseRequest_1<StsGUI_Aktar2_Response> implements IReturn<StsGUI_Aktar2_Response>
{
    public islemKod: string;
    public temFisDonem: number;
    public kurumsalKod: string;
    public dosyaNo: number;

    public constructor(init?: Partial<StsGUI_Aktar2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_Aktar2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_Aktar2_Response(); }
}

// @Route("/Sts/TifFormOnay", "POST")
export class StsGUI_TifFormOnay_Request implements IReturn<BaseResponse>
{
    public muayeneKod: number;
    public ambarKod: number;

    public constructor(init?: Partial<StsGUI_TifFormOnay_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_TifFormOnay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Sts/TifCikisForm", "POST")
export class StsGUI_TifCikisForm_Request extends BaseRequest_1<StsGUI_TifCikisForm_Response> implements IReturn<StsGUI_TifCikisForm_Response>
{
    public piDonem: number;
    public piTifGirisKod: number;
    public piCikisTarih: string;
    public piCikisNo: number;
    public piCikisTuru: string;
    public piCikisTurKod: number;
    public piIstekFisTarih: string;
    public piIstekFisNo: number;
    public piCikisAmbarKod: number;
    public piCikisKurumsalKod: string;
    public piTeslimTckn: number;
    public piTeslimAdSoyad: string;
    public piVerilenPersonelKod: number;
    public piCikisYerKod: number;
    public piNereyeGonderildi: string;
    public piCikisMahalleCaddeKod: number;
    public piNotlar: string;
    public piTeslimRolAd: string;
    public piKkyRolAd: string;
    public piVerilenRolAd: string;

    public constructor(init?: Partial<StsGUI_TifCikisForm_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_TifCikisForm_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_TifCikisForm_Response(); }
}

// @Route("/Sts/StsMuhasebeAktarForm", "POST")
export class StsGUI_StsMuhasebeAktarForm_Request extends BaseRequest_1<StsGUI_StsMuhasebeAktarForm_Response> implements IReturn<StsGUI_StsMuhasebeAktarForm_Response>
{
    public piGelenToplam?: number;
    public piDonem?: number;
    public piKurumsalKod?: string;
    public piFisTarih?: string;
    public piFisNo?: number;
    public piFisTuru?: string;
    public piFisIslemKod?: number;
    public piKisiKod?: number;
    public piKisiTckn?: number;
    public piKisiAdiSoyadi?: string;
    public piKisiAdres?: string;
    public piKisiVergiNo?: string;
    public piKisiVergiDairesi?: string;
    public piKisiBankaSubesi?: string;
    public piKisiBankaHesapNo?: string;
    public piKisiIbanNo?: string;
    public piKisiYetkiliKisiKod?: number;
    public piKisiYetkiliAdiSoyadi?: string;
    public piAciklama?: string;
    public piEmaneteAlindiTarih?: string;
    public piEmanetAciklama?: string;
    public piIlkDefterTarih?: string;
    public piSonDefterTarih?: string;
    public piIlkDefterNo?: number;
    public piSonDefterNo?: number;
    public piAvansVerildigiTarih?: string;
    public piAvansNo?: number;
    public piAvansFisNo?: number;
    public piAvansFisNo1?: number;
    public piOdemeTuru?: string;
    public piOdemeNo?: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih?: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih?: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih?: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih?: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih?: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piKayitTarih?: string;
    public piKayitKullaniciKod?: number;
    public piDegisTarih?: string;
    public piDegisKullaniciKod?: number;
    public piDogrudanTeminEh?: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod?: string;
    public piMuayeneKod?: number;

    public constructor(init?: Partial<StsGUI_StsMuhasebeAktarForm_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_StsMuhasebeAktarForm_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_StsMuhasebeAktarForm_Response(); }
}

// @Route("/Sts/TifForm", "POST")
export class StsGUI_TifForm_Request extends BaseRequest_1<StsGUI_TifForm_Response> implements IReturn<StsGUI_TifForm_Response>
{
    public piAmbarKod: number;
    public piDonem: number;
    public piMuayeneKod: number;
    public kkyPersonelKod?: number;
    public teslimTckn?: number;
    public verilenPersonelKod?: number;
    public islemKod: number;
    public nereyeGonderildi?: string;
    public teslimEden?: string;
    public teslimRolAd?: string;
    public verilenRolAd?: string;
    public kkyRolAd?: string;

    public constructor(init?: Partial<StsGUI_TifForm_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_TifForm_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_TifForm_Response(); }
}

export class StsGUI_OtomatikAktarSonra_Request extends BaseRequest_1<StsGUI_OtomatikAktarSonra_Response> implements IReturn<StsGUI_OtomatikAktarSonra_Response>
{
    public donem: number;
    public dosyaNo: number;
    public muayeneKod: number;

    public constructor(init?: Partial<StsGUI_OtomatikAktarSonra_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StsGUI_OtomatikAktarSonra_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StsGUI_OtomatikAktarSonra_Response(); }
}

// @Route("/TEM/PgdTemButon/SpBankaAlacakSorgula")
export class TemButon_SpBankaAlacakSorgula_Request extends BaseRequest_1<TemButon_SpBankaAlacakSorgula_Response> implements IReturn<TemButon_SpBankaAlacakSorgula_Response>
{
    public piDonem: number;
    public piHesapKod: string;

    public constructor(init?: Partial<TemButon_SpBankaAlacakSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemButon_SpBankaAlacakSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemButon_SpBankaAlacakSorgula_Response(); }
}

// @Route("/TEM/PgdTemButon/SpFisYansimaIsle")
export class TemButon_SpFisYansimaIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;

    public constructor(init?: Partial<TemButon_SpFisYansimaIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemButon_SpFisYansimaIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTE/PgdTemButon/SpThkFisYansimaIsle")
export class TemButon_SpThkFisYansimaIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemButon_SpThkFisYansimaIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemButon_SpThkFisYansimaIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemButon/SpFisYansimaSil")
export class TemButon_SpFisYansimaSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;

    public constructor(init?: Partial<TemButon_SpFisYansimaSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemButon_SpFisYansimaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemButon/SpBankaAlacakIsle")
export class TemButon_SpBankaAlacakIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
  public piDonem: number;
  public piHesapKod: string;
  public piFisTarih: string;
  public piFisNo: number;
  public piFisNo1: number;
  public piIslemKod: string;
  public piAlacakListesi: number[];
  public piKisaAciklama: string;
  public piAciklama: string;
  public piOdenenTarih: string;
  public piDetayAktarEh: string;

  public constructor(init?: Partial<TemButon_SpBankaAlacakIsle_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'TemButon_SpBankaAlacakIsle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}
// DKM-5314 Cedric: Odeme Isle penceresi kapaninca islem koduna ait TMP_BANKA_ALACAK satirlarini siler
// @Route("/TEM/PgdTemButon/TmpBankaAlacakSil")
export class TemButon_TmpBankaAlacakSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
  public piIslemKod: string;

  public constructor(init?: Partial<TemButon_TmpBankaAlacakSil_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'TemButon_TmpBankaAlacakSil_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}
// DKM-5321 Cedric (TAAHHUT-23): Taahhutler Defteri listesi kurumsal kod yetkisiyle suzuluyor; donemin toplam / gorulebilen taahhut sayisi
export class TemButon_TaahhutYetkiOzet_Response extends BaseResponse
{
  public poToplam: number;
  public poGorunen: number;

  public constructor(init?: Partial<TemButon_TaahhutYetkiOzet_Response>) { super(init); (Object as any).assign(this, init); }
}
// @Route("/TEM/PgdTemButon/TaahhutYetkiOzet")
export class TemButon_TaahhutYetkiOzet_Request extends BaseRequest_1<TemButon_TaahhutYetkiOzet_Response> implements IReturn<TemButon_TaahhutYetkiOzet_Response>
{
  public piDonem: number;

  public constructor(init?: Partial<TemButon_TaahhutYetkiOzet_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'TemButon_TaahhutYetkiOzet_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new TemButon_TaahhutYetkiOzet_Response(); }
}
// @Route("/TEM/PgdTemButon/SpHesapTasi")
export class TemButon_SpHesapTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piYazDonem: number;

    public constructor(init?: Partial<TemButon_SpHesapTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemButon_SpHesapTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/FncYeniHesapBul")
export class TemFisKontrol_FncYeniHesapBul_Request implements IReturn<FnIntResponse>
{
    public piOkuDonem: number;
    public piOkuHesapKod: string;
    public piYazDonem: number;

    public constructor(init?: Partial<TemFisKontrol_FncYeniHesapBul_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_FncYeniHesapBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/TemButTalepAktEkFisYaz")
export class TemFisKontrol_TemButTalepAktEkFisYaz_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piAnaKod: number;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piAciklama: string;

  public constructor(init?: Partial<TemFisKontrol_TemButTalepAktEkFisYaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_TemButTalepAktEkFisYaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/FncTemBankaAlacakTop")
export class TemFisKontrol_FncTemBankaAlacakTop_Request implements IReturn<FnIntResponse>
{
    public piDonem: number;
    public piHesapKod: string;

    public constructor(init?: Partial<TemFisKontrol_FncTemBankaAlacakTop_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_FncTemBankaAlacakTop_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/SpFisYansimaIsle")
export class TemFisKontrol_SpFisYansimaIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piFisKod: number;

    public constructor(init?: Partial<TemFisKontrol_SpFisYansimaIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_SpFisYansimaIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/SpBirimFisYansimaIsle")
export class TemFisKontrol_SpBirimFisYansimaIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod: number;

    public constructor(init?: Partial<TemFisKontrol_SpBirimFisYansimaIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_SpBirimFisYansimaIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/SpBirimOdemeSablonIsle")
export class TemFisKontrol_SpBirimOdemeSablonIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBirimFisKod: number;
    public piOdemeSablonKod: number;
    public piDogrudanTeminTuru: string;

    public constructor(init?: Partial<TemFisKontrol_SpBirimOdemeSablonIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_SpBirimOdemeSablonIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/FncTemBankaBorcTop")
export class TemFisKontrol_FncTemBankaBorcTop_Request implements IReturn<FnIntResponse>
{
    public piDonem: number;
    public piHesapKod: string;

    public constructor(init?: Partial<TemFisKontrol_FncTemBankaBorcTop_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_FncTemBankaBorcTop_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/FncGiderNetButceToplam")
export class TemFisKontrol_FncGiderNetButceToplam_Request implements IReturn<FnIntResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;
    public piFonksiyonelKod: string;
    public piFinansmanKod: string;
    public piEkoGiderKod: string;

    public constructor(init?: Partial<TemFisKontrol_FncGiderNetButceToplam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_FncGiderNetButceToplam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/PrcImzaYetkiliDoldur")
export class TemFisKontrol_PrcImzaYetkiliDoldur_Request extends BaseRequest_1<TemFisKontrol_PrcImzaYetkiliDoldur_Response> implements IReturn<TemFisKontrol_PrcImzaYetkiliDoldur_Response>
{
    public piDonem: number;
    public piKurumsalKod: string;

    public constructor(init?: Partial<TemFisKontrol_PrcImzaYetkiliDoldur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_PrcImzaYetkiliDoldur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemFisKontrol_PrcImzaYetkiliDoldur_Response(); }
}

// @Route("/TEM/PgdTemFisKontrol/PrcTemKisiKodKontrol")
export class TemFisKontrol_PrcTemKisiKodKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKisiKod: number;

    public constructor(init?: Partial<TemFisKontrol_PrcTemKisiKodKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_PrcTemKisiKodKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/TemButceTalepAktarEkleSil")
export class TemFisKontrol_TemButceTalepAktarEkleSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piAnaKod: number;

    public constructor(init?: Partial<TemFisKontrol_TemButceTalepAktarEkleSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_TemButceTalepAktarEkleSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/FncTemGonEmrGunToplam")
export class TemFisKontrol_FncTemGonEmrGunToplam_Request implements IReturn<FnIntResponse>
{
    public piTarih: string;

    public constructor(init?: Partial<TemFisKontrol_FncTemGonEmrGunToplam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_FncTemGonEmrGunToplam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemFisKontrol/FncTemKullaniciKontrol")
export class TemFisKontrol_FncTemKullaniciKontrol_Request implements IReturn<FnIntResponse>
{
    public piDonem: number;
    public piKurumsalKod: string;

    public constructor(init?: Partial<TemFisKontrol_FncTemKullaniciKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemFisKontrol_FncTemKullaniciKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/Tem/TemHesapYansima", "POST")
export class TemGUI_TemHesapYansima_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public hesapKod: string;
    public hesapTuru: number;

    public constructor(init?: Partial<TemGUI_TemHesapYansima_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TemHesapYansima_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TemBirimGonder", "POST")
export class TemGUI_BirimGonder_Request implements IReturn<BaseResponse>
{
    public temBirimFisKod: number;

    public constructor(init?: Partial<TemGUI_BirimGonder_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BirimGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TemBirimSmsGonder", "POST")
export class TemGUI_BirimSmsGonder_Request implements IReturn<BaseResponse>
{
    public metin: string;
    public gonderTarih: string;
    public gsmNo: string;

    public constructor(init?: Partial<TemGUI_BirimSmsGonder_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BirimSmsGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TemDefterAlacSec", "POST")
export class TemGUI_DefterAlacSec_Request implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<TemGUI_DefterAlacSec_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_DefterAlacSec_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TemDefterAlacKaldir", "POST")
export class TemGUI_DefterAlacKaldir_Request implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<TemGUI_DefterAlacKaldir_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_DefterAlacKaldir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/MuhasebeAktarYansitmaSil", "POST")
export class TemGUI_MuhasebeAktarYansitmaSil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_MuhasebeAktarYansitmaSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_MuhasebeAktarYansitmaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/Sorgula", "POST")
export class TemGUI_Sorgula_Request extends BaseRequest_1<TemGUI_Sorgula_Response> implements IReturn<TemGUI_Sorgula_Response>
{

    public constructor(init?: Partial<TemGUI_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_Sorgula_Response(); }
}

// @Route("/Tem/TahahutYansitmaSil", "POST")
export class TemGUI_TahahutYansitmaSil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_TahahutYansitmaSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TahahutYansitmaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TahsilAktar", "POST")
export class TemGUI_TahsilAktar_Request extends BaseRequest_1<TemGUI_TahsilAktar_Response> implements IReturn<TemGUI_TahsilAktar_Response>
{
    public teslimatKaydetEh: string;
    public piDonem: number;
    public piIlkVezne: number;
    public piSonVezne: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkMakbuzNo: number;
    public piSonMakbuzNo: number;
    public piTahsilTurKod: number;
    // DKM-5395: coklu tahsilat turu (bos = tum turler)
    public piTahsilTurKodlari: number[];
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemGUI_TahsilAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TahsilAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_TahsilAktar_Response(); }
}

// @Route("/Tem/TahsilAktarSilme", "POST")
export class TemGUI_TahsilAktarSilme_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_TahsilAktarSilme_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TahsilAktarSilme_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/Aktar2", "POST")
export class TemGUI_Aktar2_Request implements IReturn<BaseResponse>
{
    public islemKod: string;
    public gelenToplam: number;

    public constructor(init?: Partial<TemGUI_Aktar2_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_Aktar2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TahahutSorgulama", "POST")
export class TemGUI_TahahutSorgulama_Request implements IReturn<BaseResponse>
{
    public fisKod: number;

    public constructor(init?: Partial<TemGUI_TahahutSorgulama_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TahahutSorgulama_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TemTahahutAktar", "POST")
export class TemGUI_TahahutAktar_Request implements IReturn<BaseResponse>
{
    public gelenToplam: number;
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_TahahutAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TahahutAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/FisSilme", "POST")
export class TemGUI_FisSilme_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_FisSilme_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_FisSilme_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/KDVMahsupSorgula", "POST")
export class TemGUI_KDVMahsupSorgula_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public ilkTarih: string;
    public sonTarih: string;
    public devredenKdvHesabi: string;
    public fisKod: number;

    public constructor(init?: Partial<TemGUI_KDVMahsupSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_KDVMahsupSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/BirimFisMahsupSorgula", "POST")
export class TemGUI_BirimFisMahsupSorgula_Request implements IReturn<BaseResponse>
{
    public kisiKod: number;
    public islemTuru: string;
    public birimFisKod: number;
    public mahsupIadeSec: string;

    public constructor(init?: Partial<TemGUI_BirimFisMahsupSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BirimFisMahsupSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/BirimFisMahsupDengele", "POST")
export class TemGUI_BirimFisMahsupDengele_Request implements IReturn<BaseResponse>
{
    public kisiKod: number;
    public islemTuru: string;
    public birimFisKod: number;
    public mahsupSecAlacak: number;

    public constructor(init?: Partial<TemGUI_BirimFisMahsupDengele_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BirimFisMahsupDengele_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/BirimFisMahsupSil", "POST")
export class TemGUI_BirimFisMahsupSil_Request implements IReturn<BaseResponse>
{
    public birimFisKod: number;

    public constructor(init?: Partial<TemGUI_BirimFisMahsupSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BirimFisMahsupSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TaksitAktar", "POST")
export class TemGUI_TaksitAktar_Request implements IReturn<BaseResponse>
{
    public piIslemTuru: number;
    public piIslemKod: string;
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod?: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod?: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;

    public constructor(init?: Partial<TemGUI_TaksitAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TaksitAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/FisSorgula", "POST")
export class TemGUI_FisSorgula_Request implements IReturn<BaseResponse>
{
    public birimFisKod: number;
    public kisiKod: number;
    public islemTuru: string;
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_FisSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_FisSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/GysMahsupSil", "POST")
export class TemGUI_GysMahsupSil_Request implements IReturn<BaseResponse>
{
    public birimFisKod: number;

    public constructor(init?: Partial<TemGUI_GysMahsupSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_GysMahsupSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/FisTopluOnay", "POST")
export class TemGUI_FisTopluOnay_Request extends BaseRequest_1<TemGUI_FisTopluOnay_Response> implements IReturn<TemGUI_FisTopluOnay_Response>
{
    public fisTurKod: number;
    public donem: number;

    public constructor(init?: Partial<TemGUI_FisTopluOnay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_FisTopluOnay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_FisTopluOnay_Response(); }
}

// @Route("/Tem/MuhasebeAktar", "POST")
export class TemGUI_MuhasebeAktar_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TemGUI_MuhasebeAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_MuhasebeAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/TerkinAktar", "POST")
export class TemGUI_TerkinAktar_Request implements IReturn<BaseRequest>
{
    public piGelenToplam: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod?: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod?: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemGUI_TerkinAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TerkinAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseRequest(); }
}

// @Route("/Tem/MahsupAktar", "POST")
export class TemGUI_MahsupAktar_Request implements IReturn<BaseResponse>
{
    public piGelenToplam: number;
    public piIslemKod: string;
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIlkVezne: number;
    public piSonVezne: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkMakbuzNo: number;
    public piSonMakbuzNo: number;
    public piTahsilTurKod: number;

    public constructor(init?: Partial<TemGUI_MahsupAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_MahsupAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/KdvMahsupAktar", "POST")
export class TemGUI_KdvMahsupAktar_Request implements IReturn<BaseRequest>
{
    public piIlkTarih: string;
    public piSonTarih: string;
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod?: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod?: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod?: number;
    public piOtomatikOdemeKod?: number;
    public piTaahhutKod?: number;
    public piHarcamaKod?: number;
    public piDuzenleyenKod?: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod?: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod?: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod?: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod?: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod?: number;
    public piOnaylayanSefKod?: number;
    public piOnaylayanYetkiliKod?: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem?: number;
    public piSatinalmaDosyaNo?: number;
    public piIhaleMaddeKod?: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemGUI_KdvMahsupAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_KdvMahsupAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseRequest(); }
}

// @Route("/Tem/TahakAktar", "POST")
export class TemGUI_TahakAktar_Request implements IReturn<BaseResponse>
{
    public piToplamTahak: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piDonem: number;
    public piKurumsalKod: string;
    public piFisTarih: string;
    public piFisNo: number;
    public piFisNo1: number;
    public piFisTuru: string;
    public piDevirFisKapanis: string;
    public piOdemeBelgeNo: number;
    public piOdemeBelgeNo1: number;
    public piFisIslemKod: number;
    public piKisiKod: number;
    public piKisiTckn: number;
    public piKisiAdiSoyadi: string;
    public piKisiAdres: string;
    public piKisiVergiNo: string;
    public piKisiVergiDairesi: string;
    public piKisiBankaSubesi: string;
    public piKisiBankaHesapNo: string;
    public piKisiIbanNo: string;
    public piKisiYetkiliKisiKod: number;
    public piKisiYetkiliAdiSoyadi: string;
    public piAciklama: string;
    public piEmaneteAlindiTarih: string;
    public piEmanetAciklama: string;
    public piIlkDefterTarih: string;
    public piSonDefterTarih: string;
    public piIlkDefterNo: number;
    public piSonDefterNo: number;
    public piAvansVerildigiTarih: string;
    public piAvansNo: number;
    public piAvansFisNo: number;
    public piAvansFisNo1: number;
    public piOdemeTuru: string;
    public piOdemeNo: string;
    public piPlanOdemeKod: number;
    public piOtomatikOdemeKod: number;
    public piTaahhutKod: number;
    public piHarcamaKod: number;
    public piDuzenleyenKod: number;
    public piDuzenleyenTarih: string;
    public piMaliKontrolKod: number;
    public piMaliKontrolTarih: string;
    public piHarcamaYetkilisiKod: number;
    public piHarcamaYetkilisiTarih: string;
    public piMuhasebeYetkilisiKod: number;
    public piMuhasebeYetkilisiTarih: string;
    public piVezneYetkiliKod: number;
    public piVezneYetkiliTarih: string;
    public piOnaylayanMemurKod: number;
    public piOnaylayanSefKod: number;
    public piOnaylayanYetkiliKod: number;
    public piKayitTarih: string;
    public piKayitKullaniciKod: number;
    public piDegisTarih: string;
    public piDegisKullaniciKod: number;
    public piDogrudanTeminEh: string;
    public piSatinalmaDonem: number;
    public piSatinalmaDosyaNo: number;
    public piIhaleMaddeKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TemGUI_TahakAktar_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_TahakAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/FisDetayTutarGetir", "POST")
export class TemGUI_FisDetayTutarGetir_Request extends BaseRequest_1<TemGUI_FisDetayTutarGetir_Response> implements IReturn<TemGUI_FisDetayTutarGetir_Response>
{
    public fisKod: number;
    public donem: number;

    public constructor(init?: Partial<TemGUI_FisDetayTutarGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_FisDetayTutarGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_FisDetayTutarGetir_Response(); }
}

// @Route("/Tem/BankaDefterTutarGoster", "POST")
export class TemGUI_BankaDefterTutarGoster_Request extends BaseRequest_1<TemGUI_BankaDefterTutarGoster_Response> implements IReturn<TemGUI_BankaDefterTutarGoster_Response>
{
    public donem: number;
    public hesapKod: string;
    public fisNo: number;
    public fisNo1: number;
    public fisDetayKod: number;

    public constructor(init?: Partial<TemGUI_BankaDefterTutarGoster_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BankaDefterTutarGoster_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_BankaDefterTutarGoster_Response(); }
}

// @Route("/Tem/OtomatikDefaultGetir", "POST")
export class TemGUI_OtomatikDefaultGetir_Request extends BaseRequest_1<TemGUI_OtomatikDefaultGetir_Response> implements IReturn<TemGUI_OtomatikDefaultGetir_Response>
{
    public Donem: number;

    public constructor(init?: Partial<TemGUI_OtomatikDefaultGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_OtomatikDefaultGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_OtomatikDefaultGetir_Response(); }
}

export class TemGUI_YeniFisEkle_Request extends BaseRequest_1<TemGUI_YeniFisEkle_Response> implements IReturn<TemGUI_YeniFisEkle_Response>
{
    public fisKod: number;

    public constructor(init?: Partial<TemGUI_YeniFisEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_YeniFisEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_YeniFisEkle_Response(); }
}

export class TemGUI_KisiEkstreRapor_Request extends BaseRequest_1<TemGUI_KisiEkstreRapor_Response> implements IReturn<TemGUI_KisiEkstreRapor_Response>
{
    public piDonem: number;
    public piIlkKisiKod: number;
    public piSonKisiKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkTutar: number;
    public piSonTutar: number;
    public piSifirEh: string;
    public piBirimDosyaEh: string;

    public constructor(init?: Partial<TemGUI_KisiEkstreRapor_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_KisiEkstreRapor_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_KisiEkstreRapor_Response(); }
}

// @Route("/Tem/MaliCetvel", "POST")
export class TemGUI_MaliCetvel_Request implements IReturn<BaseResponse>
{
    public okuDonem: number;
    public yazDonem: number;
    public onay: boolean;

    public constructor(init?: Partial<TemGUI_MaliCetvel_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_MaliCetvel_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tem/FisTutarGetir", "POST")
export class TemGUI_FisTutarGetir_Request extends BaseRequest_1<TemGUI_FisTutarGetir_Response> implements IReturn<TemGUI_FisTutarGetir_Response>
{
    public fisKod: number;
    public hesapKod: string;
    public karsiDefterNo?: number;
    public kisiKod?: number;
    public kurumsalKod?: string;

    public constructor(init?: Partial<TemGUI_FisTutarGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_FisTutarGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_FisTutarGetir_Response(); }
}

// @Route("/Tem/FisTutarGetir", "POST")
export class TemGUI_BirimFisTutarGetir_Request extends BaseRequest_1<TemGUI_FisTutarGetir_Response> implements IReturn<TemGUI_FisTutarGetir_Response>
{
    public birimFisKod: number;
    public hesapKod: string;
    public karsiDefterNo?: number;
    public kisiKod?: number;
    public kurumsalKod?: string;

    public constructor(init?: Partial<TemGUI_BirimFisTutarGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_BirimFisTutarGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_FisTutarGetir_Response(); }
}

// @Route("/TEM/PgdTemYilsonuServis/FncYeniHesapBul")
export class TemYilsonu_FncYeniHesapBul_Request implements IReturn<FnIntResponse>
{
    public piOkuDonem: number;
    public piOkuHesapKod: string;
    public piYazDonem: number;

    public constructor(init?: Partial<TemYilsonu_FncYeniHesapBul_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_FncYeniHesapBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpHesapBilancoDuzelt")
export class TemYilsonu_SpHesapBilancoDuzelt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piBilancoHesapKod: string;
    public piHesapTuru: string;

    public constructor(init?: Partial<TemYilsonu_SpHesapBilancoDuzelt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpHesapBilancoDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpTem570Kapat")
export class TemYilsonu_SpTem570Kapat_Request extends BaseRequest_1<TemYilsonu_SpTem570Kapat_Response> implements IReturn<TemYilsonu_SpTem570Kapat_Response>
{
    public piOkuDonem: number;
    public piYazKurumsalKod: string;
    public piYevTarih: string;
    public piYevNo: number;
    public piYevNo1: number;
    public piFisIslemKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TemYilsonu_SpTem570Kapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpTem570Kapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemYilsonu_SpTem570Kapat_Response(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpTem600Kapat")
export class TemYilsonu_SpTem600Kapat_Request extends BaseRequest_1<TemYilsonu_SpTem600Kapat_Response> implements IReturn<TemYilsonu_SpTem600Kapat_Response>
{
    public piOkuDonem: number;
    public piYazKurumsalKod: string;
    public piYevTarih: string;
    public piYevNo: number;
    public piYevNo1: number;
    public piFisIslemKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TemYilsonu_SpTem600Kapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpTem600Kapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemYilsonu_SpTem600Kapat_Response(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpTem800Kapat")
export class TemYilsonu_SpTem800Kapat_Request extends BaseRequest_1<TemYilsonu_SpTem800Kapat_Response> implements IReturn<TemYilsonu_SpTem800Kapat_Response>
{
    public piOkuDonem: number;
    public piYazKurumsalKod: string;
    public piYevTarih: string;
    public piYevNo: number;
    public piYevNo1: number;
    public piFisIslemKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TemYilsonu_SpTem800Kapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpTem800Kapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemYilsonu_SpTem800Kapat_Response(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpTem900Kapat")
export class TemYilsonu_SpTem900Kapat_Request extends BaseRequest_1<TemYilsonu_SpTem900Kapat_Response> implements IReturn<TemYilsonu_SpTem900Kapat_Response>
{
    public piOkuDonem: number;
    public piYazKurumsalKod: string;
    public piYevTarih: string;
    public piYevNo: number;
    public piYevNo1: number;
    public piFisIslemKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TemYilsonu_SpTem900Kapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpTem900Kapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemYilsonu_SpTem900Kapat_Response(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpTemTumKapat")
export class TemYilsonu_SpTemTumKapat_Request extends BaseRequest_1<TemYilsonu_SpTemTumKapat_Response> implements IReturn<TemYilsonu_SpTemTumKapat_Response>
{
    public piOkuDonem: number;
    public piYazKurumsalKod: string;
    public piYevTarih: string;
    public piYevNo: number;
    public piYevNo1: number;
    public piFisIslemKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TemYilsonu_SpTemTumKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpTemTumKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemYilsonu_SpTemTumKapat_Response(); }
}

// @Route("/TEM/PgdTemYilsonuServis/SpTemYilsonuDevir")
export class TemYilsonu_SpTemYilsonuDevir_Request extends BaseRequest_1<TemYilsonu_SpTemYilsonuDevir_Response> implements IReturn<TemYilsonu_SpTemYilsonuDevir_Response>
{
    public piOkuDonem: number;
    public piYazDonem: number;
    public piYazKurumsalKod: string;
    public piYevTarih: string;
    public piYevNo: number;
    public piYevNo1: number;
    public piFisIslemKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TemYilsonu_SpTemYilsonuDevir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemYilsonu_SpTemYilsonuDevir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemYilsonu_SpTemYilsonuDevir_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/FnDemirbasSorguKontrol")
export class TmsGenel_FnDemirbasSorguKontrol_Request implements IReturn<FnIntResponse>
{
    public piDemirbasKod: number;
    public piSorguTuru: number;

    public constructor(init?: Partial<TmsGenel_FnDemirbasSorguKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_FnDemirbasSorguKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FnIntResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpMuhAmortisman")
export class TmsGenel_SpMuhAmortisman_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemKod: string;

    public constructor(init?: Partial<TmsGenel_SpMuhAmortisman_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpMuhAmortisman_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifCikisYap")
export class TmsGenel_SpTifCikisYap_Request extends BaseRequest_1<TmsGenel_SpTifCikisYap_Response> implements IReturn<TmsGenel_SpTifCikisYap_Response>
{
    public piDonem: number;
    public piTifGirisKod: number;
    public piCikisTarih: string;
    public piCikisNo: number;
    public piCikisTuru: string;
    public piCikisTurKod: number;
    public piIstekFisTarih: string;
    public piIstekFisNo: number;
    public piCikisAmbarKod: number;
    public piCikisKurumsalKod: string;
    public piTeslimTckn: number;
    public piTeslimAdSoyad: string;
    public piVerilenPersonelKod: number;
    public piCikisYerKod: number;
    public piNereyeGonderildi: string;
    public piCikisMahalleCaddeKod: number;
    public piNotlar: string;
    public piTeslimRolAd: string;
    public piKkyRolAd: string;
    public piVerilenRolAd: string;

    public constructor(init?: Partial<TmsGenel_SpTifCikisYap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifCikisYap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTifCikisYap_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpZimmetKontrol")
export class TmsGenel_SpZimmetKontrol_Request extends BaseRequest_1<TmsGenel_SpZimmetKontrol_Response> implements IReturn<TmsGenel_SpZimmetKontrol_Response>
{
    public piZimmetTerkinKod: number;

    public constructor(init?: Partial<TmsGenel_SpZimmetKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpZimmetKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpZimmetKontrol_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpAmortismanHesapla")
export class TmsGenel_SpAmortismanHesapla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piYil: number;

    public constructor(init?: Partial<TmsGenel_SpAmortismanHesapla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpAmortismanHesapla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifYilsonuDevir")
export class TmsGenel_SpTifYilsonuDevir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piOkuAmbarKod: number;
    public piOkuKurumsalKod: string;
    public piYazDonem: number;
    public piYazAmbarKod: number;
    public piYazKurumsalKod: string;
    public piDevirTarih: string;
    public piGirisNo: number;
    public piGirisTurKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TmsGenel_SpTifYilsonuDevir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifYilsonuDevir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTutanakNoUret")
export class TmsGenel_SpTutanakNoUret_Request extends BaseRequest_1<TmsGenel_SpTutanakNoUret_Response> implements IReturn<TmsGenel_SpTutanakNoUret_Response>
{
    public piDonem: number;
    public piAmbarKod: number;

    public constructor(init?: Partial<TmsGenel_SpTutanakNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTutanakNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTutanakNoUret_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifNoUret")
export class TmsGenel_SpTifNoUret_Request extends BaseRequest_1<TmsGenel_SpTifNoUret_Response> implements IReturn<TmsGenel_SpTifNoUret_Response>
{
    public piDonem: number;
    public piAmbarKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifNoUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifNoUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTifNoUret_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifGirisKontrol")
export class TmsGenel_SpTifGirisKontrol_Request extends BaseRequest_1<TmsGenel_SpTifGirisKontrol_Response> implements IReturn<TmsGenel_SpTifGirisKontrol_Response>
{
    public piDonem: number;
    public piTifGirisKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifGirisKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifGirisKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTifGirisKontrol_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifGirisBul")
export class TmsGenel_SpTifGirisBul_Request extends BaseRequest_1<TmsGenel_SpTifGirisBul_Response> implements IReturn<TmsGenel_SpTifGirisBul_Response>
{
    public piMuayeneKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifGirisBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifGirisBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTifGirisBul_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifMasterUret")
export class TmsGenel_SpTifMasterUret_Request extends BaseRequest_1<TmsGenel_SpTifMasterUret_Response> implements IReturn<TmsGenel_SpTifMasterUret_Response>
{
    public piMuayeneKod: number;
    public piTeslimAdSoyad: string;
    public piTeslimTckn: number;
    public piTeslimRolAd: string;
    public piKkyPersonelKod: number;
    public piKkyRolAd: string;
    public piVerilenPersonelKod: number;
    public piVerilenRolAd: string;
    public piNereyeGonderildi: string;
    public piGirisTurKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifMasterUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifMasterUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTifMasterUret_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifTasinirUret")
export class TmsGenel_SpTifTasinirUret_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTifGirisDetayKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifTasinirUret_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifTasinirUret_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpZimmetTerkinSil")
export class TmsGenel_SpZimmetTerkinSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piZimmetTerkinAnaKod: number;

    public constructor(init?: Partial<TmsGenel_SpZimmetTerkinSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpZimmetTerkinSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTasinirKontrol")
export class TmsGenel_SpTasinirKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piTasinirKod: string;

    public constructor(init?: Partial<TmsGenel_SpTasinirKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTasinirKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTerkinImhaSil")
export class TmsGenel_SpTerkinImhaSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTerkinImhaKod: number;

    public constructor(init?: Partial<TmsGenel_SpTerkinImhaSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTerkinImhaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifAmbarGirisAktar")
export class TmsGenel_SpTifAmbarGirisAktar_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTifGirisKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifAmbarGirisAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifAmbarGirisAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifCikisSil")
export class TmsGenel_SpTifCikisSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTifCikisKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifCikisSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifCikisSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifGirisSil")
export class TmsGenel_SpTifGirisSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piTifGirisKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifGirisSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifGirisSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifSatinAktar")
export class TmsGenel_SpTifSatinAktar_Request extends BaseRequest_1<TmsGenel_SpTifSatinAktar_Response> implements IReturn<TmsGenel_SpTifSatinAktar_Response>
{
    public piDonem: number;
    public piTifGirisKod: number;
    public piMuayeneKod: number;

    public constructor(init?: Partial<TmsGenel_SpTifSatinAktar_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifSatinAktar_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGenel_SpTifSatinAktar_Response(); }
}

// @Route("/TMS/PgTmsGenelServis/SpTifAmbarDevir")
export class TmsGenel_SpTifAmbarDevir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuDonem: number;
    public piOkuAmbarKod: number;
    public piOkuKurumsalKod: string;
    public piYazAmbarKod: number;
    public piYazKurumsalKod: string;
    public piDevirTarih: string;
    public piCikisNo: number;
    public piCikisTurKod: number;
    public piGirisNo: number;
    public piGirisTurKod: number;
    public piNotlar: string;

    public constructor(init?: Partial<TmsGenel_SpTifAmbarDevir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGenel_SpTifAmbarDevir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/Sorgula", "POST")
export class TmsGUI_Sorgula_Request extends BaseRequest_1<TmsGUI_Sorgula_Response> implements IReturn<TmsGUI_Sorgula_Response>
{

    public constructor(init?: Partial<TmsGUI_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGUI_Sorgula_Response(); }
}

// @Route("/Tms/AmbarDevirTamam", "POST")
export class TmsGUI_AmbarDevirTamam_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public okuAmbar: number;
    public yazAmbar: number;
    public okuKurumsal: string;
    public yazKurumsal: string;
    public girisTurKod: number;
    public cikisTurKod: number;

    public constructor(init?: Partial<TmsGUI_AmbarDevirTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_AmbarDevirTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TifAmbarCikisTamam", "POST")
export class TmsGUI_TifAmbarCikisTamam_Request implements IReturn<BaseResponse>
{
    public cikisTurKod: number;
    public tifGirisKod: number;
    public cikisTarih: string;

    public constructor(init?: Partial<TmsGUI_TifAmbarCikisTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TifAmbarCikisTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/AmbarTamam", "POST")
export class TmsGUI_AmbarTamam_Request implements IReturn<BaseResponse>
{
    public ambarKod: number;
    public sifre: string;

    public constructor(init?: Partial<TmsGUI_AmbarTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_AmbarTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TifGirisKurusDuzelt", "POST")
export class TmsGUI_TifGirisKurusDuzelt_Request implements IReturn<BaseResponse>
{
    public girisKod: number;

    public constructor(init?: Partial<TmsGUI_TifGirisKurusDuzelt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TifGirisKurusDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TifCikisKurusDuzelt", "POST")
export class TmsGUI_TifCikisKurusDuzelt_Request implements IReturn<BaseResponse>
{
    public cikisKod: number;

    public constructor(init?: Partial<TmsGUI_TifCikisKurusDuzelt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TifCikisKurusDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/AmbarCikisTamam", "POST")
export class TmsGUI_AmbarCikisTamam_Request implements IReturn<BaseResponse>
{
    public cikisTarih: string;
    public tifCikisKod: number;

    public constructor(init?: Partial<TmsGUI_AmbarCikisTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_AmbarCikisTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TerkinTamam", "POST")
export class TmsGUI_TerkinTamam_Request implements IReturn<BaseResponse>
{
    public fisTarih: string;
    public terkinKod: number;
    public zimmetEh: string;
    public verilenPersonelKod: number;
    public verilenRolAd: string;

    public constructor(init?: Partial<TmsGUI_TerkinTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TerkinTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TerkinTopluCikisTamam", "POST")
export class TmsGUI_TerkinTopluCikisTamam_Request implements IReturn<BaseResponse>
{
    public tifCikisKod: number;
    public islemKod: string;
    public verilenRolAd: string;

    public constructor(init?: Partial<TmsGUI_TerkinTopluCikisTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TerkinTopluCikisTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TifCikisTopluCikisSorgula", "POST")
export class TmsGUI_TifCikisTopluCikisSorgula_Request implements IReturn<BaseResponse>
{
    public tifCikisKod: number;
    public tasinirTur: string;
    public piAmbarKod: number;
    public piDonem: number;
    public piTasinirGrup: string;
    public piIlkTasinir: string;
    public piSonTasinir: string;

    public constructor(init?: Partial<TmsGUI_TifCikisTopluCikisSorgula_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TifCikisTopluCikisSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/ImhaTopluCikisTamam", "POST")
export class TmsGUI_ImhaTopluCikisTamam_Request implements IReturn<BaseResponse>
{
    public tasinirTur: number;
    public sonTasinir: number;
    public imhaKod: number;
    public ilkTasinir: number;

    public constructor(init?: Partial<TmsGUI_ImhaTopluCikisTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_ImhaTopluCikisTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/CikisDetaySil", "POST")
export class TmsGUI_CikisDetaySil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_CikisDetaySil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_CikisDetaySil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/CikisDetayKontrol", "POST")
export class TmsGUI_CikisDetayKontrol_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_CikisDetayKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_CikisDetayKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/DemirbasKontrol", "POST")
export class TmsGUI_DemirbasKontrol_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_DemirbasKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_DemirbasKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TerkinImhaAmbarTamam", "POST")
export class TmsGUI_TerkinImhaAmbarTamam_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public ambarKod: number;
    public sifre: string;

    public constructor(init?: Partial<TmsGUI_TerkinImhaAmbarTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TerkinImhaAmbarTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/BankaAlacakSil", "POST")
export class TmsGUI_BankaAlacakSil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_BankaAlacakSil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_BankaAlacakSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/AmbarDevirForm", "POST")
export class TmsGUI_AmbarDevirForm_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public okuAmbarKod: number;
    public yazAmbarKod: number;
    public kurumsalKod: string;
    public cikisNo: number;
    public girisTurKod: number;
    public cikisTurKod: number;

    public constructor(init?: Partial<TmsGUI_AmbarDevirForm_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_AmbarDevirForm_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/YilSonuAmbarDevirForm", "POST")
export class TmsGUI_YilSonuAmbarDevirForm_Request implements IReturn<BaseResponse>
{
    public okuDonem: number;
    public yazDonem: number;
    public okuAmbarKod: number;
    public yazAmbarKod: number;
    public okuKurumsalKod: string;
    public yazKurumsalKod: string;
    public girisTurKod: number;

    public constructor(init?: Partial<TmsGUI_YilSonuAmbarDevirForm_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_YilSonuAmbarDevirForm_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TerkinImhaTamam", "POST")
export class TmsGUI_TerkinImhaTamam_Request implements IReturn<BaseResponse>
{
    public terkinImhaKod: number;
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_TerkinImhaTamam_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TerkinImhaTamam_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/IslemCikisDetaySil", "POST")
export class TmsGUI_IslemCikisDetaySil_Request implements IReturn<BaseResponse>
{
    public islemKod: string;

    public constructor(init?: Partial<TmsGUI_IslemCikisDetaySil_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_IslemCikisDetaySil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TIFGirisAmbarCikis", "POST")
export class TmsGUI_TIFGirisAmbarCikis_Request implements IReturn<BaseResponse>
{
    public donem: number;
    public tifGirisKod: number;
    public piCikisTarih: string;
    public piCikisNo: number;
    public piCikisTuru: string;
    public piCikisTurKod: number;
    public piIstekFisTarih: string;
    public piIstekFisNo: number;
    public piCikisAmbarKod: number;
    public piCikisKurumsalKod: string;
    public piTeslimTckn: number;
    public piTeslimAdSoyad: string;
    public piVerilenPersonelKod: number;
    public piCikisYerKod: number;
    public piNereyeGonderildi: string;
    public piCikisMahalleCaddeKod: number;
    public piNotlar: string;
    public piTeslimRolAd: string;
    public piKkyRolAd: string;
    public piVerilenRolAd: string;

    public constructor(init?: Partial<TmsGUI_TIFGirisAmbarCikis_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TIFGirisAmbarCikis_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/ZimmetFisTerkin", "POST")
export class TmsGUI_ZimmetFisTerkin_Request implements IReturn<BaseResponse>
{
    public zimmetTerkinKod: number;
    public piZimmetTerkinKod: number;
    public piIslemTarih: string;
    public piIslemTuru: string;
    public piTerkinTurKod: number;
    public piNotlar: string;
    public piVerilenPersonel: number;
    public piVerilenRolAd: string;

    public constructor(init?: Partial<TmsGUI_ZimmetFisTerkin_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_ZimmetFisTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/Tms/TasinirFisIslemDoldur", "POST")
export class TmsGUI_TasinirFisIslemDoldur_Request extends BaseRequest_1<TmsGUI_TasinirFisIslemDoldur_Response> implements IReturn<TmsGUI_TasinirFisIslemDoldur_Response>
{
    public satinalmaDonem: number;
    public satinalmaDosyaNo: number;

    public constructor(init?: Partial<TmsGUI_TasinirFisIslemDoldur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TmsGUI_TasinirFisIslemDoldur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TmsGUI_TasinirFisIslemDoldur_Response(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// export class TemGUI_KisiEkstreRapor_Response extends BaseResponse
// {
//     public islemKod: string;
//
//     public constructor(init?: Partial<TemGUI_KisiEkstreRapor_Response>) { super(init); (Object as any).assign(this, init); }
// }

// export class TemGUI_KisiEkstreRapor_Request extends BaseRequest_1<TemGUI_KisiEkstreRapor_Response> implements IReturn<TemGUI_KisiEkstreRapor_Response>
// {
//     public piDonem: number;
//     public piIlkKisiKod: number;
//     public piSonKisiKod: number;
//     public piIlkTarih: string;
//     public piSonTarih: string;
//     public piIlkTutar: number;
//     public piSonTutar: number;
//     public piSifirEh: string;
//     public piBirimDosyaEh: string;
//
//     public constructor(init?: Partial<TemGUI_KisiEkstreRapor_Request>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'TemGUI_KisiEkstreRapor_Request'; }
//     public getMethod() { return 'POST'; }
//     public createResponse() { return new TemGUI_KisiEkstreRapor_Response(); }
// }

// @Route("/DTE/PgdTemGenelServis/SpTemDefterOdeHazirlik")
export class TemGenel_SpTemDefterOdeHazirlik_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piIslemKod: string;
    public piSonTarih: string;

    public constructor(init?: Partial<TemGenel_SpTemDefterOdeHazirlik_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTemDefterOdeHazirlik_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DTE/PgdTemGenelServis/SpTemDefOdeHazFisOlustur")
export class TemGenel_SpTemDefOdeHazFisOlustur_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;
    public piKod: number;
    public piHesapKod: string;
    public piBankaHesap: string;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazFisOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTemDefOdeHazFisOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class TemGenel_SpTemDefterOdeHazirlikV2_Response extends BaseResponse
{
    public poMesaj: string;

    public constructor(init?: Partial<TemGenel_SpTemDefterOdeHazirlikV2_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DTE/PgdTemGenelServis/SpTemDefterOdeHazirlikV2")
export class TemGenel_SpTemDefterOdeHazirlikV2_Request extends BaseRequest_1<TemGenel_SpTemDefterOdeHazirlikV2_Response> implements IReturn<TemGenel_SpTemDefterOdeHazirlikV2_Response>
{
    public piDonem: number;
    public piSonTarih: string;

    public constructor(init?: Partial<TemGenel_SpTemDefterOdeHazirlikV2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTemDefterOdeHazirlikV2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpTemDefterOdeHazirlikV2_Response(); }
}

export class TemGenel_SpTemDefOdeHazDagitV2_Response extends BaseResponse
{
    public poMesaj: string;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazDagitV2_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DTE/PgdTemGenelServis/SpTemDefOdeHazDagitV2")
export class TemGenel_SpTemDefOdeHazDagitV2_Request extends BaseRequest_1<TemGenel_SpTemDefOdeHazDagitV2_Response> implements IReturn<TemGenel_SpTemDefOdeHazDagitV2_Response>
{
    public piDonem: number;
    public piKisiKod: number;
    /** @description Islem yapilan sekme: 1 = tutar girisi, 2 = mudur onayi */
    public piStatu: number;
    /** @description Firmaya odenecek toplam tutar; bos/0 mudur onayini iptal eder */
    public piTutar?: number;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazDagitV2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTemDefOdeHazDagitV2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpTemDefOdeHazDagitV2_Response(); }
}

export class TemGenel_SpTemDefOdeHazDurumDegistirV2_Response extends BaseResponse
{
    public poMesaj: string;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazDurumDegistirV2_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DTE/PgdTemGenelServis/SpTemDefOdeHazDurumDegistirV2")
export class TemGenel_SpTemDefOdeHazDurumDegistirV2_Request extends BaseRequest_1<TemGenel_SpTemDefOdeHazDurumDegistirV2_Response> implements IReturn<TemGenel_SpTemDefOdeHazDurumDegistirV2_Response>
{
    public piDonem: number;
    public piKisiKodList: number[];
    /** @description Firmalarin su anki statusu (1 = tutar girisi, 2 = mudur onayi) */
    public piStatu: number;
    /** @description 1 -> 2 Mudur Onayina Gonder, 2 -> 1 Muhasebeye Geri Gonder */
    public piYeniStatu: number;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazDurumDegistirV2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTemDefOdeHazDurumDegistirV2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpTemDefOdeHazDurumDegistirV2_Response(); }
}

export class TemGenel_SpTemDefOdeHazFisOlusturV2_Response extends BaseResponse
{
    public poMesaj: string;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazFisOlusturV2_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DTE/PgdTemGenelServis/SpTemDefOdeHazFisOlusturV2")
export class TemGenel_SpTemDefOdeHazFisOlusturV2_Request extends BaseRequest_1<TemGenel_SpTemDefOdeHazFisOlusturV2_Response> implements IReturn<TemGenel_SpTemDefOdeHazFisOlusturV2_Response>
{
    public piDonem: number;
    public piKisiKod: number;
    public piHesapKod: string;

    public constructor(init?: Partial<TemGenel_SpTemDefOdeHazFisOlusturV2_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpTemDefOdeHazFisOlusturV2_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpTemDefOdeHazFisOlusturV2_Response(); }
}

// @Route("/Kps/GenKisiTempKpsTopluGuncelle", "POST")
export class GenKisiTemp_KpsTopluGuncelle_Request extends BaseRequest_1<GenKisiTemp_KpsTopluGuncelle_Response> implements IReturn<GenKisiTemp_KpsTopluGuncelle_Response>
{
    public kisiKodStart: number;
    public kisiKodEnd: number;
    public detayYn: boolean;
    public forceYn: boolean;
    public kisiTuru: KisiTurleri;
    public useHangfire: boolean;

    public constructor(init?: Partial<GenKisiTemp_KpsTopluGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKisiTemp_KpsTopluGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKisiTemp_KpsTopluGuncelle_Response(); }
}

export class GenKisiTemp_KpsTopluGuncelle_Response extends BaseResponse
{

    public constructor(init?: Partial<GenKisiTemp_KpsTopluGuncelle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysGenel_SpTahakkukSorgulaYeni_Response extends BaseResponse
{
    public tahakkukList: TmpTyGysTahakkukTerkin[];

    public constructor(init?: Partial<GysGenel_SpTahakkukSorgulaYeni_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DGY/PgdGysGenelServis/SpTahakkukSorgulaYeni")
export class GysGenel_SpTahakkukSorgulaYeni_Request extends BaseRequest_1<GysGenel_SpTahakkukSorgulaYeni_Response> implements IReturn<GysGenel_SpTahakkukSorgulaYeni_Response>
{
    public piTahakAnaKod: number;
    public piIslemKod: string;

    public constructor(init?: Partial<GysGenel_SpTahakkukSorgulaYeni_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGenel_SpTahakkukSorgulaYeni_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGenel_SpTahakkukSorgulaYeni_Response(); }
}

export class TmpTyGysTahakkukTerkin {
    belediyeKod?:number;
    islemKod?:string;
    kod?:number;
    netGecikmeFaiz?:number;
    netTahakkukVergi?:number;
    netTahsilatGecikmeFaiz?:number;
    netTahsilatVergi?:number;
    tahakkukKod?:number;
    constructor(item?:any){
    this.belediyeKod=item?.BelediyeKod;
    this.islemKod=item?.IslemKod;
    this.kod=item?.Kod;
    this.netGecikmeFaiz=item?.NetGecikmeFaiz;
    this.netTahakkukVergi=item?.NetTahakkukVergi;
    this.netTahsilatGecikmeFaiz=item?.NetTahsilatGecikmeFaiz;
    this.netTahsilatVergi=item?.NetTahsilatVergi;
    this.tahakkukKod=item?.TahakkukKod;
    }
}

export class KbsKontrol_SpKbsDataOlustur_Response extends BaseResponse
{
    public poDosyaAdi: string;
    public poIslemKod: string;

    public constructor(init?: Partial<KbsKontrol_SpKbsDataOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/KBS/KbsKontrol/SpKbsDataOlustur")
export class KbsKontrol_SpKbsDataOlustur_Request extends BaseRequest_1<KbsKontrol_SpKbsDataOlustur_Response> implements IReturn<KbsKontrol_SpKbsDataOlustur_Response>
{
    public piDonem: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkHesap: string;
    public piSonHesap: string;
    public piTip: string;

    public constructor(init?: Partial<KbsKontrol_SpKbsDataOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'KbsKontrol_SpKbsDataOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new KbsKontrol_SpKbsDataOlustur_Response(); }
}


export class KbsKontrol_SpKbsDataSil_Response extends BaseResponse
{
    public poHata: string;

    public constructor(init?: Partial<KbsKontrol_SpKbsDataSil_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/KBS/PgdKbsKontrol/SpKbsDataSil")
export class KbsKontrol_SpKbsDataSil_Request extends BaseRequest_1<KbsKontrol_SpKbsDataSil_Response> implements IReturn<KbsKontrol_SpKbsDataSil_Response>
{
    public piDonem: number;
    public piIslemKod: string;

    public constructor(init?: Partial<KbsKontrol_SpKbsDataSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'KbsKontrol_SpKbsDataSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new KbsKontrol_SpKbsDataSil_Response(); }
}

export class EisGenel_SpSatisTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;
    // DKM-5359 Cedric (SATIS-Ö7): önizlemede yazılacak, gerçek yazımda yazılan peşinat + taksit satırları (servis EisKiraTahakkukOnizlemeSatir)
    public onizleme?: { kisiKod?: number; tasinmazKod?: number; gelirKod?: number; gelirAd?: string; yil?: number; donem?: number; vadeTarih?: string; kiraTutari: number; kdvTutari: number; toplam: number }[];

    public constructor(init?: Partial<EisGenel_SpSatisTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DEI/PgdEisGenelServis/SpSatisTahakkuk")
export class EisGenel_SpSatisTahakkuk_Request extends BaseRequest_1<EisGenel_SpSatisTahakkuk_Response> implements IReturn<EisGenel_SpSatisTahakkuk_Response>
{
    public piIslemTuru: string;
    public piIslemKod: string;
    public piKisiKod: number;
    public piYil: number;
    public piDonem: number;
    public piTasinmazKod: number;
    public piSatisKod: number;
    public piGelirKod: number;
    public piTahakTarih: string;
    public piAciklama: string;
    // DKM-5359 Cedric (SATIS-Ö7): true ise paket çalıştırılıp yazacağı satırlar okunur, kayıt geri alınır (önizleme)
    public piOnizleme?: boolean;

    public constructor(init?: Partial<EisGenel_SpSatisTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGenel_SpSatisTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EisGenel_SpSatisTahakkuk_Response(); }
}

export class EisGenel_SpDegerGuncelleToplu_Response extends BaseResponse
{
    public poIslemYapildiEh: string;
    // DKM-5367 Cedric (TASINMAZ-17/Ö4): güncellenen (önizlemede: güncellenecek) taşınmaz sayısı ve satırlar
    public guncellenenSayi?: number;
    public satirlar?: EisArtisAktarSatir[];

    public constructor(init?: Partial<EisGenel_SpDegerGuncelleToplu_Response>) { super(init); (Object as any).assign(this, init); }
}

// DKM-5367 Cedric (TASINMAZ-Ö4): Artış Aktar önizleme/sonuç satırı
export class EisArtisAktarSatir
{
    public kod: number;
    public tasinmazKod: number;
    public ad: string;
    public eskiDeger: number;
    public yeniDeger: number;
    public artisTutar: number;

    public constructor(init?: Partial<EisArtisAktarSatir>) { (Object as any).assign(this, init); }
}

// DKM-5367 Cedric (TASINMAZ-06/Ö7): arsa m² rayiç değeri (FN_GYS_ARSA_M2_DEGER_BUL)
export class EisGenel_ArsaRayicDegerBul_Response extends BaseResponse
{
    public m2Deger?: number;

    public constructor(init?: Partial<EisGenel_ArsaRayicDegerBul_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DEI/PgdEisGenelServis/ArsaRayicDegerBul")
export class EisGenel_ArsaRayicDegerBul_Request extends BaseRequest_1<EisGenel_ArsaRayicDegerBul_Response> implements IReturn<EisGenel_ArsaRayicDegerBul_Response>
{
    public piYil?: number;
    public piMahalleCaddeKod?: number;
    public piKapiNo?: number;
    public piKapiNo1?: string;
    public piAda?: number;
    public piParsel?: number;

    public constructor(init?: Partial<EisGenel_ArsaRayicDegerBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGenel_ArsaRayicDegerBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EisGenel_ArsaRayicDegerBul_Response(); }
}

// @Route("/DEİ/PgdEisGenelServis/SpDegerGuncelleToplu")
export class EisGenel_SpDegerGuncelleToplu_Request extends BaseRequest_1<EisGenel_SpDegerGuncelleToplu_Response> implements IReturn<EisGenel_SpDegerGuncelleToplu_Response>
{
    public piIlkTasinmaz: number;
    public piSonTasinmaz: number;
    public piArtisTur: string;
    public piArtisTutar: number;
    // DKM-5367 Cedric (TASINMAZ-Ö4): true ise artış yapılıp sonuç okunur ve geri alınır
    public piOnizleme?: boolean;

    public constructor(init?: Partial<EisGenel_SpDegerGuncelleToplu_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGenel_SpDegerGuncelleToplu_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EisGenel_SpDegerGuncelleToplu_Response(); }
}

// @Route("/DET/PgdEtsGenelServis/SpRezervIsle")
export class EtsGenel_SpRezervIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSalonKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkSaat: string;
    public piSonSaat: string;
    public piKacDakika: number;

    public constructor(init?: Partial<EtsGenel_SpRezervIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EtsGenel_SpRezervIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/DET/PgdEtsGenelServis/SpIzinOnay")
export class EtsGenel_SpIzinOnay_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piEvlenBeyanKod: number;
    public piIzinTarih: string;
    public piIzinNo: number;

    public constructor(init?: Partial<EtsGenel_SpIzinOnay_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EtsGenel_SpIzinOnay_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class ExcelGUI_AracGet_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_AracGet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_AracGet_Request extends BaseRequest_1<ExcelGUI_AracGet_Response> implements IReturn<ExcelGUI_AracGet_Response>
{
    public kods: number[];
    public sorguTuru: number;

    public constructor(init?: Partial<ExcelGUI_AracGet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_AracGet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_AracGet_Response(); }
}

export class ExcelGUI_AracEkle_Request implements IReturn<BaseResponse>
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_AracEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_AracEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class ExcelGUI_AracYakitEkle_Request implements IReturn<BaseResponse>
{
    public yakitListesi: number[];

    public constructor(init?: Partial<ExcelGUI_AracYakitEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_AracYakitEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class ImageResponse extends BaseResponse
{
    public base64: string;
    public image: string;

    public constructor(init?: Partial<ImageResponse>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/UploadPersonelResim")
export class Ika_UploadPersonelResim_Request extends BaseRequest_1<ImageResponse> implements IReturn<ImageResponse>
{
    public personelKod: number;
    public base64: string;
    public image: string;
    public base64Yn: number;

    public constructor(init?: Partial<Ika_UploadPersonelResim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ika_UploadPersonelResim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageResponse(); }
}

export enum ResimSourceType
{
    personel = 1,
}

// @Route("/System/GetResim/{SourceType}/{ResimKod}", "GET")
export class GetResim_Request extends BaseRequest_1<ImageResponse> implements IReturn<ImageResponse>
{
    public resimKod: number;
    public sourceType: ResimSourceType;
    public base64Yn: number;

    public constructor(init?: Partial<GetResim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetResim_Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageResponse(); }
}

export class SysKisiAileFromKpsDto extends BaseResponse
{
    public sosyalKisiKod: number;
    public sysKisiKendisi: SysKisiAile;
    public sysKisiAileListesi: SysKisiAile[];
    public sysKisiAdresListesi: SysKisiAdres[];

    public constructor(init?: Partial<SysKisiAileFromKpsDto>) { super(init); (Object as any).assign(this, init); }
}

export class SysKisiAile_Sorgula_Response extends BaseResponse
{
    public sysKisiAileListesi: SysKisiAileFromKpsDto;

    public constructor(init?: Partial<SysKisiAile_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/Kps/SysKisiAileSorgula", "POST")
export class SysKisiAile_Sorgula_Request extends BaseRequest_1<SysKisiAile_Sorgula_Response> implements IReturn<SysKisiAile_Sorgula_Response>
{
    public tckn: string;
    public dogumTarihi: string;

    public constructor(init?: Partial<SysKisiAile_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysKisiAile_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysKisiAile_Sorgula_Response(); }
}

export class SysKisi_KpsAdresGuncelle_Response extends BaseResponse
{

    public constructor(init?: Partial<SysKisi_KpsAdresGuncelle_Response>) { super(init); (Object as any).assign(this, init); }
}

// [Route("/Kps/SysKisiKpsAdresGuncelle", "POST")]
export class SysKisi_KpsAdresGuncelle_Request extends BaseRequest_1<SysKisi_KpsAdresGuncelle_Response> implements IReturn<SysKisi_KpsAdresGuncelle_Response>
{
    public SysKisiKod: string;

    public constructor(init?: Partial<SysKisi_KpsAdresGuncelle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysKisi_KpsAdresGuncelle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysKisi_KpsAdresGuncelle_Response(); }
}

export class GenKpsKisiVaris_Sorgula_Response extends BaseResponse
{
    public genKisiVarisListesi: GenKisiVaris[];
    public genKpsKisiAileFromKpsDto: GenKpsKisiAileFromKpsDto;
    public constructor(init?: Partial<GenKpsKisiVaris_Sorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/Kps/GenKpsKisiVarisSorgula", "POST")
export class GenKpsKisiVaris_Sorgula_Request extends BaseRequest_1<GenKpsKisiVaris_Sorgula_Response> implements IReturn<GenKpsKisiVaris_Sorgula_Response>
{
    public tckn: string;
    public dogumTarihi: string;
    public kisiKod?: number;
    public constructor(init?: Partial<GenKpsKisiVaris_Sorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKpsKisiVaris_Sorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenKpsKisiVaris_Sorgula_Response(); }
}

export class TemGUI_LytKampanyaWebKisiEkle_Request implements IReturn<BaseResponse>
{
    public webKisis: string;
    public kampanyaKod: number;
    public constructor(init?: Partial<TemGUI_LytKampanyaWebKisiEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_LytKampanyaWebKisiEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/ETS/UploadResim")
export class Ets_UploadResim_Request extends BaseRequest_1<ImageResponse> implements IReturn<ImageResponse>
{
    public beyanKod: number;
    public base64: string;
    public image: string;
    public base64Yn: number;
    public cinsiyet: string;

    public constructor(init?: Partial<Ets_UploadResim_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Ets_UploadResim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageResponse(); }
}

// @Route("/DTI/PgdTisGenelServis/SpUcretTahakHesap")
export class TisGenel_SpUcretTahakHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piUcretTahakKod: number;

    public constructor(init?: Partial<TisGenel_SpUcretTahakHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TisGenel_SpUcretTahakHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class GysGUI_GysTarifeLimitResponse extends BaseResponse
{
    public tarifeTutar: number;
    public kapaAc: boolean;

    public constructor(init?: Partial<GysGUI_GysTarifeLimitResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GysGUI_GysTarifeLimitRequest extends BaseRequest_1<GysGUI_GysTarifeLimitResponse> implements IReturn<GysGUI_GysTarifeLimitResponse>
{
    public detayGelirKod: number;
    public gelirKod: number;
    public ucretTarifeKod: number;
    public yil: number;
    public matrahi: number;
    public yrsKod: number;
    public tahakkukTarih: string;

    public constructor(init?: Partial<GysGUI_GysTarifeLimitRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_GysTarifeLimitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_GysTarifeLimitResponse(); }


}

export class TemGUI_UcretTahakkukOtomatikDoldur_Response extends BaseResponse
{
    public yevmiyeTarih: string;
    public yevmiyeNo: string;

    public constructor(init?: Partial<TemGUI_UcretTahakkukOtomatikDoldur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/Tem/UcretTahakkukOtomatikDoldur", "POST")
export class TemGUI_UcretTahakkukOtomatikDoldur_Request extends BaseRequest_1<TemGUI_UcretTahakkukOtomatikDoldur_Response> implements IReturn<TemGUI_UcretTahakkukOtomatikDoldur_Response>
{
    public tahakAnaKod: number;

    public constructor(init?: Partial<TemGUI_UcretTahakkukOtomatikDoldur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGUI_UcretTahakkukOtomatikDoldur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGUI_UcretTahakkukOtomatikDoldur_Response(); }
}

export class GysGUI_GysIhbarTahakkukRequest implements IReturn<BaseResponse>
{
    public piIhbarAnaKod: number;

    public constructor(init?: Partial<GysGUI_GysIhbarTahakkukRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_GysIhbarTahakkukRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class TemDamgaBeyan_SpDamgaBeyan01_Response extends BaseResponse
{
    public poHata: string;

    public constructor(init?: Partial<TemDamgaBeyan_SpDamgaBeyan01_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemDamgaBeyan/SpDamgaBeyan01")
export class TemDamgaBeyan_SpDamgaBeyan01_Request extends BaseRequest_1<TemDamgaBeyan_Dosya_Response> implements IReturn<TemDamgaBeyan_Dosya_Response>
{
    public piDonem: number;
    public piDamgaBeyanTur: string;
    public piHazirlananAy: string;
    public piBuAy: string;
    public piSonTarih: string;
    public piDosyaAdi: string;
    public sorguTuru: number;

    public constructor(init?: Partial<TemDamgaBeyan_SpDamgaBeyan01_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemDamgaBeyan_SpDamgaBeyan01_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemDamgaBeyan_Dosya_Response(); }
}

export class TemDamgaBeyan_SpDamgaBeyan02_Response extends BaseResponse
{
    public poHata: string;

    public constructor(init?: Partial<TemDamgaBeyan_SpDamgaBeyan02_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemDamgaBeyan/SpDamgaBeyan02")
export class TemDamgaBeyan_SpDamgaBeyan02_Request extends BaseRequest_1<TemDamgaBeyan_Dosya_Response> implements IReturn<TemDamgaBeyan_Dosya_Response>
{
    public piDonem: number;
    public piDamgaBeyanTur: string;
    public piHazirlananAy: string;
    public piBuAy: string;
    public piSonTarih: string;
    public piDosyaAdi: string;
    public sorguTuru: number;

    public constructor(init?: Partial<TemDamgaBeyan_SpDamgaBeyan02_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemDamgaBeyan_SpDamgaBeyan02_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemDamgaBeyan_Dosya_Response(); }
}

export class TemDamgaBeyan_SpDamgaBeyan03_Response extends BaseResponse
{
    public poHata: string;

    public constructor(init?: Partial<TemDamgaBeyan_SpDamgaBeyan03_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemDamgaBeyan/SpDamgaBeyan03")
export class TemDamgaBeyan_SpDamgaBeyan03_Request extends BaseRequest_1<TemDamgaBeyan_Dosya_Response> implements IReturn<TemDamgaBeyan_Dosya_Response>
{
    public piDonem: number;
    public piDamgaBeyanTur: string;
    public piHazirlananAy: string;
    public piBuAy: string;
    public piSonTarih: string;
    public piDosyaAdi: string;
    public sorguTuru: number;

    public constructor(init?: Partial<TemDamgaBeyan_SpDamgaBeyan03_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemDamgaBeyan_SpDamgaBeyan03_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemDamgaBeyan_Dosya_Response(); }
}

export class TemDamgaBeyan_Dosya_Response extends BaseResponse
{
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<TemDamgaBeyan_Dosya_Response>) { super(init); (Object as any).assign(this, init); }
}

export class PtsGenel_SpPazarTopluTerkin_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<PtsGenel_SpPazarTopluTerkin_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/PTS/PgdPtsGenelServis/SpPazarTopluTerkin")
export class PtsGenel_SpPazarTopluTerkin_Request extends BaseRequest_1<PtsGenel_SpPazarTopluTerkin_Response> implements IReturn<PtsGenel_SpPazarTopluTerkin_Response>
{
    public piIlkKisiKod: number;
    public piSonKisiKod: number;
    public piPazarKod: number;
    public piYil: number;
    public piDonem: number;
    public piIsgalGelirKod: number;
    public piTerkinTarih: string;
    public piIslemKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<PtsGenel_SpPazarTopluTerkin_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PtsGenel_SpPazarTopluTerkin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PtsGenel_SpPazarTopluTerkin_Response(); }
}

export class PtsGenel_SpPazarTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;

    public constructor(init?: Partial<PtsGenel_SpPazarTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/PTS/PgdPtsGenelServis/SpPazarTahakkuk")
export class PtsGenel_SpPazarTahakkuk_Request extends BaseRequest_1<PtsGenel_SpPazarTahakkuk_Response> implements IReturn<PtsGenel_SpPazarTahakkuk_Response>
{
    public piIlkKisiKod: number;
    public piSonKisiKod: number;
    public piPazarKod: number;
    public piYil: number;
    public piDonem: number;
    public piIsgalGelirKod: number;
    public piTahakTarih: string;
    public piIslemKod: string;
    public piAciklama: string;

    public constructor(init?: Partial<PtsGenel_SpPazarTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PtsGenel_SpPazarTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PtsGenel_SpPazarTahakkuk_Response(); }
}

export class ZysGenel_SpTahakkuk_Response extends BaseResponse
{
    public poIslemYapildiEh: string;
    public piAnaKod: number;

    public constructor(init?: Partial<ZysGenel_SpTahakkuk_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/ZYS/PgdZysGenelServis/SpTahakkuk")
export class ZysGenel_SpTahakkuk_Request extends BaseRequest_1<ZysGenel_SpTahakkuk_Response> implements IReturn<ZysGenel_SpTahakkuk_Response>
{
    public piIslemTuru: string;
    public piIslemKod: string;
    public piKisiKod: number;
    public piYil: number;
    public piDonem: number;
    public piVarakaKod: number;
    public piTahakTarih: string;
    public piAciklama: string;

    public constructor(init?: Partial<ZysGenel_SpTahakkuk_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ZysGenel_SpTahakkuk_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ZysGenel_SpTahakkuk_Response(); }
}


export class EisGUI_İhaleTopluEkle_Request implements IReturn<BaseResponse>
{
    public ihaleKod: number;
    public tasinmazKods: number[];

    public constructor(init?: Partial<EisGUI_İhaleTopluEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGUI_İhaleTopluEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// DKM-5375 Cedric (IHALE-05): İhale Sonuç Gir (servis: EisServicesDab.Any(EisGUI_IhaleSonucGir_Request))
export class EisGUI_IhaleSonucGir_Request implements IReturn<BaseResponse>
{
    public ihaleDetayKod: number;
    public kazananBasvuruKod: number;
    public sonucBedel?: number;

    public constructor(init?: Partial<EisGUI_IhaleSonucGir_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGUI_IhaleSonucGir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// DKM-5360 Cedric (SATIS-Ö1): Taşınmaz Satış iptali (servis: EisServicesDab.Any(EisGUI_SatisIptal_Request)); onizleme = true yazmaz
export class EisSatisIptalSatir
{
    public tahakkukKod: number;
    public yil: number;
    public donem: number;
    public vadeTarih: string;
    public gelirKod: number;
    public gelirAd?: string;
    public tahakkuk: number;
    public terkin: number;
    public tahsil: number;
    public terkinEdilecek: number;
}
export class EisGUI_SatisIptal_Response extends BaseResponse
{
    public iptalDestekli: boolean;
    public satirlar?: EisSatisIptalSatir[];
    public toplamTerkin: number;
    public toplamTahsil: number;
    public uyari?: string;
    public islemKod?: string;
    public terkinSatirSayisi: number;

    public constructor(init?: Partial<EisGUI_SatisIptal_Response>) { super(init); (Object as any).assign(this, init); }
}
export class EisGUI_SatisIptal_Request implements IReturn<EisGUI_SatisIptal_Response>
{
    public kod: number;
    public onizleme: boolean;
    public terkinTarih?: string;
    public terkinTuruKod?: number;
    public aciklama?: string;
    public tasinmazAktifYap?: boolean;

    public constructor(init?: Partial<EisGUI_SatisIptal_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGUI_SatisIptal_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EisGUI_SatisIptal_Response(); }
}
// DKM-5360 Cedric (SATIS-Ö2): satış kaydedilirken "Taşınmaz pasife alınsın mı?" → Evet: AktifEh = 'H'
export class EisGUI_SatisTasinmazAktifEh_Request implements IReturn<BaseResponse>
{
    public kod: number;
    public aktifEh: string;

    public constructor(init?: Partial<EisGUI_SatisTasinmazAktifEh_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EisGUI_SatisTasinmazAktifEh_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GEN/PgdGenKisiBirlesServis/SpKisiBirles")
export class GenKisiBirles_SpKisiBirles_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKaynakKisiKod: number;
    public piHedefKisiKod: number;
    public piTcknAktarEh: string;
    public piVergiNoAktarEh: string;
    public piAdresAktarEh: string;

    public constructor(init?: Partial<GenKisiBirles_SpKisiBirles_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenKisiBirles_SpKisiBirles_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}





// @Route("/Gys/GysGUI_MakbuzOlustur", "POST")
export class GysGUI_MakbuzOlustur_Request implements IReturn<BaseResponse>
{
    public makbuzList: number[];
    public vezneKod: number;

    public constructor(init?: Partial<GysGUI_MakbuzOlustur_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_MakbuzOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class GysGUI_MakbuzOlustur_Response extends BaseResponse
{
    public makbuzEh: string;
    public makbuzRaw: string;
    public makbuzBase64: string;
    public yaziciTipi: string;
    public yaziciAd: string;
    public makbuzTipi: string;
    public makbuzStr: string;

    public constructor(init?: Partial<GysGUI_MakbuzOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/SYS/IncelemeyeGonder")
export class Sys_BasvuruIncelemeGonder_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public basvuruKod: number;

    public constructor(init?: Partial<Sys_BasvuruIncelemeGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_BasvuruIncelemeGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/TopluIncelemeyeGonder")
export class Sys_BasvuruTopluIncelemeGonder_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public basvuruKod: number[];

    public constructor(init?: Partial<Sys_BasvuruTopluIncelemeGonder_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_BasvuruTopluIncelemeGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/GorevIade")
export class Sys_GorevSonuclandir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public sonucTuru: number;
    public incelemeKod: number;
    public aciklama: string;

    public constructor(init?: Partial<Sys_GorevSonuclandir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_GorevSonuclandir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/Sys_GorevSonuclandirTeslimEt")
export class Sys_GorevSonuclandirTeslimEt_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public incelemeKod: number;
    public incelemeKodlar: number[];
    public aciklama: string;
    public onayPersonelKod: number;
    public onayTarih: string;
    public encumenOnayTarih: string;
    public teslimTarih: string;
    public teslimEden: string;
    public encumenKararNo: string;

    public constructor(init?: Partial<Sys_GorevSonuclandirTeslimEt_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_GorevSonuclandirTeslimEt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/BasvuruYardimOnayla")
export class Sys_IncelemeKomisyonSonuclandir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public incelemeKod: number;
    public sonucTuru: number;
    public aciklama: string;
    public basvuruDetayKodlar: number[];
    public onayPersonelKod: number;
    public onayTarih: string;
    public encumenOnayTarih: string;
    public encumenKararNo: string;

    public constructor(init?: Partial<Sys_IncelemeKomisyonSonuclandir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_IncelemeKomisyonSonuclandir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/SYS/IncelemeGorevAta")
export class Sys_IncelemeEkipAta_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public incelemeKodlari: number[];
    public ekipKod: number;

    public constructor(init?: Partial<Sys_IncelemeEkipAta_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_IncelemeEkipAta_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class Sys_YeniIncelemeOlustur_Response extends BaseResponse
{
    public incelemeKod: number;

    public constructor(init?: Partial<Sys_YeniIncelemeOlustur_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/SYS/YeniIncelemeOlustur")
export class Sys_YeniIncelemeOlustur_Request extends BaseRequest_1<Sys_YeniIncelemeOlustur_Response> implements IReturn<Sys_YeniIncelemeOlustur_Response>
{
    public basvuruKod: number;
    public ekipKod?: number;
    public aciklama: string;

    public constructor(init?: Partial<Sys_YeniIncelemeOlustur_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_YeniIncelemeOlustur_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Sys_YeniIncelemeOlustur_Response(); }
}

// DKM-5018 Clara: Sosyal Kişi Yönetimi - toplu başvuru
export class Sys_TopluBasvuruEkleSonucDto
{
    public sosyalKisiKod: number;
    public tckn?: number;
    public adSoyad: string;
    public basvuruKod?: number;
    public olusturulduEh: string;
    public aciklama: string;

    public constructor(init?: Partial<Sys_TopluBasvuruEkleSonucDto>) { (Object as any).assign(this, init); }
}

export class Sys_TopluBasvuruEkle_Response extends BaseResponse
{
    public olusanSayi: number;
    public atlananSayi: number;
    public sonucList: Sys_TopluBasvuruEkleSonucDto[];

    public constructor(init?: Partial<Sys_TopluBasvuruEkle_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/SYS/TopluBasvuruEkle")
export class Sys_TopluBasvuruEkle_Request extends BaseRequest_1<Sys_TopluBasvuruEkle_Response> implements IReturn<Sys_TopluBasvuruEkle_Response>
{
    public sosyalKisiKodList: number[];
    /** 'yyyy-MM-dd' (saat dilimi kaymasın diye metin) */
    public basvuruTarih: string;
    public basvuruSekliKod: number;
    public yardimTurKod?: number;
    public acilEh: string;
    public aciklama: string;
    public uyariliDahilEh: string;

    public constructor(init?: Partial<Sys_TopluBasvuruEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_TopluBasvuruEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Sys_TopluBasvuruEkle_Response(); }
}


// @Route("/SYS/YardimSonuclandir")
export class Sys_YardimSonuclandir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public aciklama: string;
    public sonucKodlar: number[];
    public islemTuru: number;
    public teslimEden: string;
    public teslimTarih: string;

    public constructor(init?: Partial<Sys_YardimSonuclandir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_YardimSonuclandir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/SYS/GorevDegis")
export class Sys_GorevDegis_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public basvuruKod: number;
    public incelemeKod: number;
    public ekipKod: number;

    public constructor(init?: Partial<Sys_GorevDegis_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_GorevDegis_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class TemGenel_SpEkstreOlusturOzel_Response extends BaseResponse
{
    public poIslemKod: string;

    public constructor(init?: Partial<TemGenel_SpEkstreOlusturOzel_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemGenelServis/SpEkstreOlusturOzel")
export class TemGenel_SpEkstreOlusturOzel_Request extends BaseRequest_1<TemGenel_SpEkstreOlusturOzel_Response> implements IReturn<TemGenel_SpEkstreOlusturOzel_Response>
{
    public piDonem: number;
    public piIslemKod: string;
    public piIlkKisiKod: number;
    public piSonKisiKod: number;
    public piIlkTarih: string;
    public piSonTarih: string;
    public piIlkTutar: number;
    public piSonTutar: number;
    public piSifirEh: string;
    public piBirimDosyaEh: string;

    public constructor(init?: Partial<TemGenel_SpEkstreOlusturOzel_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemGenel_SpEkstreOlusturOzel_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemGenel_SpEkstreOlusturOzel_Response(); }
}

export class Sys_BasvuruKayitKontrol_Response extends BaseResponse
{
    public poUyariList: DWarningDto[];
    public poAciklama: string;

    public constructor(init?: Partial<Sys_BasvuruKayitKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}


// @Route("/SYS/BasvuruKayitKontrol")
export class Sys_BasvuruKayitKontrol_Request extends BaseRequest_1<Sys_BasvuruKayitKontrol_Response> implements IReturn<Sys_BasvuruKayitKontrol_Response>
{
    public piKisiKod: number;

    public constructor(init?: Partial<Sys_BasvuruKayitKontrol_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_BasvuruKayitKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Sys_BasvuruKayitKontrol_Response(); }
}

// @Route("/TAR/PgdTarifeGenelServis/SpEtpTarifeTasi")
export class TarifeGenel_SpEtpTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<TarifeGenel_SpEtpTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TarifeGenel_SpEtpTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TAR/PgdTarifeGenelServis/SpFisTarifeTasi")
export class TarifeGenel_SpFisTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<TarifeGenel_SpFisTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TarifeGenel_SpFisTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TAR/PgdTarifeGenelServis/SpPptTarifeTasi")
export class TarifeGenel_SpPptTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<TarifeGenel_SpPptTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TarifeGenel_SpPptTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TAR/PgdTarifeGenelServis/SpTisTarifeTasi")
export class TarifeGenel_SpTisTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<TarifeGenel_SpTisTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TarifeGenel_SpTisTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TAR/PgdTarifeGenelServis/SpYktTarifeTasi")
export class TarifeGenel_SpYktTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<TarifeGenel_SpYktTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TarifeGenel_SpYktTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/TAR/PgdTarifeGenelServis/SpYrsTarifeTasi")
export class TarifeGenel_SpYrsTarifeTasi_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piOkuYil: number;
    public piYazYil: number;

    public constructor(init?: Partial<TarifeGenel_SpYrsTarifeTasi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TarifeGenel_SpYrsTarifeTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class DabIdChangeMobilePhone_Response extends BaseResponse
{

    public constructor(init?: Partial<DabIdChangeMobilePhone_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/DabId/DabIdChangeMobilePhone", "POST")
export class DabIdChangeMobilePhone_Request extends BaseRequest_1<DabIdChangeMobilePhone_Response> implements IReturn<DabIdChangeMobilePhone_Response>
{
    public webKisiKod: number;
    public gsmAlanKod: number;
    public gsmNo: number;

    public constructor(init?: Partial<DabIdChangeMobilePhone_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DabIdChangeMobilePhone_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DabIdChangeMobilePhone_Response(); }
}

// @Route("/GEN/PgdGenSistem/SpPrepareDlists")
export class GenSistem_SpPrepareDlists_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GenSistem_SpPrepareDlists_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenSistem_SpPrepareDlists_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GEN/PgdGenSistem/SpCreateDlistClone")
export class GenSistem_SpCreateDlistClone_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piKaynakDlistCode: string;
    public piDlistCode: string;
    public piDlistName: string;

    public constructor(init?: Partial<GenSistem_SpCreateDlistClone_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenSistem_SpCreateDlistClone_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/GEN/PgdGenSistem/SpPrepareFormYetki")
export class GenSistem_SpPrepareFormYetki_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public constructor(init?: Partial<GenSistem_SpPrepareFormYetki_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GenSistem_SpPrepareFormYetki_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/SYS/YardimDetayEkle")
export class Sys_YardimDetayEkle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public sosyalBasvuruKod: number;
    public sosyalBasvuruDetayKod: number;
    public aciklama: string;
    public islemTarih: string;
    public islemTuru: number;
    public adet: number;
    public malzemeKod: string;
    public teslimEden: string;
    public teslimTarih: string;

    public constructor(init?: Partial<Sys_YardimDetayEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_YardimDetayEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class GysGUI_MakbuzBilgi_Response extends BaseResponse
{
    public raporAdi: string;
    public raporUrl: string;

    public constructor(init?: Partial<GysGUI_MakbuzBilgi_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/Gys/TahakkukMakbuzBilgi", "POST")
export class GysGUI_MakbuzBilgi_Request extends BaseRequest_1<GysGUI_MakbuzBilgi_Response> implements IReturn<GysGUI_MakbuzBilgi_Response>
{
    public tur: string;
    public kod: number;
    public modulKod: number;
    public islemTipi: number;

    public constructor(init?: Partial<GysGUI_MakbuzBilgi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_MakbuzBilgi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_MakbuzBilgi_Response(); }
}

export class PYS_CokluMemKazancTanımDetayEkle_Request implements IReturn<BaseResponse>
{
    public memKazancAds: number[];
    public kazancTanimKod: number;

    public constructor(init?: Partial<PYS_CokluMemKazancTanımDetayEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PYS_CokluMemKazancTanımDetayEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class PYS_CokluMemKesintiTanımDetayEkle_Request implements IReturn<BaseResponse>
{
    public memKesintiAds: number[];
    public kesintiTanimKod: number;

    public constructor(init?: Partial<PYS_CokluMemKesintiTanımDetayEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PYS_CokluMemKesintiTanımDetayEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class PYS_CokluIsmGelirTanımDetayEkle_Request implements IReturn<BaseResponse>
{
    public ismKazancAds: number[];
    public ismKazancTanimKod: number;

    public constructor(init?: Partial<PYS_CokluIsmGelirTanımDetayEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PYS_CokluIsmGelirTanımDetayEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class PYS_CokluIsmKesintiTanimDetayEkle_Request implements IReturn<BaseResponse>
{
    public ismKesintiAds: number[];
    public ismKesintiTanimKod: number;

    public constructor(init?: Partial<PYS_CokluIsmKesintiTanimDetayEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PYS_CokluIsmKesintiTanimDetayEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class IkaGUI_PersonelIzin_Request implements IReturn<BaseResponse>
{
    public personelKod: number;
    public kontrolTarih?: string;

    public constructor(init?: Partial<IkaGUI_PersonelIzin_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGUI_PersonelIzin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}
export class ExcelGUI_AccessVeriAktarim_Request
{
    public fileData: string;
    public fileName: string;

    public constructor(init?: Partial<ExcelGUI_AccessVeriAktarim_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_AccessVeriAktarim_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
// DKM-4160 Clara: TKGM "Bir Nolu Bilgi Formu" (tapu hareketleri) Excel aktarimi
export class ExcelGUI_TapuGelenHamEkle_Request implements IReturn<BaseResponse>
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_TapuGelenHamEkle_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_TapuGelenHamEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class PYS_CokluYeniTanimEkle_Response extends BaseResponse
{
    public tanimKod: number;
    public tanimDetayKods?: number[];

    public constructor(init?: Partial<PYS_CokluYeniTanimEkle_Response>) { super(init); (Object as any).assign(this, init); }
}

export class PYS_CokluYeniTanimEkle_Request extends BaseRequest_1<PYS_CokluYeniTanimEkle_Response> implements IReturn<PYS_CokluYeniTanimEkle_Response>
{
    public tanimKod: number;
    public turu: string;

    public constructor(init?: Partial<PYS_CokluYeniTanimEkle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PYS_CokluYeniTanimEkle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PYS_CokluYeniTanimEkle_Response(); }
}

export class PysGUI_MemMaasSicilOzetGetir_Response extends BaseResponse
{
    public ilk_Personel?: number;
    public son_Personel_Kod?: number;
    public ilk_Gorev_Birim_Kod?: number;
    public son_Gorev_Birim_Kod?: number;
    public ilk_Kadro_Birim_Kod?: number;
    public son_Kadro_Birim_Kod?: number;

    public constructor(init?: Partial<PysGUI_MemMaasSicilOzetGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class PysGUI_MemMaasSicilOzetGetir_Request extends BaseRequest_1<PysGUI_MemMaasSicilOzetGetir_Response> implements IReturn<PysGUI_MemMaasSicilOzetGetir_Response>
{
    public memDonemKod: number;

    public constructor(init?: Partial<PysGUI_MemMaasSicilOzetGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PysGUI_MemMaasSicilOzetGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PysGUI_MemMaasSicilOzetGetir_Response(); }
}

export class PysGUI_BankDisketHazirlaMem_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<PysGUI_BankDisketHazirlaMem_Response>) { super(init); (Object as any).assign(this, init); }
}

export class PysGUI_BankDisketHazirla_Request extends BaseRequest_1<PysGUI_BankDisketHazirlaMem_Response> implements IReturn<PysGUI_BankDisketHazirlaMem_Response>
{
    public personelTuru: string;
    public odemeBankaTuru: string;
    public ilkBirimKod: number;
    public sonBirimKod: number;
    public ilkPersonelKod: number;
    public sonPersonelKod: number;
    public donemKod: number;
    public sorguTuru: number;

    public constructor(init?: Partial<PysGUI_BankDisketHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PysGUI_BankDisketHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PysGUI_BankDisketHazirlaMem_Response(); }
}

export class TemSayistayYeni_SpSayistayEmiTasinmaz_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayEmiTasinmaz_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayEmiTasinmaz")
export class TemSayistayYeni_SpSayistayEmiTasinmaz_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayEmiTasinmaz_Response> implements IReturn<TemSayistayYeni_SpSayistayEmiTasinmaz_Response>
{
    public piDonem?: number;
    public raporSekli: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayEmiTasinmaz_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayEmiTasinmaz_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayEmiTasinmaz_Response(); }
}

export class TemSayistayYeni_SpSayistayTaahhutKarti_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTaahhutKarti_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTaahhutKarti")
export class TemSayistayYeni_SpSayistayTaahhutKarti_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTaahhutKarti_Response> implements IReturn<TemSayistayYeni_SpSayistayTaahhutKarti_Response>
{
    public piDonem?: number;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTaahhutKarti_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTaahhutKarti_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTaahhutKarti_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo21_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo21_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo21")
export class TemSayistayYeni_SpSayistayTablo21_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo21_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo21_Response>
{
    public piDonem?: number;
    public piBelde?: string;
    public piBaslikBas?: string;
    public piDosyaAdi?: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo21_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo21_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo21_Response(); }
}
export class TemSayistayYeni_SpSayistayTablo210_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo210_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo210")
export class TemSayistayYeni_SpSayistayTablo210_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo210_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo210_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piDispAdi1: string;
    public piDispAdi2: string;
    public piDispAdi3: string;
    public piBelde?: string;
    public piChkKbs: string;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo210_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo210_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo210_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo22_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo22_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo22")
export class TemSayistayYeni_SpSayistayTablo22_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo22_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo22_Response>
{
    public piDonem?: number;
    public piBelde?: string;
    public piBaslikBas?: string;
    public piDosyaAdi?: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo22_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo22_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo22_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo23_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo23_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo23")
export class TemSayistayYeni_SpSayistayTablo23_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo23_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo23_Response>
{
    public piDonem?: number;
    public piSonTarih?: string;
    public piDispAdi1: string;
    public piKdv: string;
    public piBelde?: string;
    public piKmuzeDahil?: string;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo23_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo23_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo23_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo24_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo24_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo24")
export class TemSayistayYeni_SpSayistayTablo24_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo24_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo24_Response>
{
    public piDonem?: number;
    public piSonTarih?: string;
    public piDispAdi1: string;
    public piDispAdi2: string;
    public piDispAdi3: string;
    public piKdv: string;
    public piBelde?: string;
    public piKmuzeDahil?: string;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo24_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo24_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo24_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo25_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo25_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo25")
export class TemSayistayYeni_SpSayistayTablo25_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo25_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo25_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piBelde?: string;
    public piBaslikBas?: string;
    public piNazimBas?: string;
    public piDosyaAdi?: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo25_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo25_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo25_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo26_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo26_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo26")
export class TemSayistayYeni_SpSayistayTablo26_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo26_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo26_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piBelde?: string;
    public piBaslikBas?: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo26_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo26_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo26_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo27_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo27_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo27")
export class TemSayistayYeni_SpSayistayTablo27_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo27_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo27_Response>
{
    public piDonem?: number;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo27_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo27_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo27_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo28_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo28_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo28")
export class TemSayistayYeni_SpSayistayTablo28_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo28_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo28_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piIlkYevmiye?: number;
    public piSonYevmiye?: number;
    public piChkKbs: string;
    public piCheckYevmiyeNo: string;
    public piBelde?: string;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo28_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo28_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo28_Response(); }
}

export class TemSayistayYeni_SpSayistayTablo29_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo29_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTablo29")
export class TemSayistayYeni_SpSayistayTablo29_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTablo29_Response> implements IReturn<TemSayistayYeni_SpSayistayTablo29_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piDispAdi1: string;
    public piDispAdi2: string;
    public piDispAdi3: string;
    public piBelde?: string;
    public piChkKbs: string;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTablo29_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTablo29_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTablo29_Response(); }
}

export class TemSayistayYeni_SpSayistayTasinirIslemFisi_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTasinirIslemFisi_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayTasinirIslemFisi")
export class TemSayistayYeni_SpSayistayTasinirIslemFisi_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayTasinirIslemFisi_Response> implements IReturn<TemSayistayYeni_SpSayistayTasinirIslemFisi_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayTasinirIslemFisi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayTasinirIslemFisi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayTasinirIslemFisi_Response(); }
}

export class TemSayistayYeni_SpSayistayYevmiyeKayitleri_Response extends BaseResponse
{
    public cv1: BaseCursorDto[];
    public value: Object[];
    public poHata: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayYevmiyeKayitleri_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/TEM/PgdTemSayistayYeni/SpSayistayYevmiyeKayitleri")
export class TemSayistayYeni_SpSayistayYevmiyeKayitleri_Request extends BaseRequest_1<TemSayistayYeni_SpSayistayYevmiyeKayitleri_Response> implements IReturn<TemSayistayYeni_SpSayistayYevmiyeKayitleri_Response>
{
    public piDonem?: number;
    public piIlkTarih?: string;
    public piSonTarih?: string;
    public piChkKbs: string;
    public piCheckYevmiyeNo: string;
    public piBaslikBas?: string;
    public piDosyaAdi: string;

    public constructor(init?: Partial<TemSayistayYeni_SpSayistayYevmiyeKayitleri_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TemSayistayYeni_SpSayistayYevmiyeKayitleri_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TemSayistayYeni_SpSayistayYevmiyeKayitleri_Response(); }
}
export class SasGUI_SpSayacOkumaHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSayacOkumaKod: number;

    public constructor(init?: Partial<SasGUI_SpSayacOkumaHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpSayacOkumaHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class IkaGUI_IscDonemTasi_Request implements IReturn<BaseResponse>
{
    public okuDonem: number;
    public yazDonem: number;

    public constructor(init?: Partial<IkaGUI_IscDonemTasi_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGUI_IscDonemTasi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


// @Route("/SYS/GorevTopluSonuclandir")
export class Sys_GorevTopluSonuclandir_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public sonucTuru: number;
    public incelemeKodList: number[];
    public aciklama: string;

    public constructor(init?: Partial<Sys_GorevTopluSonuclandir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'Sys_GorevTopluSonuclandir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class IkaRapor_SpMemFiiliHizmetHazirla_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemFiiliHizmetHazirla_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemFiiliHizmetHazirla")
export class IkaRapor_SpMemFiiliHizmetHazirla_Request extends BaseRequest_1<IkaRapor_SpMemFiiliHizmetHazirla_Response> implements IReturn<IkaRapor_SpMemFiiliHizmetHazirla_Response>
{
    public piDokuman: string;
    public piDonem: number;
    public piYil: number;
    public piAy: number;
    public piIlkAy: number;
    public piIsyeriNo: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemFiiliHizmetHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemFiiliHizmetHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemFiiliHizmetHazirla_Response(); }
}

// DKM-5203 Clara: İşçi Maaş Bordro Dökümü öncesi TMP_ISC_KAZANC / TMP_ISC_KESINTI hazırlığı
// @Route("/IKA/PgdIkaRaporServis/SpIscBordroHazirla")
export class IkaRapor_SpIscBordroHazirla_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonem: number;

    public constructor(init?: Partial<IkaRapor_SpIscBordroHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpIscBordroHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// DKM-5247 Clara: BES katkı payı bildirim dosyası (memur + işçi)
export class IkaRapor_BesKatkiDosyaHazirla_Response extends BaseResponse
{
    public fileName: string;
    public fileData: string;
    public mimeType: string;
    public kayitSayisi: number;
    public toplamTutar: number;

    public constructor(init?: Partial<IkaRapor_BesKatkiDosyaHazirla_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/BesKatkiDosyaHazirla")
export class IkaRapor_BesKatkiDosyaHazirla_Request extends BaseRequest_1<IkaRapor_BesKatkiDosyaHazirla_Response> implements IReturn<IkaRapor_BesKatkiDosyaHazirla_Response>
{
    /** M = Memur, I = İşçi */
    public piPersonelTuru: string;
    public piIlkKurumsal?: number;
    public piSonKurumsal?: number;
    public piIlkPersonel?: number;
    public piSonPersonel?: number;
    /** Virgülle ayrılmış maaş dönemi kodları */
    public piDonemList: string;
    public piKesintiKod: number;
    /** yyyy-MM-ddT00:00:00 */
    public piOdemeTarih: string;
    /** E = Excel (sekme ayraçlı .xls), T = Text (.txt) */
    public piDosyaTipi: string;

    public constructor(init?: Partial<IkaRapor_BesKatkiDosyaHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_BesKatkiDosyaHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_BesKatkiDosyaHazirla_Response(); }
}


export class IkaRapor_SpMemSgkSahisDosyaA_Response extends BaseResponse
{
    public islemKod: string;
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaA_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemSgkSahisDosyaA")
export class IkaRapor_SpMemSgkSahisDosyaA_Request extends BaseRequest_1<IkaRapor_SpMemSgkSahisDosyaA_Response> implements IReturn<IkaRapor_SpMemSgkSahisDosyaA_Response>
{
    public sorguTuru: number;
    public piMaasTuru: string;
    public piIlkKurumsal: string;
    public piSonKurumsal: string;
    public piDonemList: string;
    public piYil: number;
    public piAy: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaA_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemSgkSahisDosyaA_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemSgkSahisDosyaA_Response(); }
}

export class IkaRapor_SpMemSgkSahisDosyaB_Response extends BaseResponse
{
    public islemKod: string;
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaB_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemSgkSahisDosyaB")
export class IkaRapor_SpMemSgkSahisDosyaB_Request extends BaseRequest_1<IkaRapor_SpMemSgkSahisDosyaB_Response> implements IReturn<IkaRapor_SpMemSgkSahisDosyaB_Response>
{
    public sorguTuru: number;
    public piMaasTuru: string;
    public piIlkKurumsal: string;
    public piSonKurumsal: string;
    public piDonemList: string;
    public piYil: number;
    public piAy: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaB_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemSgkSahisDosyaB_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemSgkSahisDosyaB_Response(); }
}

export class IkaRapor_SpMemSgkSahisDosyaE_Response extends BaseResponse
{
    public islemKod: string;
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaE_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemSgkSahisDosyaE")
export class IkaRapor_SpMemSgkSahisDosyaE_Request extends BaseRequest_1<IkaRapor_SpMemSgkSahisDosyaE_Response> implements IReturn<IkaRapor_SpMemSgkSahisDosyaE_Response>
{
    public piMaasTuru: string;
    public piIlkKurumsal: string;
    public piSonKurumsal: string;
    public piDonemList: string;
    public piYil: number;
    public piAy: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaE_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemSgkSahisDosyaE_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemSgkSahisDosyaE_Response(); }
}

export class IkaRapor_SpMemSgkSahisDosyaF5434_Response extends BaseResponse
{
    public islemKod: string;
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaF5434_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemSgkSahisDosyaF5434")
export class IkaRapor_SpMemSgkSahisDosyaF5434_Request extends BaseRequest_1<IkaRapor_SpMemSgkSahisDosyaF5434_Response> implements IReturn<IkaRapor_SpMemSgkSahisDosyaF5434_Response>
{
    public sorguTuru: number;
    public piMaasTuru: string;
    public piIlkKurumsal: string;
    public piSonKurumsal: string;
    public piDonemList: string;
    public piYil: number;
    public piAy: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaF5434_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemSgkSahisDosyaF5434_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemSgkSahisDosyaF5434_Response(); }
}

export class IkaRapor_SpMemSgkSahisDosyaF5510_Response extends BaseResponse
{
    public islemKod: string;
    public fileName: string;
    public fileData: string;
    public mimeType: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaF5510_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemSgkSahisDosyaF5510")
export class IkaRapor_SpMemSgkSahisDosyaF5510_Request extends BaseRequest_1<IkaRapor_SpMemSgkSahisDosyaF5510_Response> implements IReturn<IkaRapor_SpMemSgkSahisDosyaF5510_Response>
{
    public sorguTuru: number;
    public piMaasTuru: string;
    public piIlkKurumsal: string;
    public piSonKurumsal: string;
    public piDonemList: string;
    public piYil: number;
    public piAy: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemSgkSahisDosyaF5510_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemSgkSahisDosyaF5510_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemSgkSahisDosyaF5510_Response(); }
}

export class IkaRapor_SpMemYillikSahisHazirla_Response extends BaseResponse
{
    public islemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemYillikSahisHazirla_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/IKA/PgdIkaRaporServis/SpMemYillikSahisHazirla")
export class IkaRapor_SpMemYillikSahisHazirla_Request extends BaseRequest_1<IkaRapor_SpMemYillikSahisHazirla_Response> implements IReturn<IkaRapor_SpMemYillikSahisHazirla_Response>
{
    public piDokuman: string;
    public piIlkKurumsal: string;
    public piSonKurumsal: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piYil: number;
    public piIlkAy: number;
    public piSonAy: number;
    public piIslemKod: string;

    public constructor(init?: Partial<IkaRapor_SpMemYillikSahisHazirla_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaRapor_SpMemYillikSahisHazirla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IkaRapor_SpMemYillikSahisHazirla_Response(); }
}

export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Request extends BaseRequest_1<ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Response> implements IReturn<ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Response>
{
    public firmaMusteriNo: string;
    public firmaSubeKodu: string;
    public firmaHesapNoIban: number;
    public odemeKesinti: string;
    public odemeTuru: string;
    public odemeAciklama: string;
    public odemeTarih: string;
    public piIlkKurumsal?: string;
    public piSonKurumsal?: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piDonemList?: string;
    public piYil: number;
    public piAy: number;
    public piAciklama?: string;

    public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_IscPersonelMaasOdemeBankaGetir_VakifBank_Response(); }
}

export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Request extends BaseRequest_1<ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Response> implements IReturn<ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Response>
{
    public piIlkKurumsal?: string;
    public piSonKurumsal?: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piDonemList?: string;
    public piYil: number;
    public piAy: number;
    public piAciklama?: string;

    public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_MemPersonelMaasOdemeBankaGetir_VakifBank_Response(); }
}
export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Request extends BaseRequest_1<ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Response> implements IReturn<ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Response>
{
    public firmaMusteriNo: string;
    public firmaSubeKodu: string;
    public firmaHesapNoIban: number;
    public odemeKesinti: string;
    public odemeTuru: string;
    public odemeAciklama: string;
    public odemeTarih: string;
    public piIlkKurumsal?: string;
    public piSonKurumsal?: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piDonemList?: string;
    public piYil: number;
    public piAy: number;
    public piAciklama?: string;

    public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_IscPersonelMaasOdemeBankaGetir_HalkBank_Response(); }
}

export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Request extends BaseRequest_1<ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Response> implements IReturn<ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Response>
{
    public piIlkKurumsal?: string;
    public piSonKurumsal?: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piDonemList?: string;
    public piYil: number;
    public piAy: number;
    public piAciklama?: string;
    public firmaMusteriNo: string; 
    public firmaSubeKodu: string; 
    public firmaHesapNoIban: number; 
    public odemeKesinti: string; 
    public odemeTuru: string; 
    public odemeAciklama: string;

    public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_MemPersonelMaasOdemeBankaGetir_HalkBank_Response(); }
}

// DKM-5246 Clara: eski hali - Ziraat icin ayri uc kaldirildi (dtokgoz 17.10: tek uc + banka parametresi).
// Yerine: ExcelGUI_Mem/IscPersonelMaasOdemeBankaGetir_Request (bankaKod = '3').
// // DKM-5246 Clara: Ziraat Bankasi maas dosyasi (Forms ZIRAAT_DISKET_HAZIRLA). dosyaTipi: 'E' = .xls (tab), 'C' = .csv (;)
// export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Response extends BaseResponse
// {
//     public fileName: string;
//     public mimeType: string;
//     public fileData: string;
//
//     public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Response>) { super(init); (Object as any).assign(this, init); }
// }
//
// export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Request extends BaseRequest_1<ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Response> implements IReturn<ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Response>
// {
//     public dosyaTipi?: string;
//     public odemeTarih?: string;
//     public piIlkKurumsal?: string;
//     public piSonKurumsal?: string;
//     public piIlkPersonel: number;
//     public piSonPersonel: number;
//     public piDonemList?: string;
//     public piYil: number;
//     public piAy: number;
//     public piAciklama?: string;
//
//     public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Request>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Request'; }
//     public getMethod() { return 'POST'; }
//     public createResponse() { return new ExcelGUI_MemPersonelMaasOdemeBankaGetir_ZiraatBank_Response(); }
// }
//
// export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Response extends BaseResponse
// {
//     public fileName: string;
//     public mimeType: string;
//     public fileData: string;
//
//     public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Response>) { super(init); (Object as any).assign(this, init); }
// }
//
// export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Request extends BaseRequest_1<ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Response> implements IReturn<ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Response>
// {
//     public dosyaTipi?: string;
//     public odemeTarih?: string;
//     public piIlkKurumsal?: string;
//     public piSonKurumsal?: string;
//     public piIlkPersonel: number;
//     public piSonPersonel: number;
//     public piDonemList?: string;
//     public piYil: number;
//     public piAy: number;
//     public piAciklama?: string;
//
//     public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Request>) { super(init); (Object as any).assign(this, init); }
//     public getTypeName() { return 'ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Request'; }
//     public getMethod() { return 'POST'; }
//     public createResponse() { return new ExcelGUI_IscPersonelMaasOdemeBankaGetir_ZiraatBank_Response(); }
// }

// DKM-5246 Clara: banka maas dosyasi tek uc - bankaKod: '1' Halk, '2' Vakif, '3' Ziraat.
// dosyaTipi yalniz Ziraat'ta: 'E' = .xls (tab), 'C' = .csv (;). Firma/odeme alanlari yalniz Halk dosyasinin basligina yazilir.
export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_MemPersonelMaasOdemeBankaGetir_Request extends BaseRequest_1<ExcelGUI_MemPersonelMaasOdemeBankaGetir_Response> implements IReturn<ExcelGUI_MemPersonelMaasOdemeBankaGetir_Response>
{
    public bankaKod?: string;
    public dosyaTipi?: string;
    public firmaMusteriNo?: string;
    public firmaSubeKodu?: string;
    public firmaHesapNoIban?: number;
    public odemeKesinti?: string;
    public odemeTuru?: string;
    public odemeTarih?: string;
    public odemeAciklama?: string;
    public piIlkKurumsal?: string;
    public piSonKurumsal?: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piDonemList?: string;
    public piYil: number;
    public piAy: number;
    public piAciklama?: string;

    public constructor(init?: Partial<ExcelGUI_MemPersonelMaasOdemeBankaGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_MemPersonelMaasOdemeBankaGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_MemPersonelMaasOdemeBankaGetir_Response(); }
}

export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_Response extends BaseResponse
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_Response>) { super(init); (Object as any).assign(this, init); }
}

export class ExcelGUI_IscPersonelMaasOdemeBankaGetir_Request extends BaseRequest_1<ExcelGUI_IscPersonelMaasOdemeBankaGetir_Response> implements IReturn<ExcelGUI_IscPersonelMaasOdemeBankaGetir_Response>
{
    public bankaKod?: string;
    public dosyaTipi?: string;
    public firmaMusteriNo?: string;
    public firmaSubeKodu?: string;
    public firmaHesapNoIban?: number;
    public odemeKesinti?: string;
    public odemeTuru?: string;
    public odemeTarih?: string;
    public odemeAciklama?: string;
    public piIlkKurumsal?: string;
    public piSonKurumsal?: string;
    public piIlkPersonel: number;
    public piSonPersonel: number;
    public piDonemList?: string;
    public piYil: number;
    public piAy: number;
    public piAciklama?: string;

    public constructor(init?: Partial<ExcelGUI_IscPersonelMaasOdemeBankaGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExcelGUI_IscPersonelMaasOdemeBankaGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExcelGUI_IscPersonelMaasOdemeBankaGetir_Response(); }
}

export class SgkMuhsgkDosyaGetir_Response
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;

    public constructor(init?: Partial<SgkMuhsgkDosyaGetir_Response>) { (Object as any).assign(this, init); }
}

export class SgkMuhsgkDosyaGetir_Request extends BaseRequest_1<SgkMuhsgkDosyaGetir_Response> implements IReturn<SgkMuhsgkDosyaGetir_Response>
{
    public donemList: string;
    public yil: number;
    public ay: number;
    public lstDokum: string;
    public lstSgk: string;
    public islemTuru: string;
    public vergiDaireKodu: string;
    public kurumVergiNo: string;
    public kurumSoyadi: string;
    public kurumAdi: string;
    public telAlanKodu: string;
    public telNo: string;
    public duzenSoyadi: string;
    public duzenAdi: string;
    public duzenTckn: string;
    public ticSicilNo: string;
    public duzenEMail: string;
    public duzenTelAlanKodu: string;
    public duzenTelNo: string;
    public meslekMatrah: number;
    public meslekKesinti: number;
    public odemeTarih?: string;
    public odemeNo: string;
    public isyeriTur: string;
    public isyeriKod: string;
    public isyeriTicNo: string;
    public isyeriMudurluk: string;
    public isyeriFaaliyet: string;
    public isyeriAdi: string;
    public isyeriAdresNo: string;
    public araciKod: string;

    public constructor(init?: Partial<SgkMuhsgkDosyaGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SgkMuhsgkDosyaGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SgkMuhsgkDosyaGetir_Response(); }
}


// DKM-4549 Clara: servisin (ExcelServiceDab) aylık bildirge yanıtı; hata BaseResponse.errorMessage değil errorCode + errorMsg ile döner
export class SgkAylikBildirgeDosyaGetir_Response
{
    public fileName: string;
    public mimeType: string;
    public fileData: string;
    public errorCode?: string;
    public errorMsg?: string;
    public result?: boolean;

    public constructor(init?: Partial<SgkAylikBildirgeDosyaGetir_Response>) { (Object as any).assign(this, init); }
}

export class SgkAylikBildirgeDosyaGetir_Request extends BaseRequest_1<SgkMuhsgkDosyaGetir_Response> implements IReturn<SgkMuhsgkDosyaGetir_Response>
{
    public donemList: string;
    public donemKod?: number;
    public yil: number;
    public ay: number;
    public lstDokum: string;
    public lstSgk: string;
    public belgeTurKod?: number;
    public isyeriSskNo: string;
    public kontrolNo: string;
    public araciKod: string;

    public constructor(init?: Partial<SgkAylikBildirgeDosyaGetir_Request>) { super(init); (Object as any).assign(this, init); }
    // DKM-4549 Clara: eski hâli — Muhtasar servisine (/api/SgkMuhsgkDosyaGetir_Request) gidiyordu
    // public getTypeName() { return 'SgkMuhsgkDosyaGetir_Request'; }
    public getTypeName() { return 'SgkAylikBildirgeDosyaGetir_Request'; }
    public getMethod() { return 'POST'; }
    // DKM-4549 Clara: eski hâli
    // public createResponse() { return new SgkMuhsgkDosyaGetir_Response(); }
    public createResponse() { return new SgkAylikBildirgeDosyaGetir_Response(); }
}
export class CevapDto
{
    public kod: number;
    public ad: string;
    public veriTipi?: number;
    public selected: boolean;
    public text: string;
    public tutar?: number;

    public constructor(init?: Partial<CevapDto>) { (Object as any).assign(this, init); }
}

export class PanelSoruDto
{
    public soruKod: number;
    public ad: string;
    public soruTuru?: number;
    public cevaplar: CevapDto[];
    public text: string;
    public tutar?: number;
    public puan?: number;

    public constructor(init?: Partial<PanelSoruDto>) { (Object as any).assign(this, init); }
}

export class PanelSekmeDto
{
    public kod: number;
    public ad: string;
    public panelSoruList: PanelSoruDto[];

    public constructor(init?: Partial<PanelSekmeDto>) { (Object as any).assign(this, init); }
}

export class PanelDto
{
    public kod: number;
    public ad: string;
    public panelSekmeList: PanelSekmeDto[];

    public constructor(init?: Partial<PanelDto>) { (Object as any).assign(this, init); }
}
export class SysSoru_SaveBasvuru_Response extends BaseResponse
{
    public incelemeKod: number;

    public constructor(init?: Partial<SysSoru_SaveBasvuru_Response>) { super(init); (Object as any).assign(this, init); }
}
// @Route("/SYS/Soru/SaveBasvuru")
export class SysSoru_SaveBasvuru_Request extends BaseRequest_1<SysSoru_SaveBasvuru_Response> implements IReturn<SysSoru_SaveBasvuru_Response>
{
    public sosyalBasvuruKod: number;
    public paneller: PanelDto[];

    public constructor(init?: Partial<SysSoru_SaveBasvuru_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SysSoru_SaveBasvuru_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SysSoru_SaveBasvuru_Response(); }
}

export class SasGUI_SpSayacOkumaBankaTalimatiKontrol_Request implements IReturn<BaseResponse>
{
    public sayacOkumaKod: number;

    public constructor(init?: Partial<SasGUI_SpSayacOkumaBankaTalimatiKontrol_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpSayacOkumaBankaTalimatiKontrol_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class SasGUI_SpSayacOkumaBankaTalimatiKaldir_Request implements IReturn<BaseResponse>
{
    public sayacOkumaKod: number;

    public constructor(init?: Partial<SasGUI_SpSayacOkumaBankaTalimatiKaldir_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpSayacOkumaBankaTalimatiKaldir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class SasGUI_SpEndexSakla_Request implements IReturn<BaseResponse>
{
    public aboneKod?: number;
    public ilkDefter: number;
    public sonDefter: number;

    public constructor(init?: Partial<SasGUI_SpEndexSakla_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpEndexSakla_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}


export class SasGUI_SpVadeDuzelt_Request implements IReturn<BaseResponse>
{
    public vadeTarih: string;
    public sayacOkumaKod: number;

    public constructor(init?: Partial<SasGUI_SpVadeDuzelt_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpVadeDuzelt_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class SasGUI_SpSayacOkumaSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSayacOkumaKod: number;

    public constructor(init?: Partial<SasGUI_SpSayacOkumaSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpSayacOkumaSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class SasGUI_YeniSayacOkuma_Response extends BaseResponse
{
    public sayacOkuma: SasSayacOkuma;
    public faturaToplam: number;
    public terkinToplam: number;
    public bakiye: number;
    public yevmiyeNo: string;
    public yevmiyeTarihi: string;
    public sayacUyari: string;
    public bankaTalimatEh: string;
    public bankaTalimatUyari: string;

    public constructor(init?: Partial<SasGUI_YeniSayacOkuma_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SasGUI_YeniSayacOkuma_Request extends BaseRequest_1<SasGUI_YeniSayacOkuma_Response> implements IReturn<SasGUI_YeniSayacOkuma_Response>
{
    public okumaKod: number;
    public aboneKod: number;
    public yil: number;
    public donem: number;
    public donemDetayKod: number;

    public constructor(init?: Partial<SasGUI_YeniSayacOkuma_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_YeniSayacOkuma_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SasGUI_YeniSayacOkuma_Response(); }
}

export class SasGUI_SpSayacTerkinHesap_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSayacOkumaKod: number;
    public piTerkinTarih: string;
    public piEndeks: number;
    public piNotlar: string;
    public piSarfiyatsizTerkinEh: string;

    public constructor(init?: Partial<SasGUI_SpSayacTerkinHesap_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpSayacTerkinHesap_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class SmsGonderModulItem
{
    public kod: number;
    public ad: string;
    public sec: string;

    public constructor(init?: Partial<SmsGonderModulItem>) { (Object as any).assign(this, init); }
}

export class SasGUI_SmsGonder_Request implements IReturn<BaseResponse>
{
    public smsTuru: number;
    public bilgiTuru?: number;
    public ilkKisi: number;
    public sonKisi: number;
    public ilkVadeTarih: string;
    public sonVadeTarih: string;
    public gonderTarih: string;
    public yil?: number;
    public donem?: number;
    public minBorc?: number;
    public metin: string;
    public moduller: SmsGonderModulItem[];

    public constructor(init?: Partial<SasGUI_SmsGonder_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SmsGonder_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class GysGUI_KisiKartBorcGetir_Response extends BaseResponse
{
    public poVadesiGecmis: number;
    public poVadesiGelmemis: number;
    public poBorcToplam: number;
    public poTaksitBorc: number;
    public poTebligatIhbar: number;
    public poTebligatTakip: number;

    public constructor(init?: Partial<GysGUI_KisiKartBorcGetir_Response>){ super(init); (Object as any).assign(this, init); }

}

export class GysGUI_KisiKartBorcGetir_Request extends BaseRequest_1<GysGUI_KisiKartBorcGetir_Response> implements IReturn<GysGUI_KisiKartBorcGetir_Response>
{
    public kisiKod: number;

    public constructor(init?: Partial<GysGUI_KisiKartBorcGetir_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysGUI_KisiKartBorcGetir_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GysGUI_KisiKartBorcGetir_Response(); }
}

export class SasGUIVadesiGecmisBorcDagit_Response extends BaseResponse
{
    public kisiToplamBorc: number;
    public aboneNoBorc: number;
    public aboneSayisi: number;
    public toplamGuncelleneSayisi: number;
    public hisseBasi: number;
    public detaylar: AboneBorcDagitimDetay[];

    public constructor(init?: Partial<SasGUIVadesiGecmisBorcDagit_Response>){ super(init); (Object as any).assign(this, init); }

}

export class SasGUI_VadesiGecmisBorcDagit_Request extends BaseRequest_1<SasGUIVadesiGecmisBorcDagit_Response> implements IReturn<SasGUIVadesiGecmisBorcDagit_Response>
{
    public kisiKod: number;
    public aboneNo: number;
    public constructor(init?: Partial<SasGUI_VadesiGecmisBorcDagit_Request>) { super(init); (Object as any).assign(this, init); }

    public getTypeName(){ return 'SasGUI_VadesiGecmisBorcDagit_Request'; }

    public getMethod(){ return 'POST'; }

    public createResponse(){ return new SasGUIVadesiGecmisBorcDagit_Response(); }
}



export class AboneBorcDagitimDetay{
    public aboneKod: number;
    public aboneNetKalan: number;
    public hedefHisse: number;
    public guncelleneSayisi: number;

    public constructor(init?: Partial<AboneBorcDagitimDetay>){ (Object as any).assign(this, init); }
}

export class SasGUI_AboneBorcSorgula_Response extends BaseResponse
{
    public kisiKod: number;
    public aboneNo: number;
    public aboneVadesiGecmisBorc: number;
    public aboneVadesiGelmeyenBorc: number;
    public kisiVadesiGecmisBorc: number;
    public kisiVadesiGelmeyenBorc: number;
    public kisiSasVadesiGecmisBorc: number;
    public kisiSasVadesiGelmeyenBorc: number;

    public constructor(init?: Partial<SasGUI_AboneBorcSorgula_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SasGUI_AboneBorcSorgula_Request extends BaseRequest_1<SasGUI_AboneBorcSorgula_Response> implements IReturn<SasGUI_AboneBorcSorgula_Response>
{
    public kisiKod: number;
    public aboneNo: number;

    public constructor(init?: Partial<SasGUI_AboneBorcSorgula_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_AboneBorcSorgula_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SasGUI_AboneBorcSorgula_Response(); }
}

export class SasGUI_SpSayacTerkinSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piSayacTerkinKod: number;
    public piSuOkumaKod: number;

    public constructor(init?: Partial<SasGUI_SpSayacTerkinSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpSayacTerkinSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class SasGUI_SpDefterSayfaBul_Response extends BaseResponse
{
    public defterKod?: number;
    public sayfaNo?: number;
    public siraNo?: number;

    public constructor(init?: Partial<SasGUI_SpDefterSayfaBul_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SasGUI_SpDefterSayfaBul_Request extends BaseRequest_1<SasGUI_SpDefterSayfaBul_Response> implements IReturn<SasGUI_SpDefterSayfaBul_Response>
{
    public mahalleCaddeKod: number;
    public kapiNo?: number;
    public daireNo: string;

    public constructor(init?: Partial<SasGUI_SpDefterSayfaBul_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SasGUI_SpDefterSayfaBul_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SasGUI_SpDefterSayfaBul_Response(); }
}

export class GysTahsil_SpTahsilTopluSil_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{

    public piTahsilAnaKodList: number[];
    public piMakbuzIptalKod: number;
    public piMakbuzIptalAciklama: string;

    public constructor(init?: Partial<GysTahsil_SpTahsilTopluSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GysTahsil_SpTahsilTopluSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }

}

// @Route("/IKA/PgdIkaMemGenelServis/SpTopluKesintiIsle")
export class IkaMemGenel_SpTopluKesintiIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piKesintiKod: number;
    public piPuan: number;
    public piTutar: number;

    public constructor(init?: Partial<IkaMemGenel_SpTopluKesintiIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpTopluKesintiIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

// @Route("/IKA/PgdIkaMemGenelServis/SpTopluKazancIsle")
export class IkaMemGenel_SpTopluKazancIsle_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
    public piDonemKod: number;
    public piBirimKod: number;
    public piIlkPersonelKod: number;
    public piSonPersonelKod: number;
    public piKazancKod: number;
    public piPuan: number;
    public piTutar: number;

    public constructor(init?: Partial<IkaMemGenel_SpTopluKazancIsle_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaMemGenel_SpTopluKazancIsle_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}